/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/clipboard/dist/clipboard.js":
/*!**************************************************!*\
  !*** ./node_modules/clipboard/dist/clipboard.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clipboard; }
});

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(279);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
var listen = __webpack_require__(370);
var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
// EXTERNAL MODULE: ./node_modules/select/src/select.js
var src_select = __webpack_require__(817);
var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
;// CONCATENATED MODULE: ./src/common/command.js
/**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */
function command(type) {
  try {
    return document.execCommand(type);
  } catch (err) {
    return false;
  }
}
;// CONCATENATED MODULE: ./src/actions/cut.js


/**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */

var ClipboardActionCut = function ClipboardActionCut(target) {
  var selectedText = select_default()(target);
  command('cut');
  return selectedText;
};

/* harmony default export */ var actions_cut = (ClipboardActionCut);
;// CONCATENATED MODULE: ./src/common/create-fake-element.js
/**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */
function createFakeElement(value) {
  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS

  fakeElement.style.fontSize = '12pt'; // Reset box model

  fakeElement.style.border = '0';
  fakeElement.style.padding = '0';
  fakeElement.style.margin = '0'; // Move element out of screen horizontally

  fakeElement.style.position = 'absolute';
  fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

  var yPosition = window.pageYOffset || document.documentElement.scrollTop;
  fakeElement.style.top = "".concat(yPosition, "px");
  fakeElement.setAttribute('readonly', '');
  fakeElement.value = value;
  return fakeElement;
}
;// CONCATENATED MODULE: ./src/actions/copy.js



/**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */

var fakeCopyAction = function fakeCopyAction(value, options) {
  var fakeElement = createFakeElement(value);
  options.container.appendChild(fakeElement);
  var selectedText = select_default()(fakeElement);
  command('copy');
  fakeElement.remove();
  return selectedText;
};
/**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */


var ClipboardActionCopy = function ClipboardActionCopy(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    container: document.body
  };
  var selectedText = '';

  if (typeof target === 'string') {
    selectedText = fakeCopyAction(target, options);
  } else if (target instanceof HTMLInputElement && !['text', 'search', 'url', 'tel', 'password'].includes(target === null || target === void 0 ? void 0 : target.type)) {
    // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
    selectedText = fakeCopyAction(target.value, options);
  } else {
    selectedText = select_default()(target);
    command('copy');
  }

  return selectedText;
};

/* harmony default export */ var actions_copy = (ClipboardActionCopy);
;// CONCATENATED MODULE: ./src/actions/default.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */

var ClipboardActionDefault = function ClipboardActionDefault() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Defines base properties passed from constructor.
  var _options$action = options.action,
      action = _options$action === void 0 ? 'copy' : _options$action,
      container = options.container,
      target = options.target,
      text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.

  if (action !== 'copy' && action !== 'cut') {
    throw new Error('Invalid "action" value, use either "copy" or "cut"');
  } // Sets the `target` property using an element that will be have its content copied.


  if (target !== undefined) {
    if (target && _typeof(target) === 'object' && target.nodeType === 1) {
      if (action === 'copy' && target.hasAttribute('disabled')) {
        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
      }

      if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
      }
    } else {
      throw new Error('Invalid "target" value, use a valid Element');
    }
  } // Define selection strategy based on `text` property.


  if (text) {
    return actions_copy(text, {
      container: container
    });
  } // Defines which selection strategy based on `target` property.


  if (target) {
    return action === 'cut' ? actions_cut(target) : actions_copy(target, {
      container: container
    });
  }
};

/* harmony default export */ var actions_default = (ClipboardActionDefault);
;// CONCATENATED MODULE: ./src/clipboard.js
function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }






/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */

function getAttributeValue(suffix, element) {
  var attribute = "data-clipboard-".concat(suffix);

  if (!element.hasAttribute(attribute)) {
    return;
  }

  return element.getAttribute(attribute);
}
/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */


var Clipboard = /*#__PURE__*/function (_Emitter) {
  _inherits(Clipboard, _Emitter);

  var _super = _createSuper(Clipboard);

  /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */
  function Clipboard(trigger, options) {
    var _this;

    _classCallCheck(this, Clipboard);

    _this = _super.call(this);

    _this.resolveOptions(options);

    _this.listenClick(trigger);

    return _this;
  }
  /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */


  _createClass(Clipboard, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
    }
    /**
     * Adds a click event listener to the passed trigger.
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     */

  }, {
    key: "listenClick",
    value: function listenClick(trigger) {
      var _this2 = this;

      this.listener = listen_default()(trigger, 'click', function (e) {
        return _this2.onClick(e);
      });
    }
    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var trigger = e.delegateTarget || e.currentTarget;
      var action = this.action(trigger) || 'copy';
      var text = actions_default({
        action: action,
        container: this.container,
        target: this.target(trigger),
        text: this.text(trigger)
      }); // Fires an event based on the copy operation result.

      this.emit(text ? 'success' : 'error', {
        action: action,
        text: text,
        trigger: trigger,
        clearSelection: function clearSelection() {
          if (trigger) {
            trigger.focus();
          }

          window.getSelection().removeAllRanges();
        }
      });
    }
    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultAction",
    value: function defaultAction(trigger) {
      return getAttributeValue('action', trigger);
    }
    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultTarget",
    value: function defaultTarget(trigger) {
      var selector = getAttributeValue('target', trigger);

      if (selector) {
        return document.querySelector(selector);
      }
    }
    /**
     * Allow fire programmatically a copy action
     * @param {String|HTMLElement} target
     * @param {Object} options
     * @returns Text copied.
     */

  }, {
    key: "defaultText",

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */
    value: function defaultText(trigger) {
      return getAttributeValue('text', trigger);
    }
    /**
     * Destroy lifecycle.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listener.destroy();
    }
  }], [{
    key: "copy",
    value: function copy(target) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        container: document.body
      };
      return actions_copy(target, options);
    }
    /**
     * Allow fire programmatically a cut action
     * @param {String|HTMLElement} target
     * @returns Text cutted.
     */

  }, {
    key: "cut",
    value: function cut(target) {
      return actions_cut(target);
    }
    /**
     * Returns the support of the given action, or all actions if no action is
     * given.
     * @param {String} [action]
     */

  }, {
    key: "isSupported",
    value: function isSupported() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
      var actions = typeof action === 'string' ? [action] : action;
      var support = !!document.queryCommandSupported;
      actions.forEach(function (action) {
        support = support && !!document.queryCommandSupported(action);
      });
      return support;
    }
  }]);

  return Clipboard;
}((tiny_emitter_default()));

/* harmony default export */ var clipboard = (Clipboard);

/***/ }),

/***/ 828:
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(828);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 879:
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(879);
var delegate = __webpack_require__(438);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 817:
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(686);
/******/ })()
.default;
});

/***/ }),

/***/ "./node_modules/mobile-detect/mobile-detect.js":
/*!*****************************************************!*\
  !*** ./node_modules/mobile-detect/mobile-detect.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.5 2021-03-13*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
        "Pixel": "; \\bPixel\\b",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "Xiaomi": "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo (3DS|Switch)",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "OnePlus": "ONEPLUS",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "GoogleTablet": "Android.*Pixel C",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android [0-9.]+; [a-z-]+; \\bG1\\b",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9|TECNO DP8D",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
        "iPadOS": "CPU OS 13",
        "SailfishOS": "Sailfish",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "\\bEdgiOS\\b|Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "WeChat": "\\bMicroMessenger\\b",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UCBrowser": [
            "UCWEB[VER]",
            "UC.*Browser\/[VER]"
        ],
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "SailfishBrowser": "SailfishBrowser\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "Sailfish": "Sailfish [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    function prepareUserAgent(userAgent) {
        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = prepareUserAgent(userAgent);
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.4.5 2021-03-13';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if ( true && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (true) {
        return __webpack_require__(/*! !webpack amd define */ "./node_modules/webpack/buildin/amd-define.js");
    } else {}
})());

/***/ }),

/***/ "./node_modules/webpack/buildin/amd-define.js":
/*!***************************************!*\
  !*** (webpack)/buildin/amd-define.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/scripts/common/animate.js":
/*!***************************************!*\
  !*** ./src/scripts/common/animate.js ***!
  \***************************************/
/*! exports provided: animateCSS, ANIMATE_EFFECT */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateCSS", function() { return animateCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANIMATE_EFFECT", function() { return ANIMATE_EFFECT; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


const animateCSS = (element, animationName, callback) => {
  const isIE = _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isIE();
  const node = element instanceof String ? document.querySelector(element) : element;
  if (isIE) {
    $(node).addClass('animated');
    $(node).addClass(animationName);
  } else {
    node.classList.add('animated', animationName);
  }

  function handleAnimationEnd() {
    if (isIE) {
      $(node).removeClass('animated');
      $(node).removeClass(animationName);
    } else {
      node.classList.remove('animated', animationName);
      node.removeEventListener('animationend', handleAnimationEnd);
    }
    if (typeof callback === 'function') callback();
  }

  node.addEventListener('animationend', handleAnimationEnd);
};

const ANIMATE_EFFECT = Object.freeze({
  BOUNCE_IN_UP: 'bounceInUp',
  SLIDE_IN_UP: 'slideInUp',
  SLIDE_IN_DOWN: 'slideInDown',
  BOUNCE_IN_DOWN: 'bounceInDown',
  ZOOM_IN: 'zoomIn',
  FADE_IN: 'fadeIn',
  FADE_IN_UP: 'fadeInUp',
  FADE_OUT: 'fadeOut',
  FADE_OUT_DOWN: 'fadeOutDown',
  BOUNCE_IN: 'bounceIn'
});


/***/ }),

/***/ "./src/scripts/common/card.js":
/*!************************************!*\
  !*** ./src/scripts/common/card.js ***!
  \************************************/
/*! exports provided: CardComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardComponent", function() { return CardComponent; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class CardComponent {
    constructor() {

        var isMobile = $(window).outerWidth() < 1024;
        if (!isMobile) {
            $('.card-editorial').hover(
                (event) => {
                    this.handleHover(event.target, true);
                },
                (event) => {
                    this.handleHover(event.target, false);
                }
            );
        }

        $('.card-editorial, .cover-card-big, .cover-card').click(this.handleClick);
    }

    handleHover(el, inOut) {
        try {
            const yellowLine = $(el).hasClass('.card-editorial') ? $(el).find('i.dash') : $(el).parents('.card-editorial')
                .find('i.dash');
            if (yellowLine && yellowLine.length > 0) {
                if (inOut) {
                    yellowLine.addClass('active');
                } else {
                    yellowLine.removeClass('active');
                }
            } else {
                const cardsEditorialActiveDashes = $('.card-editorial').find('i.dash.active');
                if (cardsEditorialActiveDashes && cardsEditorialActiveDashes.length > 0) {
                    for (let i = 0; i < cardsEditorialActiveDashes.length; i++) {
                        const cardEditorialActiveDash = cardsEditorialActiveDashes[i];
                        $(cardEditorialActiveDash).removeClass('active');
                    }
                }
            }
            return false;
        } catch (ex) {

        }
    }

    handleClick(event) {

        // Carousel Publications - Prevent click when card is not centered/active
        if ($(event.target).parents('.card-editorial').length && $(event.target).parents(
                '.carousel-publications-container').length) {
            let carouselPublicationsCard = $(event.target).parents('.card-editorial');
            if ((carouselPublicationsCard.hasClass('publication-type') ||
                    carouselPublicationsCard.hasClass('press-release-type')) &&
                !carouselPublicationsCard.hasClass(
                    'carousel-center')) {
                event.preventDefault();
                return;
            }
        }

        if ($(event.target).hasClass('icon-share-small') || $(event.target).hasClass('btn-share')) {
            event.preventDefault();
            return;
        }

        let href, target;
        if ($(event.target).hasClass('external-link') || $(event.target.parentElement).hasClass('external-link')) {
            const a = $(event.target).parent('a');
            href = a.attr('href');
            target = a.attr('target');
        } else {
            href = $(event.currentTarget).attr('data-href');
            target = ( $(event.currentTarget).attr('data-target') ) ? $(event.currentTarget).attr('data-target') : '_self';
        }
        window.open(href, target);
    }
}

$(() => {
    const component = new CardComponent();
});

/***/ }),

/***/ "./src/scripts/common/carousel-utils.js":
/*!**********************************************!*\
  !*** ./src/scripts/common/carousel-utils.js ***!
  \**********************************************/
/*! exports provided: CarouselUtils */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselUtils", function() { return CarouselUtils; });
class CarouselUtils {

  constructor() {
    $(document).ready(() => {
      setTimeout(() => {
        $(".carousel-widget").find(".carousel-container").addClass("visible");
      }, 570);
    });
  }
}


$(() => {
  const component = new CarouselUtils();
});


/***/ }),

/***/ "./src/scripts/common/cookie-banner.js":
/*!*********************************************!*\
  !*** ./src/scripts/common/cookie-banner.js ***!
  \*********************************************/
/*! exports provided: CookieBanner */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CookieBanner", function() { return CookieBanner; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./src/scripts/common/utils.js");


class CookieBanner {
  constructor() {
    var banner = $("#eni-cookie-banner");
    var confirm = $(banner).find(".btn.confirm");
    var refuse = $(banner).find(".btn.refuse");

    var cookieName = "cookies-accepted"
    var cookie = this.getCookie(cookieName);
    console.log("Cookies cookie", cookie);
    if (!cookie) {
      $(banner).show();
    }

    $(confirm).click(() => {
      $(banner).hide();
      this.setCookie(cookieName, true, 50 * 365);
    });

    $(refuse).click(() => {
      $(banner).hide();
      this.setCookie(cookieName, false, 50 * 365);
    });

  }



  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }
}


$(() => {
  const component = new CookieBanner();
});


/***/ }),

/***/ "./src/scripts/common/datepicker_translations.js":
/*!*******************************************************!*\
  !*** ./src/scripts/common/datepicker_translations.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var DatepickerTranslations = function () {

  var italian = {
    monthsFull: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre',
      'Ottobre', 'Novembre', 'Dicembre'
    ],
    monthsShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    weekdaysFull: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
    weekdaysShort: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
    today: 'Oggi',
    clear: 'Cancella',
    close: 'Chiudi',
    format: 'd / m / yyyy',
    firstDay: 0,
    formatSubmit: 'dd/mm/yyyy',
    hiddenName: true,
    labelMonthNext: 'Mese successivo',
    labelMonthPrev: 'Mese precedente',
    labelMonthSelect: 'Seleziona un mese',
    labelYearSelect: 'Seleziona un anno'
  };

  var english = {
    monthsFull: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
      'November', 'December'
    ],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdaysFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    today: 'Oggi',
    clear: 'Clear',
    close: 'close',
    format: 'd / m / yyyy',
    firstDay: 0,
    formatSubmit: 'dd/mm/yyyy',
    hiddenName: true,
    labelMonthNext: 'Next month',
    labelMonthPrev: 'Previous month',
    labelMonthSelect: 'Select the month',
    labelYearSelect: 'Select the year',
  };

  return {
    italian: italian,
    english: english
  };
}();

module.exports = DatepickerTranslations;


/***/ }),

/***/ "./src/scripts/common/digital-data.js":
/*!********************************************!*\
  !*** ./src/scripts/common/digital-data.js ***!
  \********************************************/
/*! exports provided: DIGITAL, DigitalDataUtils */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIGITAL", function() { return DIGITAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DigitalDataUtils", function() { return DigitalDataUtils; });
const DIGITAL = {
  DATA_JSON_ID: 'data-jsnid'
};

class DigitalDataUtils {

  constructor(init) {

    if(init) {
      //Card External Link
      $('.card-external-link .cards-container a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Carousel Editorial Card - Carousel Editorial Big Card - Carousel Publication
      $('.card-editorial, .cover-card-big, .cover-card').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Carousel Event
      $('.card-event').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Carousel Category Card
      $('.carousel-category-card .category-card a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Contacts Carousel
      $('.contacts-carousel .contact-card a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Contacts Grid Three
      $('.contacts-grid .contact-card a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Carousel Corporate Card
      $('.corporate-carousel .card-corporate').on('click',(event) => {
        if($(event.target).hasClass('icon-arrow-right-small') || $(event.target).hasClass('cta-link')){
          return;
        }
        this.handleClickItem(event);
      });
      $('.corporate-carousel .card-corporate .cta-link').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Board of directors - Managers Card
      $('.managers-card .manager-item').on('click',(event) => {
        if($(event.target).hasClass('icon-arrow-right-small')){
          return;
        }
        this.handleClickItem(event);
      });
      $('.managers-card .manager-item .manager-arrow .icon-arrow-right-small').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Corporate Detail Launch
      $('.corporate-detail-launch .content-title a,.corporate-detail-launch a.btn-view').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Corporate generic Launch
      $('.corporate-generic-launch .content-type a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Editorial Content List - Filter press - Filter news
      $('.editorial-content-list .content-box a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Eni Headquarter Contact
      $('.headquarter-contacts .content-type a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Filter channel
      $('.filter-channel .icon-arrow-right-small').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Link Band
      $('.fascia-link .intro a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Grid Card 3
      $('.grid-card-3 .grid-card a').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.grid-card-3 .grid-card.link-card').on('click',(event) => {
        if ($(event.target).is('a')) {
          return;
        } else {
          this.handleClickItem(event);
        }
      });
      //Calendar
      $('.eni-calendar a.icon-add-calendar').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.eni-calendar .card-body a.external-link').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.eni-calendar .card-header .btn-link').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Editorial Collection Detail - Editorial Collection Highlight
      $('.editorial-collection-highlight .view-more-container').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.editorial-collection-highlight .description-container a').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.editorial-collection-highlight .content-type > a').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.editorial-collection-highlight .collection-col-right a.link').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Global Presence Card Country Grid Four
      $('.global-presence-card-country-grid-da-4 .card-country a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Global presence - Carousel Places
      $('.carousel-places .card-places a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Global Presence Project Highlight
      $('.global-presence-project-highlight .description-container a.eni-btn').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Global presence project highlight complex page
      $('.global-presence-project-highlight-complex-page-desktop .btn-view-more').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Numbers
      $('.carousel-numbers .card-number').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Full Video Image
      $('section.full-video-image-widget.yt-video').on('click',(event) => {
        this.handleClickItemVideo(event);
      });
      //Highlight Editorial Content
      $('.highlight-editorial-content').on('click',(event) => {
        if ($(event.currentTarget).hasClass('two-content')) {
          return;
        } else {
          this.handleClickItem(event);
        }
      });
      $('.highlight-editorial-content.two-content .highlight-2col').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Hero Banner Video
      $('.herobanner-video-widget .card--main a.eni-btn').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Manager Detail
      $('.manager-detail .content-container a').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.manager-detail .btn-view-more, .manager-detail .btn-view-less').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Publications List
      $('.publications-list-container .card-header .btn-link').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.publications-list-container .title-container a').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.publications-list-container .buttons-container a').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Media Highlight
      $('.media-highlight-widget.media-highlight-1col, .media-highlight-widget .media-highlight-2col').on('click',(event) => {
        if ($(event.currentTarget).hasClass('media-video-highlight')) {
          return;
        } else {
          this.handleClickItem(event);
        }
      });
      //Video Highlight
      $('section.media-video-highlight .video-box picture').on('click',(event) => {
        this.handleClickItemVideo(event);
      });
      //Hero banner homepage
      $('section.herobanner-homepage').on('click',(event) => {
        if($(event.target).hasClass('eni-btn')){
          return;
        }
        if($(event.target).hasClass('icon-arrow-right-small') || $(event.target).hasClass('arrow-link')){
          return;
        }
        this.handleClickItem(event);
      });
      $('section.herobanner-homepage a.eni-btn').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Event Hightlight countdown
      $('section.event-highlight-countdown').on('click',(event) => {
        if($(event.target).hasClass('eni-btn')){
          return;
        }
        if($(event.target).hasClass('icon-arrow-right-small') || $(event.target).hasClass('arrow-link')){
          return;
        }
        this.handleClickItem(event);
      });
      $('section.event-highlight-countdown a.eni-btn').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Event Hightlight
      $('section.event-highlight').on('click',(event) => {
        if($(event.currentTarget).hasClass('double')){
          return;
        }
        this.handleClickItem(event);
      });
      $('section.event-highlight.double .section-content').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Opportunità professionali
      $('.job-opportunities-container a.job-opportunity-card').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Media Collection Detail Cover
      $('.media-detail-cover .playlist-container .drawer-btn').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.media-detail-cover .playlist-details .content-detail-item a').on('click',(event) => {
        this.handleClickItem(event);
      });
      $('.media-detail-cover .playlist-image, .media-detail-cover .playlist-detail-title').on('click',(event) => {
        if ($(event.currentTarget).attr('data-yt-index')) {
          this.handleClickItemVideo(event);
        } else {
          this.handleClickItem(event);
        }
      });
       //Single Video
       $('section.single-image-video .video-container .overlay-video').on('click',(event) => {
        this.handleClickItemVideo(event);
      });
       //Gallery Video
       $('section.photo-gallery-widget .photo-gallery-item.mfp-iframe').on('click',(event) => {
        this.handleClickItemVideo(event);
      });
      


      /*Link comuni*/
      //carousel-link
      $('.carousel-link').on('click',(event) => {
        this.handleClickItem(event);
      });
      //arrow-link
      $('.arrow-link').on('click',(event) => {
        this.handleClickItem(event);
      });
      //view-more-box
      $('.view-more-box button').on('click',(event) => {
        this.handleClickItem(event);
      });
      //Download transcript
      $('.icon-transcript-container a').on('click',(event) => {
        this.handleClickItem(event);
      });
    }
  }

  handleClickItemVideo(event){
    if ($(event.target).hasClass('icon-share-small') || $(event.target).hasClass('btn-share')) {
      event.preventDefault();
      return;
    }
    let target = $( event.currentTarget );
    console.log(target);
    let jsnid = target.attr(DIGITAL.DATA_JSON_ID);
    console.log('jsnid: %s',jsnid);

    if(jsnid && jsnid.length > 0 ) {
      let digitalDataJson = "";
      try{
        digitalDataJson = eval(jsnid);
      }
      catch(ex){}
      if(digitalDataJson) {
        let href = target.attr('data-href') || target.attr('data-url') || target.attr('data-mfp-src') || '';
        console.log('href: %s',href);
        if (href.charAt(0) === "/") {
          href = window.location.origin + href;
        }
        digitalDataJson.pageEvent.eventInfo.contentURL = href;
        let eventType = 'click-video';
        digitalDataJson.event = eventType;    
        digitalDataJson.pageEvent.eventInfo.eventDetail = 'Play';
        digitalDataJson.pageEvent.eventInfo.ctaLabel = '';

        console.log(digitalDataJson);
        try{
          window.digitalData.push(digitalDataJson);
        }
        catch(ex){}
      }
    }
  }

  handleClickItemFilter(currentFilter){
  
    let jsnid = currentFilter.attr(DIGITAL.DATA_JSON_ID);
    console.log('jsnid: %s',jsnid);

    if(jsnid && jsnid.length > 0 ) {
      let digitalDataJson = "";
      try{
        digitalDataJson = eval(jsnid);
      }
      catch(ex){}
      if(digitalDataJson) {
        digitalDataJson.pageEvent.eventInfo.ctaLabel = '';
        console.log(digitalDataJson);
        try{
          window.digitalData.push(digitalDataJson);
        }
        catch(ex){}
      }
    }
  }

  static handleClickItemFormatVideo(item){
  
    let jsnid = item.attr(DIGITAL.DATA_JSON_ID);
    console.log('jsnid: %s',jsnid);

    if(jsnid && jsnid.length > 0 ) {
      let digitalDataJson = "";
      try{
        digitalDataJson = eval(jsnid);
      }
      catch(ex){}
      if(digitalDataJson) {
        let href = item.attr('data-href') || item.attr('data-url') || '';
        console.log('href: %s',href);
        if (href.charAt(0) === "/") {
          href = window.location.origin + href;
        }
        digitalDataJson.pageEvent.eventInfo.contentURL = href;
        let eventType = 'click-video';
        digitalDataJson.event = eventType;    
        digitalDataJson.pageEvent.eventInfo.eventDetail = 'Play';
        digitalDataJson.pageEvent.eventInfo.ctaLabel = '';

        console.log(digitalDataJson);
        try{
          window.digitalData.push(digitalDataJson);
        }
        catch(ex){}
      }
    }
  }

  handleClickItem(event) {

    //lo share è gestito in share.js
    if ($(event.target).hasClass('icon-share-small') || $(event.target).hasClass('btn-share')) {
      event.preventDefault();
      return;
    }
    let target = $( event.currentTarget );
    console.log(target);
    let jsnid = target.attr(DIGITAL.DATA_JSON_ID);
    console.log('jsnid: %s',jsnid);

    if(jsnid && jsnid.length > 0 ) {
      let digitalDataJson = "";
      try{
        digitalDataJson = eval(jsnid);
      }
      catch(ex){}

      if(digitalDataJson) {
        let href = target.attr('href') || target.attr('data-href') || target.attr('data-url') || '';
        console.log('href: %s',href);
        let eventType = this.getEventType(target, href);
        let eventDetail = this.getEventDetail(eventType);
        if (href.charAt(0) === "/") {
          href = window.location.origin + href;
        }
        digitalDataJson.pageEvent.eventInfo.contentURL = href;
        digitalDataJson.event = eventType;    
        digitalDataJson.pageEvent.eventInfo.eventDetail = eventDetail;
        digitalDataJson.pageEvent.eventInfo.ctaLabel = '';

        if (eventType == 'click-download') {
          
          let fileExt = href.split('.').pop();
          if(href.endsWith("calendars.zip") || fileExt == 'ics')
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Calendar';
          else if(href.endsWith("transcript.txt"))
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Transcript';
          else if(fileExt == 'jpg' || fileExt == 'png')
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Image';
          else if(fileExt == 'docx' || fileExt == 'doc')
            digitalDataJson.event.eventInfo.eventDetail = 'Doc';
          else if(fileExt == 'xlsx' || fileExt == 'xls')
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Excel';
          else if(fileExt == 'pptx' || fileExt == 'ppt')
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Presentation';
          else if(fileExt == 'pdf')
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'PDF';
          else if(fileExt == 'zip')
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Zip';
          else 
            digitalDataJson.pageEvent.eventInfo.eventDetail = fileExt;
        }

        if (eventType == 'click-accordion') {
          if(target.attr('aria-expanded') == 'true' || target.hasClass('view-less') || (!target.parent().hasClass('closed') && target.parent().hasClass('playlist-container')))
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Close';
          else 
            digitalDataJson.pageEvent.eventInfo.eventDetail = 'Open';
        }
        
        //CTAlabel
        if(target.hasClass('btn-view') || target.hasClass('eni-btn') || target.hasClass('arrow-link') || target.hasClass('carousel-link') || target.hasClass('view-less') || target.hasClass('view-more') || target.hasClass('btn-view-less') || target.hasClass('btn-view-more') || target.hasClass('cta-link') || target.hasClass('drawer-btn')){ 
          digitalDataJson.pageEvent.eventInfo.ctaLabel = target[0].innerText;
        }
        if(target.hasClass('job-opportunity-card')){
          digitalDataJson.pageEvent.eventInfo.ctaLabel = target.find('h3')[0].innerText;
        }
        
        console.log(digitalDataJson);
        try{
          window.digitalData.push(digitalDataJson);
        }
        catch(ex){}
      }
    }
  }
  
  getEventType(target, href){
    const regex = new RegExp("(.*?)\.(docx|doc|pdf|xls|xlsx|ppt|zip|ics|png|jpg|txt)$");
    let eventType = '';
    if(href.startsWith('http'))
      eventType = 'click-link-external';
    else if(regex.test(href))
      eventType = 'click-download';
    else if(target.hasClass('btn-view') || target.hasClass('arrow-link') || target.hasClass('carousel-link') || target.hasClass('eni-btn') || target.hasClass('icon-arrow-right-small') || target.hasClass('cta-link') )
      eventType = 'click-cta';
    else if(target.hasClass('btn-link') || target.hasClass('view-more') || target.hasClass('view-less') || (target.hasClass('btn-view-more') && target.is('button')) || (target.hasClass('btn-view-less') && target.is('button')) || target.hasClass('drawer-btn')) 
      eventType = 'click-accordion';
    else if(href.startsWith('tel:'))
      eventType = 'click-tel';
    else if(href.startsWith('mailto:'))
      eventType = 'click-mail-to';
    else 
      eventType = 'click-link';

    return eventType;
  }

  getEventDetail(eventType){
    let eventDetail;
    switch (eventType) {
      case 'click-link-external':
        eventDetail='Link External';
        break;
      case 'click-cta':
        eventDetail='Cta';
        break;
      case 'click-tel':
        eventDetail='Telephone';
        break;
      case 'click-mail-to':
        eventDetail='Mail to';
        break;
      case 'click-link':
        eventDetail='Link';
        break;
    }
    return eventDetail;
  }

}
$(() => {
  const component = new DigitalDataUtils(true);
});

/***/ }),

/***/ "./src/scripts/common/eni-tales.js":
/*!*****************************************!*\
  !*** ./src/scripts/common/eni-tales.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(function () {

  $(".icon-close-small").on("click", function () {
    $("#eni-tales-banner").hide();
  });

});


/***/ }),

/***/ "./src/scripts/common/filters-util.js":
/*!********************************************!*\
  !*** ./src/scripts/common/filters-util.js ***!
  \********************************************/
/*! exports provided: FiltersUtil */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FiltersUtil", function() { return FiltersUtil; });
/* harmony import */ var _common_datepicker_translations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/datepicker_translations */ "./src/scripts/common/datepicker_translations.js");
/* harmony import */ var _common_datepicker_translations__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_common_datepicker_translations__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");
/* harmony import */ var _common_digital_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/digital-data */ "./src/scripts/common/digital-data.js");




class FiltersUtil {
  constructor() {

    // Dropdown Filters in page
    const dropdowns = $('.eni-filters .dropdown.filter');
    if (dropdowns && dropdowns.length > 0) {
      for (let i = 0; i < dropdowns.length; i++) {
        const dataFilter = $(dropdowns[i]).data('filter');
        const dataTargetContainer = $(dropdowns[i]).data('target-container');
        const dataTargetElementClass = $(dropdowns[i]).data('target-element-class');

        const filterButton = $(dropdowns[i]).children('.dropdown-toggle');
        const dropdownButtonsListContainer = $(dropdowns[i]).children('.dropdown-menu');
        const dropdownButtons = $(dropdownButtonsListContainer).children('button.dropdown-item');

        if (dropdownButtons && dropdownButtons.length > 0) {
          for (let i = 0; i < dropdownButtons.length; i++) {

            
            // Map click of dropdown element
            $(dropdownButtons[i]).on('click', (e) => {

              const currentTarget = e.currentTarget;
              const currentSection = $(currentTarget).parents('section');

              //const currentFilter = $(currentTarget).parents('.dropdown.filter');
              //const ddutils = new DigitalDataUtils()
              //ddutils.handleClickItemFilter(currentFilter);

              // Update main button with new label
              const dropdownButtonText = $(currentTarget).text();
              $(filterButton).text(_common_utils__WEBPACK_IMPORTED_MODULE_1__["default"].truncateDropdownButtonText(dropdownButtonText));

              // Update item with active class and remove active from others (if present)
              const actualDropdownActiveButton = $(currentTarget.parentElement).children(
                'button.dropdown-item.active');
              if (actualDropdownActiveButton && actualDropdownActiveButton.length > 0) {
                $(actualDropdownActiveButton).removeClass('active');
              }
              $(currentTarget).addClass('active');

              const dataFilterValue = $(currentTarget).attr(dataFilter);

              this.prepareFiltersToApply(
                'dropdown', currentSection, dataTargetContainer, currentTarget, dataFilter, dataFilterValue,
                dataTargetElementClass);
            });
          }
        }
      }
    }

    // Calendar Filters in page
    const calendars = $('.eni-filters .calendar.filter');
    if (calendars && calendars.length > 0) {
      for (let i = 0; i < calendars.length; i++) {
        const dataFilter = $(calendars[i]).data('filter');
        const dataTargetContainer = $(calendars[i]).data('target-container');
        const dataTargetElementClass = $(calendars[i]).data('target-element-class');
        const calendarLanguage = $(calendars[i]).data('language');

        const calendar = $(calendars[i]).children('.datepicker');
        const calendarFilterIcon = $(calendars[i]).children('.icon-calendar-filter');
        const currentSection = $(calendars[i]).parents('section');
        const currentTarget = calendars[i];

        let calendarLanguageConfig = calendarLanguage === 'ita' ? _common_datepicker_translations__WEBPACK_IMPORTED_MODULE_0___default.a.italian :
          _common_datepicker_translations__WEBPACK_IMPORTED_MODULE_0___default.a.english;

        // const calendarConfig =
        // Object.assign({}, calendarLanguageConfig,
        //   {
        //   onOpen: (() => $(calendarFilterIcon).addClass('active')),
        //   onClose: (() => $(calendarFilterIcon).removeClass('active')),
        //   onSet: ((e) => e && e.select ? this.prepareFiltersToApply(
        //     'calendar', currentSection, dataTargetContainer, currentTarget, dataFilter,
        //     Utils.convertDateForCalendars(e.select, dataFilter === 'data-date-from' ? true : false, true),
        //     dataTargetElementClass, true) : null)
        //   });


        const calendarConfig = {
          ...calendarLanguageConfig,
          onOpen: (() => $(calendarFilterIcon).addClass('active')),
          onClose: (() => $(calendarFilterIcon).removeClass('active')),
          onSet: ((e) => e && e.select ? this.prepareFiltersToApply(
            'calendar', currentSection, dataTargetContainer, currentTarget, dataFilter,
            _common_utils__WEBPACK_IMPORTED_MODULE_1__["default"].convertDateForCalendars(e.select, dataFilter === 'data-date-from' ? true : false, true),
            dataTargetElementClass, true) : null),
        };

        const calendarIntance = $(calendar).pickadate(calendarConfig);

        $(calendarFilterIcon).on('click', (e) => {

          // Open pickadate with api method (causes multiple opened filter at same time when dropdown is opened)

          // Close all opened section calendar instances (done automatically whenl clicked on imput instead icon)
          /* const allSectionCalendarInstances = $(currentSection).find('.picker__input.picker__input--active');
          if (allSectionCalendarInstances && allSectionCalendarInstances.length > 0) {
            for (let index = 0; index < allSectionCalendarInstances.length; index++) {
              const otherOpenedCalendarInstance = allSectionCalendarInstances[index];
              $(otherOpenedCalendarInstance).pickadate().pickadate("picker").close();
            }
          }
          // Open calendar
          $(calendarIntance).pickadate("picker").open();

          // If a “click” is involved, prevent the event bubbling.
          e.stopPropagation();
          */

          // Open pickadate with click trigger (causes multiple opened filter at same time when dropdown is opened)

          if (!$(calendarFilterIcon).hasClass('active')) {
            setTimeout(function () {
              $(calendar).click();
            }, 0);
          }
        });
      }
    }

    const checkboxs = $('.eni-filters .checkbox.filter');
    if (checkboxs && checkboxs.length > 0) {
      for (let i = 0; i < checkboxs.length; i++) {
        const currentSection = $(checkboxs[i]).parents('section');
        const currentTarget = $(checkboxs[i]);
        const dataFilter = $(checkboxs[i]).data('filter');
        const dataTargetContainer = $(checkboxs[i]).data('target-container');
        const dataTargetElementClass = $(checkboxs[i]).data('target-element-class');

        const checkboxInput = $(checkboxs[i]).find("input[type=checkbox]");
        console.log(checkboxInput);
        $(checkboxInput).on('change', (e) => {
          console.log(e);
          var self = $(e.currentTarget);
          let dataFilterValue = '0';
          if (self.is(":checked")) {
            dataFilterValue = '1';
          } else {
            dataFilterValue = 'all';
          }

          this.prepareFiltersToApply(
            'checkbox', currentSection, dataTargetContainer, currentTarget, dataFilter, dataFilterValue,
            dataTargetElementClass);
        });


        // Apply checkbox filter after load page because unchecked checkbox has value 0
        /* if (!this.checkSearchFilters(currentSection)) {
          this.prepareFiltersToApply(
            'checkbox', currentSection, dataTargetContainer, currentTarget, dataFilter, '0', dataTargetElementClass);
        } */
      }
    }

    // Reset Buttons in page
    const resetFilterContainers = $('.eni-filters .reset-filters-container');
    if (resetFilterContainers && resetFilterContainers.length > 0) {
      for (let i = 0; i < resetFilterContainers.length; i++) {

        const resetFilterButton = $(resetFilterContainers[i]).children('.btn.btn-reset-filters');
        $(resetFilterButton).on('click', (e) => {
          const currentSection = $(e.currentTarget).parents('section');

          // All filters in page
          const allFilters = $(currentSection).find('.eni-filters .filter');

          const dataTargetContainer = $(resetFilterContainers[i]).data('target-container');
          const dataTargetElementClass = $(resetFilterContainers[i]).data('target-element-class');

          this.resetFilters(allFilters, currentSection, dataTargetContainer, dataTargetElementClass);
        });
      }
    };
  }

  checkFEPaginator(currentSection, dataTargetContainer) {
    const currentSectionPaginator = $(currentSection).find('.tt-paginator-container');
    const paginatorContainer = $(currentSection).find(dataTargetContainer);
    if (currentSectionPaginator && currentSectionPaginator.length > 0) {
      const paginatorContainerDataAjax = $(paginatorContainer).data('ajax');
      if (paginatorContainerDataAjax && paginatorContainerDataAjax === true) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  checkSearchFilters(currentSection) {
    const searchSection = $("section.search-template-filters");
    if (searchSection && searchSection.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  checkCalendarWidgetFilters(currentSection) {
    const calendarSection = $(currentSection).hasClass("eni-calendar");
    if (calendarSection) {
      return true;
    } else {
      return false;
    }
  }

  resetAjaxPaginator(currentSection, dataTargetContainer, arrayFiltersToBeApplied) {
    const currentSectionPaginator = $(currentSection).find('.tt-paginator-container');
    const paginatorContainer = $(currentSection).find(dataTargetContainer);
    if (currentSectionPaginator && currentSectionPaginator.length > 0) {
      // Do a new call for applied filters when there is be paginator
      $(paginatorContainer).ttPaginator({
        ajax: true,
        filters: arrayFiltersToBeApplied
      }, 'setFilters');
      return;
    }
  }

  getAllFiltersWithSameDataTargetElementClass(allFilters, dataFilter, dataTargetElementClass) {
    const arrayOthersFiltersToBeApplied = [];
    const otherFiltersWithSameDataTarget = [];

    for (let i = 0; i < allFilters.length; i++) {

      const otherFilterWithSameDataTarget = allFilters[i];

      switch ($(otherFilterWithSameDataTarget).data('filter-type')) {
        case 'dropdown':
          // Exclude current filter and push into array other filters
          if (!$(otherFilterWithSameDataTarget).hasClass('show') &&
            $(otherFilterWithSameDataTarget).data('filter') !== dataFilter &&
            $(otherFilterWithSameDataTarget).data('target-element-class') ===
            dataTargetElementClass) {

            otherFiltersWithSameDataTarget.push(otherFilterWithSameDataTarget);

            const otherFilterWithSameDataTargetDataFilter = $(otherFilterWithSameDataTarget).data('filter');
            const otherFilterWithSameDataTargetActive = $(otherFilterWithSameDataTarget).find(
              '.dropdown-item.active');
            const otherFilterWithSameDataTargetFilterKey = $(otherFilterWithSameDataTarget).data('filter');
            const otherFilterWithSameDataTargetFilterValue = $(otherFilterWithSameDataTargetActive)
              .attr(otherFilterWithSameDataTargetDataFilter);

            arrayOthersFiltersToBeApplied.push({
              key: otherFilterWithSameDataTargetFilterKey,
              value: otherFilterWithSameDataTargetFilterValue,
              type: 'dropdown'
            });
          }
          break;

        case 'calendar':

          // Exclude current filter and push into array other filters
          if (!$(otherFilterWithSameDataTarget).children('.picker__input').hasClass('picker__input--active') &&
            $(otherFilterWithSameDataTarget).data('filter') !== dataFilter &&
            $(otherFilterWithSameDataTarget).data('target-element-class') ===
            dataTargetElementClass) {



            otherFiltersWithSameDataTarget.push(otherFilterWithSameDataTarget);

            const otherFilterWithSameDataTargetFilterKey = $(otherFilterWithSameDataTarget).data('filter');
            const otherFilterWithSameDataTargetValueInput = $(otherFilterWithSameDataTarget)
              .children('input[type=hidden]');
            const otherFilterWithSameDataTargetValue = $(otherFilterWithSameDataTargetValueInput).val();

            arrayOthersFiltersToBeApplied.push({
              key: otherFilterWithSameDataTargetFilterKey,
              value: otherFilterWithSameDataTargetValue === '' ? 'all' : _common_utils__WEBPACK_IMPORTED_MODULE_1__["default"].convertDateForCalendars(
                otherFilterWithSameDataTargetValue, otherFilterWithSameDataTargetFilterKey ===
                'data-date-from' ? true : false, false),
              type: 'calendar'
            });
          }
          break;

        case 'checkbox':
          // Exclude current filter and push into array other filters
          if ($(otherFilterWithSameDataTarget).data('filter') !== dataFilter &&
            $(otherFilterWithSameDataTarget).data('target-element-class') ===
            dataTargetElementClass) {

            otherFiltersWithSameDataTarget.push(otherFilterWithSameDataTarget);
            const otherFilterWithSameDataTargetFilterKey = $(otherFilterWithSameDataTarget).data('filter');
            const otherFilterWithSameDataTargetInput = $(otherFilterWithSameDataTarget).find("input[type=checkbox]");
            console.log($(otherFilterWithSameDataTargetInput).is(":checked"));
            const otherFilterWithSameDataTargetFilterValue = $(otherFilterWithSameDataTargetInput).is(":checked") ?
              '1' : 'all';
            arrayOthersFiltersToBeApplied.push({
              key: otherFilterWithSameDataTargetFilterKey,
              value: otherFilterWithSameDataTargetFilterValue,
              type: 'checkbox'
            });
          }
          break;

        default:
          break;
      }
    }

    return arrayOthersFiltersToBeApplied;

  }

  checkAccordions(currentSection) {
    const currentSectionAccordions = $(currentSection).find('.accordion.accordion-container');
    if (currentSectionAccordions && currentSectionAccordions.length > 0) {
      for (let i = 0; i < currentSectionAccordions.length; i++) {
        const currentSectionAccordion = currentSectionAccordions[i];

        // Find all accordion detail items and check if all of them have hidden class
        const accordionDetailItems = $(currentSectionAccordion).find('.accordion-detail-item');
        let hiddenDetailItemsLength = 0;
        if (accordionDetailItems && accordionDetailItems.length > 0) {
          for (let i = 0; i < accordionDetailItems.length; i++) {
            if ($(accordionDetailItems[i]).css('display') === 'none') {
              hiddenDetailItemsLength++;
            }
          }
          if (accordionDetailItems.length === hiddenDetailItemsLength) {
            $(currentSectionAccordion).hide();
          } else {
            $(currentSectionAccordion).show();
          }
        }
      }
    }
  }

  /* manageYearFilter(currentSection, arrayFiltersToBeApplied) {
    if ($(currentSection).hasClass('calendar-filters')) {
      arrayFiltersToBeApplied.find(
        filterApplied.key === 'data-year'
      );
    }
  } */

  resetCurrentSectionPaginator(currentSection, dataTargetContainer) {
    const currentSectionPaginator = $(currentSection).find('.tt-paginator-container');
    const paginatorContainer = $(currentSection).find('[data-pagination="true"]');
    if (currentSectionPaginator && currentSectionPaginator.length > 0) {
      $(paginatorContainer).ttPaginator(null, 'reinit');
    }
  }

  changeFilterValue(arrayFiltersToBeApplied, filterKey, filterValue) {
    for (let i = 0; i < arrayFiltersToBeApplied.length; i++) {
      const element = arrayFiltersToBeApplied[i];
      if (element.key === filterKey) {
        element.value = filterValue;
      }
    }
  }

  changeDropdownFilterValue(dropdownButton, value) {

    const optionButton = $(dropdownButton).parents().children('.dropdown-menu').children(
      '.dropdown-item[data-type="' + value + '"]');
    const optionButtonText = $(optionButton).text();

    // Update main button with new label
    $(dropdownButton).text(optionButtonText);

    // Update item with active class and remove active from others (if present)
    const actualDropdownActiveButton = $(dropdownButton).parents().children('.dropdown-menu').children(
      '.dropdown-item.active');
    if (actualDropdownActiveButton && actualDropdownActiveButton.length > 0) {
      $(actualDropdownActiveButton).removeClass('active');
    }
    $(optionButton).addClass('active');


  }

  prepareFiltersToApply(filterType, currentSection, dataTargetContainer, currentTarget, dataFilter, dataFilterValue,
    dataTargetElementClass) {

    //digital data push  
    const ddutils = new _common_digital_data__WEBPACK_IMPORTED_MODULE_2__["DigitalDataUtils"]();
    if(filterType === 'dropdown')
      ddutils.handleClickItemFilter($(currentTarget).parents('.dropdown.filter'));
    else if(filterType === 'calendar')
      ddutils.handleClickItemFilter($(currentTarget));

    // All filters in page
    const allFilters = $(currentSection).find('.eni-filters .filter');

    // Check all other filters that have same dataTargetElementClass and get its pair of key value, based on filter type
    let arrayFiltersToBeApplied = [];

    if (allFilters && allFilters.length > 1) {

      const getAllFiltersWithSameDataTargetElementClassResponse =
        this.getAllFiltersWithSameDataTargetElementClass(
          allFilters, dataFilter, dataTargetElementClass, filterType);

      if (getAllFiltersWithSameDataTargetElementClassResponse &&
        getAllFiltersWithSameDataTargetElementClassResponse.length > 0) {
        arrayFiltersToBeApplied = getAllFiltersWithSameDataTargetElementClassResponse;
      }
    }

    // Data filter of current clicked button to apply
    const dataFilterKeyToApply = dataFilter;
    const dataFilterValueToApply = dataFilterValue;
    const dataFilterType = filterType;

    arrayFiltersToBeApplied.push({
      key: dataFilterKeyToApply,
      value: dataFilterValueToApply,
      type: dataFilterType
    });

    const areSearchFilters = this.checkSearchFilters(currentSection);
    const areCalendarFilers = this.checkCalendarWidgetFilters(currentSection);

    if (areSearchFilters) {
      console.log("Search Section found! Full back end filters in use.");
      if (!(arrayFiltersToBeApplied && arrayFiltersToBeApplied.length > 0)) {
        const arrayFiltersToBeApplied = [];
      }
      this.applyFBEFilters(arrayFiltersToBeApplied);

    } else {
      // Check if there is front end paginator
      const isThereFEPaginator = this.checkFEPaginator(currentSection, dataTargetContainer);
      if (!isThereFEPaginator) {
        this.resetAjaxPaginator(currentSection, dataTargetContainer, arrayFiltersToBeApplied);
      }

      // If calendar filters apply specific handling to type related filter
      if (areCalendarFilers) {
        const yearFilter = arrayFiltersToBeApplied.find(filterToBeApplied => filterToBeApplied.key === 'data-date');
        const typeFilter = arrayFiltersToBeApplied.find(filterToBeApplied => filterToBeApplied.key === 'data-type');
        console.log('yearFilter', yearFilter);
        console.log('typeFilter', typeFilter);
        const selectedYear = parseInt(yearFilter.value) ? parseInt(yearFilter.value) : yearFilter.value;
        const currentYear = (new Date()).getFullYear();

        const typeFilterEl = $(currentSection).find('[data-filter="data-type"]');
        const typeFilterElButton = $(typeFilterEl).children('.dropdown-toggle');

        if (selectedYear !== 'all' && selectedYear !== currentYear) {
          if (typeFilterElButton && typeFilterElButton.length > 0) {
            // Apply past or future value
            // Edit arrayFiltersToBeApplied changing value of data-type from 'all' to 'past' or 'future'
            typeFilter.value = parseInt(selectedYear) < currentYear ? 'past' : 'future';
            this.changeDropdownFilterValue(typeFilterElButton, typeFilter.value);

            // Make readonly (if not yet)
            $(typeFilterElButton).prop('disabled', true);
          }
        } else if ($(currentTarget).data('date') &&
          $(currentTarget).data('date').toString() &&
          $(currentTarget).data('date').toString().length > 0) {
          // Remove readonly (if already)
          console.log('currentTarget', currentTarget);
          $(typeFilterElButton).prop('disabled', false);
          this.changeDropdownFilterValue(typeFilterElButton, 'all');
          this.changeFilterValue(arrayFiltersToBeApplied, 'data-type', 'all');
        }
      };

      // Apply filter to target elements to dataTargetContainer -> dataTargetContainer only for fe paginator
      this.applyFilter(currentSection, dataTargetContainer, dataTargetElementClass, arrayFiltersToBeApplied,
        filterType);
    }
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  applyFBEFilters(arrayFiltersToBeApplied) {
    var oldUrl = window.location.href;
    var currentUrl = oldUrl.split('?')[0];
    var urlFilters = [];
    var paramsToKeep = ["query", "tab", "page", "wcmmode", "question", "onlytab"];

    for (var i = 0; i < arrayFiltersToBeApplied.length; i++) {
      const key = arrayFiltersToBeApplied[i].key;
      const value = arrayFiltersToBeApplied[i].value;
      if (value && value.toString().length > 0 && value != "all" && value != 0) {
        urlFilters.push({
          key: key,
          value: value,
          type: arrayFiltersToBeApplied[i].type
        });
      }
    }

    for (var i = 0; i < paramsToKeep.length; i++) {
      var paramValue = this.getUrlParameter(paramsToKeep[i]);
      if (paramValue) {
        urlFilters.push({
          key: paramsToKeep[i],
          value: paramValue,
          type: "urlParamToKeep"
        });
      }
    }


    if (currentUrl[currentUrl.length - 1] != "?") {
      currentUrl += "?";
    }

    for (var i = 0; i < urlFilters.length; i++) {
      currentUrl += urlFilters[i].key + "=" + urlFilters[i].value + "&";
    }

    const urlLastChar = currentUrl[currentUrl.length - 1];
    if (urlLastChar == "&") {
      currentUrl = currentUrl.substring(0, currentUrl.length - 1);
    }
    window.location = currentUrl;
  }

  applyFilter(currentSection, dataTargetContainer, dataTargetElementClass, arrayFiltersToBeApplied) {
    const arrayFilterKeys = [];
    for (let index = 0; index < arrayFiltersToBeApplied.length; index++) {
      arrayFilterKeys.push(arrayFiltersToBeApplied[index].key);
    }

    try {
      const dataTargetElements = $(currentSection).find(dataTargetContainer + ' ' + dataTargetElementClass)
        .not('accordion-container'); // Avoid considering accordion container items as filterable elements
      const isCalendarWidget = this.checkCalendarWidgetFilters(currentSection);
      if (dataTargetElements && dataTargetElements.length > 0) {
        for (let i = 0; i < dataTargetElements.length; i++) {

          // Save into an array all filter value of item and compare with filter array, then apply hidden/show based on array of differences
          const arrayElementFilterDataValues = [];

          for (let index = 0; index < arrayFiltersToBeApplied.length; index++) {
            const filterToBeApplied = arrayFiltersToBeApplied[index];
            const filterKey = filterToBeApplied.key;
            const filterType = filterToBeApplied.type;

            if ((filterKey === 'data-type') && isCalendarWidget) {
              const currentYear = (new Date()).getFullYear();
              const hasTargetElementYearDataAttribute = $(dataTargetElements[i]).attr('data-date') &&
                $(dataTargetElements[i]).attr('data-date').toString().length > 0;

              arrayElementFilterDataValues.push({
                key: filterKey,
                value: hasTargetElementYearDataAttribute ? $(dataTargetElements[i]).attr('data-date') : 'all'
              });
            } else {
              arrayElementFilterDataValues.push({
                key: filterKey,
                /* value: $(dataTargetElements[i]).attr(filterType) === 'calendar' ? 'data-date' : (
                  $(dataTargetElements[i]).attr(filterType) === 'type' ? 'data-year' : filterKey
                ) */
                value: $(dataTargetElements[i]).attr(filterType === 'calendar' ? 'data-date' : filterKey)
              });
            }
          }

          const currentYear = (new Date()).getFullYear();

          let arrayFilterDifferences = arrayFiltersToBeApplied.filter(
            o1 => arrayElementFilterDataValues.some(
              o1.type === 'calendar' ?
              (o2 => o1.key === 'data-date-from' ?
                (o1.value === 'all' || o1.key === o2.key && parseInt(o1.value) < parseInt(o2.value)) :
                (o1.value === 'all' || o1.key === o2.key && parseInt(o1.value) > parseInt(o2.value))) :

              (

                o1.type === 'dropdown' && o1.key === 'data-type' && isCalendarWidget ?
                (o2 => o1.value === 'all' || (o1.value === 'past' ? parseInt(o2.value) < (new Date()).valueOf() :
                  (new Date()).valueOf() < parseInt(o2.value))) :

                (
                  o1.type === 'dropdown' && o1.key === 'data-date' && isCalendarWidget ?
                  (o2 => o1.value === 'all' || parseInt(o1.value) === (new Date(parseInt(o2.value)))
                    .getFullYear()) :

                  o2 => o1.value === 'all' || o1.key === o2.key &&
                  (o2.value && Array.isArray(o2.value.split(',')) ? o2.value.split(',').includes(o1.value) : o1
                    .value === o2.value)
                )
              )
            ));

          console.log('arrayFilterDifferences', arrayFilterDifferences);

          // Check if dataTargetElement has card-project-filters class, so apply filter to parent container
          let finalTargetElement = $(dataTargetElements[i]).hasClass('card-project-filters') ?
            $(dataTargetElements[i]).parent('.card-container') : $(dataTargetElements[i]);

          if ($(dataTargetElements[i]).hasClass('card-project-filters')) {
            let finalTargetElement = $(dataTargetElements[i]).parent('.card-container');
            if (arrayFiltersToBeApplied.length !== arrayFilterDifferences.length) {
              console.log('finalTargetElement', finalTargetElement);
              $(finalTargetElement).attr('style', 'display: none !important');
              $(finalTargetElement).addClass('filtered');
            } else {
              $(finalTargetElement).css('display', '');
              $(finalTargetElement).removeClass('filtered');
            }
          } else {
            const finalTargetElementList = $(dataTargetElements[i]);
            if (arrayFiltersToBeApplied.length !== arrayFilterDifferences.length) {
              $(finalTargetElementList).attr('style', 'display: none !important');
              $(finalTargetElementList).parents().addClass('filtered');
            } else {
              $(finalTargetElementList).css('display', '');
              $(finalTargetElementList).parents().removeClass('filtered');
            }
          }


        }
      }

      // Check if accordion items are filtered so hide all accordion container if all child elements are hidden
      this.checkAccordions(currentSection);

      // Reset paginator (if available in current section)
      this.resetCurrentSectionPaginator(currentSection, dataTargetContainer);

      // Manage border bottom of last publication items and children accordion elements
      _common_utils__WEBPACK_IMPORTED_MODULE_1__["default"].managePublicationListsBorders(currentSection);

    } catch (error) {
      console.log(error);
    }
  }

  resetFilters(allFilters, currentSection, dataTargetContainer, dataTargetElementClass) {
    const arrayFiltersToReset = [];
    const tempArrayFiltersToReset = [];
    for (let i = 0; i < allFilters.length; i++) {
      const filterToReset = allFilters[i];
      switch ($(filterToReset).data('filter-type')) {
        case 'dropdown':
          // Exclude current filter and push into array other filters
          if ($(filterToReset).data('target-element-class') ===
            dataTargetElementClass) {

            tempArrayFiltersToReset.push(filterToReset);

            // Apply default dropdown value

            const dataFilter = $(filterToReset).data('filter');
            const filterButton = $(filterToReset).children('.dropdown-toggle');
            const dropdownButtonsListContainer = $(filterToReset).children('.dropdown-menu');
            const dropdownButtons = $(dropdownButtonsListContainer).children('button.dropdown-item');
            const defaultValueDropdownButton = $(dropdownButtonsListContainer).children('[' + dataFilter +
              '="all"]');

            const defaultValueDropdownButtonText = $(defaultValueDropdownButton).text();
            $(filterButton).text(_common_utils__WEBPACK_IMPORTED_MODULE_1__["default"].truncateDropdownButtonText(defaultValueDropdownButtonText));

            // Update item with active class and remove active from others
            const actualDropdownActiveButton = $(dropdownButtonsListContainer).children(
              'button.dropdown-item.active');
            if (actualDropdownActiveButton && actualDropdownActiveButton.length > 0) {
              $(actualDropdownActiveButton).removeClass('active');
            }
            $(defaultValueDropdownButton).addClass('active');

            const filterToResetFilterKey = $(filterToReset).data('filter');
            const filterToResetFilterType = $(filterToReset).data('filter-type');
            const filterToResetFilterValue = 'all';

            arrayFiltersToReset.push({
              key: filterToResetFilterKey,
              value: filterToResetFilterValue,
              type: filterToResetFilterType
            });
          }
          break;

        case 'calendar':

          if ($(filterToReset).data('target-element-class') ===
            dataTargetElementClass) {
            tempArrayFiltersToReset.push(filterToReset);
            const calendarInput = $(filterToReset).find(".picker__input");
            const filterToResetFilterKey = $(filterToReset).data('filter');
            const filterToResetFilterType = $(filterToReset).data('filter-type');
            $(calendarInput).pickadate().pickadate("picker").clear();
            arrayFiltersToReset.push({
              key: filterToResetFilterKey,
              value: 'all',
              type: filterToResetFilterType
            });
          }
          break;

        case 'checkbox':

          if ($(filterToReset).data('target-element-class') ===
            dataTargetElementClass) {
            tempArrayFiltersToReset.push(filterToReset);
            const checkboxInput = $(filterToReset).find("input[type=checkbox]");
            const filterToResetFilterKey = $(filterToReset).data('filter');
            const filterToResetFilterType = $(filterToReset).data('filter-type');

            if (!$(checkboxInput).is(':checked')) {
              $(checkboxInput).prop("checked", false);
            }

            arrayFiltersToReset.push({
              key: filterToResetFilterKey,
              value: 'all',
              type: filterToResetFilterType
            });
          }
          break;

        default:
          break;
      }
    }

    // Check if there is front end paginator
    const isThereFEPaginator = this.checkFEPaginator(currentSection, dataTargetContainer);

    if (!isThereFEPaginator) {
      this.resetAjaxPaginator(currentSection, dataTargetContainer, arrayFiltersToReset);
      return;
    }

    try {
      const dataTargetElements = $(currentSection).find(dataTargetContainer + ' ' + dataTargetElementClass);
      if (dataTargetElements && dataTargetElements.length > 0) {
        for (let i = 0; i < dataTargetElements.length; i++) {
          // Check if dataTargetElement has card-project-filters class, so apply filter to parent container
          const finalTargetElement = $(dataTargetElements[i]).hasClass('card-project-filters') ?
            $(dataTargetElements[i]).parent('.card-container') : $(dataTargetElements[i]);
          $(finalTargetElement).css('display', '');
          $(finalTargetElement).removeClass('filtered');
        }
      }

      // Reset paginator (if available in current section)
      this.resetCurrentSectionPaginator(currentSection, dataTargetContainer);
    } catch (error) {
      console.log(error);
    }
  }
}

window.addEventListener('load', () => {
  const component = new FiltersUtil();
});


/***/ }),

/***/ "./src/scripts/common/form-utils.js":
/*!******************************************!*\
  !*** ./src/scripts/common/form-utils.js ***!
  \******************************************/
/*! exports provided: FormUtils */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormUtils", function() { return FormUtils; });
class FormUtils {
  constructor(form) {
    console.log("Init Form Utils", form);
    console.log("Select-all buttons: ", form.find(".select-all"));

    // Handle check-all checkboxes
    $(form).find(".select-all").click((el) => {
      this.handleCheckAll(el, form);
    });

    // Handle touched class
    $(form).find("input").focusout((el) => {
      var target = el.target;
      $(target).addClass("touched");
      if ($(target).val() === '') {
        $(target).next().addClass("visible");
      } else {
        $(target).next().removeClass("visible");
      }

    });
    $(form).find("textarea").focusout((el) => {
      var target = el.target;
      $(target).addClass("touched");
    });
    if ($("input").hasClass("touched")) {
      $("error-message").addClass("visible");
    }

    // Dropdowns Handler
    this.handleDropdowns(form);

    // File Handler
    this.handleFile(form);

    // Privacy Policy Handler
    this.handlePrivacyPolicy(form);

    // EniNext CheckBox
    $(form).find("#eni-next-shares").click((el) => {
      $('#ShareAndTerms').hide();
    });

    $(form).find("#eni-next-terms").click((el) => {
      $('#ShareAndTerms').hide();
    });


    $("#company").on("click", function () {
      $("#company-section").addClass('visible');
      $("#denominazione").prop('required', true);
      $("#taxId").prop('required', true);
      $("#sedelegale").prop('required', true);
      $("#estremi").prop('required', true);
    });

    $("#person").on("click", function () {
      $("#company-section").removeClass('visible');
      $("#denominazione").removeClass('touched');
      $("#denominazione").next().removeClass('visible');
      $("#denominazione").removeAttr("required");
      $("#taxId").removeClass('touched');

      $("#taxId").next().removeClass('visible');
      $("#taxId").removeAttr("required");
      $("#sedelegale").removeClass('touched');
      $("#sedelegale").next().removeClass('visible');
      $("#sedelegale").removeAttr("required");
      $("#estremi").removeClass('touched');
      $("#estremi").next().removeClass('visible');
      $("#estremi").removeAttr("required");

    });

    //Handle "profile" textarea investor-relations form visibility
    this.handleProfileTextareaVisibility();

    //Handle "updates" textarea investor-relations form visibility
    this.handleUpdatesTextareaVisibility(form);

    // Handle Submit Privacy Policy Validation
    $(form).find("#submitButton").click((el) => {
      this.handleSubmitButtonClick(el, form);
    });
  }

  handleCheckAll(el, form) {
    var target = $(el.target).data("target");
    var targetElements = $(form).find(target).find("input");
    console.log("Select all clicked! Target:", target);
    console.log("Target elements", $(targetElements));
    if ($(el.target).prop("checked") == true) {
      $(targetElements).prop("checked", true);
    } else {
      $(targetElements).prop("checked", false);
    }
  }
  
  handleFile(form) {
    const file = $('#FileAttachment');
    const filename = $('#fileuploadurl');

    const file1 = $('#FileAttachmentReportFirst');
    const filename1 = $('#fileuploadurl1');

    const file2 = $('#FileAttachmentReportSecond');
    const filename2 = $('#fileuploadurl2');

    const file3 = $('#FileAttachmentReportThird');
    const filename3 = $('#fileuploadurl3');

    const fileNext = $('#FileAttachmentNext');
    const filenameNext = $('#fileuploadurlNext');
    
    $(file).on('change', function () {
      var file = this.files[0];

      if (file.size > 2000000) {
        $('.file-error-message').css({
          'display': 'inline-block'
        });
        $(filename).css({
          'display': 'none'
        });
      } 
      else {
        $('.file-error-message').css({
          'display': 'none'
        });
        const name = this.value.replace("C:\\fakepath\\", "");
        $(filename).val(name);
        $(filename).css({
          'display': 'inline-block'
        });
      }
      if (file.type === 'application/pdf' || file.type === 'image/jpeg') {
        $('.type-error-message').css({
          'display': 'none'
        });
      }
      else {
        $('.type-error-message').css({
          'display': 'inline-block'
        });
        $(filename).css({
          'display': 'none'
        });
      }
    });
    $(file1).on('change', function () {
      var file = this.files[0];

      if (file.size > 10485760) {
        $('.file-error-message1').css({
          'display': 'inline-block'
        });
        $(filename1).css({
          'display': 'none'
        });
      } 
      else {
        $('.file-error-message1').css({
          'display': 'none'
        });
        const name = this.value.replace("C:\\fakepath\\", "");
        $(filename1).val(name);
        $(filename1).css({
          'display': 'inline-block'
        });
      }
      if (file.type === 'application/pdf' || file.type === 'image/jpeg') {
        $('.type-error-message1').css({
          'display': 'none'
        });
      }
      else {
        $('.type-error-message1').css({
          'display': 'inline-block'
        });
        $(filename1).css({
          'display': 'none'
        });
      }
    });
    $(file2).on('change', function () {
      var file = this.files[0];

      if (file.size > 10485760) {
        $('.file-error-message2').css({
          'display': 'inline-block'
        });
        $(filename2).css({
          'display': 'none'
        });
      } 
      else {
        $('.file-error-message2').css({
          'display': 'none'
        });
        const name = this.value.replace("C:\\fakepath\\", "");
        $(filename2).val(name);
        $(filename2).css({
          'display': 'inline-block'
        });
      }
      if (file.type === 'application/pdf' || file.type === 'image/jpeg') {
        $('.type-error-message2').css({
          'display': 'none'
        });
      }
      else {
        $('.type-error-message2').css({
          'display': 'inline-block'
        });
        $(filename2).css({
          'display': 'none'
        });
      }
    });
    $(file3).on('change', function () {
      var file = this.files[0];

      if (file.size > 10485760) {
        $('.file-error-message3').css({
          'display': 'inline-block'
        });
        $(filename3).css({
          'display': 'none'
        });
      } 
      else {
        $('.file-error-message3').css({
          'display': 'none'
        });
        const name = this.value.replace("C:\\fakepath\\", "");
        $(filename3).val(name);
        $(filename3).css({
          'display': 'inline-block'
        });
      }
      if (file.type === 'application/pdf' || file.type === 'image/jpeg') {
        $('.type-error-message3').css({
          'display': 'none'
        });
      }
      else {
        $('.type-error-message3').css({
          'display': 'inline-block'
        });
        $(filename3).css({
          'display': 'none'
        });
      }
    });
    $(fileNext).on('change', function () {
      var file = this.files[0];

      if (file.size > 10485760) {
        $('.file-error-message').css({
          'display': 'inline-block'
        });
        $(filenameNext).css({
          'display': 'none'
        });
      } 
      else {
        $('.file-error-message').css({
          'display': 'none'
        });
        const name = this.value.replace("C:\\fakepath\\", "");
        $(filenameNext).val(name);
        $(filenameNext).css({
          'display': 'inline-block'
        });
      }
      if (file.type === 'application/pdf') {
        $('.type-error-message').css({
          'display': 'none'
        });
      }
      else {
        $('.type-error-message').css({
          'display': 'inline-block'
        });
        $(filenameNext).css({
          'display': 'none'
        });
      }
    });
  }

  handlePrivacyPolicy(form) {
    /*
    const formPrivacyErrorMessage = $(form).find('.button-form-privacy-error-message');
    $('#privacyPolicyYes').click(function () {
      $(formPrivacyErrorMessage).hide();
    });

    // Enable if error message has to be showed when change privacy instead when click submit button
    /* $('#privacyPolicyNo').click(function () {
      $(formPrivacyErrorMessage).show();
    }); */
    $('#privacyPolicyYes').click(function () {
      //$('#submitButton').prop("disabled", !$("#privacyPolicyYes").prop("checked"));
      //  $('#submitButton').removeClass("no-submit");
      // $('#submitButton').addClass("ok-submit");
      //$('.button-error-message').removeClass('visible');
    $('.button-error-message').hide();
      $('.no-submit').css({
        'display': 'none'
      });
      $('#submitButton').css({
        'display': 'block'
      });
    });
    $('#privacyPolicyNo').click(function () {
      // $('#submitButton').addClass("no-submit");
      // $('#submitButton').removeClass("ok-submit");
      //   $('#submitButton').prop("disabled", !$("#privacyPolicyNo").prop(""));
      $('.no-submit').css({
        'display': 'block'
      });
      $('#submitButton').css({
        'display': 'none'
      });

    });
    $('.no-submit').click(function (e) {
      //$('.button-error-message').addClass('visible');
      $('.button-error-message').show();
      e.stopPropagation();
    });

  }

  handleDropdowns(form) {
    // Handle form dropdowns
    var dropdownComponent = $(form).find(".form-dropdown");
    var dropdownComponentInput = $(dropdownComponent).find("input");
    var dropdownComponentButton = $(dropdownComponent).find(".dropdown-toggle");
    var dropdownComponentItems = $(dropdownComponent).find(".dropdown-item");

    $(dropdownComponentItems).click((el) => {
      // Set vars to correct elements
      var currentElement = el.target;
      dropdownComponent = $(currentElement).parent().parent();
      dropdownComponentInput = $(dropdownComponent).find("input");
      dropdownComponentButton = $(dropdownComponent).find(".dropdown-toggle");
      dropdownComponentItems = $(dropdownComponent).find(".dropdown-item");

      $(dropdownComponent).addClass("touched");
      $(dropdownComponentItems).removeClass("active");
      $(currentElement).addClass("active");

      $(dropdownComponentButton).text($(currentElement).text());
      $(dropdownComponentInput).val($(currentElement).data("value"));
    });
  }

  handleProfileTextareaVisibility() {
    const otherTextArea = $("#other-textarea");
    $("#other-label").on("click", function () {
      $(otherTextArea).addClass('visible');
      $(otherTextArea).prop('required', true);
    });

    $(".profile-activity-label").on("click", function () {
      $(otherTextArea).removeClass('visible');
      $(otherTextArea).prop('required', false);
    });
  }

  handleUpdatesTextareaVisibility(form) {
    const updatesTextarea = $(form).find('#updates-textarea');
    $(".other-updates-checkbox").on("click", function (el) {
      const currentOtherUpdatesCheckbox = el.target;
      if ($(currentOtherUpdatesCheckbox).is(':checked')) {
        $(updatesTextarea).prop('required', true);
      } else {
        $(updatesTextarea).prop('required', false);
      }
    });
  }

  handleSubmitButtonClick(ev, form) {
    const privacyPolicyLabel = $(form).find('privacy-label');
    const privacyPolicyYesRadio = $(form).find('#privacyPolicyYes');
    const privacyPolicyNoRadio = $(form).find('#privacyPolicyNo');

    const eniNextShares = $(form).find('#eni-next-shares');
    const eniNextTerms = $(form).find('#eni-next-terms');

    if (privacyPolicyLabel && privacyPolicyYesRadio && privacyPolicyNoRadio) {
      const formPrivacyErrorMessage = $(form).find('.button-form-privacy-error-message');
      
      // Check if privacy is accepted
      if ($(privacyPolicyNoRadio).is(':checked') || !$(privacyPolicyYesRadio).is(':checked')) {
        $(formPrivacyErrorMessage).show();
        ev.preventDefault();
      }
    }

    // check report form files for encription
    var reportForm = $("#reportForm");
    if(reportForm.length){
      var file1 = document.getElementById("FileAttachmentReportFirst").files[0];
      var file2 = document.getElementById("FileAttachmentReportSecond").files[0];
      var file3 = document.getElementById("FileAttachmentReportThird").files[0];

      if(file1 != undefined || file2 != undefined || file3 != undefined){
        reportForm.attr("enctype","multipart/form-data");        
      }
      else{
        reportForm.removeAttr("enctype");
      }
      //var file2 = $("#FileAttachment2");
      //var file3 = $("#FileAttachment3");
      
      /*if( (file1.size>0 && (file1.type=='jpg' || file1.type=='pdf')) || (file2.size>0 && (file2.type=='jpg' || file2.type=='pdf')) || (file3.size>0 && (file3.type=='jpg' || file1.type=='pdf')) ){
        reportForm.attr("enctype","multipart/form-data");
      }
      
      if(file1.size>0 && (file1.type=='image/jpeg' || file1.type=='application/pdf')){
        reportForm.attr("enctype","multipart/form-data");
      }
      
      else{
        reportForm.removeAttr("enctype");
      }  
      */
    }
    if(eniNextShares.length && eniNextTerms.length){
      const shareAndTermsError = $(form).find('#ShareAndTerms');

      if (!$(eniNextShares).is(':checked') || !$(eniNextTerms).is(':checked')) {
        $(shareAndTermsError).show();
        ev.preventDefault();
      }
    }
    var recaptcha = $("#g-recaptcha-response").val();
    if (recaptcha === "") {
        event.preventDefault();
        var currentLang = $('html')[0].lang;
      if(currentLang.indexOf('it')>-1){
        alert("Captcha: campo obbligatorio");
      }
      else alert("Captcha: compulsory field");
    }
  }
}

$(() => {
  const form = $('form');
  const component = new FormUtils(form);
});


/***/ }),

/***/ "./src/scripts/common/initDynamicContent.js":
/*!**************************************************!*\
  !*** ./src/scripts/common/initDynamicContent.js ***!
  \**************************************************/
/*! exports provided: initDynamicContent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initDynamicContent", function() { return initDynamicContent; });
/* harmony import */ var _widgets_highlight_editorial_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../widgets/highlight_editorial_content */ "./src/scripts/widgets/highlight_editorial_content.js");
/* harmony import */ var _widgets_media_highlight__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../widgets/media-highlight */ "./src/scripts/widgets/media-highlight.js");
/* harmony import */ var _widgets_herobanner_homepage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../widgets/herobanner-homepage */ "./src/scripts/widgets/herobanner-homepage.js");
/* harmony import */ var _widgets_event_highlight_countdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../widgets/event-highlight-countdown */ "./src/scripts/widgets/event-highlight-countdown.js");
/* harmony import */ var _common_share__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/share */ "./src/scripts/common/share.js");
// Highlight editorial content classes

// Media highlight classes

// Hero banner classes

// Event highlight countdown classes

// Share class




const dynamicContentWidgetMap = new Map();
const dynamicContentWidgets = [];
const classesToBeReinstantiated = [];

const highlightEditorialContentMap = {
  key: 'highlight-editorial-content',
  classes: ['highlight-editorial-content', 'share']
};
const mediaHighlightMap = {
  key: 'media-highlight',
  classes: ['media-highlight', 'share']
};
const heroBannerMap = {
  key: 'hero-banner',
  classes: ['hero-banner-homepage', 'share']
};
const mediaHighlightVideoMap = {
  key: 'media-highlight',
  classes: ['media-highlight', 'yt-video']
};



dynamicContentWidgets.push(highlightEditorialContentMap, mediaHighlightMap, heroBannerMap);
for (let i = 0; i < dynamicContentWidgets.length; i++) {
  dynamicContentWidgetMap.set(dynamicContentWidgets[i].key, dynamicContentWidgets[i].classes);
}

function initDynamicContent() {
  console.log('Init dynamic content');
  const dynamicContentContainers = $('.eni-target-widget');
  if (dynamicContentContainers && dynamicContentContainers.length > 0) {

    for (let i = 0; i < dynamicContentContainers.length; i++) {
      const dynamicContentContainer = dynamicContentContainers[i];
      handleDynamicContentContainer(dynamicContentContainer);
    }

    reinstantiateClasses();
  } else {
    console.warn('No dynamic content widgets found while trying to reinstantiate dynamic content classes');
  }

  // Fix Pciturefill polyfill IE11 for dynamic content
  if(typeof picturefill !== 'undefined'){
    picturefill();
  }

}

// Make initDynamicContent global accessibility outside app.min
global.initDynamicContent = initDynamicContent;
function handleDynamicContentContainer(dynamicContentContainer) {
  if ($(dynamicContentContainer).hasClass('highlight-editorial-content')) {
    const highlightEditorialContentClasses = dynamicContentWidgetMap.get('highlight-editorial-content');
    for (let i = 0; i < highlightEditorialContentClasses.length; i++) {
      const highlightEditorialContentClass = highlightEditorialContentClasses[i];
      if (classesToBeReinstantiated.indexOf(highlightEditorialContentClass) === -1) {
        classesToBeReinstantiated.push(highlightEditorialContentClass);
      }
    }
  } else if ($(dynamicContentContainer).hasClass('media-highlight-widget')) {
    const mediaHighlightContentClasses = dynamicContentWidgetMap.get('media-highlight');
    for (let i = 0; i < mediaHighlightContentClasses.length; i++) {
      const mediaHighlightContentClass = mediaHighlightContentClasses[i];
      if (classesToBeReinstantiated.indexOf(mediaHighlightContentClass) === -1) {
        classesToBeReinstantiated.push(mediaHighlightContentClass);
      }
    }
  } else if ($(dynamicContentContainer).hasClass('herobanner-homepage')) {
    const heroBannerContentClasses = dynamicContentWidgetMap.get('hero-banner');
    for (let i = 0; i < heroBannerContentClasses.length; i++) {
      const heroBannerContentClass = heroBannerContentClasses[i];
      if (classesToBeReinstantiated.indexOf(heroBannerContentClass) === -1) {
        classesToBeReinstantiated.push(heroBannerContentClass);
      }
    }
 
  }
}

function reinstantiateClasses() {
  if (classesToBeReinstantiated.length > 0) {
    for (let i = 0; i < classesToBeReinstantiated.length; i++) {
      switch (classesToBeReinstantiated[i]) {
        case 'highlight-editorial-content':
          console.log('REINITIALIZING HighlightEditorialContent');
          new _widgets_highlight_editorial_content__WEBPACK_IMPORTED_MODULE_0__["HighlightEditorialContent"](true);
          break;
        case 'media-highlight':
          console.log('REINITIALIZING MediaHighlight');
          new _widgets_media_highlight__WEBPACK_IMPORTED_MODULE_1__["MediaHighlight"](true);
          break;
        case 'hero-banner-homepage':
          console.log('REINITIALIZING HeroBannerHomepage');
          new _widgets_herobanner_homepage__WEBPACK_IMPORTED_MODULE_2__["HeroBannerHomepage"](true);
          break;
        case 'share':
          console.log('REINITIALIZING Share');
          new _common_share__WEBPACK_IMPORTED_MODULE_4__["Share"](true);
          break;
          
        default:
          break;
      }
    }
  } else {
    console.warn('No classes to be reinstantiated found for dynamic content widgets');
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/scripts/common/modals.js":
/*!**************************************!*\
  !*** ./src/scripts/common/modals.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

//const modalDisclaimer = $("#ModalDisclaimerPressRelease']");
//const modalOpen = $("#ModalEmailNewsletter']");
//if (modalOpen && modalOpen.length > 0) {
$('#ModalDisclaimerPressRelease').modal('show');
$('#ModalEmailNewsletter').modal('show');
//}



$(document).ready(function () {
  var maForm = $("#maForm");
  $("#enterMail").on("click",function(){
    $("#emailError").hide();
  });
  $(".ma_interests").on("click",function(){
    $("#interestError").hide();
  });
  $(".mail-alert-continue-btn").on("click", function () {
    var checkboxes=maForm.find('.ma_interests');
    var mailField=$('#enterMail').val();
    var isCboxesSelected = false;
    var isMailValid = false;
    var currentLang = $('html')[0].lang;
    for(var i = 0;i<checkboxes.length;i++){
      if(checkboxes[i].checked){
        isCboxesSelected=true;
      }
    }
    if( (mailField!="" || mailField!=null) && mailField.indexOf('@')>-1 && mailField.indexOf('.')>-1){
      isMailValid=true;
    }
    if(isMailValid && isCboxesSelected){
      $(".step-one").hide();
      $(".step-two").show();
    }
    else{
      if(!isMailValid){
        $("#emailError").show();
      }
      if(!isCboxesSelected){
        $("#interestError").show();
      }
    }
  });

  $(".mail-alert-go-back-btn").on("click", function () {
    $(".step-one").show();
    $(".step-two").hide();
  });

});


/***/ }),

/***/ "./src/scripts/common/owl-carousel.js":
/*!********************************************!*\
  !*** ./src/scripts/common/owl-carousel.js ***!
  \********************************************/
/*! exports provided: owlCarouselUtls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "owlCarouselUtls", function() { return owlCarouselUtls; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


const owlCarouselUtls = (bindClass, opts, isBindMouseWheel) => {

  const owl = $(bindClass).owlCarousel(opts);

  /* if (isBindMouseWheel) {
    $(bindClass).on('mousewheel', '.owl-stage', (e) => {

      if (e.deltaY > 0) {
        $(e.target).trigger('next.owl');
      } else {
        $(e.target).trigger('prev.owl');
      }
      e.preventDefault();
    });

    $(bindClass).on('change.owl.carousel', () => {
      // Close card share modal when owl carousel changes
      Utils.closeShareModal();
    });


  } */

  return owl;
};


/***/ }),

/***/ "./src/scripts/common/pagination-util.js":
/*!***********************************************!*\
  !*** ./src/scripts/common/pagination-util.js ***!
  \***********************************************/
/*! exports provided: PaginationUtil */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationUtil", function() { return PaginationUtil; });
class PaginationUtil {

  constructor(containerDiv) {
    const elements = $(containerDiv);
    console.log("PAGINATORS", elements);
    for (let i = 0; i < elements.length; i++) {
      this.init(elements[i]);
    }
  }


  init(currentElement) {
    const elementsPerPage = $(currentElement).data('per-page');
    const targetElementsClass = $(currentElement).data('target');
    const ajax = $(currentElement).data('ajax');
    const minElements = $(currentElement).data('min-elements');
    console.log("Paginator Initialized!", currentElement);
    console.log("Elements per page!", elementsPerPage);

    $(currentElement).ttPaginator({
      perPage: elementsPerPage,
      targetElementsClass: targetElementsClass,
      ajax: ajax,
      minElements: minElements
    });
  }
}

$(() => {
  const elements = $('[data-pagination="true"]');
  for (var i = 0; i < elements.length; i++) {
    const component = new PaginationUtil(elements[i]);
  }
});


/***/ }),

/***/ "./src/scripts/common/scroll.js":
/*!**************************************!*\
  !*** ./src/scripts/common/scroll.js ***!
  \**************************************/
/*! exports provided: ScrollUtil */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollUtil", function() { return ScrollUtil; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");

class ScrollUtil {
    constructor() {
        const backtop = $('.backtop');
        var isMobile = $(window).outerWidth() < 1024;

        $('.fab-search-mobile').on('click', function () {
            $('#mobileSearchModal').modal('show');
            $('.eni-search-modal-input').trigger('focus');
            return false;
        });

        if (backtop && backtop.length > 0) {

            $(backtop).on('click', function () {
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $(backtop).removeClass("backtop-absolute");
                $(backtop).removeClass("backtop-fixed");
                $(backtop).stop(true, true).fadeOut(1);
                return false;
            });

            $(window).scroll(function (event) {


                
                var scrollPercent = 100 * $(window).scrollTop() / ($(document).height() - $(window).height());
               

                if (_common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isInViewport(".footer-description-enicom div:nth-last-child(3)") || (isMobile)) {

                    $(backtop).removeClass("backtop-fixed");
                    $(backtop).addClass("backtop-absolute");
                    $(backtop).fadeIn(1500);
                    //console.error('viewport');
                } else if (scrollPercent > 66) {

                   
                    $(backtop).removeClass("backtop-absolute");
                    $(backtop).addClass("backtop-fixed");
                    
                    $(backtop).fadeIn(1500);
                    //console.error('maggiore di 66');
                } else {
                    $(backtop).removeClass("backtop-absolute");
                    $(backtop).stop(true, true).fadeOut(1);

                   // console.error('minore di 66');

                }
              

               
            });
        }
    }
}

$(() => {
    const component = new ScrollUtil();
});


/***/ }),

/***/ "./src/scripts/common/search-tab-utils.js":
/*!************************************************!*\
  !*** ./src/scripts/common/search-tab-utils.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(() => {
  setTimeout(() => {
    $(".eni-searchbar-container").find(".carousel-container").addClass("visible");
  }, 500);
});


/***/ }),

/***/ "./src/scripts/common/share.js":
/*!*************************************!*\
  !*** ./src/scripts/common/share.js ***!
  \*************************************/
/*! exports provided: SHARE_PROPS, Share */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHARE_PROPS", function() { return SHARE_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Share", function() { return Share; });
/* harmony import */ var clipboard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! clipboard */ "./node_modules/clipboard/dist/clipboard.js");
/* harmony import */ var clipboard__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(clipboard__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_digital_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/digital-data */ "./src/scripts/common/digital-data.js");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");




const SHARE_PROPS = {
  DROPDOWN_BTN_CLASS: '.btn.btn-share',
  DROPDOWN_ID: '#share-dropdown',
  MODAL_ID: '#shareModal',
  SHARE_SOCIAL_BTN_CLASS: '.btn.btn-share.btn-social',
  SHARE_SMALL_ICON_CLASS: '.icon-share-small',
  BTN_DROPDOWN_COPY_ID: '#copyDropdownBtn',
  BTN_MODAL_COPY_ID: '#copyModalBtn',
  BTN_COPY_CLASS: '.btn-copy-url',
  DATA_TOGGLE: 'data-toggle',
  DATA_URL: 'data-url',
  DATA_SHARE_URL: 'data-share-url',
  DATA_CLIPBOARD_TEXT: 'data-clipboard-text',
  DATA_SHARE_SOCIAL: 'data-share-social',
  MODAL_SEARCH: '.search-gallery-popup'
};
class Share {


  constructor(initializeForDynamicContent) {

    // Manage children selector when dynamic section instantiate class
    if (initializeForDynamicContent) {
      SHARE_PROPS.DROPDOWN_BTN_CLASS = '.eni-target-widget ' + SHARE_PROPS.DROPDOWN_BTN_CLASS;
      SHARE_PROPS.SHARE_SOCIAL_BTN_CLASS = '.eni-target-widget ' + SHARE_PROPS.SHARE_SOCIAL_BTN_CLASS;
      SHARE_PROPS.BTN_COPY_CLASS = '.eni-target-widget ' + SHARE_PROPS.BTN_COPY_CLASS;
    }

    $(SHARE_PROPS.DROPDOWN_BTN_CLASS).on('click', (el) => this.showModal(el));

    $(document).mouseup((e) => {
      const container = $(SHARE_PROPS.DROPDOWN_ID);
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.fadeOut();
      }
    });
    if ($(SHARE_PROPS.MODAL_SEARCH).length < 1) {
      $(SHARE_PROPS.SHARE_SOCIAL_BTN_CLASS).on('click', (e) => {
        // Carousel Publications - Prevent share click when card is not centered/active
        if ($(e.currentTarget).parents('.card-editorial') &&
          $(e.currentTarget).parents('.carousel-publications-container')) {
          let carouselPublicationsCard = $(e).parents('.card-editorial');
          if ((carouselPublicationsCard.hasClass('publication-type') ||
            carouselPublicationsCard.hasClass('press-release-type')) &&
            !carouselPublicationsCard.hasClass(
              'carousel-center')) {
            e.preventDefault();
            return;
          }
        }
        this.share(e.target);
      });
    }

    if ($(SHARE_PROPS.MODAL_SEARCH).length < 1) {
      var clipboard = new clipboard__WEBPACK_IMPORTED_MODULE_0___default.a(SHARE_PROPS.BTN_COPY_CLASS);

      clipboard.on('success', (e) => {
        console.log('text copied', e.text);
        console.log('action', e.action);
        console.log('trigger', e.trigger);

        let jsnid_copy = $(e.trigger).attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID);

        if (jsnid_copy && jsnid_copy.length > 0) {
          console.log(jsnid_copy);
          let digitalDataJson = "";
          try {
            digitalDataJson = eval(jsnid_copy);
          }
          catch (ex) { }
          if (digitalDataJson) {
            digitalDataJson.event = "click-share";
            digitalDataJson.pageEvent.eventInfo.eventDetail = "CopyLink";
            digitalDataJson.pageEvent.eventInfo.contentURL = e.text;
            digitalDataJson.pageEvent.eventInfo.ctaLabel = "";
            console.log(digitalDataJson);
            try {
              window.digitalData.push(digitalDataJson);
            }
            catch (ex) { }
            finally {
              $(e.trigger).removeAttr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID);
            }
          }
        }

        $('.toast').toast('show');
        // setTimeout(() => {
        //   $(SHARE_PROPS.DROPDOWN_ID).fadeOut(400)
        // }, 700);
      });
      clipboard.on('error', (e) => {
        console.log('clipboard error');
      });
    }
    this.handleScrollAndResize(initializeForDynamicContent);
  }


  showModal(event) {
    const el = event.currentTarget;
    if (!$(el).hasClass('btn-social')) {
      console.log('showModal');

      // Carousel Publications - Prevent share click when card is not centered/active
      if ($(el).parents('.card-editorial').length > 0 && $(el).parents('.carousel-publications-container').length > 0) {
        let carouselPublicationsCard = $(el).parents('.card-editorial');
        if ((carouselPublicationsCard.hasClass('publication-type') ||
          carouselPublicationsCard.hasClass('press-release-type')) &&
          !carouselPublicationsCard.hasClass(
            'carousel-center')) {
          event.preventDefault();
          return;
        }
      }

      // Close share modal if there is one already opened
      if (_common_utils__WEBPACK_IMPORTED_MODULE_2__["default"].closeShareModal()) {
        return;
      };

      var dataUrl = $(el).attr(SHARE_PROPS.DATA_URL);


      if (dataUrl != undefined) {
        // Check if dataUrl is a relative path beginning with "/", if so add current domain, otherwise leave it as is
        if (dataUrl.charAt(0) === "/") {
          dataUrl = window.location.origin + dataUrl;
        }
      }

      var data_jsnid = $(el).attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID);

      const isModal = $(el).attr(SHARE_PROPS.DATA_TOGGLE) === 'modal';
      if (dataUrl) {
        if (isModal) {
          $(SHARE_PROPS.MODAL_ID).attr(SHARE_PROPS.DATA_SHARE_URL, dataUrl);
          $(SHARE_PROPS.MODAL_ID).attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID, data_jsnid);
          const btnCopy = $(SHARE_PROPS.BTN_MODAL_COPY_ID);
          if (btnCopy) {
            btnCopy.attr(SHARE_PROPS.DATA_CLIPBOARD_TEXT, dataUrl);
            btnCopy.attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID, data_jsnid);
          }
        } else {
          $(SHARE_PROPS.DROPDOWN_ID).attr(SHARE_PROPS.DATA_SHARE_URL, dataUrl);
          $(SHARE_PROPS.DROPDOWN_ID).attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID, data_jsnid);
          const btnCopy = $(SHARE_PROPS.BTN_DROPDOWN_COPY_ID);
          if (btnCopy) {
            btnCopy.attr(SHARE_PROPS.DATA_CLIPBOARD_TEXT, dataUrl);
            btnCopy.attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID, data_jsnid);
          }
          const position = $(el).offset(); //$(el).position();
          const height = $(el).height();

          const innerHeight = window.innerHeight;
          const rect = el.getBoundingClientRect();
          let space = innerHeight - rect.top - 330;

          // editorial-collection-highlight exception
          if ($(el).parents('.editorial-collection-highlight') && $(el).parents('.editorial-collection-highlight')
            .length > 0) {
            space = space - 30;
          }

          $(SHARE_PROPS.DROPDOWN_ID).css({
            'position': 'absolute',
            'top': space >= 0 ? `${position.top + height}px` : `${position.top - (space * -1) + height}px`,
            'left': $(el).parents('.carousel-event').length > 0 ? `${position.left - 50}px` :
              `${position.left - 252}px`
          });
          if ($(SHARE_PROPS.MODAL_SEARCH).length > 0) {
            $(SHARE_PROPS.DROPDOWN_ID).css({
              'z-index': '1044'
            });
          }
          $(SHARE_PROPS.DROPDOWN_ID).show();
        }

      }
    }
  }

  share(el) {
    //fix copy link search image
    if ($(SHARE_PROPS.MODAL_SEARCH).length > 0 && $(el).hasClass('btn-copy-url')) {
      let copyLinkValue = $(SHARE_PROPS.BTN_COPY_CLASS).attr('data-clipboard-text');
      console.log('copyLinkValue' + copyLinkValue);
      navigator.clipboard.writeText(copyLinkValue);
    }

    const shareDesktop = $(SHARE_PROPS.DROPDOWN_ID);
    const shareMobile = $(SHARE_PROPS.MODAL_ID);

    let shareUrl = '';
    let jsnid = '';

    if (shareDesktop && shareDesktop.length > 0 && !shareMobile.is(":visible")) {
      shareUrl = $(shareDesktop).attr(SHARE_PROPS.DATA_SHARE_URL);
      jsnid = $(shareDesktop).attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID);
    } else if (shareMobile && shareMobile.length > 0 && shareMobile.is(":visible")) {
      shareUrl = $(shareMobile).attr(SHARE_PROPS.DATA_SHARE_URL);
      jsnid = $(shareMobile).attr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID);
    }
    console.log(jsnid);

    const social = $(el).attr(SHARE_PROPS.DATA_SHARE_SOCIAL);

    if (social && jsnid && jsnid.length > 0) {
      let digitalData = "";
      try {
        digitalData = eval(jsnid);
      }
      catch (ex) { }
      if (digitalData) {
        digitalData.event = "click-share";
        if (social == 'facebook') digitalData.pageEvent.eventInfo.eventDetail = "Facebook";
        else if (social == 'twitter') digitalData.pageEvent.eventInfo.eventDetail = "Twitter";
        else if (social == 'linkedin') digitalData.pageEvent.eventInfo.eventDetail = "Linkedin";
        else if (social == 'mail') digitalData.pageEvent.eventInfo.eventDetail = "Email";
        digitalData.pageEvent.eventInfo.contentURL = shareUrl;
        digitalData.pageEvent.eventInfo.ctaLabel = "";
        console.log(digitalData);
        try {
          window.digitalData.push(digitalData);
        }
        catch (ex) { }
        finally {
          $(shareDesktop).removeAttr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID);
          $(shareMobile).removeAttr(_common_digital_data__WEBPACK_IMPORTED_MODULE_1__["DIGITAL"].DATA_JSON_ID);
        }
      }
    }

    if (shareUrl && shareUrl.length > 0) {
      switch (social) {
        case 'facebook':
          this.shareFacebook(shareUrl);
          break;
        case 'twitter':
          this.shareTwitter(shareUrl);
          break;
        case 'linkedin':
          this.shareLinkedIn(shareUrl);
          break;
        case 'mail':
          this.shareMail(shareUrl);
          break;
      }
    }
  }

  shareFacebook(url) {
    console.log('shareFacebook', url);
    return this.openPopupWindow(`https://www.facebook.com/sharer/sharer.php?u=${url}`, 'Facebook');
  }

  shareTwitter(url) {
    console.log('shareTwitter', url);
    return this.openPopupWindow(`https://twitter.com/share?url=${url}`, 'Twitter');
  }

  shareLinkedIn(url) {
    console.log('shareLinkedIn', url);
    return this.openPopupWindow(`https://www.linkedin.com/shareArticle?mini=true&url=${url}`, 'LinkedIn');
  }

  shareMail(url) {
    window.location.href = `mailto:?body=${url}`;
  }

  openPopupWindow(url, title) {
    var popupWindow = window.open(url, title, 'height=350,width=600');
    if (popupWindow.focus) {
      popupWindow.focus();
    }
    $(SHARE_PROPS.DROPDOWN_ID).fadeOut();
    return false;
  }

  closeModal() {
    const container = $(SHARE_PROPS.DROPDOWN_ID);
    if (container && container.length > 0) {
      for (let i = 0; i < container.length; i++) {
        if ($(container[i]).is(':visible')) {
          $(container[i]).hide();
        }
      }
    }
  }

  handleScrollAndResize(initializeForDynamicContent) {
    $(SHARE_PROPS.SHARE_SMALL_ICON_CLASS).click(() => {
      var lastPosition = window.pageYOffset;
      document.onscroll = function () {
        var scroll = window.pageYOffset;
        var absDiff = lastPosition - scroll;
        if (absDiff < 0) {
          absDiff = absDiff * -1;
        }
        if (absDiff > 300) {
          _common_utils__WEBPACK_IMPORTED_MODULE_2__["default"].closeShareModal();
        }
      };
    });

    if (!initializeForDynamicContent) {
      $(window).on('resize', function () {
        // Close card share modal at resize action
        _common_utils__WEBPACK_IMPORTED_MODULE_2__["default"].closeShareModal();
      });
    }
  }

  static createInstance(initDynamicContent) {
    const shareUtils = new Share(initDynamicContent);
    return shareUtils;
  }
}

global.share = Share;

$(() => {
  // escluso la versalis generic serp dall'init. Viene gestito usando i global
  if ($('.generic-serp').length === 0) {
    const share = new Share(false);
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/scripts/common/tab-utils.js":
/*!*****************************************!*\
  !*** ./src/scripts/common/tab-utils.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(() => {
  setTimeout(() => {
    $(".tab-content-container").find(".carousel-container").addClass("visible");
  }, 500);
});


/***/ }),

/***/ "./src/scripts/common/tooltip.js":
/*!***************************************!*\
  !*** ./src/scripts/common/tooltip.js ***!
  \***************************************/
/*! exports provided: Tooltip */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return Tooltip; });
class Tooltip {

  constructor() {

  }

  show(x, y, text) {
    // creating element if not exists
    if (this.element === undefined) {
      console.log('element');
      this.element = document.createElement('div');
      this.element.id = 'map-tooltip';
      this.element.className = 'mapTooltip';
      document.body.insertBefore(this.element, document.body.firstChild);
      this.body = document.createElement('div');
      this.body.id = 'tooltip-body';
      this.body.className = 'body';
      this.element.appendChild(this.body);
    }
    this.body.innerHTML = text;
    // filling and giving position
    this.element.style.display = 'block';
    var left = x - (this.body.offsetWidth / 2);
    var top = y - 50;
    this.element.style.top = top + 'px';
    this.element.style.left = left + 'px';
  }

  hide() {
    this.element.style.display = 'none';
  }
}


$(function() {
  let gloss = $(".glossary");

  if(gloss.length > 0 && gloss.is("span")){
    var localUrl = window.location.href;
    var site = "enicom";
    var lang = "en";

    if(localUrl.indexOf("/enirewind/")>-1){
      site = "enirewind";
      if(localUrl.indexOf("/it-IT/")>-1){
        lang = "it";
      }
    }

    if(localUrl.indexOf("/ravenna-ccs-hub/")>-1){
      site = "ravenna-ccs-hub";
      if(localUrl.indexOf("/it/it")>-1){
        lang = "it";
      }
    }

    var baseUrl = window.location.origin;
    var servletURL = "/services/data/glossary.json?site=";

    var result = $.ajax({
      type: "GET",
      async: false,
      url: baseUrl + servletURL + site + "&lang=" + lang
    });

    var jsonResult = JSON.parse(result.responseText);

    for (var i = 0; i < gloss.length; i++) {
      for (var j = 0; j < jsonResult.content.length; j++) {
        let key = $(gloss[i]).attr("dataKey");

        if (key === jsonResult.content[j].properties.dataKey) {
          let title = jsonResult.content[j].properties.title;
          let desc  = jsonResult.content[j].properties.description;

          let content = "<em>" + title + "</em> <br></br> <span>" + desc + "</span>";

          $(gloss[i]).attr("data-toggle", "tooltip");
          $(gloss[i]).attr("data-original-title", content);
        }
      }
    }

    $(".glossary").tooltip({
      placement: "auto",
      html: true,
    });
  }
});


/***/ }),

/***/ "./src/scripts/common/tt-paginator.plugin.js":
/*!***************************************************!*\
  !*** ./src/scripts/common/tt-paginator.plugin.js ***!
  \***************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./src/scripts/common/utils.js");


(function ($) {
  var currentPage = 1;

  $.fn.ttPaginator = function (options, action) {
    var settings = $.extend({
      // Default Settings here
      perPage: 2, // Number of items per page
      paginatorIndicatorsContainer: 'tt-paginator-container',
      targetElementsClass: '',
      ajax: false,
      filters: null,
      minElements: 1
    }, options);

    if (settings.ajax && settings.ajax === true) {

      if (action === 'setFilters') {
        const paginatorId = $(this).attr("id");
        const perPage = $(this).data("per-page");
        const apiUrl = $(this).data("api-url");
        settings.perPage = perPage;
        settings.apiUrl = apiUrl;
        const indicatorsContainerSelector = '#' + paginatorId + ' .' + settings.paginatorIndicatorsContainer;
        $(indicatorsContainerSelector).remove();
        console.log("Paginator Set Filters!", settings);
        initAjaxPaginator(settings, $(this));
      } else {
        initAjaxPaginator(settings, $(this));
      }
    } else {
      if (action && action === 'reinit') {
        const paginatorId = $(this).attr('id');
        if (!paginatorId || paginatorId.length === 0) {
          console.error(
            "Please always set an ID when using the ttPaginator jQuery plugin! If an ID is set, please check if you are applying the reinit function to the right DOM element (the one which contains data-pagination='true')"
          );
        };

        settings.perPage = $(this).data('per-page');
        settings.targetElementsClass = $(this).data('target');

        const paginatorIndicatorsContainerSelector = '#' + paginatorId + ' .' + settings
          .paginatorIndicatorsContainer +
          ' .pages';
        const paginatorPrevContainerSelector = '#' + paginatorId + ' .' + settings
          .paginatorIndicatorsContainer +
          ' .ttpaginator-prev';
        const paginatorNextContainerSelector = '#' + paginatorId + ' .' + settings
          .paginatorIndicatorsContainer +
          ' .ttpaginator-next';
        const elements = $(this).children('.' + settings.targetElementsClass + ':visible');
        const elementsCount = elements.length;
        const pagesCount = Math.ceil(elementsCount / settings.perPage);
        removeIndicators('#' + paginatorId + ' .' + settings
          .paginatorIndicatorsContainer);
        injectPaginatorHtml(paginatorId, settings.paginatorIndicatorsContainer);

        drawIndicators(1, pagesCount, paginatorIndicatorsContainerSelector, elements, settings
          .perPage, paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings);
        showElements(elements, 0, settings.perPage - 1);
      } else {
        console.log('PAGINATOR ACTION');
        return this.each(function () {
          const paginatorId = $(this).attr('id');
          console.log("Settato il paginator ID", paginatorId);
          if (!paginatorId || paginatorId.length === 0) {
            console.error("Please always set an ID when using the ttPaginator jQuery plugin!");
          }
          console.log("Paginator Initialized with id " + paginatorId);
          const paginatorIndicatorsContainerSelector = '#' + paginatorId + ' .' + settings
            .paginatorIndicatorsContainer +
            ' .pages';
          const paginatorPrevContainerSelector = '#' + paginatorId + ' .' + settings
            .paginatorIndicatorsContainer +
            ' .ttpaginator-prev';
          const paginatorNextContainerSelector = '#' + paginatorId + ' .' + settings
            .paginatorIndicatorsContainer +
            ' .ttpaginator-next';
          const elements = $(this).children('.' + settings.targetElementsClass);
          const elementsCount = elements.length;
          const pagesCount = Math.ceil(elementsCount / settings.perPage);
          console.log("Number of Pages: ", pagesCount);

          if (elementsCount >= settings.minElements) {
            injectPaginatorHtml(paginatorId, settings.paginatorIndicatorsContainer);
            drawIndicators(currentPage, pagesCount, paginatorIndicatorsContainerSelector, elements, settings
              .perPage, paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings);
            showElements(elements, 0, settings.perPage - 1);
          }
        });
      }
    }

  };

}(jQuery));

function initAjaxPaginator(settings, paginator) {
  console.log("Ajax Paginator Initialized");
  const paginatorId = $(paginator).attr("id");
  const perPage = $(paginator).data("per-page");
  const apiUrl = $(paginator).data("api-url");
  const contentBox = $(paginator).data("content-box"); // class of the div where content from the api will be placed
  const contentSelector = '#' + paginatorId + ' .' + contentBox;
  const indicatorsContainerSelector = '#' + paginatorId + ' .' + settings.paginatorIndicatorsContainer;
  const indicatorsContainerSelectorPages = '#' + paginatorId + ' .' + settings.paginatorIndicatorsContainer + ' .pages';
  // First call to load basic data
  showLoader(contentSelector);
  $.ajax({
    url: apiUrl,
    data: {
      page: 1,
      perPage: perPage,
      filters: settings.filters
    },
    success: function (data, status, xhr) {
      console.log("First Ajax call done!");
      const htmlContent = data.content;
      const currentPage = data.page;
      const elementCount = data.count;

      $(contentSelector).html(htmlContent);
      console.log("Content selector", contentSelector);
      injectPaginatorHtml(paginatorId, settings.paginatorIndicatorsContainer); //TODO: Inject div.ajax-data
      drawAjaxIndicators(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings, elementCount,
        currentPage);
      bindToIndicatorArrowClick(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings,
        currentPage, perPage, apiUrl, contentSelector, paginatorId);
      setTimeout(function () {
        hideLoader(contentSelector);
      }, 2000);
    },
    error: function (data) {
      handleError(data);
    }
  });
}

// Handle Indicators Click (AJAX PAGINATOR)
function bindToIndicatorArrowClick(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings, currentPage,
  perPage, apiUrl, contentSelector, paginatorId) {
  const selector = indicatorsContainerSelectorPages + ' button';
  const pagPrevArrow = indicatorsContainerSelector + ' .ttpaginator-prev';
  const pagNextArrow = indicatorsContainerSelector + ' .ttpaginator-next';
  $(selector).click(function () {
    console.log("Current Page: ", currentPage);
    const clickedPage = $(this).data('value');
    console.log("Indicator clicked! Page: ", clickedPage);

    // Every call after the first one happens here
    showLoader(contentSelector);
    $.ajax({
      url: apiUrl,
      data: {
        page: clickedPage,
        perPage: perPage,
        filters: settings.filters
      },
      success: function (data, status, xhr) {
        console.log("Ajax call done!");
        const htmlContent = data.content;
        const currentPage = data.page;
        const elementCount = data.count;

        $(contentSelector).html(htmlContent);
        console.log("Content selector", contentSelector);
        removeIndicators(selector);
        drawAjaxIndicators(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings,
          elementCount,
          currentPage);
        clearIndicatorClickHandler(selector, pagPrevArrow, pagNextArrow);
        bindToIndicatorArrowClick(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings,
          currentPage, perPage, apiUrl, contentSelector, paginatorId);
        setTimeout(function () {
          hideLoader(contentSelector);
        }, 2000);
        if ($('#' + paginatorId).closest("section").length > 0)
          $('#' + paginatorId).closest("section").scrollintoview({
            duration: 300
          });
        else
          $('#' + paginatorId).closest(".main-container").scrollintoview({
            duration: 300
          });
      }
    });
  });

  $(pagPrevArrow).click(function () {
    console.log("Current Page: ", currentPage);
    const clickedPage = currentPage - 1;
    console.log("Prev arrow clicked! Page: ", clickedPage);

    // Every call after the first one happens here
    showLoader(contentSelector);
    $.ajax({
      url: apiUrl,
      data: {
        page: clickedPage,
        perPage: perPage,
        filters: settings.filters
      },
      success: function (data, status, xhr) {
        console.log("Ajax call done!");
        const htmlContent = data.content;
        const currentPage = data.page;
        const elementCount = data.count;

        $(contentSelector).html(htmlContent);
        console.log("Content selector", contentSelector);
        removeIndicators(selector);
        drawAjaxIndicators(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings,
          elementCount,
          currentPage);
        clearIndicatorClickHandler(selector, pagPrevArrow, pagNextArrow);
        bindToIndicatorArrowClick(indicatorsContainerSelector, indicatorsContainerSelectorPages,
          settings,
          currentPage, perPage, apiUrl, contentSelector, paginatorId);
        setTimeout(function () {
          hideLoader(contentSelector);
        }, 2000);
        if ($('#' + paginatorId).closest("section").length > 0)
          $('#' + paginatorId).closest("section").scrollintoview({
            duration: 300
          });
        else
          $('#' + paginatorId).closest(".main-container").scrollintoview({
            duration: 300
          });
      }
    });
  });

  $(pagNextArrow).click(function () {
    console.log("Current Page: ", currentPage);
    const clickedPage = currentPage + 1;
    console.log("Next arrow clicked! Page: ", clickedPage);

    // Every call after the first one happens here
    showLoader(contentSelector);
    $.ajax({
      url: apiUrl,
      data: {
        page: clickedPage,
        perPage: perPage,
        filters: settings.filters
      },
      success: function (data, status, xhr) {
        console.log("Ajax call done!");
        const htmlContent = data.content;
        const currentPage = data.page;
        const elementCount = data.count;

        $(contentSelector).html(htmlContent);
        console.log("Content selector", contentSelector);
        removeIndicators(selector);
        drawAjaxIndicators(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings,
          elementCount,
          currentPage);
        clearIndicatorClickHandler(selector, pagPrevArrow, pagNextArrow);
        bindToIndicatorArrowClick(indicatorsContainerSelector, indicatorsContainerSelectorPages,
          settings,
          currentPage, perPage, apiUrl, contentSelector, paginatorId);
        setTimeout(function () {
          hideLoader(contentSelector);
        }, 2000);
        if ($('#' + paginatorId).closest("section").length > 0)
          $('#' + paginatorId).closest("section").scrollintoview({
            duration: 300
          });
        else
          $('#' + paginatorId).closest(".main-container").scrollintoview({
            duration: 300
          });
      }
    });
  });
}

function drawAjaxIndicators(indicatorsContainerSelector, indicatorsContainerSelectorPages, settings, elementCount,
  currentPage) {
  const pageCount = Math.ceil(elementCount / settings.perPage);
  const pagPrevArrow = indicatorsContainerSelector + ' .ttpaginator-prev';
  const pagNextArrow = indicatorsContainerSelector + ' .ttpaginator-next';

  // Disable Next and Prev arrows when needed
  $(pagPrevArrow).removeClass("disabled");
  $(pagPrevArrow).attr("disabled", false);
  $(pagNextArrow).removeClass("disabled");
  $(pagNextArrow).attr("disabled", false);
  if (currentPage === 1) {
    $(pagPrevArrow).addClass("disabled");
    $(pagPrevArrow).attr("disabled", true);
  }
  if (currentPage === pageCount) {
    $(pagNextArrow).addClass("disabled");
    $(pagNextArrow).attr("disabled", true);
  }

  if (pageCount === 0 || pageCount === 1) {
    $(indicatorsContainerSelector).attr("style", "display: none !important;");
  } else if (pageCount <= 7) {
    for (let i = 1; i < pageCount + 1; i++) {
      createIndicator(indicatorsContainerSelectorPages, i, i === currentPage);
    }
  } else {
    if (currentPage < 5) {
      for (let i = 1; i <= 5; i++) {
        createIndicator(indicatorsContainerSelectorPages, i, i === currentPage);
      }
      createIndicator(indicatorsContainerSelectorPages, -1, false); // Three-dot dummy button when pageCount is -1
      createIndicator(indicatorsContainerSelectorPages, pageCount, false);
    } else if (currentPage > pageCount - 5) {
      for (let i = 1; i < pageCount + 1; i++) {
        if (i === 1) {
          createIndicator(indicatorsContainerSelectorPages, i, i === currentPage);
          createIndicator(indicatorsContainerSelectorPages, -1, false);
        }
        if (i > pageCount - 5) {
          createIndicator(indicatorsContainerSelectorPages, i, i === currentPage);
        }
      }
    } else {
      for (let i = 1; i < pageCount + 1; i++) {
        if (i === 1) {
          createIndicator(indicatorsContainerSelectorPages, i, i === currentPage);
          createIndicator(indicatorsContainerSelectorPages, -1, false);
        }
        if (i === currentPage - 1 | i === currentPage | i === currentPage + 1) {
          createIndicator(indicatorsContainerSelectorPages, i, i === currentPage);
        }
        if (i === pageCount) {
          createIndicator(indicatorsContainerSelectorPages, -1, false);
          createIndicator(indicatorsContainerSelectorPages, i, i === currentPage);
        }
      }
    }
  }
}

function injectPaginatorHtml(paginatorId, elementClass) {
  $('#' + paginatorId).append('<div class="' + elementClass +
    '"><button class="ttpaginator-prev icon-arrow-left"></button><div class="pages"></div><button class="ttpaginator-next icon-arrow-right"></button></div>'
  );
}

function removeIndicators(selector) {
  $(selector).remove();
}

function drawIndicators(currentPage, pagesCount, paginatorContainerSelector, elements, perPage,
  paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings) {
  const elementsCount = elements.length;
  pagesCount = Math.ceil(elementsCount / settings.perPage);
  paginatorContainerSelector = $('#' + paginatorId)
    .children('.' + settings.paginatorIndicatorsContainer)
    .children('.pages');
  console.log("paginatorId drawIndicators", paginatorContainerSelector);

  // Disable Next and Prev arrows when needed
  $(paginatorPrevContainerSelector).removeClass("disabled");
  $(paginatorPrevContainerSelector).attr("disabled", false);
  $(paginatorNextContainerSelector).removeClass("disabled");
  $(paginatorNextContainerSelector).attr("disabled", false);

  if (currentPage === 1) {
    $(paginatorPrevContainerSelector).addClass("disabled");
    $(paginatorPrevContainerSelector).attr("disabled", true);
  }
  if (currentPage === pagesCount) {
    $(paginatorNextContainerSelector).addClass("disabled");
    $(paginatorNextContainerSelector).attr("disabled", true);
  }

  if (pagesCount === 0 || pagesCount === 1) {
    $('#' + paginatorId + ' .' + settings.paginatorIndicatorsContainer).attr("style", "display: none !important;");
  } else if (pagesCount <= 7) {
    for (let i = 1; i < pagesCount + 1; i++) {
      createIndicator(paginatorContainerSelector, i, i === currentPage);
    }
  } else if (pagesCount > 7) {
    if (currentPage < 5) {
      for (let i = 1; i < pagesCount + 1; i++) {
        if (i < 6) {
          createIndicator(paginatorContainerSelector, i, i === currentPage);
        }
      }
      $(paginatorContainerSelector).append('<button disabled="true">...</button>');

    } else if (currentPage > pagesCount - 4) {
      createIndicator(paginatorContainerSelector, 1, 1 === currentPage);
      $(paginatorContainerSelector).append('<button disabled="true">...</button>');
      for (let i = pagesCount - 4; i < pagesCount; i++) {
        createIndicator(paginatorContainerSelector, i, i === currentPage);
      }
    } else {
      createIndicator(paginatorContainerSelector, 1, 1 === currentPage);
      $(paginatorContainerSelector).append('<button disabled="true">...</button>');
      if (currentPage + 1 < pagesCount) {
        createIndicator(paginatorContainerSelector, currentPage - 1, (currentPage - 1) === currentPage);
        createIndicator(paginatorContainerSelector, currentPage, currentPage === currentPage);
        createIndicator(paginatorContainerSelector, currentPage + 1, (currentPage + 1) === currentPage);
        $(paginatorContainerSelector).append('<button disabled="true">...</button>');
      }

    }
    createIndicator(paginatorContainerSelector, pagesCount, pagesCount === currentPage);
  }

  if (pagesCount > 1) {
    $('#' + paginatorId + ' .' + settings.paginatorIndicatorsContainer).show();
  }

  clearIndicatorClickHandler(paginatorContainerSelector.children('button'), paginatorPrevContainerSelector,
    paginatorNextContainerSelector);
  handleIndicatorClick(paginatorContainerSelector.children('button'), currentPage, pagesCount,
    paginatorContainerSelector,
    elements, perPage, paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings);
}

// Append one page button to the container specified as selector
function createIndicator(selector, pageNumber, isCurrent) {
  if (pageNumber === -1) {
    $(selector).append('<button disabled="true">...</button>');
  } else {
    if (isCurrent) {
      $(selector).append('<button class="current" data-value="' + pageNumber + '">' + pageNumber + '</button>');
    } else {
      $(selector).append('<button data-value="' + pageNumber + '">' + pageNumber + '</button>');
    }
  }
}

// Unbinds from click events
function clearIndicatorClickHandler(selector, paginatorPrevContainerSelector, paginatorNextContainerSelector) {
  $(selector).off();
  $(paginatorPrevContainerSelector).off();
  $(paginatorNextContainerSelector).off();
}

// Handle Page Indicator Click (FRONTEND PAGINATOR)
function handleIndicatorClick(selector, currentPage, pagesCount, paginatorContainerSelector, elements, perPage,
  paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings) {

  // Handle indicator click
  $(selector).click(function (event) {
    const paginatorId = $(this).parent().parent().parent().attr("id");
    const selector = $('#' + paginatorId).children(".tt-paginator-container").children(".pages").children("button");
    const paginatorContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .pages';
    const paginatorPrevContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .ttpaginator-prev';
    const paginatorNextContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .ttpaginator-next';
    settings.perPage = $("#" + paginatorId).data('per-page');
    settings.targetElementsClass = $("#" + paginatorId).data('target');
    elements = $("#" + paginatorId).children('.' + settings.targetElementsClass).not('.filtered');

    const clickedPage = $(this).data('value');
    const elementsCount = elements.length;
    const pagesCount = Math.ceil(elementsCount / settings.perPage);
    currentPage = clickedPage;
    console.log("Elements", elements);
    console.log("Target Elements Class", settings.targetElementsClass);
    console.log("paginatorId", paginatorId);

    removeIndicators(selector);
    drawIndicators(currentPage, pagesCount, paginatorContainerSelector, elements, perPage,
      paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings);
    showElements(elements, ((currentPage - 1) * perPage), (currentPage * perPage) - 1);
    if ($('#' + paginatorId).closest("section").length > 0)
      $('#' + paginatorId).closest("section").scrollintoview({
        duration: 300
      });
    else
      $('#' + paginatorId).closest(".main-container").scrollintoview({
        duration: 300
      });
  });

  // Handle Prev Click
  $(paginatorPrevContainerSelector).click(function () {
    const paginatorId = $(this).parent().parent().attr("id");
    const selector = $('#' + paginatorId).children(".tt-paginator-container").children(".pages").children("button");
    const paginatorContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .pages';
    const paginatorPrevContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .ttpaginator-prev';
    const paginatorNextContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .ttpaginator-next';
    settings.perPage = $("#" + paginatorId).data('per-page');
    settings.targetElementsClass = $("#" + paginatorId).data('target');
    elements = $("#" + paginatorId).children('.' + settings.targetElementsClass).not('.filtered');

    const elementsCount = elements.length;
    const pagesCount = Math.ceil(elementsCount / settings.perPage);
    if (currentPage > 1) {
      currentPage--;
      console.log("Elements", elements);
      console.log("Target Elements Class", settings.targetElementsClass);
      console.log("paginatorId", paginatorId);
      removeIndicators(selector);
      drawIndicators(currentPage, pagesCount, paginatorContainerSelector, elements, perPage,
        paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings);
      showElements(elements, ((currentPage - 1) * perPage), (currentPage * perPage) - 1);
      if ($('#' + paginatorId).closest("section").length > 0)
        $('#' + paginatorId).closest("section").scrollintoview({
          duration: 300
        });
      else
        $('#' + paginatorId).closest(".main-container").scrollintoview({
          duration: 300
        });
    }
  });

  // Handle Next Click
  $(paginatorNextContainerSelector).click(function () {
    const paginatorId = $(this).parent().parent().attr("id");
    const selector = $('#' + paginatorId).children(".tt-paginator-container").children(".pages").children("button");
    const paginatorContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .pages';
    const paginatorPrevContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .ttpaginator-prev';
    const paginatorNextContainerSelector = '#' + paginatorId + ' .' + settings
      .paginatorIndicatorsContainer +
      ' .ttpaginator-next';
    settings.perPage = $("#" + paginatorId).data('per-page');
    settings.targetElementsClass = $("#" + paginatorId).data('target');
    elements = $("#" + paginatorId).children('.' + settings.targetElementsClass).not('.filtered');
    const elementsCount = elements.length;
    const pagesCount = Math.ceil(elementsCount / settings.perPage);
    if (currentPage < pagesCount) {
      currentPage++;
      console.log("Elements", elements);
      console.log("Target Elements Class", settings.targetElementsClass);
      console.log("paginatorId", paginatorId);
      removeIndicators(selector);
      drawIndicators(currentPage, pagesCount, paginatorContainerSelector, elements, perPage,
        paginatorPrevContainerSelector, paginatorNextContainerSelector, paginatorId, settings);
      showElements(elements, ((currentPage - 1) * perPage), (currentPage * perPage) - 1);
      if ($('#' + paginatorId).closest("section").length > 0)
        $('#' + paginatorId).closest("section").scrollintoview({
          duration: 300
        });
      else
        $('#' + paginatorId).closest(".main-container").scrollintoview({
          duration: 300
        });
    }
  });
}

// Show elements from start to end
function showElements(elements, start, end) {
  for (let i = 0; i < elements.length; i++) {
    if (i >= start && i <= end) {
      $(elements[i]).show();
    } else {
      $(elements[i]).attr("style", "display: none !important;");
    }
  }

  // Manage border bottom of last publication items and children accordion elements
  const currentSection = $(elements).parents('section');
  _utils__WEBPACK_IMPORTED_MODULE_0__["default"].managePublicationListsBorders(currentSection);
}

function handleError() {

}

function showLoader(selector) {
  $(selector).append('<div class="pagination-loader"></div>'); // il log va ma non aggiunge il div
  console.log("Pagination Loader Visible!", $(selector));
}

function hideLoader(selector) {
  $(selector).remove(".pagination-loader");
  console.log("Pagination Loader Hidden!");
}


/***/ }),

/***/ "./src/scripts/common/tt-show-more.plugin.js":
/*!***************************************************!*\
  !*** ./src/scripts/common/tt-show-more.plugin.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

(function ($) {
  $.fn.ttShowMore = function (options, action) {
    var settings = $.extend({
      perPage: 2, // Number of elements added when showMore is clicked
      elementsContainerSelector: "", // Optional jQuery selector of the container where elements to be hidden and shown are placed
      targetElementsSelector: "", // Mandatory jQuery selector of the elements to be hidden or shown
      indicatorsContainerClass: "tt-show-more-indicators"
    }, options);

    return this.each(function () {
      const mainContainerSelector = '#' + $(this).attr('id');
      if (!mainContainerSelector || mainContainerSelector === "#undefined") {
        console.error("TTShowMore: Please set an ID on the main container on which .ttShowMore is applied!");
      } else {
        // Set Settings as per data attributes
        settings.perPage = $(this).data("per-page");
        settings.elementsContainerSelector = $(this).data("elements-container-selector");
        settings.targetElementsSelector = $(this).data("target-selector");

        // Build jQuery selector for the elements to be shown or hidden
        const completeTargetElementsSelector = mainContainerSelector + " " + settings
          .elementsContainerSelector + " " +
          settings.targetElementsSelector;
        // Build jQuery selector for View More and View Less buttons
        const viewMoreSelector = mainContainerSelector + " ." + settings.indicatorsContainerClass +
          " .view-more";
        const viewLessSelector = mainContainerSelector + " ." + settings.indicatorsContainerClass +
          " .view-less";

        // Inject the HTML container and buttons into the DOM
        injectIndicatorsContainer(mainContainerSelector, settings.indicatorsContainerClass);

        // Get an array of target elements
        const allElements = $(this).children(settings.targetElementsSelector + ':visible');
        console.log("All elements", allElements);

        // Show first n elements
        showElements(allElements, 0, settings.perPage);

        if (allElements.length < settings.perPage) {
          toggleIndicatorsContainer(false, mainContainerSelector, settings.indicatorsContainerClass);
        }

        // Bind to indicator click
        var showMultiplier = 1;
        $(viewMoreSelector).click(function () {
          showMultiplier++;
          showElements(allElements, 0, settings.perPage * showMultiplier);
          handleShowHideButtons(viewMoreSelector, viewLessSelector, settings.perPage, showMultiplier,
            allElements);
        });

        $(viewLessSelector).click(function () {
          showMultiplier = 1;
          showElements(allElements, 0, settings.perPage);
          handleShowHideButtons(viewMoreSelector, viewLessSelector, settings.perPage, showMultiplier,
            allElements);
        })
      }
    });

  };

}(jQuery));

// Inject the HTML container and buttons into the DOM
function injectIndicatorsContainer(mainContainerSelector, indicatorsContainerClass) {
  const indicatorsHtml =
    '<div class="view-more-box ' + indicatorsContainerClass +
    '"> <button class="btn view-more text-uppercase">View more<i class="d-block icon-arrow-down-small"></i></button><button class="btn view-less text-uppercase" style="display: none;"><i class="d-block icon-arrow-up"></i>View less</button></div>';
  $(mainContainerSelector).append(indicatorsHtml);
}

function toggleIndicatorsContainer(showHide, mainContainerSelector, indicatorsContainerClass) {
  if (showHide === true) {
    $(mainContainerSelector + ' .' + indicatorsContainerClass).show();
  } else {
    $(mainContainerSelector + ' .' + indicatorsContainerClass).hide();
    console.log("TTShowMore: Indicators hidden due to perPage > elements count")
  }
}

function showButton(buttonSelector) {
  $(buttonSelector).show();
}

function hideButton(buttonSelector) {
  $(buttonSelector).hide();
}

function showElements(allElements, startIndex, endIndex) {
  for (let i = 0; i < allElements.length; i++) {
    if (i >= startIndex && i < endIndex) {
      $(allElements[i]).show();
    } else {
      $(allElements[i]).hide();
    }
  }
}

function handleShowHideButtons(viewMoreSelector, viewLessSelector, perPage, showMultiplier, allElements) {
  if (showMultiplier === 1) {
    showButton(viewMoreSelector);
    hideButton(viewLessSelector);
  }

  if ((showMultiplier * perPage) >= allElements.length) {
    showButton(viewLessSelector);
    hideButton(viewMoreSelector);
  }
}


// TT Show More Utils
$(() => {
  const elements = '[data-show-more="true"]';
  $(elements).ttShowMore();
});


/***/ }),

/***/ "./src/scripts/common/utils.js":
/*!*************************************!*\
  !*** ./src/scripts/common/utils.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Utils; });
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobile-detect */ "./node_modules/mobile-detect/mobile-detect.js");
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mobile_detect__WEBPACK_IMPORTED_MODULE_0__);


class Utils {

  static isMobile() {
    const detect = new mobile_detect__WEBPACK_IMPORTED_MODULE_0___default.a(window.navigator.userAgent);
    return detect.mobile() !== null;
  }

  static isPhone() {
    const detect = new mobile_detect__WEBPACK_IMPORTED_MODULE_0___default.a(window.navigator.userAgent);
    return detect.phone() !== null;
  }
  static isIosDevice() {
    if (typeof window !== 'undefined' && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window
      .navigator.platform)) {
      return true;
    } else {
      return false;
    };
  };

  static isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || navigator.userAgent.indexOf("Edge") > 0 ?
      true : false;
  }

  static ellipse(str, n) {
    return str.length > n ? str.substr(0, n) + '...' : str;
  }

  static getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    return parts.length < 2 ?
      undefined :
      parts
        .pop()
        .split(';')
        .shift();
  };

  static setCookie(name, value, expiryDays, domain, path, secure) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + (expiryDays || 365));

    var cookie = [
      name + '=' + value,
      'expires=' + exdate.toUTCString(),
      'path=' + (path || '/')
    ];

    if (domain) {
      cookie.push('domain=' + domain);
    }
    if (secure) {
      cookie.push('secure');
    }
    document.cookie = cookie.join(';');
  };

  static getLocalStorage(localStorageKey, localStorageEncrypt) {
    const currentLang = $('html')[0].lang;
    var localStorageValue = localStorage.getItem(localStorageKey + '_' + currentLang);
    if (localStorageValue && localStorageEncrypt) {
      return atob(localStorageValue);
    } else if (localStorageValue && !localStorageEncrypt) {
      return localStorageValue;
    } else {
      return undefined;
    }
  }

  static setLocalStorage(localStorageKey, localStorageValue, localStorageEncrypt) {
    const currentLang = $('html')[0].lang;
    if (localStorageEncrypt) {
      localStorageValue = btoa(localStorageValue);
    }
    localStorage.setItem(localStorageKey + '_' + currentLang, localStorageValue);
  }

  static isInViewport(el) {
    const elementTop = $(el).offset().top;
    const elementBottom = elementTop + $(el).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > (viewportTop + ($(el).outerHeight() / 3 * 2)) && elementTop < (viewportBottom + ($(el)
      .outerHeight() / 3 * 2));
  };

  static closeShareModal() {
    const container = $('#share-dropdown');
    if (container && container.length > 0) {
      for (let i = 0; i < container.length; i++) {
        if ($(container[i]).is(':visible')) {
          //  setTimeout(function() {
          $(container[i]).hide();
          // }, 300);
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  static convertDateForCalendars(date, isStarting, isPrimitive) {
    if (!isPrimitive) {
      var date = date.toString();
      var dates = date.split('/');
      var newDate = new Date();
      newDate.setYear(dates[2]);
      newDate.setMonth(Number(dates[1]) - 1);
      newDate.setDate(dates[0]);
    } else {
      var newDate = new Date(date);
      console.log('new date from primitive', newDate);
    }

    if (isStarting == true) {
      newDate.setHours('00');
      newDate.setMinutes('00');
      newDate.setSeconds('00');
    } else {
      newDate.setHours('23');
      newDate.setMinutes('59');
      newDate.setSeconds('59');
    }

    return newDate.valueOf();
  }

  static stopBodyScrollingiOSPreventFunction(e) {
    e.preventDefault();
  };

  static stopBodyScrollingiOS(bool) {
    if (this.isIosDevice) {
      if (bool === true) {
        document.body.addEventListener('touchmove', this.stopBodyScrollingiOSPreventFunction, {
          passive: false
        });
      } else {
        document.body.removeEventListener("touchmove", this.stopBodyScrollingiOSPreventFunction, {
          passive: false
        });
      }
    }
  };

  static checkLastVisiblePublicationItem(currentSection) {

    const allPublicationItems = $(currentSection).find(
      '.publications-item-container .list-item');
    if (allPublicationItems.length > 0) {
      for (let i = 0; i < allPublicationItems.length; i++) {
        const publicationItem = allPublicationItems[i];
        if ($(publicationItem).hasClass('nbb')) {
          $(publicationItem).removeClass('nbb');
        }
      }
    }

    const allAccordionsItems = $(currentSection).find(
      '.publications-item-container .accordion.accordion-container');
    if (allAccordionsItems.length > 0) {
      for (let i = 0; i < allAccordionsItems.length; i++) {
        const accordionItem = allAccordionsItems[i];
        if ($(accordionItem).hasClass('nbb')) {
          $(accordionItem).removeClass('nbb');
        }
      }
    }

    const currentSectionLastVisiblePublicationItem = $(currentSection).find(
      '.publications-item-container .list-item:visible:last');
    const currentSectionLastVisibleAccordionItem = $(currentSection).find(
      '.publications-item-container .accordion.accordion-container:visible:last');

    if ((currentSectionLastVisiblePublicationItem.length + currentSectionLastVisibleAccordionItem.length) > 1) {
      const isLastVisiblePublicationItemAnAccordion = !currentSectionLastVisiblePublicationItem.is(
        currentSectionLastVisibleAccordionItem);

      if (isLastVisiblePublicationItemAnAccordion) {
        $(currentSectionLastVisibleAccordionItem).addClass('nbb');
      } else {
        $(currentSectionLastVisiblePublicationItem).addClass('nbb');
      }
    } else if ((currentSectionLastVisiblePublicationItem.length + currentSectionLastVisibleAccordionItem.length) ===
      1) {
      if (currentSectionLastVisiblePublicationItem.length > 0) {
        $(currentSectionLastVisiblePublicationItem).addClass('nbb');
      } else {
        $(currentSectionLastVisibleAccordionItem).addClass('nbb');
      }
    }
  }

  static checkLastVisibleAccordionsElement(currentSection) {
    const currentSectionAccordions = $(currentSection).find('.accordion.accordion-container');
    for (let i = 0; i < currentSectionAccordions.length; i++) {
      const currentSectionAccordion = currentSectionAccordions[i];

      // Find all accordion detail items and check if all of them have hidden class
      const accordionDetailItems = $(currentSectionAccordion).find('.accordion-detail-item');

      if (accordionDetailItems && accordionDetailItems.length > 0) {
        for (let i = 0; i < accordionDetailItems.length; i++) {
          //Check if has nbb class then remove it
          if ($(accordionDetailItems[i]).hasClass('nbb')) {
            $(accordionDetailItems[i]).removeClass('nbb');
          }
        }
        // Check last visible accordion children
        for (let j = accordionDetailItems.length - 1; j >= 0; j--) {
          const accordionDetailItem = accordionDetailItems[j];
          if ($(accordionDetailItem).css('display') !== 'none') {
            $(accordionDetailItem).addClass('nbb');
            break;
          }
        }
      }
    }
  }

  static managePublicationListsBorders(currentSection) {
    const publicationListContainers = $(currentSection).find('.publications-item-container');
    const thereArePublicationLists = publicationListContainers && publicationListContainers.length > 0 ? true : false;
    if (thereArePublicationLists) {
      this.checkLastVisiblePublicationItem(currentSection);
      this.checkLastVisibleAccordionsElement(currentSection);
    }
  }

  static truncateDropdownButtonText(dropdownButtonText) {
    const trimmedDropdownButtonText = dropdownButtonText.trim();
    if (trimmedDropdownButtonText.length > 20)
      return trimmedDropdownButtonText.substring(0, 20) + '...';
    else
      return trimmedDropdownButtonText;
  };

  static b64toBlob(b64Data, contentType = 'application/pdf', sliceSize = 512) {
    // contentType = contentType || 'image/png';
    // sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}


/***/ }),

/***/ "./src/scripts/common/yt-utils.js":
/*!****************************************!*\
  !*** ./src/scripts/common/yt-utils.js ***!
  \****************************************/
/*! exports provided: YtUtils */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YtUtils", function() { return YtUtils; });
/* harmony import */ var _common_digital_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/digital-data */ "./src/scripts/common/digital-data.js");


const YT_API_SRC = "https://www.youtube.com/player_api";

const BASE_RATIO = 16 / 9;

var onYouTubeIframeAPIReadyCallbacks = [];

window.onYouTubeIframeAPIReady = () => {
  console.log('onYouTubeIframeAPIReady');
  onYouTubeIframeAPIReadyCallbacks.forEach(ytUtils => {
    setTimeout(() => {
      ytUtils.createPlayer();
    }, 500);
  });
};

class YtUtils {
  constructor(playerId, ytId, playerDefaults, isAutoPlay, heightPriority) {
    this.player = null;
    this.playerId = playerId;
    this.ytId = ytId;
    this.playerDefaults = playerDefaults;
    this.isAutoPlay = isAutoPlay || false;
    this.heightPriority = heightPriority || false;
    this.checkYtScript();
    // window.onYouTubeIframeAPIReady();

    $(document).ready(() => {
      setTimeout(() => {
        window.onYouTubeIframeAPIReady();
      }, 100);
    });
  }

  get YTPlayer() {
    return this.player;
  }

  get PlayerId() {
    return this.playerId;
  }

  createPlayer() {

    console.log('YtUtils createPlayer playerId', this.playerId);
    console.log('YtUtils createPlayer player', this.player);
    //console.log( 'YtUtils createPlayer', YT );

    if (this.playerId && this.player === null) {
      console.log('YtUtils YT.Player', YT.Player);
      console.log('YtUtils YT', YT);
      this.player = new YT.Player(this.playerId, {
        events: {
          onReady: event => this.onPlayerReady(event),
          onStateChange: event => this.onPlayerStateChange(event, this.playerDefaults)
        },
        playerVars: this.playerDefaults
      });
    } else {
      console.log('YtUtils createPlayer NOP');
    }
  }

  onPlayerReady(event) {
    console.log('event', event);
    const isArray = Array.isArray(this.ytId);
    console.log('YtUtils onPlayerReady isAutoPlay', this.ytId, this.isAutoPlay);
    if (this.isAutoPlay) {
      //const container = $(event.target.f).parent();
      // const container = $(event.target.i).parent();
      const container = $(event.target.getIframe().parentNode);
      console.log('YtUtils onPlayerReady container', isArray, event.target, event.target.h);
      //START push digitalData
      const section = container.closest('section.media-detail-cover');
      if (section.length > 0) _common_digital_data__WEBPACK_IMPORTED_MODULE_0__["DigitalDataUtils"].handleClickItemFormatVideo(section);
      //END push digitalData

      this.setSize(container, event.target);
      if (isArray) {
        event.target.loadPlaylist(this.ytId);
      } else {

        event.target.loadVideoById(this.ytId);
      }
    } else {
      if (isArray) {
        event.target.cuePlaylist(this.ytId);
      } else {
        event.target.cueVideoById(this.ytId);
      }
    }
  }

  onPlayerStateChange(event, playerdefaults) {
    if (event && event.data === 0 && playerdefaults.loop && playerdefaults.loop === 1) {
      event.target.playVideo();
    }
  }

  setSize(container, player) {
    console.log('YtUtils setSize', container, player);
    const w = $(container).width();
    const h = $(container).height();
    console.log('YtUtils setSize', w, h);
    const ratio = w / h;

    if (this.heightPriority === true) {
      player.setSize(w, h);
    } else {
      if (w > 1024) {
        if (ratio > BASE_RATIO) {
          // player.setSize(w, w / 16 * 9);
          player.setSize(w, h);
        } else {
          // player.setSize(h / 9 * 16, h);
          player.setSize(w, h);
        }
      } else {
        player.setSize(w, h);
      }
    }
  }

  startVideo(container) {
    if (this.player) {
      if (container) {
        this.setSize(container, this.player);
      }
      if (typeof this.player.playVideo == "function") {
        this.player.playVideo();
      } else {
        setTimeout(() => {
          this.player.playVideo();
        }, 1000);
      }
    }
  }

  pauseVideo() {
    if (this.player) {
      if (typeof this.player.pauseVideo == "function") {
        this.player.pauseVideo();
      } else {
        setTimeout(() => {
          this.player.pauseVideo();
        }, 1000);
      }
    }
  }

  pauseVideoFull() {
    if (this.player) {
      if (typeof this.player.pauseVideo == "function") {
        this.player.pauseVideo();
        this.player.destroy();
      } else {
        setTimeout(() => {
          this.player.pauseVideo();
          this.player.destroy();
        }, 1000);
      }
    }
  }

  stopVideo() {
    if (typeof this.player.stopVideo == "function") {
      this.player.stopVideo();

    } else {
      setTimeout(() => {
        this.player.stopVideo();

      }, 1000);
    }
  }

  static createInstance(playerId, ytId, playerDefaults, isAutoPlay, heightPriority) {
    const ytUtils = new YtUtils(playerId, ytId, playerDefaults, isAutoPlay, heightPriority);
    onYouTubeIframeAPIReadyCallbacks.push(ytUtils);
    return ytUtils;
  }

  checkYtScript() {
    console.log('YtUtils checkYtScript');

    // check if yt script exists
    let ytScript = $(document).find(`script[src="${YT_API_SRC}"]`);
    if (ytScript.length === 0) {
      ytScript = document.createElement("script");
      ytScript.src = YT_API_SRC;
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(ytScript, firstScriptTag);
    }
  }
}

$(window).on("resize", () => {
  onYouTubeIframeAPIReadyCallbacks.forEach(ytUtils => {
    if (ytUtils.player && ytUtils.player.f) {
      const container = $(ytUtils.player.f).parent();
      ytUtils.setSize(container, ytUtils.player);
    }
  });
});


/***/ }),

/***/ "./src/scripts/header/header-rich-text-carousel.js":
/*!*********************************************************!*\
  !*** ./src/scripts/header/header-rich-text-carousel.js ***!
  \*********************************************************/
/*! exports provided: RichTextAnchrosCarousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RichTextAnchrosCarousel", function() { return RichTextAnchrosCarousel; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class RichTextAnchrosCarousel {

  constructor(bindClass) {
    this.richTextAnchrosCarousel = Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 20,
      navText: [],
      rewind: false,
    }, true);

    // Active items handling based on paragraph visibility during scroll
    this.handleRichTextActiveItems();

    // Scroll to target paragraph handling
    $('.eni-header-rich-text .owl-item').click((e) => this.handleClick(e));

    // Click and longpress on navigation arrow
    let scrollLeftIntervalId = 0;
    let scrollRightIntervalId = 0;

    // Go to the previous item with longpress
    $('.owl-prev').on('mousedown touchstart', (event) => {
      scrollLeftIntervalId = setInterval(() => {
        this.richTextAnchrosCarousel.trigger('prev.owl.carousel', [500]);
      }, 500);
    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollLeftIntervalId);
    });

    // Go to the next item with longpress
    $('.owl-next').on('mousedown touchstart', (event) => {
      scrollRightIntervalId = setInterval(() => {
        this.richTextAnchrosCarousel.trigger('next.owl.carousel', [500]);
      }, 500);
    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollRightIntervalId);
    });
  }

  updateRichTextActiveItems(richTextSections, notAnchoredRichTextSections) {
    const scrollDistance = window.pageYOffset || document.documentElement.scrollTop;

    for (let i = 0; i < richTextSections.length; i++) {
      const richTextSection = richTextSections[i];

      if ($(richTextSection).position().top - $('.eni-header').height() - 20 <= scrollDistance) {
        if ($(richTextSection).data('menu') && $(richTextSection).data('menu') === 1) {
          $('.eni-header-rich-text .owl-item a.active').removeClass('active');
          $('.eni-header-rich-text .owl-item a').eq(i).addClass('active');
        } else {
          $('.eni-header-rich-text .owl-item a.active').removeClass('active');
        }
      }
    }
  };

  handleClick(e) {
    e.preventDefault();
    const currentRichTextItem = $(e.currentTarget).children('.rich-text-tab');
    const currentRichTextItemHref = $(currentRichTextItem).attr('href');
    const richTextParagraphToReach = $(currentRichTextItemHref);
    const richTextParagraphPosition = $(richTextParagraphToReach).offset().top;

    const headerHeight = $('.eni-header').height();
    const scrollOffset = headerHeight;
    let scrollYPosition = richTextParagraphPosition - scrollOffset - 10;

    window.scrollTo({
      top: scrollYPosition,
      left: 0,
      behavior: 'smooth'
    });
  }

  handleRichTextActiveItems() {
    const richTextSections = $('.rich-text-section');

    if (richTextSections && richTextSections.length > 0) {

      this.updateRichTextActiveItems(richTextSections);
      document.addEventListener("scroll", () => {
        this.updateRichTextActiveItems(richTextSections);
      });
    }
  }
}

window.addEventListener('load', () => {
  const component = new RichTextAnchrosCarousel('.rich-text-anchors-carousel.carousel-container .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/header/header-search-carousel.js":
/*!******************************************************!*\
  !*** ./src/scripts/header/header-search-carousel.js ***!
  \******************************************************/
/*! exports provided: HeaderSearchCarousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderSearchCarousel", function() { return HeaderSearchCarousel; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class HeaderSearchCarousel {

  constructor(bindClass) {
    this.headerSearchCarousel = Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 20,
      navText: [],
      rewind: false,
    }, true);

    // Click and longpress on navigation arrow
    let scrollLeftIntervalId = 0;
    let scrollRightIntervalId = 0;

    // Go to the previous item with longpress
    $('.owl-prev').on('mousedown touchstart', (event) => {
      scrollLeftIntervalId = setInterval(() => {
        this.headerSearchCarousel.trigger('prev.owl.carousel', [500]);
      }, 500);
    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollLeftIntervalId);
    });

    // Go to the next item with longpress
    $('.owl-next').on('mousedown touchstart', (event) => {
      scrollRightIntervalId = setInterval(() => {
        this.headerSearchCarousel.trigger('next.owl.carousel', [500]);
      }, 500);
    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollRightIntervalId);
    });

  }
}

window.addEventListener('load', () => {
  const component = new HeaderSearchCarousel('.search-header-carousel.carousel-container .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/header/header.component.js":
/*!************************************************!*\
  !*** ./src/scripts/header/header.component.js ***!
  \************************************************/
/*! exports provided: HEADER_PROPS, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADER_PROPS", function() { return HEADER_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeaderComponent; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");
/* harmony import */ var _common_animate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/animate */ "./src/scripts/common/animate.js");





const HEADER_PROPS = {
  EXPLORE_MENU: {
    EXPLORE_CLASS: "aside.enicom-explore",
    EXPLORE_TITLE: "aside.enicom-explore .explore-menu-title",
    EXPLORE_BTN_CLOSE_ID: "#explore-menu-btn-close",
    EXLORE_BTN_ID: "#explore-button",
    EXLORE_BTN_EXTERNAL_ID: "#explore-button-external",
    EXPLORE_TAB_TOPIC_BTN_ID: "#category-topic",
    EXPLORE_TAB_FORMAT_BTN_ID: "#category-format",
    EXPLORE_TAB_TOPIC_CONTENT_CLASS: ".topic-container",
    EXPLORE_TAB_FORMAT_CONTENT_CLASS: ".format-container",
    EXPLORE_PADDLE_NAVIGATION_BREAKPOINT: 1024, // $lg
    EXPLORE_MENU_CONTAINER_CLASS: ".eni-firstlevel-explore-menu",
    EXPLORE_MENU_STATIC_ITEM_CLASS: ".eni-firstlevel-explore-menu-listitem-default",
    EXPLORE_MENU_STATIC_LAST_ITEM_CLASS: ".eni-firstlevel-explore-menu-listitem-default:last",
    EXPLORE_MENU_ITEM_CLASS: ".eni-firstlevel-explore-menu .eni-firstlevel-explore-menu-listitem-dynamic",
    EXPLORE_MENU_LAST_ITEM_CLASS: ".eni-firstlevel-explore-menu .eni-firstlevel-explore-menu-listitem-dynamic:last",
    EXPLORE_MENU_MOBILE_BUTTON_CLASS: ".eni-firstlevel-explore-menu .eni-firstlevel-explore-menu-listitem-explore-action",
    EXPLORE_MENU_ITEM_CLASS_FIRST_LEVEL: ".eni-firstlevel-explore-menu-item"
  },
  EXPLORE_CARD: {
    CLASS: ".explore-scroll .explore-menu-card",
    PRINCIPAL_CLASS: ".explore-scroll .principal-cards-container .explore-menu-card",
    ADDED_CLASS: "added",
    ADDED_STATUS: "added-to-menu-status",
    REMOVED_STATUS: "removed-from-menu-status",
    LINK_CLASS: ".explore-card-link",
    ADD_REMOVE_BTN_CLASS: ".btn.add-remove-btn"
  },
  HEADER_MAIN: {
    MAIN_HEADER_CLASS: "header.eni-header",
    PRE_HEADER_ID: "#eni-pre-header",
    PRE_HEADER_DESKTOP_HEIGHT: 74,
    SEARCH_BAR_ID: "#eni-header-always-visible-container",
    LANGUAGE_DROPDOWN_BUTTON_CLASS: ".eni-preheader-language-dropdown",
    OUR_CHANNEL_BTN_ID: "#preheader-menu-our-channels-btn",
    MOBILE_OUR_CHANNEL_BTN_ID: "#preheader-menu-mobile-our-channels-btn",
    OUR_CHANNEL_CLOSE_BTN_ID: '#close-our-channels-btn',
    MOBILE_HEADER_BREAKPOINT: 1024 //$lg,
  },
  HEADER_SEARCH: {
    MINIMUM_DESKTOP_SEARCHBAR_CONTAINER_HEIGHT: 285,
    MAXIMUM_DESKTOP_SEARCHBAR_CONTAINER_HEIGHT: 115,
    INDEX_DESKTOP_SEARCHBAR_CONTAINER_HEIGHT: 2.428,
    MINIMUM_DESKTOP_SEARCHBAR_HEADER_INPUT_FONT_SIZE: 36,
    MAXIMUM_DESKTOP_SEARCHBAR_HEADER_INPUT_FONT_SIZE: 18,
    INDEX_DESKTOP_SEARCHBAR_HEADER_INPUT_FONT_SIZE: 0.257,
    MINIMUM_DESKTOP_SEARCHBAR_HEADER_ICON_FONT_SIZE: 24,
    MAXIMUM_DESKTOP_SEARCHBAR_HEADER_ICON_FONT_SIZE: 20,
    INDEX_DESKTOP_SEARCHBAR_HEADER_ICON_FONT_SIZE: 0.057,
    MINIMUM_DESKTOP_MAIN_WRAPPER_MARGIN_TOP: 423,
    MAXIMUM_DESKTOP_MAIN_WRAPPER_MARGIN_TOP: 330,
    INDEX_DESKTOP_MAIN_WRAPPER_MARGIN_TOP: 1.328,
  },
  CLASSES: {
    MAIN_CONTAINER_CLASS: ".main-container",
    MAIN_WRAPPER_CLASS: ".main-wrapper",
    HOME_PAGE_CONTAINER_CLASS: "home-page",
    SEARCH_PAGE_CONTAINER_CLASS: "search-page",
    SEARCH_BAR_CONTAINER_CLASS: ".eni-searchbar-container",
    SEARCH_INPUT_CLASS: ".eni-searchbar-header-input",
    MODAL_SEARCH_INPUT_CLASS: ".eni-search-modal-input",
    VOCAL_SEARCH_HEADER_BUTTON_CLASS: "button.eni-searchbar-vocal-search",
    CLEAR_SEARCH_HEADER_BUTTON_CLASS: "button.eni-searchbar-header-clear",
    VOCAL_SEARCH_MODAL_BUTTON_CLASS: "button.eni-search-modal-vocal-search",
    CLEAR_SEARCH_MODAL_BUTTON_CLASS: "button.eni-search-modal-clear",
    VOCAL_SEARCH_MODAL_ABORT_SEARCH_BUTTON_CLASS: "button.eni-search-modal-abort-vocal-search",
    SEARCH_INPUT_ICON_CLASS: ".eni-searchbar-header-icon",
    BODY_UNSCROLLABLE_CLASS: "unscrollable",
    STICKY_CLASS: "sticky",
    HIDDEN_MOBILE_CLASS: "hader-mobile-hidden",
    HEADER_LIGHT_CLASS: "header-light",
    HEADER_LIGHT_PARTIAL_CLASS: "header-light-partial",
    HEADER_LIGHT_PARTIAL_MOBILE_CLASS: "header-light-partial-mobile",
    SLIDE_IN_DOWN_CLASS: "slideInDown",
    SLIDE_IN_UP_CLASS: "slideInUp",
    MOBILE_SEARCH_MODAL_ID: "#mobileSearchModal",
    MOBILE_SEARCH_MODAL_VOCAL_SEARCH_LOADING_CLASS: ".vocal-search",
    MOBILE_SEARCH_MODAL_SEARCH_LINKS_CLASS: ".search-links",
    ADD_REMOVE_BTN_SECTION_CORPORATE_A_CLASS: ".btn-add-remove-section-corporate-a",
    ADD_REMOVE_BTN_SECTION_MAGAZINE_CLASS: ".btn-add-remove-section-magazine",
  },
  STORAGE: {
    EXPLORE_MENU: {
      KEY: "explore_menu",
      ENCODING: false // true in production
    }
  }
};
class HeaderComponent {
  constructor(exploreMenu) {
    if(!$('header.eni-header').hasClass('header-enicountry')){
      this.syncExploreStorageWithHtml(true);
    }
    this.handleExploreMenu();
    this.handleScroll();
    this.handlePreHeaderButtons();
    this.handleContainerClass();
    this.handleMobileModal();
    this.handleSearchClearButton();
    this.handleSearchOpenButton();
    // this.getLocation();
  }

  // getLocation(){
  //   console.log('location', $(location).attr('href'));
  //   var loc = $(location).attr('href');
  //   console.log('location', loc);
  //   if(loc.includes("ricerca.html")){
  //     $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_HEADER_BUTTON_CLASS).hide();
  //     $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_HEADER_BUTTON_CLASS).show();
  //   } else if (loc.includes("search-template")){
  //     console.log('pippo');
  //     $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_HEADER_BUTTON_CLASS).hide();
  //     $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_HEADER_BUTTON_CLASS).show();
  //   }
  // }

  syncExploreStorageWithHtml(init) {
    // Get local storage
    var headerStorage = _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].getLocalStorage(
      HEADER_PROPS.STORAGE.EXPLORE_MENU.KEY,
      HEADER_PROPS.STORAGE.EXPLORE_MENU.ENCODING
    );

    // Populate local storage with default principale explore menu cards
    if (!headerStorage && init) {
      const exploreMenuPrincipalCards = $(HEADER_PROPS.EXPLORE_CARD.PRINCIPAL_CLASS);

      if (exploreMenuPrincipalCards && exploreMenuPrincipalCards.length > 0) {
        for (let i = 0; i < exploreMenuPrincipalCards.length; i++) {
          const dataInfo = this.getExploreMenuCardDataAttributesObj($(exploreMenuPrincipalCards[i]).data());
          this.addRemoveExploreMenuCard(exploreMenuPrincipalCards[i], dataInfo, 'true');
        }
        headerStorage = _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].getLocalStorage(
          HEADER_PROPS.STORAGE.EXPLORE_MENU.KEY,
          HEADER_PROPS.STORAGE.EXPLORE_MENU.ENCODING
        );
      }
    }


    // Parse local storage
    if (headerStorage) {
      var exploreMenuStorageDynamicElementsArray = JSON.parse(headerStorage);
    };

    // Get html explore firstlevel menu items
    var exploreMenuHtmlDynamicElementsArray = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_ITEM_CLASS);

    // Get html explore menu items
    var exploreMenuCards = $(HEADER_PROPS.EXPLORE_CARD.CLASS);

    if (exploreMenuStorageDynamicElementsArray) {
      // Enable following line if firstlevel explore menu must cotain at least 1 dynamic item
      /* if (exploreMenuHtmlDynamicElementsArray.length > 0) { */

      // Compare local storage items with html firstlevel menu items and prepare missing items
      // that will be added
      var exploreFirstLevelMenuHtmlDynamicElementsToBeAdded = [];

      function comparerStorageWithHtml(htmlArray) {
        return function (current) {
          return (
            htmlArray.filter(function (i) {
              return htmlArray[i].dataset.id ? htmlArray[i].dataset.id == current.id : false;
            }).length == 0
          );
        };
      }

      function comparerHtmlWithStorage(storageArray) {
        return function (i) {
          return (
            storageArray.filter(function (storageItem) {
              return storageItem.id == exploreMenuHtmlDynamicElementsArray[i].dataset.id;
            }).length == 0
          );
        };
      }

      // Compare storage items with firstlevel menu items and create an array with items to add
      exploreFirstLevelMenuHtmlDynamicElementsToBeAdded = exploreMenuStorageDynamicElementsArray.filter(
        comparerStorageWithHtml(exploreMenuHtmlDynamicElementsArray)
      );

      if (exploreMenuStorageDynamicElementsArray && exploreFirstLevelMenuHtmlDynamicElementsToBeAdded.length > 0) {
        for (var i = 0; i < exploreFirstLevelMenuHtmlDynamicElementsToBeAdded.length; i++) {
          // Sync Explore Firstlevel Menu Items -> Add
          this.addExploreFirstlevelMenuItem(exploreFirstLevelMenuHtmlDynamicElementsToBeAdded[i]);

          if (init) {
            // Sync Explore Menu Items (Cards) -> Edit active css class
            this.editExploreMenuItems(exploreFirstLevelMenuHtmlDynamicElementsToBeAdded[i], exploreMenuCards);
          }
        }
      }

      if (!init) {
        // Sync Explore Firstlevel Menu Items -> Remove and Animate (when closing explore menu)
        var exploreFirstLevelMenuHtmlDynamicElementsToBeRemoved = exploreMenuHtmlDynamicElementsArray.filter(
          comparerHtmlWithStorage(exploreMenuStorageDynamicElementsArray)
        );

        var afterSlideInDownAnimation = function (exploreMenuItem) {
          setTimeout(() => {
            $(exploreMenuItem).remove();
          }, 1000);
        };

        if (
          exploreFirstLevelMenuHtmlDynamicElementsToBeRemoved &&
          exploreFirstLevelMenuHtmlDynamicElementsToBeRemoved.length > 0
        ) {
          for (var i = 0; i < exploreFirstLevelMenuHtmlDynamicElementsToBeRemoved.length; i++) {
            console.log("To remove: ", exploreFirstLevelMenuHtmlDynamicElementsToBeRemoved[i]);
            Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
              exploreFirstLevelMenuHtmlDynamicElementsToBeRemoved[i],
              _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_OUT_DOWN,
              afterSlideInDownAnimation(exploreFirstLevelMenuHtmlDynamicElementsToBeRemoved[i])
            );
          }
          setTimeout(() => {
            this.handleExploreMenuScrolling();
          }, 1000);
        }

        // Sync Explore Firstlevel Menu Items -> Animate (when closing explore menu)
        if (
          exploreFirstLevelMenuHtmlDynamicElementsToBeAdded &&
          exploreFirstLevelMenuHtmlDynamicElementsToBeAdded.length > 0
        ) {
          for (var i = 0; i < exploreFirstLevelMenuHtmlDynamicElementsToBeAdded.length; i++) {
            var exploreMenuItemToBeAnimated = $(
              HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_ITEM_CLASS +
              '[data-id="' +
              exploreFirstLevelMenuHtmlDynamicElementsToBeAdded[i].id +
              '"]'
            );
            Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(exploreMenuItemToBeAnimated[0], _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].SLIDE_IN_UP);
            var yellowLink = $(
              HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_ITEM_CLASS +
              '[data-id="' +
              exploreFirstLevelMenuHtmlDynamicElementsToBeAdded[i].id +
              '"]' +
              " .eni-firstlevel-explore-menu-item"
            );

            $(yellowLink[0]).css({
              'color': '#ffd300'
            });
            window.setInterval(() => {
              $('.eni-firstlevel-explore-menu-item').css({
                'color': '#ffffff'
              });
            }, 2000);
            window.setInterval(() => {
              $('.header-light .eni-firstlevel-explore-menu-item').css({
                'color': '#333333'
              });
            }, 2000);
          }
          this.handleExploreMenuScrolling(true);
        }
      } else {
        this.handleExploreMenuScrolling();
      }

      /* } */
    } else {
      this.handleExploreMenuScrolling();
    }

    // Handle Add Remove Buttons Section Corporate A after Sync of explore storage with html
    if (init) {
      this.handleAddRemoveButtonsSectionCorporateA();
    }
  }

  unmapCardsClick() {
    try {
      var exploreMenuCards = $(HEADER_PROPS.EXPLORE_CARD.CLASS);
      if (exploreMenuCards && exploreMenuCards.length > 0) {
        for (let i = 0; i < exploreMenuCards.length; i++) {
          var exploreMenuCardAddRemoveButton = $(exploreMenuCards[i])
            .children()
            .children(HEADER_PROPS.EXPLORE_CARD.ADD_REMOVE_BTN_CLASS);
          if (exploreMenuCardAddRemoveButton) {
            $(exploreMenuCardAddRemoveButton).off("click");
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  handleExploreMenu() {
    try {
      this.body = $("body");
      this.exploreMenu = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_CLASS)[0];
      this.exploreMenuTopicTabContent = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_TAB_TOPIC_CONTENT_CLASS);
      this.exploreMenuFormatTabContent = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_TAB_FORMAT_CONTENT_CLASS);
      if (this.exploreMenu) {
        let exploreBtn = $(HEADER_PROPS.EXPLORE_MENU.EXLORE_BTN_ID);
        let exploreBtnExternal = $(HEADER_PROPS.EXPLORE_MENU.EXLORE_BTN_EXTERNAL_ID);
        let exploreCloseBtn = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_BTN_CLOSE_ID);
        let exploreMenuTopicTabButton = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_TAB_TOPIC_BTN_ID);
        let exploreMenuFormatTabButton = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_TAB_FORMAT_BTN_ID);
        if (exploreBtn && exploreBtnExternal && exploreCloseBtn) {
          exploreBtn.on("click", () => {
            this.showExploreMenu();
          });
          exploreBtnExternal.on("click", () => {
            this.showExploreMenu();
          });
          exploreCloseBtn.on("click", () => {
            this.hideExploreMenu();
            this.syncExploreStorageWithHtml(false);
            this.unmapCardsClick();
          });
          exploreMenuTopicTabButton.on("click", topicBtn => {
            exploreMenuFormatTabButton.removeClass("active");
            this.showExploreTabTopicContent();
            exploreMenuTopicTabButton.addClass("active");
          });
          exploreMenuFormatTabButton.on("click", formatBtn => {
            exploreMenuTopicTabButton.removeClass("active");
            this.showExploreTabFormatContent();
            exploreMenuFormatTabButton.addClass("active");
          });
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  handleAddRemoveButtonsSectionCorporateA() {
    var addRemoveButtonsSectionCorporate = $(`${HEADER_PROPS.CLASSES.ADD_REMOVE_BTN_SECTION_CORPORATE_A_CLASS}`);
    var addRemoveButtonsSectionMagazine = $(`${HEADER_PROPS.CLASSES.ADD_REMOVE_BTN_SECTION_MAGAZINE_CLASS}`);

    const addRemoveButtons = addRemoveButtonsSectionCorporate.length > 0 ? addRemoveButtonsSectionCorporate : (
      addRemoveButtonsSectionMagazine.length > 0 ? addRemoveButtonsSectionMagazine : []);

    if (addRemoveButtons && addRemoveButtons.length > 0) {
      for (let i = 0; i < addRemoveButtons.length; i++) {
        var currentAddRemoveBtn = $(addRemoveButtons[i]);
        var addRemoveBtnId = currentAddRemoveBtn.data('id');

        // Looking for explore menu card with same id of add remove button and set button classes (add/remove)
        var exploreMenuCardWithSameId = $(HEADER_PROPS.EXPLORE_CARD.CLASS +
          '[data-id="' + addRemoveBtnId.toString() + '"]');

        var updateCurrentAddRemoveBtn = function () {
          if (exploreMenuCardWithSameId && exploreMenuCardWithSameId.hasClass(HEADER_PROPS.EXPLORE_CARD
              .ADDED_CLASS)) {
            currentAddRemoveBtn.removeClass('add');
            currentAddRemoveBtn.addClass('remove');
          } else if (!currentAddRemoveBtn.hasClass('add')) {
            currentAddRemoveBtn.removeClass('remove');
            currentAddRemoveBtn.addClass('add');
          }
        };

        updateCurrentAddRemoveBtn();


        $(currentAddRemoveBtn).click(() => {
          var dataInfo = this.getExploreMenuCardDataAttributesObj($(exploreMenuCardWithSameId).data());
          var isOutsideExplore = true;
          this.addRemoveExploreMenuCard(exploreMenuCardWithSameId, dataInfo, isOutsideExplore);
          this.syncExploreStorageWithHtml(false);
          updateCurrentAddRemoveBtn();
        });

        // Update add/remove buttons if some items are added/remove from explore menu overlay (only when in the page there is one or more add/remove buttons)
        let exploreCloseBtnIfAddRemove = $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_BTN_CLOSE_ID);
        exploreCloseBtnIfAddRemove.on("click", () => {
          updateCurrentAddRemoveBtn();
        });
      }

    }
  }

  applyExploreMenuHandling(scrollToOffset) {
    var leftPaddle = $(".left-paddle")[0];
    var rightPaddle = $(".right-paddle")[0];
    var menuItems = [];

    // duration of scroll animation
    var scrollDuration = 150;
    // get menu items array
    menuItems = $(".eni-firstlevel-explore-menu-listitem");

    // div with gradient
    var gradientLeft = $('.eni-firstlevel-explore-menu-wrapper-shadow-left');
    var gradientRight = $('.eni-firstlevel-explore-menu-wrapper-shadow-right');

    // get some relevant size for the paddle triggering point
    var paddleMargin = 5;
    // margin-right of menu items
    var marginItems = 16;
    // padding of menu wrapper (to calculate paddles area)
    var menuPadding = 20;

    // detect internet explorer user agent
    var msieversion = function () {
      var ua = window.navigator.userAgent;
      var isIE = /MSIE|Trident/.test(ua);
      return isIE ? true : false;
    };

    // get wrapper width
    var getMenuWrapperSize = function () {
      return $(".eni-firstlevel-explore-menu-wrapper").outerWidth() - menuPadding;
    };

    // get total size width of all menu items
    var getMenuSize = function () {
      var menuTotalSize = 0;
      for (let i = 0; i < menuItems.length - 1; i++) {
        menuTotalSize += menuItems[i].clientWidth + marginItems;
      }
      return menuTotalSize;
    };

    // Menu horizontal scrolling management
    var handleExploreMenuNavigation = function () {
      var menuWrapperSize = 0;
      var menuSize = 0;
      var menuInvisibleSize = 0;

      menuWrapperSize = getMenuWrapperSize();
      menuSize = getMenuSize();

      // get how much of menu is invisible
      menuInvisibleSize = menuSize - menuWrapperSize;

      // declare handling of scroll event
      var handleScrollEvent = function () {
        var menuPosition = 0;
        var menuEndOffset = 0;
        var checkMsieversion = false;

        // get how much of menu is invisible
        menuInvisibleSize = menuSize - menuWrapperSize;

        // get how much have we scrolled so far
        menuPosition = getMenuPosition();

        /* var menuEndOffset = menuInvisibleSize - paddleMargin; */
        checkMsieversion = msieversion();

        menuEndOffset = checkMsieversion ? menuInvisibleSize - 8 + 20 : menuInvisibleSize - 8 - 1;

        // show & hide the paddles depending on scroll position

        // console.log("menuPosition : " + menuPosition + "  menuEndOffset : " + menuEndOffset);

        if (menuPosition <= paddleMargin) {
          // show right paddle and hide left paddle
          $(leftPaddle).addClass("hidden");
          $('.paddles').css({
            'display': 'block'
          });
          $(gradientLeft).css({
            'visibility': 'hidden'
          });
          $(rightPaddle).removeClass("hidden");
          $(gradientRight).css({
            'visibility': 'visible'
          });
          console.log('1');

        } else if (menuPosition < menuEndOffset) {
          // show both paddles
          $('.paddles').css({
            'display': 'block'
          });
          $(leftPaddle).removeClass("hidden");
          $(gradientLeft).css({
            'visibility': 'visible'
          });
          $(rightPaddle).removeClass("hidden");
          $(gradientRight).css({
            'visibility': 'visible'
          });
          console.log('2');
        } else if (menuPosition >= menuEndOffset) {
          $('.paddles').css({
            'display': 'block'
          });
          // show left paddle and hide right paddle
          $(leftPaddle).removeClass("hidden");
          $(gradientLeft).css({
            'visibility': 'visible'
          });
          $(rightPaddle).addClass("hidden");
          $(gradientRight).css({
            'visibility': 'hidden'
          });
        }
      };

      // get how much have we scrolled to the left
      var getMenuPosition = function () {
        return $(".eni-firstlevel-explore-menu").scrollLeft();
      };

      var handleArrowClick = function (arrowScrollDirection) {
        var menuPosition = 0;
        var menuPartialSize = 0;
        var scrollQty = 0;
        var index = 0;

        menuPosition = getMenuPosition();

        // get how much size of menu based on each item width
        for (let i = 0; i < menuItems.length - 1; i++) {
          menuPartialSize += menuItems[i].clientWidth + marginItems;
          if (menuPosition < menuPartialSize) {
            break;
          }
          index++;
        }

        if (arrowScrollDirection === "right") {
          if (menuItems[index].clientWidth + marginItems > menuPartialSize - menuPosition) {
            // scroll right only to end of first visible item (item partial scrolled)
            scrollQty = menuPartialSize - menuPosition;
          } else {
            // scroll right the entire size of first visible item (item not scrolled yet)
            scrollQty = menuItems[index].clientWidth + marginItems;

          }
          return menuPosition + scrollQty;
        } else {
          if (menuItems[index].clientWidth + marginItems > menuPartialSize - menuPosition) {
            // scroll left only to start of first visible item (item partial scrolled)
            var partialItemResidualScrollQty =
              menuItems[index].clientWidth + marginItems - (menuPartialSize - menuPosition);
            scrollQty = partialItemResidualScrollQty;

          } else {
            // scroll left the entire size of first visible item (item not scrolled yet)
            var previousMenuItemIndex = index > 0 ? index - 1 : index;
            scrollQty = menuItems[previousMenuItemIndex].clientWidth + marginItems;

          }
          return menuPosition - scrollQty;
        }
      };

      // on scroll event
      $(".eni-firstlevel-explore-menu").on("scroll", () => {
        handleScrollEvent();
      });

      handleScrollEvent();

      // left paddle click
      $(rightPaddle).click(() => {
        $(rightPaddle).attr("disabled", true);
        var scrollQty = handleArrowClick("right");
        $(".eni-firstlevel-explore-menu").animate({
            scrollLeft: scrollQty
            /* scrollLeft: menuInvisibleSize */
          },
          scrollDuration
        );
        $(rightPaddle).attr("disabled", false);
      });

      // right paddle click
      $(leftPaddle).click(() => {
        $(leftPaddle).attr("disabled", true);
        var scrollQty = handleArrowClick("left");
        $(".eni-firstlevel-explore-menu").animate({
            scrollLeft: scrollQty
          },
          scrollDuration
        );
        $(leftPaddle).attr("disabled", false);
      });
    };

    // check if eni-firstlevel-explore-menu-wrapper reaches his max width
    var checkMenuWrapperMaxWidth = function () {
      var menuWrapper = $(".eni-firstlevel-explore-menu-wrapper");
      var menuWrapperSize = menuWrapper.outerWidth();
      var menuContainerSize = $(".eni-firstlevel-explore-menu-container").width();

      // Apply different menu width calculation based on desktop breakpoint (differnet menu type)
      const wasteDifferenceMenu = 87 + 2 * 20;

      var menuWrapperMaxSize = menuContainerSize - (wasteDifferenceMenu);
      // console.log('menuWrapperSize ', Math.floor(menuWrapperSize));
      // console.log('menuContainerSize: ', menuContainerSize);
      // console.log('menuWrapperMaxSize: ', Math.floor(menuWrapperMaxSize));9
      if (Math.floor(menuWrapperSize) === Math.floor(menuWrapperMaxSize)) {
        return true;
      } else {
        return false;
      }
    };

    var hasMenuWrapperMaxWidth = false;
    hasMenuWrapperMaxWidth = checkMenuWrapperMaxWidth();

    if (hasMenuWrapperMaxWidth) {
      console.log(hasMenuWrapperMaxWidth);

      //     $(gradientRight).css({
      //       'visibility': 'visible'
      //     });

    } else {
      //   $(gradientLeft).css({
      //     'visibility': 'hidden'
      //   });
      $(gradientRight).css({
        'visibility': 'hidden'
      });
      console.log(hasMenuWrapperMaxWidth);
      $('.paddles').css({
        'display': 'none'
      });
    }

    if (hasMenuWrapperMaxWidth && scrollToOffset) {
      var menuWrapperSize = 0;
      var menuSize = 0;
      var menuInvisibleSize = 0;
      var menuEndOffset = 0;

      menuWrapperSize = getMenuWrapperSize();
      menuSize = getMenuSize();

      // get how much of menu is invisible
      menuInvisibleSize = menuSize - menuWrapperSize;

      menuEndOffset = menuInvisibleSize;

      $(".eni-firstlevel-explore-menu").animate({
          scrollLeft: menuEndOffset
          /* scrollLeft: menuInvisibleSize */
        },
        scrollDuration
      );
    }

    // Start managing explore menu only on mouse hover
    // $(".eni-firstlevel-explore-menu-wrapper").hover(

    //   function () {

    // inFunction
    //console.log('hasMenuWrapperMaxWidth: ', hasMenuWrapperMaxWidth);
    if (hasMenuWrapperMaxWidth) {
      handleExploreMenuNavigation();
      Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(leftPaddle, _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].SLIDE_IN_UP);
      Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(rightPaddle, _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].SLIDE_IN_UP);
      //   $(gradientRight).css({
      //     'visibility': 'visible'
      //   });
    } else {
      $(rightPaddle).addClass("hidden");
      //   $(gradientRight).css({
      //     'visibility': 'visible'
      //   });
    }
    //   },
    //   function () {
    //     if (hasMenuWrapperMaxWidth) {
    //       // outFunction
    //       animateCSS(leftPaddle, ANIMATE_EFFECT.SLIDE_IN_DOWN);
    //       animateCSS(rightPaddle, ANIMATE_EFFECT.SLIDE_IN_DOWN);
    //       // $(gradientLeft).css({
    //       //   'visibility': 'hidden'
    //       // });
    //       // $(gradientRight).css({
    //       //   'visibility': 'hidden'
    //       // });
    //     }
    //   }
    // );
  }

  handleScrollToOffsetMobile() {
    var menuWrapperSize = 0;
    var menuSize = 0;
    var menuInvisibleSize = 0;
    var menuEndOffset = 0;
    // duration of scroll animation
    var scrollDuration = 150;

    var marginItems = 16;
    var menuPadding = 10;
    // get menu items array
    var menuItems = $(".eni-firstlevel-explore-menu-listitem");

    var getMenuSize = function () {
      var menuTotalSize = 0;
      for (let i = 0; i < menuItems.length - 1; i++) {
        menuTotalSize += menuItems[i].clientWidth + marginItems;
      }
      return menuTotalSize;
    };

    menuWrapperSize = $(".eni-firstlevel-explore-menu-wrapper").outerWidth() - menuPadding;
    menuSize = getMenuSize();

    // get how much of menu is invisible
    menuInvisibleSize = menuSize - menuWrapperSize;

    menuEndOffset = menuInvisibleSize;

    $(".eni-firstlevel-explore-menu").animate({
        scrollLeft: menuEndOffset
        /* scrollLeft: menuInvisibleSize */
      },
      scrollDuration
    );
  }

  handleExploreMenuScrolling(scrollToOffset) {

    var checkMenuWrapperMaxWidth = function () {
      var menuWrapper = $(".eni-firstlevel-explore-menu-wrapper");
      var menuWrapperSize = menuWrapper.outerWidth();
      var menuContainerSize = $(".eni-firstlevel-explore-menu-container").width();

      // Apply different menu width calculation based on mobile breakpoint (differnet menu type)
      const wasteDifferenceMenu = 25;

      var menuWrapperMaxSize = menuContainerSize - (wasteDifferenceMenu);
      if (Math.floor(menuWrapperSize) === Math.floor(menuWrapperMaxSize)) {
        return true;
      } else {
        return false;
      }
    };

    if ($(window).width() >= HEADER_PROPS.EXPLORE_MENU.EXPLORE_PADDLE_NAVIGATION_BREAKPOINT) {
      // Manage paddles scrolling only on screen resolution > 1024 (in combo with scss)
      this.applyExploreMenuHandling(scrollToOffset);
    } else if (scrollToOffset) {
      const hasMenuWrapperMaxWidth = checkMenuWrapperMaxWidth();
      if (hasMenuWrapperMaxWidth) {
        this.handleScrollToOffsetMobile();
      }
    }

    $(window).on("resize", () => {
      if ($(window).width() >= HEADER_PROPS.EXPLORE_MENU.EXPLORE_PADDLE_NAVIGATION_BREAKPOINT) {
        this.applyExploreMenuHandling(scrollToOffset);
      }
      /*  } */
    });
  }

  getExploreMenuCardDataAttributesObj(exploreMenuCardDataAttributes) {
    if (exploreMenuCardDataAttributes) {
      try {
        var dataId = exploreMenuCardDataAttributes.id;
        /* var dataTitle = exploreMenuCardDataAttributes.title; */
        /* var dataUrl = exploreMenuCardDataAttributes.url; */

        if (dataId /* && dataTitle */ /* && dataUrl */ ) {
          var exploreMenuCardDataAttributesObj = {
            id: dataId,
            /* title: dataTitle */
            /* url: encodeURIComponent(dataUrl) */
          };

          return exploreMenuCardDataAttributesObj;
        } else {
          return undefined;
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  addExploreFirstlevelMenuItem(exploreMenuStorageItemObj) {
    if (exploreMenuStorageItemObj) {
      var id = exploreMenuStorageItemObj.id;
      var referencedExploreMenuCard = $(HEADER_PROPS.EXPLORE_CARD.CLASS + '[data-id="' + id + '"]');
      if (referencedExploreMenuCard && referencedExploreMenuCard.length > 0) {
        var title = $(referencedExploreMenuCard).data('title');
        var link = $(referencedExploreMenuCard).find(HEADER_PROPS.EXPLORE_CARD.LINK_CLASS);
        var decodedUrl = $(link).attr("href");
        var isActiveClass = $(referencedExploreMenuCard).hasClass('active') ? 'active' : '';
      } else {
        // Remove explore item to menu
        this.removeExploreMenuStorageItem(exploreMenuStorageItemObj);
        console.log('Error finding reference explore card with id: ' + id);
        return;
      }

      if (
        $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_ITEM_CLASS).length > 0 &&
        $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_LAST_ITEM_CLASS).length > 0
      ) {
        // Already present dynamic items, add item after last dynamic item
        $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_LAST_ITEM_CLASS).after(
          '<li class="eni-firstlevel-explore-menu-listitem eni-firstlevel-explore-menu-listitem-dynamic eni-menu-element ' +
          isActiveClass + '"' +
          ' data-id="' +
          id +
          '"><a class="eni-firstlevel-explore-menu-item" href="' +
          decodedUrl +
          '" title="' +
          title +
          '">' +
          title +
          "</a></li>"
        );
      } else if (
        $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_STATIC_ITEM_CLASS).length > 0 &&
        $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_STATIC_LAST_ITEM_CLASS).length > 0
      ) {
        // No dynamic items, add item after last static item
        $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_STATIC_LAST_ITEM_CLASS).after(
          '<li class="eni-firstlevel-explore-menu-listitem eni-firstlevel-explore-menu-listitem-dynamic eni-menu-element ' +
          isActiveClass + '"' +
          'data-id="' +
          id +
          '"><a class="eni-firstlevel-explore-menu-item" href="' +
          decodedUrl +
          '" title="' +
          title +
          '">' +
          title +
          "</a></li>"
        );
      } else {
        // No menu items, add item in main explore menu container before explore button visible only < $lg
        $(HEADER_PROPS.EXPLORE_MENU.EXPLORE_MENU_MOBILE_BUTTON_CLASS).before(
          '<li class="eni-firstlevel-explore-menu-listitem eni-firstlevel-explore-menu-listitem-dynamic eni-menu-element ' +
          isActiveClass + '"' +
          'data-id="' +
          id +
          '"><a class="eni-firstlevel-explore-menu-item" href="' +
          decodedUrl +
          '" title="' +
          title +
          '">' +
          title +
          "</a></li>"
        );
      }
    }
  }

  editExploreMenuItems(exploreMenuStorageItemObj, exploreMenuCards) {
    if (exploreMenuStorageItemObj && exploreMenuCards && exploreMenuCards.length > 0) {
      var id = exploreMenuStorageItemObj.id;
      var title = exploreMenuStorageItemObj.title;
      var decodedUrl = decodeURIComponent(exploreMenuStorageItemObj.url);
      var exploreMenuCardToBeUpdated = $(HEADER_PROPS.EXPLORE_CARD.CLASS + '[data-id="' + id + '"]');
      if (exploreMenuCardToBeUpdated) {
        exploreMenuCardToBeUpdated.addClass(HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS);

        // Update background opacity of card
        if (!$(exploreMenuCardToBeUpdated).hasClass('format-card')) {
          $(exploreMenuCardToBeUpdated).css(
            'background-image',
            $(exploreMenuCardToBeUpdated).css('background-image').replace(/0.5/g, '0.9')
          );
        };
      }
    }
  }

  removeExploreMenuItem(exploreMenuHtmlItemObj) {
    if (exploreMenuHtmlItemObj) {}
  }

  addExploreMenuStorageItem(exploreMenuStorageItemObj) {
    var currentStorage = _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].getLocalStorage(
      HEADER_PROPS.STORAGE.EXPLORE_MENU.KEY,
      HEADER_PROPS.STORAGE.EXPLORE_MENU.ENCODING
    );
    var stringifiedStorage = "";

    if (currentStorage && JSON.parse(currentStorage) && JSON.parse(currentStorage).length > 0) {
      // Items already present in storage, concat new items
      var parsedStorage = JSON.parse(currentStorage);
      var updatedStorage = parsedStorage.concat(exploreMenuStorageItemObj);
      stringifiedStorage = JSON.stringify(updatedStorage);
    } else {
      // No item in storage, so create new array
      var newStorage = [];
      newStorage.push(exploreMenuStorageItemObj);
      stringifiedStorage = JSON.stringify(newStorage);
    }

    if (stringifiedStorage) {
      // Items will be added to explore firstlevel menu when explore will be closed
      // this.addExploreFirstlevelMenuItem(exploreMenuStorageItemObj);
      _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].setLocalStorage(
        HEADER_PROPS.STORAGE.EXPLORE_MENU.KEY,
        stringifiedStorage,
        HEADER_PROPS.STORAGE.EXPLORE_MENU.ENCODING
      );
    }
  }

  removeExploreMenuStorageItem(exploreMenuStorageItemObj) {
    var currentStorage = _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].getLocalStorage(
      HEADER_PROPS.STORAGE.EXPLORE_MENU.KEY,
      HEADER_PROPS.STORAGE.EXPLORE_MENU.ENCODING
    );
    var stringifiedStorage = "";

    if (
      currentStorage &&
      JSON.parse(currentStorage) &&
      JSON.parse(currentStorage).length > 0 &&
      exploreMenuStorageItemObj.id
    ) {
      // Items already present in storage, remove specific item
      var parsedStorage = JSON.parse(currentStorage);
      var removalItemId = exploreMenuStorageItemObj.id;
      for (var i = 0; i < parsedStorage.length; i++) {
        if (parsedStorage[i].id === removalItemId) {
          parsedStorage.splice(i, 1);
          break;
        }
      }
      stringifiedStorage = JSON.stringify(parsedStorage);

      if (stringifiedStorage) {
        // Items will be removed from explore menu when explore will be closed
        /* this.removeExploreMenuItem(exploreMenuStorageItemObj); */
        _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].setLocalStorage(
          HEADER_PROPS.STORAGE.EXPLORE_MENU.KEY,
          stringifiedStorage,
          HEADER_PROPS.STORAGE.EXPLORE_MENU.ENCODING
        );
      }
    } else {
      console.log("No storage for remove explore items");
    }
    var stringifiedStorage = "";
    console.log("Remove explore menu item from storage");
  }

  updateCurrentCard(exploreMenuCardToBeUpdated, action, isOutsideExplore) {
    if (action === "add") {

      // Update background opacity of card
      if (!$(exploreMenuCardToBeUpdated).hasClass('format-card')) {
        $(exploreMenuCardToBeUpdated).css(
          'background-image',
          $(exploreMenuCardToBeUpdated).css('background-image').replace(/0.5/g, '0.9')
        );
      };

      if (!isOutsideExplore) {
        $(exploreMenuCardToBeUpdated).addClass(HEADER_PROPS.EXPLORE_CARD.ADDED_STATUS);
        var afterAddedItemZoomInAction = function () {
          setTimeout(function () {
            var afterFadeOutAction = function () {
              $(exploreMenuCardToBeUpdated).removeClass(HEADER_PROPS.EXPLORE_CARD.ADDED_STATUS);
              $(exploreMenuCardToBeUpdated).addClass(HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS);
              Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
                $(exploreMenuCardToBeUpdated)
                .children()
                .children(HEADER_PROPS.EXPLORE_CARD.ADD_REMOVE_BTN_CLASS)[0],
                _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_IN
              );
              Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
                $(exploreMenuCardToBeUpdated)
                .children()
                .children(HEADER_PROPS.EXPLORE_CARD.LINK_CLASS)[0],
                _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_IN
              );
              Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
                $(exploreMenuCardToBeUpdated)
                .children()
                .children(".icon-card")[0],
                _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_IN
              );
            };
            Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
              $(exploreMenuCardToBeUpdated)
              .children()
              .children(".icon-added-to-menu")[0],
              _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_OUT
            );
            Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
              $(exploreMenuCardToBeUpdated)
              .children()
              .children(".added-to-menu-message")[0],
              _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_OUT,
              afterFadeOutAction
            );
            /* $(exploreMenuCardToBeUpdated).removeClass(HEADER_PROPS.EXPLORE_CARD.ADDED_STATUS);
            $(exploreMenuCardToBeUpdated).addClass(HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS); */
          }, 1000);
        };

        Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])($(exploreMenuCardToBeUpdated)[0], _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].ZOOM_IN, afterAddedItemZoomInAction);
      } else {
        // Add action without animation and intermediate states (Add/remove buttons action)
        $(exploreMenuCardToBeUpdated).addClass(HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS);
      }
    } else if (action === "remove") {

      // Update background opacity of card
      if (!$(exploreMenuCardToBeUpdated).hasClass('format-card')) {
        $(exploreMenuCardToBeUpdated).css(
          'background-image',
          $(exploreMenuCardToBeUpdated).css('background-image').replace(/0.9/g, '0.5')
        );
      };

      if (!isOutsideExplore) {
        $(exploreMenuCardToBeUpdated).addClass(HEADER_PROPS.EXPLORE_CARD.REMOVED_STATUS);
        var afterRemovedItemZoomInAction = function () {
          setTimeout(function () {
            var afterFadeOutAction = function () {
              $(exploreMenuCardToBeUpdated).removeClass(
                `${HEADER_PROPS.EXPLORE_CARD.REMOVED_STATUS} ${HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS}`);
              Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
                $(exploreMenuCardToBeUpdated)
                .children()
                .children(HEADER_PROPS.EXPLORE_CARD.ADD_REMOVE_BTN_CLASS)[0],
                _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_IN
              );
              Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
                $(exploreMenuCardToBeUpdated)
                .children()
                .children(HEADER_PROPS.EXPLORE_CARD.LINK_CLASS)[0],
                _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_IN
              );
              Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
                $(exploreMenuCardToBeUpdated)
                .children()
                .children(".icon-card")[0],
                _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_IN
              );
            };
            Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
              $(exploreMenuCardToBeUpdated)
              .children()
              .children(".icon-added-to-menu")[0],
              _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_OUT
            );
            Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])(
              $(exploreMenuCardToBeUpdated)
              .children()
              .children(".removed-from-menu-message")[0],
              _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].FADE_OUT,
              afterFadeOutAction
            );
          }, 1000);
        };

        Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])($(exploreMenuCardToBeUpdated)[0], _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].ZOOM_IN, afterRemovedItemZoomInAction);
      } else {
        // Remove action without animation and intermediate states (Add/remove buttons action)
        $(exploreMenuCardToBeUpdated).removeClass(HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS);
      }
    } else {
      console.log("Clicked explore card has unvalid action");
    };
  };

  addRemoveExploreMenuCard(exploreMenuCard, dataInfo, isOutsideExplore) {
    var action = $(exploreMenuCard).hasClass(HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS) ?
      "remove" :
      "add";

    // Get title from data attribute
    /* dataInfo.title = $(exploreMenuCard).attr('title'); */

    // Get url from href in card
    /* dataInfo.url = encodeURIComponent(
      $(exploreMenuCard)
      .find(HEADER_PROPS.EXPLORE_CARD.LINK_CLASS)
      .attr("href")
    ); */

    if (action && action === "add") {
      // Add explore item to menu
      this.addExploreMenuStorageItem(dataInfo);
      this.updateCurrentCard(exploreMenuCard, action, isOutsideExplore);
    } else if (action && action === "remove") {
      // Remove explore item to menu
      this.removeExploreMenuStorageItem(dataInfo);
      this.updateCurrentCard(exploreMenuCard, action, isOutsideExplore);
      // TODO: update current item class (added/ removed)
    }
  };

  mapExploreMenuCardsAction() {
    try {
      var exploreMenuCards = $(HEADER_PROPS.EXPLORE_CARD.CLASS);

      if (exploreMenuCards && exploreMenuCards.length > 0) {
        for (let i = 0; i < exploreMenuCards.length; i++) {
          var exploreMenuCardLink = $(exploreMenuCards[i]).find(HEADER_PROPS.EXPLORE_CARD.LINK_CLASS);
          var exploreMenuCardAddRemoveButton = $(exploreMenuCards[i])
            .children()
            .children(".btn.add-remove-btn");

          // Map active card click action
          if (exploreMenuCardLink && $(exploreMenuCards[i]).hasClass('active')) {
            exploreMenuCardLink.on('click', (e) => {
              e.preventDefault();
              this.hideExploreMenu();
            });
          }

          // Map add/remove button click action
          if (exploreMenuCardAddRemoveButton) {
            /* var addExploreMenuStorageItem = this.addExploreMenuStorageItem(); */
            $(exploreMenuCardAddRemoveButton).bind(
              "click", {
                exploreMenuCard: exploreMenuCards[i],
                // Check of presence of added class moved into click function because it remain unmodified after class changes of card
                // action: $(exploreMenuCards[i]).hasClass(HEADER_PROPS.EXPLORE_CARD.ADDED_CLASS) ? 'remove' : 'add',
                dataInfo: this.getExploreMenuCardDataAttributesObj($(exploreMenuCards[i]).data())
              },
              event => {
                if (event.data.dataInfo && event.data.exploreMenuCard) {
                  var isOutsideExplore = false;
                  this.addRemoveExploreMenuCard(event.data.exploreMenuCard, event.data.dataInfo,
                    isOutsideExplore);
                } else {
                  console.log("Clicked explore card has unvalid data-attribute");
                }
              }
            );
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  showExploreMenu() {
    try {
      $(this.exploreMenu).show();
      $(this.body).addClass(`${HEADER_PROPS.CLASSES.BODY_UNSCROLLABLE_CLASS}`);
      Object(_common_animate__WEBPACK_IMPORTED_MODULE_1__["animateCSS"])($(HEADER_PROPS.EXPLORE_MENU.EXPLORE_TITLE)[0], _common_animate__WEBPACK_IMPORTED_MODULE_1__["ANIMATE_EFFECT"].BOUNCE_IN);
      this.mapExploreMenuCardsAction();
    } catch (e) {
      console.error(e);
    }
  }

  hideExploreMenu() {
    try {
      $(this.body).removeClass(`${HEADER_PROPS.CLASSES.BODY_UNSCROLLABLE_CLASS}`);
      $(this.exploreMenu).hide();
    } catch (e) {
      console.error(e);
    }
  }

  showExploreTabTopicContent() {
    this.exploreMenuTopicTabContent.removeClass("hidden");
    this.exploreMenuFormatTabContent.addClass("hidden");
  }

  showExploreTabFormatContent() {
    this.exploreMenuTopicTabContent.addClass("hidden");
    this.exploreMenuFormatTabContent.removeClass("hidden");
  }

  handleScroll() {
    // UpScroll variables
    let lastScrollDown,
      lastScrollTop,
      scrollTopIncrement = 0;
    let scrollTopBreakpoint = 10;



    var isMobile = $(window).outerWidth() < HEADER_PROPS.HEADER_MAIN.MOBILE_HEADER_BREAKPOINT;

    $(window).on("resize", () => {
      isMobile = $(window).outerWidth() >= HEADER_PROPS.HEADER_MAIN.MOBILE_HEADER_BREAKPOINT ? false : true;
    });

    var onScrollLeftMobile = () => {
      var getMenuPosition = () => {
        return $(".eni-firstlevel-explore-menu").scrollLeft();
      };
      var menuPos = 0;
      //console.log(menuPos);
      var gradientLeft = $('.eni-firstlevel-explore-menu-wrapper-shadow-left');
      var gradientRight = $('.eni-firstlevel-explore-menu-wrapper-shadow-right');
      $(".eni-firstlevel-explore-menu").on("scroll", () => {
        menuPos = getMenuPosition();
        //console.log(menuPos);
        if (isMobile && menuPos == 0) {
          $(gradientLeft).css({
            'visibility': 'hidden'
          });
        } else if (isMobile && menuPos > 0) {
          $(gradientLeft).css({
            'visibility': 'visible'
          });
        }
      });
    };

    onScrollLeftMobile();






    document.addEventListener("scroll", () => {
      let isHomePage = $(`${HEADER_PROPS.CLASSES.MAIN_CONTAINER_CLASS}`).hasClass(
        HEADER_PROPS.CLASSES.HOME_PAGE_CONTAINER_CLASS
      );
      let isSearchPage = $(`${HEADER_PROPS.CLASSES.MAIN_CONTAINER_CLASS}`).hasClass(
        HEADER_PROPS.CLASSES.SEARCH_PAGE_CONTAINER_CLASS
      );

      /* custom siti esteri*/
      if($('body').hasClass('eni-light-rounded')){
        $('.eni-searchbar-container').removeClass('open');
        $('body').removeClass('open-search-bar');
        $('.search-open-link').removeClass('active'); 
      }
      /* fine custom*/
      try {
        let newScroll = window.scrollY || window
          .pageYOffset; // window.scrollY not available in IE (use pageYOffset for IE9+)
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // console.log('goingUp scrollTop > lastScrollTop', scrollTop, lastScrollTop);
        if (scrollTop > lastScrollTop) {
          // console.log('goingUp false');
          $('.eni-header').removeClass('goingUp');
        } else {
          // console.log('goingUp true');
          $('.eni-header').addClass('goingUp');
        }

        !isMobile
          ?
          isHomePage ?
          this.handleHomeScroll(newScroll) :
          isSearchPage ? this.handleSearchScroll(newScroll) & this.handleInternalScroll(newScroll) :
          this.handleInternalScroll(newScroll) :
          isHomePage ?
          this.handleHomeScrollMobile(newScroll) :
          isSearchPage ? this.handleInternalScrollMobile(newScroll) :
          this.handleInternalScrollMobile(newScroll);

        // console.log('scrollTop > lastScrollTop', scrollTop, lastScrollTop);
        if (scrollTop > lastScrollTop) {
          // DownScroll behaviour

          scrollTopIncrement = 0;
          lastScrollDown = scrollTop;
        } else {
          // UpScroll Handling - Start

          if ( isMobile || (!$('body').hasClass('eni-rounded') && !$('body').hasClass('eni-light-rounded'))){


            if (isMobile && newScroll > 127) {
              // Mobile UpScroll

              this.manageHeaderVisibility("mobile-upscroll");
            } else {
              // Desktop UpScroll
              scrollTopIncrement = lastScrollDown === 0 ? 0 : lastScrollDown - scrollTop;
              if (
                scrollTopIncrement >= scrollTopBreakpoint &&
                newScroll > (isHomePage ? 270 : 70) + HEADER_PROPS.HEADER_MAIN.PRE_HEADER_DESKTOP_HEIGHT
              ) {
                isHomePage
                  ?
                  this.manageHeaderVisibility("light-full") :
                  this.manageHeaderVisibility("light-full-internal");
              }
            }
          }
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
        // UpScroll Handling - End
      } catch (e) {
        console.error(e);
      }
    });
  }

  handleHomeScroll(newScroll) {

    if ( !$('body').hasClass('eni-rounded') && !$('body').hasClass('eni-light-rounded')){
      if (newScroll < 70) {
        this.manageHeaderVisibility("default");
      }
      if (newScroll >= 70 && newScroll < 270) {
        this.manageHeaderVisibility("light-full");
      }
      if (newScroll >= 270) {
        this.manageHeaderVisibility("light-partial");
      }
    } else {
      if($('body').hasClass('eni-light-rounded')){
        if (newScroll < 70) {
          this.manageHeaderVisibility("default");
        }
        if (newScroll >= 70 && newScroll < 600) {
          this.manageHeaderVisibility("light-full");
        }
      }
      else{
        //inside eni.com new search
        if ( newScroll < 70) {
          this.manageHeaderVisibility("default");
        }
        if (newScroll >= 70 && newScroll < 600) {
          this.manageHeaderVisibility("light-full");
        }
        if (newScroll >= 600) {
          this.manageHeaderVisibility("light-partial");
        }
      }
    }

  }
  
  handleInternalScroll(newScroll) {
    if ( !$('body').hasClass('eni-rounded') && !$('body').hasClass('eni-light-rounded') ){
      if ( newScroll < 70) {
        this.manageHeaderVisibility("default-internal");
      }
      if (newScroll >= 70) {
        this.manageHeaderVisibility("light-full-internal");
      }
    } else { 
      if($('body').hasClass('eni-light-rounded')){
        if($('body').hasClass('eni-light-rounded')){
          if (newScroll < 70) {
            this.manageHeaderVisibility("default-internal");
          }
          if (newScroll >= 70 && newScroll < 600) {
            this.manageHeaderVisibility("light-full-internal");
          }
        }
      }
      else{ 
        if ( newScroll < 70) {
          this.manageHeaderVisibility("default-internal");
        }
        if (newScroll >= 70 && newScroll < 270) {
          this.manageHeaderVisibility("light-full-internal");
        }
        if (newScroll >= 600) {
          this.manageHeaderVisibility("light-partial-internal");
        }
      }
    }
  }

  handleHomeScrollMobile(newScroll) {
    if (newScroll == 0) {
      this.manageHeaderVisibility("default");
    }
    if (newScroll > 127) {
      this.manageHeaderVisibility("mobile-downscroll");
    }
  }

  handleInternalScrollMobile(newScroll) {
    if (newScroll == 0) {
      this.manageHeaderVisibility("default-internal");

    }
    if (newScroll > 127) {
      this.manageHeaderVisibility("mobile-downscroll");
    }
  }

  handleSearchScroll(newScroll) {

    let headerSearchBarContainer = $(`${HEADER_PROPS.CLASSES.SEARCH_BAR_CONTAINER_CLASS}`);
    let headerSearchInput = $(`${HEADER_PROPS.CLASSES.SEARCH_INPUT_CLASS}`);
    let headerSearchIcon = $(`${HEADER_PROPS.CLASSES.SEARCH_INPUT_ICON_CLASS}`);
    let mainWrapper = $(`${HEADER_PROPS.CLASSES.MAIN_WRAPPER_CLASS}`);

    if (newScroll >= 0 && newScroll < 70) {

      // Set height of eni-searchbar-container from 285 to minimum 115px
      // Set font size of eni-searchbar-header-input from 36px to minimum 18px
      // Set font size of eni-searchbar-header-icon from 24px to minimum 20px
      // Set margin-top of main-wrapper from 423px to minimum 330px


      let searchBarContainerHeight = HEADER_PROPS.HEADER_SEARCH.MINIMUM_DESKTOP_SEARCHBAR_CONTAINER_HEIGHT -
        (newScroll * HEADER_PROPS.HEADER_SEARCH.INDEX_DESKTOP_SEARCHBAR_CONTAINER_HEIGHT);
      let headerInputFontSize = HEADER_PROPS.HEADER_SEARCH.MINIMUM_DESKTOP_SEARCHBAR_HEADER_INPUT_FONT_SIZE -
        (newScroll * HEADER_PROPS.HEADER_SEARCH.INDEX_DESKTOP_SEARCHBAR_HEADER_INPUT_FONT_SIZE);
      let headerIconFontSize = HEADER_PROPS.HEADER_SEARCH.MINIMUM_DESKTOP_SEARCHBAR_HEADER_ICON_FONT_SIZE -
        (newScroll * HEADER_PROPS.HEADER_SEARCH.INDEX_DESKTOP_SEARCHBAR_HEADER_ICON_FONT_SIZE);
      let mainWrapperMarginTop = HEADER_PROPS.HEADER_SEARCH.MINIMUM_DESKTOP_MAIN_WRAPPER_MARGIN_TOP -
        (newScroll * HEADER_PROPS.HEADER_SEARCH.INDEX_DESKTOP_MAIN_WRAPPER_MARGIN_TOP);

      if (searchBarContainerHeight && headerInputFontSize && headerIconFontSize) {
        try {
          headerSearchBarContainer.css('height', searchBarContainerHeight.toFixed(2) + 'px');
          headerSearchInput.css('font-size', headerInputFontSize.toFixed(2) + 'px');
          headerSearchIcon.css('font-size', headerIconFontSize.toFixed(2) + 'px');
          mainWrapper.css('margin-top', mainWrapperMarginTop.toFixed(2) + 'px');
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      if (headerSearchBarContainer.css('height') !== HEADER_PROPS.HEADER_SEARCH
        .MAXIMUM_DESKTOP_SEARCHBAR_CONTAINER_HEIGHT + 'px') {
        headerSearchBarContainer.css('height', HEADER_PROPS.HEADER_SEARCH
          .MAXIMUM_DESKTOP_SEARCHBAR_CONTAINER_HEIGHT + 'px');
      }
      if (headerSearchInput.css('font-size') !== HEADER_PROPS.HEADER_SEARCH
        .MAXIMUM_DESKTOP_SEARCHBAR_HEADER_INPUT_FONT_SIZE + 'px') {
        headerSearchInput.css('font-size', HEADER_PROPS.HEADER_SEARCH
          .MAXIMUM_DESKTOP_SEARCHBAR_HEADER_INPUT_FONT_SIZE + 'px');
      }
      if (headerSearchIcon.css('font-size') !== HEADER_PROPS.HEADER_SEARCH
        .MAXIMUM_DESKTOP_SEARCHBAR_HEADER_ICON_FONT_SIZE + 'px') {
        headerSearchIcon.css('font-size', HEADER_PROPS.HEADER_SEARCH
          .MAXIMUM_DESKTOP_SEARCHBAR_HEADER_ICON_FONT_SIZE + 'px');
      }
      if (mainWrapper.css('margin-top') !==
        HEADER_PROPS.HEADER_SEARCH.MAXIMUM_DESKTOP_MAIN_WRAPPER_MARGIN_TOP + 'px') {
        mainWrapper.css('margin-top', HEADER_PROPS.HEADER_SEARCH.MAXIMUM_DESKTOP_MAIN_WRAPPER_MARGIN_TOP + 'px');
      }
    }
  }

  manageHeaderVisibility(headerType) {
    try {
      let mainHeader = $(HEADER_PROPS.HEADER_MAIN.MAIN_HEADER_CLASS)[0];
      let preHeader = $(HEADER_PROPS.HEADER_MAIN.PRE_HEADER_ID);
      let alwaysVisibleHeader = $(HEADER_PROPS.HEADER_MAIN.SEARCH_BAR_ID);
      let languageDropdown = $(HEADER_PROPS.HEADER_MAIN.LANGUAGE_DROPDOWN_BUTTON_CLASS)[0];

      // Check if language dropdown is opened, so close it
      if ($(languageDropdown).hasClass("show")) {
        this.toggleLanguageDropdown(languageDropdown);
      }

      if (mainHeader && preHeader && alwaysVisibleHeader) {
        switch (headerType) {
          case "default":
            // Header Default
            $(mainHeader).removeClass(
              `${HEADER_PROPS.CLASSES.HEADER_LIGHT_CLASS} ${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_CLASS}
              ${HEADER_PROPS.CLASSES.STICKY_CLASS} ${HEADER_PROPS.CLASSES.SLIDE_IN_DOWN_CLASS}`
            );

            // Check if mobile default-internal class has to be removed
            if ($(mainHeader).hasClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_MOBILE_CLASS}`)) {
              $(mainHeader).removeClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_MOBILE_CLASS}`);
            }

            break;
          case "default-internal":
            // Header Default
            $(mainHeader).removeClass(
              `${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_CLASS}
              ${HEADER_PROPS.CLASSES.STICKY_CLASS} ${HEADER_PROPS.CLASSES.SLIDE_IN_DOWN_CLASS}`
            );

            // Check if mobile default-internal class has to be removed
            if ($(mainHeader).hasClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_MOBILE_CLASS}`)) {
              $(mainHeader).removeClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_MOBILE_CLASS}`);
            }

            break;
          case "light-full":
            $(mainHeader).addClass(
              `${HEADER_PROPS.CLASSES.HEADER_LIGHT_CLASS} ${HEADER_PROPS.CLASSES.STICKY_CLASS}`
            );
            if ( !$('body').hasClass('eni-rounded') && !$('body').hasClass('eni-light-rounded') ){
              $(mainHeader).addClass(
                `${HEADER_PROPS.CLASSES.SLIDE_IN_DOWN_CLASS}`
              );
            }
            $(mainHeader).removeClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_CLASS}`);

            /* if ($(languageDropdown).hasClass("show")) {
              this.toggleLanguageDropdown(languageDropdown);
            } */
            break;
          case "light-full-internal":
            $(mainHeader).addClass(
              `${HEADER_PROPS.CLASSES.HEADER_LIGHT_CLASS} ${HEADER_PROPS.CLASSES.STICKY_CLASS}`);
            // ${HEADER_PROPS.CLASSES.SLIDE_IN_DOWN_CLASS} not present because menu is already fixed
            $(mainHeader).removeClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_CLASS}`);

            /* if ($(languageDropdown).hasClass("show")) {
              this.toggleLanguageDropdown(languageDropdown);
            } */
            break;
          case "light-partial":
            $(mainHeader).addClass(
              `${HEADER_PROPS.CLASSES.HEADER_LIGHT_CLASS} ${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_CLASS}
              ${HEADER_PROPS.CLASSES.STICKY_CLASS} fab_active`
            );
            if ( !$('body').hasClass('eni-rounded') && !$('body').hasClass('eni-light-rounded') ){
              $(mainHeader).addClass(
                `${HEADER_PROPS.CLASSES.SLIDE_IN_DOWN_CLASS}`
              );
            }

            /* if ($(languageDropdown).hasClass("show")) {
              this.toggleLanguageDropdown(languageDropdown);
            } */
            break;
          case "light-partial-internal":
            $(mainHeader).addClass(
              `${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_CLASS}
              ${HEADER_PROPS.CLASSES.STICKY_CLASS} fab_active`
            );

            // ${HEADER_PROPS.CLASSES.SLIDE_IN_DOWN_CLASS} not present because menu is already fixed,
            // so applying animation it will bounce in a wrong visual manner

            // code block
            break;
          case "mobile-downscroll":
            if ( !$('body').hasClass('eni-rounded') && !$('body').hasClass('eni-light-rounded') ){
              if ($(mainHeader).hasClass(`${HEADER_PROPS.CLASSES.STICKY_CLASS}`)) {
                const ourChannelSection = $('section.our-channel-panel');
                if ((ourChannelSection && !$(ourChannelSection).hasClass('visible')) || !ourChannelSection) {
                  $(mainHeader).addClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_MOBILE_CLASS}`);
                }
              } 
            } else {
              const ourChannelSection = $('section.our-channel-panel');
                if ((ourChannelSection && !$(ourChannelSection).hasClass('visible')) || !ourChannelSection) {
                  $(mainHeader).addClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_MOBILE_CLASS}`);
                }
              
            }
            break;
          case "mobile-upscroll":
            this.manageHeaderVisibility("light-partial");
            $(mainHeader).removeClass(`${HEADER_PROPS.CLASSES.HEADER_LIGHT_PARTIAL_MOBILE_CLASS}`);
            // code block
            if ($('section.our-channel-panel').hasClass('visible')){
              //inserisco un transition più alto
              $('section.our-channel-panel').css('transition','all ease-in-out 1.3s');
              const mainWrapper = $(`${HEADER_PROPS.CLASSES.MAIN_WRAPPER_CLASS}`);

              // Restore margin at main wrapper removing height of our channel
              $(mainWrapper).css('margin-top', '');

              const ourChannelSection = $('section.our-channel-panel');
              $(ourChannelSection).removeClass('visible');

              // Remove active from menu items
              const ourChannelBtn = $(HEADER_PROPS.HEADER_MAIN.OUR_CHANNEL_BTN_ID);
              $(ourChannelBtn).removeClass('active');

              const ourChannelMobileBtn = $(HEADER_PROPS.HEADER_MAIN.MOBILE_OUR_CHANNEL_BTN_ID);
              $(ourChannelMobileBtn).removeClass('active');

              $("html, body").animate({ scrollTop: 0 }, "slow");
              
            }
            break;
          default:
            break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  toggleLanguageDropdown(languageDropdown) {
    $(languageDropdown).dropdown("toggle");
  }

  showOurChannel(ourChannelWithDataBtn, ourChannelSection, ourChannelMobileBtn, ourChannelBtn) {
    $(ourChannelSection).css('transition','all ease-in-out .8s');
    const url = $(ourChannelWithDataBtn).data('url');
    const target = $(ourChannelWithDataBtn).data('target');
    const isMobile = $(window).outerWidth() < HEADER_PROPS.HEADER_MAIN.MOBILE_HEADER_BREAKPOINT;

    // Check if anchor has data-URL and data-target. If yes open url, if not open panel
    if (url && url.length > 0) {
      window.open(url, target);
    } else {
      const mainWrapper = $(`${HEADER_PROPS.CLASSES.MAIN_WRAPPER_CLASS}`);
      const mainWrapperActualMarginTop = parseInt($(mainWrapper).css('margin-top'), 10);

      // Apply margin at main wrapper adding height of our channel
      if ($(mainWrapper).css('transition') && $(mainWrapper).css('transition') !== 'all ease-in-out 0.8s') {
        $(mainWrapper).css('transition', 'all ease-in-out 0.8s');
      }
      $(mainWrapper).css('margin-top', mainWrapperActualMarginTop + (isMobile ? 640 : 397) + 'px');

      $(ourChannelSection).addClass('visible');

      // Make menu items active
      $(ourChannelBtn).addClass('active');
      $(ourChannelMobileBtn).addClass('active');

    }
  };

  hideOurChannel(ourChannelSection, ourChannelMobileBtn, ourChannelBtn) {
    const mainWrapper = $(`${HEADER_PROPS.CLASSES.MAIN_WRAPPER_CLASS}`);

    // Restore margin at main wrapper removing height of our channel
    $(mainWrapper).css('margin-top', '');
    $(ourChannelSection).removeClass('visible');

    // Remove active from menu items
    $(ourChannelBtn).removeClass('active');
    $(ourChannelMobileBtn).removeClass('active');
  };

  handlePreHeaderButtons() {
    try {
      const ourChannelMobileBtn = $(HEADER_PROPS.HEADER_MAIN.MOBILE_OUR_CHANNEL_BTN_ID);
      const ourChannelBtn = $(HEADER_PROPS.HEADER_MAIN.OUR_CHANNEL_BTN_ID);
      const ourChannelCloseBtn = $(HEADER_PROPS.HEADER_MAIN.OUR_CHANNEL_CLOSE_BTN_ID);
      const ourChannelSection = $('section.our-channel-panel');

      if (ourChannelBtn) {
        ourChannelBtn.on("click", (e) => {
          e.preventDefault();
          const ourChannelBtnAnchor = $(e.currentTarget).children('.our-channel-btn-anchor');

          if (!$(ourChannelSection).hasClass('visible')) {
            this.showOurChannel(ourChannelBtnAnchor, ourChannelSection, ourChannelMobileBtn, ourChannelBtn);
          }
        });
      }
      if (ourChannelMobileBtn) {
        ourChannelMobileBtn.on("click", (e) => {
          e.preventDefault();
          if (!$(ourChannelSection).hasClass('visible')) {
            const ourChannelBtnAnchor = $(e.currentTarget);
            this.showOurChannel(ourChannelBtnAnchor, ourChannelSection, ourChannelMobileBtn, ourChannelBtn);
          }
        });
      }

      if (ourChannelCloseBtn) {
        ourChannelCloseBtn.on("click", (e) => {
          this.hideOurChannel(ourChannelSection, ourChannelMobileBtn, ourChannelBtn);
        });
      }

      $(window).on("resize", () => {
        if (window.innerWidth > 768){
                if ($(ourChannelSection).hasClass('visible')) {
                  this.hideOurChannel(ourChannelSection, ourChannelMobileBtn, ourChannelBtn);
                }
        }
      });

    } catch (error) {}

  }

  handleContainerClass() {
    try {
      let mainHeader = $(HEADER_PROPS.HEADER_MAIN.MAIN_HEADER_CLASS)[0];
      if (mainHeader) {
        let mainContainer = $(`${HEADER_PROPS.CLASSES.MAIN_CONTAINER_CLASS}`);
        if ($(mainHeader).hasClass('header-default') &&
          $(mainHeader).hasClass('header-home') && $(mainContainer)) {
          $(mainContainer).addClass('home-page');
        }
        /* else if ($(mainHeader).hasClass('header-light header-internal')) {
                 // Do not add any class
               }  */
        else if ($(mainHeader).hasClass('header-light') &&
          $(mainHeader).hasClass('header-search') && $(mainContainer)) {
          $(mainContainer).addClass('search-page');
        } else if ($(mainHeader).hasClass('header-light') &&
          $(mainHeader).hasClass('header-detail') && $(mainContainer)) {
          $(mainContainer).addClass('detail-page');
        }

        /* Check rich text in header */
        if ($(mainHeader).hasClass('header-rich-text') && $(mainContainer)) {
          $(mainContainer).addClass('rich-text-page');
        }
      }
    } catch (error) {}
  }

  handleMobileModal() {

    $(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_ID}`).on("shown.bs.modal", function () {
      $(window).scrollTo(0, 0);
      $('#mobileSearchModal').removeClass(modalClassToAssign);
    });

    let modalClassToAssign = 'mobile-modal-vocal-search';
    let vocalSearchHeaderButton = $(`${HEADER_PROPS.CLASSES.VOCAL_SEARCH_HEADER_BUTTON_CLASS}`);
    let vocalSearchModalButton = $(`${HEADER_PROPS.CLASSES.VOCAL_SEARCH_MODAL_BUTTON_CLASS}`);
    let vocalSearchModalAbortButton = $(`${HEADER_PROPS.CLASSES.VOCAL_SEARCH_MODAL_ABORT_SEARCH_BUTTON_CLASS}`);

    $(vocalSearchHeaderButton).click(() => {

      // $('#mobileSearchModal').addClass('ffjewiofhew');
      // Open search modal, start vocal search and show loading
      $(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_ID}`).modal('show');
      this.showVocalSearchLoading();
    });

    $(vocalSearchModalButton).click(() => {
      $('#mobileSearchModal').addClass(modalClassToAssign);
      // Start vocal search and show loading
      this.showVocalSearchLoading();
    });

    $(vocalSearchModalAbortButton).click(() => {
      // Abort vocal search and close modal
      $(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_ID}`).modal('hide');
      this.hideVocalSearchLoading();
    });

  }

  showVocalSearchLoading() {
    $(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_ID}`)
      .find(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_VOCAL_SEARCH_LOADING_CLASS}`).show();
    $(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_ID}`)
      .find(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_SEARCH_LINKS_CLASS}`).hide();

    this.handleVocalSearch();
  }

  hideVocalSearchLoading() {
    $(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_ID}`)
      .find(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_VOCAL_SEARCH_LOADING_CLASS}`).hide();
    $(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_ID}`)
      .find(`${HEADER_PROPS.CLASSES.MOBILE_SEARCH_MODAL_SEARCH_LINKS_CLASS}`).show();
  }

  handleSearchClearButton() {
    $(HEADER_PROPS.CLASSES.SEARCH_INPUT_CLASS).on('input', function () {
      if ($(HEADER_PROPS.CLASSES.SEARCH_INPUT_CLASS).val() == "") {
        console.log("Empty Searchbar!");
        $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_HEADER_BUTTON_CLASS).show();
        $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_HEADER_BUTTON_CLASS).hide();
      } else {
        console.log("Full Searchbar!");
        $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_HEADER_BUTTON_CLASS).hide();
        $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_HEADER_BUTTON_CLASS).show();
      }
    });

    $(HEADER_PROPS.CLASSES.MODAL_SEARCH_INPUT_CLASS).on('input', function () {
      if ($(HEADER_PROPS.CLASSES.MODAL_SEARCH_INPUT_CLASS).val() == "") {
        console.log("Vuota");
        $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_MODAL_BUTTON_CLASS).show();
        $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_MODAL_BUTTON_CLASS).hide();
      } else {
        console.log("Piena");
        $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_MODAL_BUTTON_CLASS).hide();
        $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_MODAL_BUTTON_CLASS).show();
      }
    });

    $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_HEADER_BUTTON_CLASS).click(function () {
      $(HEADER_PROPS.CLASSES.SEARCH_INPUT_CLASS).attr('value', '');
      $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_HEADER_BUTTON_CLASS).hide();
      $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_HEADER_BUTTON_CLASS).show();
    });

    $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_MODAL_BUTTON_CLASS).click(function () {
      $(HEADER_PROPS.CLASSES.MODAL_SEARCH_INPUT_CLASS).attr('value', '');
      $(HEADER_PROPS.CLASSES.CLEAR_SEARCH_MODAL_BUTTON_CLASS).hide();
      $(HEADER_PROPS.CLASSES.VOCAL_SEARCH_MODAL_BUTTON_CLASS).show();
    });
  }

  handleVocalSearch() {
    const vocalSearchRecordingButton = $(".btn-vocal-search");
    const recordingAnimationContainer = $(".speaker-container");
    const dataUploadUrl = $(".eni-header").data("upload-url");

    console.log("Vocal Search recording button", vocalSearchRecordingButton);

    if (Recorder.isRecordingSupported()) {
      console.log("Recording is supported!");

      var recorder = new Recorder({
        encoderPath: "/assets/js/waveWorker.min.js"
      });

      recorder.onstart = function () {
        console.log("Recording started");
      };

      recorder.onstop = function () {
        console.log("Recording stopped");
      };

      recorder.onstreamerror = function (e) {
        console.log('Error encountered: ' + e.message);
      };

      recorder.ondataavailable = function (typedArray) {
        var blob = new Blob([typedArray], {
          type: 'audio/wav'
        });

        console.log("Uploading the audio blob");

        var reader = new FileReader();
        reader.onload = function () {
          var form = document.createElement("form");
          $(form).attr("method", "POST");
          $(form).attr("action", dataUploadUrl);
          console.log("FORM", form);
          var audioInput = document.createElement("input");
          $(audioInput).attr("value", reader.result);
          $(audioInput).attr("name", "audio");
          console.log("INPUT", audioInput);
          $(form).append(audioInput);
          document.body.appendChild(form);
          form.submit();
        };
        reader.readAsDataURL(blob);
      };

    }
    $(vocalSearchRecordingButton).on('mousedown touchstart', (event) => {
      this.startAudioRecording(recorder, recordingAnimationContainer, vocalSearchRecordingButton);
    }).bind('mouseup mouseleave touchend', () => {
      this.stopAudioRecording(recorder, recordingAnimationContainer, vocalSearchRecordingButton);
    });



    // Start Vocal Recording on Button Press Down


    var record = false;
    // $(vocalSearchRecordingButton).click( (e) => {
    //   if ( !record ) {

    //     this.startAudioRecording(recorder, recordingAnimationContainer, vocalSearchRecordingButton);
    //     record = true;

    //   } else {
    //     this.stopAudioRecording(recorder, recordingAnimationContainer, vocalSearchRecordingButton);
    //     record = false;
    //   }

    // });

    const abort = $('.eni-search-modal-abort-vocal-search');

    $(abort).click(() => {
      $(recordingAnimationContainer).addClass("not-animated");
      $(vocalSearchRecordingButton).removeClass('clicked');
      recorder.loadWorker();
      record = false;
    });

    $('.eni-focus-area .close').click(() => {
      $(recordingAnimationContainer).addClass("not-animated");
      $(vocalSearchRecordingButton).removeClass('clicked');
      recorder.loadWorker();
      record = false;
    });

  }


  handleSearchOpenButton() {
    const searchOpenLink = $('.search-open-link');
    $(searchOpenLink).click((event) => {
      if($('.eni-searchbar-container').length) {
        $(searchOpenLink).toggleClass('active');
        $('.eni-searchbar-container').toggleClass('open');
        $('body.header-light-search').toggleClass('open-search-bar');
      }
    });
  }


  startAudioRecording(recorder, recordingAnimationContainer, vocalSearchRecordingButton) {
    console.log("Start Recording!");
    recorder.start().catch(function (e) {
      console.log("Recording error encountered ", e.message);
    });
    $(recordingAnimationContainer).removeClass("not-animated");
    $(vocalSearchRecordingButton).addClass('clicked');
  }

  stopAudioRecording(recorder, recordingAnimationContainer, vocalSearchRecordingButton) {
    console.log("Stop Recording!");

    $(recordingAnimationContainer).addClass("not-animated");
    $(vocalSearchRecordingButton).removeClass('clicked');
    setTimeout(() => {
      recorder.stop();
    }, 10);
  }

  /* uploadVocalSearchAudio(uploadUrl, blob) {
    console.log("Uploading the audio blob");

    var reader = new FileReader();
    reader.onload = function () {
      var form = document.createElement("form");
      $(form).attr("method", "POST");
      $(form).attr("action", uploadUrl);
      console.log("FORM", form);
      var audioInput = document.createElement("input");
      $(audioInput).attr("value", reader.result);
      $(audioInput).attr("name", "audio");
      console.log("INPUT", audioInput);
      $(form).append(audioInput);
      document.body.appendChild(form);
      form.submit();
    }
    reader.readAsDataURL(blob);
  } */
}

$(() => {
  const header = new HeaderComponent();
});


/***/ }),

/***/ "./src/scripts/mobile-menu.js":
/*!************************************!*\
  !*** ./src/scripts/mobile-menu.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*! Pushy - v1.2.0 - 2019-4-24
 * Pushy is a responsive off-canvas navigation menu using CSS transforms & transitions.
 * https://github.com/christophery/pushy/
 * by Christopher Yee */

(function ($) {
  var pushy = $('.pushy'), //menu css class
    body = $('body'),
    container = $('.main-container'), //container css class
    push = $('.push'), //css class to add pushy capability
    pushyLeft = 'pushy-left', //css class for left menu position
    pushyOpenLeft = 'pushy-open-left', //css class when menu is open (left position)
    pushyOpenRight = 'pushy-open-right', //css class when menu is open (right position)
    siteOverlay = $('.site-overlay'), //site overlay
    menuBtn = $('.preheader-menu-mobile-menu-mobile-btn'), //css classes to toggle the menu
    menuBtnFocus = $('.preheader-menu-mobile-menu-mobile-btn'), //css class to focus when menu is closed w/ esc key
    menuCloseBtn = $('.menu-mobile-close-btn'), //css classes to toggle the menu
    menuLinkFocus = $(pushy.data('focus')), //focus on link when menu is open
    menuSpeed = 200, //jQuery fallback menu speed
    menuWidth = pushy.width() + 'px', //jQuery fallback menu width
    submenuClass = '.pushy-submenu',
    submenuOpenClass = 'pushy-submenu-open',
    submenuClosedClass = 'pushy-submenu-closed',
    submenu = $(submenuClass),
    mobileMenuBreakpoint = 1024,
    languageItemsMenuMobile = $('.eni-menu-mobile .change-language li'),
    loginMyeniItemMenuMobile = $('.eni-menu-mobile .myeni-container-mobile li button.myeni-btn'),
    loginVersalisItemMenuMobile = $('.eni-menu-mobile .external-link-menu li.login-mobile a'),
    loginItemMenuMobile = $('.eni-menu-mobile .login-mobile li a');

  //close menu w/ esc key
  $(document).keyup(function (e) {
    //check if esc key is pressed
    if (e.keyCode == 27) {

      //check if menu is open
      if (body.hasClass(pushyOpenLeft) || body.hasClass(pushyOpenRight)) {
        if (cssTransforms3d) {
          closePushy(); //close pushy
        } else {
          closePushyFallback();
          opened = false; //set menu state
        }

        //focus on menu button after menu is closed
        if (menuBtnFocus) {
          menuBtnFocus.focus();
        }

      }

    }
  });

  function togglePushy() {
    //add class to body based on menu position
    if (pushy.hasClass(pushyLeft)) {
      body.toggleClass(pushyOpenLeft);
    } else {
      body.toggleClass(pushyOpenRight);
    }

    //focus on link in menu after css transition ends
    if (menuLinkFocus) {
      pushy.one('transitionend', function () {
        menuLinkFocus.focus();
      });
    }

  }

  function closePushy() {
    if (pushy.hasClass(pushyLeft)) {
      body.removeClass(pushyOpenLeft);
    } else {
      body.removeClass(pushyOpenRight);
    }
  }

  function openPushyFallback() {
    //animate menu position based on CSS class
    if (pushy.hasClass(pushyLeft)) {
      body.addClass(pushyOpenLeft);
      pushy.animate({
        left: "0px"
      }, menuSpeed);
      container.animate({
        left: menuWidth
      }, menuSpeed);
      //css class to add pushy capability
      push.animate({
        left: menuWidth
      }, menuSpeed);
    } else {
      body.addClass(pushyOpenRight);
      pushy.animate({
        right: '0px'
      }, menuSpeed);
      container.animate({
        right: menuWidth
      }, menuSpeed);
      push.animate({
        right: menuWidth
      }, menuSpeed);
    }

    //focus on link in menu
    if (menuLinkFocus) {
      menuLinkFocus.focus();
    }
  }

  function closePushyFallback() {
    //animate menu position based on CSS class
    if (pushy.hasClass(pushyLeft)) {
      body.removeClass(pushyOpenLeft);
      pushy.animate({
        left: "-" + menuWidth
      }, menuSpeed);
      container.animate({
        left: "0px"
      }, menuSpeed);
      //css class to add pushy capability
      push.animate({
        left: "0px"
      }, menuSpeed);
    } else {
      body.removeClass(pushyOpenRight);
      pushy.animate({
        right: "-" + menuWidth
      }, menuSpeed);
      container.animate({
        right: "0px"
      }, menuSpeed);
      push.animate({
        right: "0px"
      }, menuSpeed);
    }
  }

  function toggleSubmenu() {
    //hide submenu by default
    $(submenuClass).addClass(submenuClosedClass);

    $(submenuClass).on('click', function (e) {
      var selected = $(this);

      if (selected.hasClass(submenuClosedClass)) {
        //hide same-level opened submenus
        selected.siblings(submenuClass).addClass(submenuClosedClass).removeClass(submenuOpenClass);
        //show submenu
        selected.removeClass(submenuClosedClass).addClass(submenuOpenClass);
      } else {
        //hide submenu
        selected.addClass(submenuClosedClass).removeClass(submenuOpenClass);
      }
      // prevent event to be triggered on parent
      e.stopPropagation();
    });
  }

  function externalLinkMenu() {
    if ($('.eni-menu-mobile').length && $('.menu-container').length && $('.external-link-menu').length) {
      var windowHeight = $(window).height();
      var contentMenuHeight = parseInt($('.primary-menu').outerHeight()) + parseInt($('.secondary-menu').outerHeight());
      contentMenuHeight += 100;

      if (windowHeight > contentMenuHeight) {
        $('.external-link-menu').addClass('bottom');
      } else {
        $('.external-link-menu').removeClass('bottom');
      }
    }
  }

  //checks if 3d transforms are supported removing the modernizr dependency
  var cssTransforms3d = (function csstransforms3d() {
    var el = document.createElement('p'),
      supported = false,
      transforms = {
        'webkitTransform': '-webkit-transform',
        'OTransform': '-o-transform',
        'msTransform': '-ms-transform',
        'MozTransform': '-moz-transform',
        'transform': 'transform'
      };

    if (document.body !== null) {
      // Add it to the body to get the computed style
      document.body.insertBefore(el, null);

      for (var t in transforms) {
        if (el.style[t] !== undefined) {
          el.style[t] = 'translate3d(1px,1px,1px)';
          supported = window.getComputedStyle(el).getPropertyValue(transforms[t]);
        }
      }

      document.body.removeChild(el);

      return (supported !== undefined && supported.length > 0 && supported !== "none");
    } else {
      return false;
    }
  })();

  if (cssTransforms3d) {
    //toggle submenu
    /* toggleSubmenu(); */

    //toggle menu
    menuBtn.on('click', function () {
      togglePushy();
    });
    //toggle menu close
    menuCloseBtn.on('click', function () {
      togglePushy();
    });
    //close menu when clicking site overlay
    siteOverlay.on('click', function () {
      togglePushy();
    });
  } else {
    //add css class to body
    body.addClass('no-csstransforms3d');

    //hide menu by default
    if (pushy.hasClass(pushyLeft)) {
      pushy.css({
        left: "-" + menuWidth
      });
    } else {
      pushy.css({
        right: "-" + menuWidth
      });
    }

    //fixes IE scrollbar issue
    container.css({
      "overflow-x": "hidden"
    });

    //keep track of menu state (open/close)
    var opened = false;

    //toggle submenu
    /* toggleSubmenu(); */

    //toggle menu
    menuBtn.on('click', function () {
      if (opened) {
        closePushyFallback();
        opened = false;
      } else {
        openPushyFallback();
        opened = true;
      }
    });

    menuCloseBtn.on('click', function () {
      if (opened) {
        closePushyFallback();
        opened = false;
      } else {
        openPushyFallback();
        opened = true;
      }
    });

    //close menu when clicking site overlay
    siteOverlay.on('click', function () {
      if (opened) {
        closePushyFallback();
        opened = false;
      } else {
        openPushyFallback();
        opened = true;
      }
    });
  }

  //close menu when clicking language anchors
  if (languageItemsMenuMobile && languageItemsMenuMobile.length > 0) {
    languageItemsMenuMobile.each((i, el) => {
      const itemAnchor = $(el).children('a');
      if (itemAnchor && itemAnchor.length > 0) {
        $(itemAnchor).on('click', function (e) {
          togglePushy();
        });
      }
    });
  }

  //close menu when clicking login to myeni button
  if (loginMyeniItemMenuMobile && loginMyeniItemMenuMobile.length > 0) {
    loginMyeniItemMenuMobile.on('click', function (e) {
      togglePushy();
    });
  }

  //close menu when clicking login button
  if (loginItemMenuMobile && loginItemMenuMobile.length > 0) {
    loginItemMenuMobile.on('click', function (e) {
      togglePushy();
    });
  }

  if (loginVersalisItemMenuMobile && loginVersalisItemMenuMobile.length > 0) {
    loginVersalisItemMenuMobile.on('click', function (e) {
      togglePushy();
    });
  }

  function checkMobileMenuOpenStatus() {
    return (body.hasClass(pushyOpenLeft) || body.hasClass(pushyOpenRight)) ? true : false;
  };


  $(document).ready(() => {
    externalLinkMenu();
  });


  $(window).on('resize', () => {
    if ($(window).width() >= mobileMenuBreakpoint) {
      var isMobileMenuOpen = checkMobileMenuOpenStatus();
      if (isMobileMenuOpen) {
        togglePushy();
      }
    }

    externalLinkMenu();
  });

}(jQuery));


/***/ }),

/***/ "./src/scripts/widgets/breadcrumbs.js":
/*!********************************************!*\
  !*** ./src/scripts/widgets/breadcrumbs.js ***!
  \********************************************/
/*! exports provided: Breadcrumbs */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return Breadcrumbs; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class Breadcrumbs {

  constructor() {
    if (_common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isMobile()) {
      this.ellipsed($('.eni-breadcrumbs .breadcrumbs a'));
    }

    $('.eni-breadcrumbs button.icon-arrow-left-bread').click(() => window.history.back());
  }

  ellipsed(links) {
    console.log(links);
    if (links) {
      $(links).each((i, el) => {
        $(el).text(_common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].ellipse($(el).text(), 9));
      });
    }
  }

}

$(() => {
  const component = new Breadcrumbs();
});

/***/ }),

/***/ "./src/scripts/widgets/calendar.js":
/*!*****************************************!*\
  !*** ./src/scripts/widgets/calendar.js ***!
  \*****************************************/
/*! exports provided: Calendar */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Calendar", function() { return Calendar; });
class Calendar {
  constructor() {
    const viewMore = $(".eni-calendar button.view-more");
    const viewLess = $(".eni-calendar button.view-less");
    const p = $(".eni-calendar .view-more-less");

    if (p && p.length > 0 && viewMore && viewMore.length > 0 && viewLess && viewLess.length > 0) {
      const text = $(p).html();
      console.log("TEXT", text);

      if ($(window).width() < 992) {
        if (text.length > 280) {
          $(p).html(this.truncateText(text, 280));
        }
      }
      $(viewMore).click(() => {
        this.showMore(p, text);
        $(viewMore).hide();
        $(viewLess).show();
      });

      $(viewLess).click(() => {
        this.showLess(p, text);
        $(viewLess).hide();
        $(viewMore).show();
      });
    }
  }

  // Find the first space after the defined length and truncate there.
  // This allows for safe handling of HTML.

  truncateText(text, length) {
    var spaceIndex = text.indexOf(' ', length);
    var newText = text.substring(0, spaceIndex);
    return newText;
  }

  showMore(p, text) {
    console.log("View More");
    $(p).html(text);
  }

  showLess(p, text) {
    console.log("View Less");
    $(p).html(this.truncateText(text, 280));
  }
}

$(() => {
  const component = new Calendar();
});


/***/ }),

/***/ "./src/scripts/widgets/card-external-link.js":
/*!***************************************************!*\
  !*** ./src/scripts/widgets/card-external-link.js ***!
  \***************************************************/
/*! exports provided: CardExternalLink */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardExternalLink", function() { return CardExternalLink; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class CardExternalLink {
  constructor() {
    this.ellipsed($('.card-external-link .card-external p'));
  }

  ellipsed(p) {
    console.log(p);
    if (p) {
      $(p).each((i, el) => {
        $(el).text(_common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].ellipse($(el).text(), 120));
      });
    }
  }
}

$(() => {
  const component = new CardExternalLink();
});

/***/ }),

/***/ "./src/scripts/widgets/card-sub-category.js":
/*!**************************************************!*\
  !*** ./src/scripts/widgets/card-sub-category.js ***!
  \**************************************************/
/*! exports provided: CardEllipse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardEllipse", function() { return CardEllipse; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class CardEllipse {
  constructor() {
    this.ellipsed($('.sub-category-card .card-desc__title'));
  }

  ellipsed(p) {
    console.log('Frase: ' + p);
    if (p) {
      $(p).each((i, el) => {
        $(el).text(_common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].ellipse($(el).text(), 20));
      });
    }
  }
}

$(() => {
  const component = new CardEllipse();
});


/***/ }),

/***/ "./src/scripts/widgets/carousel-editorial.js":
/*!***************************************************!*\
  !*** ./src/scripts/widgets/carousel-editorial.js ***!
  \***************************************************/
/*! exports provided: CarouselEditorial, CarouselBigCard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselEditorial", function() { return CarouselEditorial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselBigCard", function() { return CarouselBigCard; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class CarouselEditorial {

    constructor(carouserEditorialContainerClass) {
        Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(carouserEditorialContainerClass, {
            loop: false,
            nav: true,
            mouseDrag: false,
            center: false,
            autoWidth: true,
            navText: [],
            /* onTranslate: this.onTranslated, */
            rewind: false,
            responsive: {
                0: {
                    items: 1.5,
                    slideBy: 1
                },
                // 768: {
                //   items: 2.5,
                //   slideBy: 2
                // },
                1024: {
                    items: 3.5,
                    slideBy: 3
                },
                1440: {
                    items: 4.5,
                    slideBy: 4
                },
                1920: {
                    items: 5.5,
                    slideBy: 5
                }
            }
        }, true);
    }
}

class CarouselBigCard {

    constructor(carouserEditorialContainerClass) {
        return Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(carouserEditorialContainerClass, {
            loop: false,
            nav: true,
            mouseDrag: false,
            center: false,
            autoWidth: true,
            navText: [],
            /* onTranslate: this.onTranslated, */
            rewind: false,
            responsive: {
                0: {
                    items: 1,
                    slideBy: 1
                },
                768: {
                    items: 1.5,
                    slideBy: 2
                },
                1024: {
                    items: 1.5,
                    slideBy: 3
                },
                1440: {
                    items: 2.5,
                    slideBy: 4
                },
                1920: {
                    items: 3.5,
                    slideBy: 5
                }
            }
        }, true);
    }
}

window.addEventListener('load', () => {
    const componentBigCard = new CarouselBigCard('.carousel-container.carousel-big-card .owl-carousel'); 
    const component = new CarouselEditorial('.carousel-container.carousel-editorial-card .owl-carousel');
    const componentCategoryCard = new CarouselEditorial('.carousel-container.carousel-category-card .owl-carousel');

    console.log( 'CarouselBigCard', componentBigCard );
    $( componentBigCard ).owlCarousel('refresh');
});

/***/ }),

/***/ "./src/scripts/widgets/carousel-event.js":
/*!***********************************************!*\
  !*** ./src/scripts/widgets/carousel-event.js ***!
  \***********************************************/
/*! exports provided: CarouselEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselEvent", function() { return CarouselEvent; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class CarouselEvent {
  constructor(carouserContainerClass) {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(carouserContainerClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 20,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 3.5,
          slideBy: 3
        },
        1440: {
          items: 4.5,
          slideBy: 4
        },
        1920: {
          items: 5.5,
          slideBy: 5
        }
      }
    });

    $('.carousel-event .card-event').click((event) => this.handleClick(event));
  }

  handleClick(event) {
    console.log(event);
    if ($(event.target).is('a') || $(event.target).hasClass('icon-share-small')) {
      return;
    }

    const currentTarget = $(event.currentTarget);
    const href = $(currentTarget).attr('data-href');
    const href_target = $(currentTarget).attr('data-target');
    const eventTarget = event.target;

    if (!($(eventTarget).hasClass("btn-share") || $(eventTarget).hasClass("icon-share-small")) &&
      (href && href.length > 0)) {
      window.open(href, href_target);
    }
  }
}

window.addEventListener('load', () => {
  const component = new CarouselEvent('.carousel-container.carousel-event-card .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/widgets/carousel-generic.js":
/*!*************************************************!*\
  !*** ./src/scripts/widgets/carousel-generic.js ***!
  \*************************************************/
/*! exports provided: GenericCarousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GenericCarousel", function() { return GenericCarousel; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class GenericCarousel {

  constructor(bindClass) {
    this.genericCarousel = Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      autoWidth: true,
      navText: [],
      rewind: false,
      responsive: {
        0: {
          slibeBy: 1,
          center: true
        },
        429: {
          center: false
        }
      }
    }, true);

    // Click and longpress on navigation arrow
    let scrollLeftIntervalId = 0;
    let scrollRightIntervalId = 0;

    // for fix bug tab owl carousel on ie11

    const innerWidth = $(window).width();

    const owlCars = $('.generic-carousel .owl-stage');
    var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    var msie = ua.indexOf('MSIE '); // IE 10 or older
    var trident = ua.indexOf('Trident/'); //IE 11


    if (msie > 0 || trident > 0) {
      if (innerWidth >= 1200) {
        for (let i = 0; i < owlCars.length; i++) {
          if (owlCars && $(owlCars)) {
            console.log('my func', $(owlCars[i]).width());
            var owlWidth = $(owlCars[i]).width();
            if (owlWidth < 1040) {
              $(owlCars[i]).css({
                "width": "100%",
                "display": "flex",
                "justify-content": "center"
              });
            }
            else{
              var currentWidth = parseInt(owlWidth);
              $(owlCars[i]).css('width',currentWidth+20+'px');
            }
          }

        }
      }
    }










    // Go to the previous item with longpress
    $('.owl-prev').on('mousedown touchstart', (event) => {
      scrollLeftIntervalId = setInterval(() => {
        this.genericCarousel.trigger('prev.owl.carousel', [500]);
      }, 500);
    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollLeftIntervalId);
    });

    // Go to the next item with longpress
    $('.owl-next').on('mousedown touchstart', (event) => {
      scrollRightIntervalId = setInterval(() => {
        this.genericCarousel.trigger('next.owl.carousel', [500]);
      }, 500);
    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollRightIntervalId);
    });

    const activeButton = $(bindClass).find('.btn.eni-tab.active');

    if (activeButton && activeButton.length > 0) {

      const activeOwlItem = $(activeButton).parent('.owl-item');
      const allOwlItems = $(bindClass).find('.owl-item');
      const currentOwlItemPosition = $(allOwlItems).index(activeOwlItem);
      // console.log("Figa Igor", currentOwlItemPosition, allOwlItems.length, activeOwlItem);



      if (activeButton && activeOwlItem && this.genericCarousel && allOwlItems.length && currentOwlItemPosition) {
        this.genericCarousel.trigger('to.owl.carousel', [currentOwlItemPosition, 0, true]);
      }
    }
  }
}

window.addEventListener('load', () => {
  const component = new GenericCarousel('.generic-carousel.carousel-container .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/widgets/carousel-global-presence.js":
/*!*********************************************************!*\
  !*** ./src/scripts/widgets/carousel-global-presence.js ***!
  \*********************************************************/
/*! exports provided: CarouselGlobalPresence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselGlobalPresence", function() { return CarouselGlobalPresence; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class CarouselGlobalPresence {

  constructor() {
    $('.carousel-inner').each(function() {
      let x = $(this).children('div').length;
          if ($(this).children('div').length === 1) $(this).siblings('.carousel-indicators').hide();

      });
  }


}

$(() => {
  const component = new CarouselGlobalPresence();
});


/***/ }),

/***/ "./src/scripts/widgets/carousel-places.js":
/*!************************************************!*\
  !*** ./src/scripts/widgets/carousel-places.js ***!
  \************************************************/
/*! exports provided: CarouselPlaces */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselPlaces", function() { return CarouselPlaces; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class CarouselPlaces {
  constructor(carouserContainerClass) {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(carouserContainerClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 3.5,
          slideBy: 3
        },
        1440: {
          items: 4.5,
          slideBy: 4
        },
        1920: {
          items: 5.5,
          slideBy: 5
        }
      }
    });

    $('.carousel-places .card-places').click((event) => this.handleClick(event));
  }

  handleClick(event) {
    console.log(event);
    if ($(event.target).is('a')) {
      return;
    }

    const currentTarget = $(event.currentTarget);
    const href = $(currentTarget).attr('data-href');
    const target = $(currentTarget).attr('data-target');
    window.open(href, target);
  }
}

window.addEventListener('load', () => {
  const component = new CarouselPlaces('.carousel-container.carousel-places-card .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/widgets/carousel-publications.js":
/*!******************************************************!*\
  !*** ./src/scripts/widgets/carousel-publications.js ***!
  \******************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");
/*!
 * Waterwheel Carousel
 * Version 2.3.0
 * https://www.bkosborne.com
 *
 * Copyright 2011-2013 Brian Osborne
 * Dual licensed under GPLv3 or MIT
 * Copies of the licenses have been distributed
 * with this plugin.
 *
 * Plugin written by Brian Osborne
 * for use with the jQuery JavaScript Framework
 * https://www.jquery.com
 */
;


(function ($) {
  'use strict';

  $.fn.waterwheelCarousel = function (startingOptions) {

    // Adds support for intializing multiple carousels from the same selector group
    if (this.length > 1) {
      this.each(function () {
        $(this).waterwheelCarousel(startingOptions);
      });
      return this; // allow chaining
    }

    var carousel = this;
    var options = {};
    var data = {};

    function initializeCarouselData() {
      data = {
        itemsContainer: $(carousel),
        totalItems: $(carousel).children().length,
        containerWidth: $(carousel).width(),
        containerHeight: $(carousel).height(),
        currentCenterItem: null,
        previousCenterItem: null,
        items: [],
        calculations: [],
        carouselRotationsLeft: 0,
        currentlyMoving: false,
        itemsAnimating: 0,
        currentSpeed: options.speed,
        intervalTimer: null,
        currentDirection: 'forward',
        leftItemsCount: 0,
        rightItemsCount: 0,
        performingSetup: true
      };
      data.itemsContainer.children().removeClass(options.activeClassName);
    }

    /**
     * This function will set the autoplay for the carousel to
     * automatically rotate it given the time in the options
     * Can clear the autoplay by passing in true
     */
    function autoPlay(stop) {
      // clear timer
      clearTimeout(data.autoPlayTimer);
      // as long as no stop command, and autoplay isn't zeroed...
      if (!stop && options.autoPlay !== 0) {
        // set timer...
        data.autoPlayTimer = setTimeout(function () {
          // to move the carousl in either direction...
          if (options.autoPlay > 0) {
            moveOnce('forward');
          } else {
            moveOnce('backward');
          }
        }, Math.abs(options.autoPlay));
      }
    }

    /**
     * This function will preload all the images in the carousel before
     * calling the passed in callback function. This is only used so we can
     * properly determine the width and height of the items. This is not needed
     * if a user instead manually specifies that information.
     */
    function preload(callback) {

      var $imageElements = data.itemsContainer.find('img'),
        totalImages = $imageElements.length,
        loadedImages = 0;

      if (options.preloadImages === false || $imageElements.length === 0) {
        callback();
        return;
      }

      $imageElements.each(function () {
        $(this).bind('load', function () {
          // Add to number of images loaded and see if they are all done yet
          loadedImages += 1;
          if (loadedImages === totalImages) {
            // All done, perform callback
            callback();
            return;
          }
        });
        // May need to manually reset the src to get the load event to fire
        // http://stackoverflow.com/questions/7137737/ie9-problems-with-jquery-load-event-not-firing
        $(this).attr('src', $(this).attr('src'));

        // If browser has cached the images, it may not call trigger a load. Detect this and do it ourselves
        if (this.complete) {
          $(this).trigger('load');
        }
      });
    }

    /**
     * Makes a record of the original width and height of all the items in the carousel.
     * If we re-intialize the carousel, these values can be used to re-establish their
     * original dimensions.
     */
    function setOriginalItemDimensions() {
      data.itemsContainer.children().each(function () {
        if ($(this).data('original_width') == undefined || options.forcedImageWidth > 0) {
          $(this).data('original_width', $(this).width());
        }
        if ($(this).data('original_height') == undefined || options.forcedImageHeight > 0) {
          $(this).data('original_height', $(this).height());
        }
      });
    }

    /**
     * Users can pass in a specific width and height that should be applied to every image.
     * While this option can be used in conjunction with the image preloader, the intended
     * use case is for when the preloader is turned off and the images don't have defined
     * dimensions in CSS. The carousel needs dimensions one way or another to work properly.
     */
    function forceImageDimensionsIfEnabled() {
      if (options.forcedImageWidth && options.forcedImageHeight) {
        data.itemsContainer.children().each(function () {
          $(this).width(options.forcedImageWidth);
          $(this).height(options.forcedImageHeight);
        });
      }
    }

    /**
     * For each "visible" item slot (# of flanking items plus the middle),
     * we pre-calculate all of the properties that the item should possess while
     * occupying that slot. This saves us some time during the actual animation.
     */
    function preCalculatePositionProperties() {
      // The 0 index is the center item in the carousel
      var $firstItem = data.itemsContainer.children().eq(0);

      data.calculations[0] = {
        distance: 0,
        offset: 0,
        opacity: 1
      };

      // Then, for each number of flanking items (plus one more, see below), we
      // perform the calcations based on our user options
      var horizonOffset = options.horizonOffset;
      var separation = options.separation;
      for (var i = 1; i <= options.flankingItems + 2; i++) {
        if (i > 1) {
          horizonOffset *= options.horizonOffsetMultiplier;
          separation *= options.separationMultiplier;
        }
        data.calculations[i] = {
          distance: data.calculations[i - 1].distance + separation,
          offset: data.calculations[i - 1].offset + horizonOffset,
          opacity: data.calculations[i - 1].opacity * options.opacityMultiplier
        };
      }
      // We performed 1 extra set of calculations above so that the items that
      // are moving out of sight (based on # of flanking items) gracefully animate there
      // However, we need them to animate to hidden, so we set the opacity to 0 for
      // that last item
      if (options.edgeFadeEnabled) {
        data.calculations[options.flankingItems + 1].opacity = 0;
      } else {
        data.calculations[options.flankingItems + 1] = {
          distance: 0,
          offset: 0,
          opacity: 0
        };
      }
    }

    /**
     * Here we prep the carousel and its items, like setting default CSS
     * attributes. All items start in the middle position by default
     * and will "fan out" from there during the first animation
     */
    function setupCarousel() {
      // Fill in a data array with jQuery objects of all the images
      data.items = data.itemsContainer.children();
      for (var i = 0; i < data.totalItems; i++) {
        data.items[i] = $(data.items[i]);
      }

      // May need to set the horizon if it was set to auto
      if (options.horizon === 0) {
        if (options.orientation === 'horizontal') {
          options.horizon = data.containerHeight / 2;
        } else {
          options.horizon = data.containerWidth / 2;
        }
      }

      // Default all the items to the center position
      data.itemsContainer
        .css('position', 'relative')
        .children()
        .each(function () {
          // Figure out where the top and left positions for center should be
          var centerPosLeft, centerPosTop;
          if (options.orientation === 'horizontal') {
            centerPosLeft = (data.containerWidth / 2) - ($(this).data('original_width') / 2);
            centerPosTop = options.horizon - ($(this).data('original_height') / 2);
          } else {
            centerPosLeft = options.horizon - ($(this).data('original_width') / 2);
            centerPosTop = (data.containerHeight / 2) - ($(this).data('original_height') / 2);
          }
          $(this)
            // Apply positioning and layering to the images
            .css({
              'left': centerPosLeft,
              'top': centerPosTop,
              'visibility': 'visible',
              'position': 'absolute',
              'z-index': 0,
              'opacity': 0
            })
            // Give each image a data object so it remembers specific data about
            // it's original form
            .data({
              top: centerPosTop,
              left: centerPosLeft,
              oldPosition: 0,
              currentPosition: 0,
              depth: 0,
              opacity: 0
            })
            // The image has been setup... Now we can show it
            .show();
        });
    }

    /**
     * All the items to the left and right of the center item need to be
     * animated to their starting positions. This function will
     * figure out what items go where and will animate them there
     */
    function setupStarterRotation() {
      options.startingItem = (options.startingItem === 0) ? Math.round(data.totalItems / 2) : options.startingItem;

      data.rightItemsCount = Math.ceil((data.totalItems - 1) / 2);
      data.leftItemsCount = Math.floor((data.totalItems - 1) / 2);

      // We are in effect rotating the carousel, so we need to set that
      data.carouselRotationsLeft = 1;

      // Center item
      moveItem(data.items[options.startingItem - 1], 0);
      data.items[options.startingItem - 1].css('opacity', 1);

      // All the items to the right of center
      var itemIndex = options.startingItem - 1;
      for (var pos = 1; pos <= data.rightItemsCount; pos++) {
        (itemIndex < data.totalItems - 1) ? itemIndex += 1: itemIndex = 0;

        data.items[itemIndex].css('opacity', 1);
        moveItem(data.items[itemIndex], pos);
      }

      // All items to left of center
      var itemIndex = options.startingItem - 1;
      for (var pos = -1; pos >= data.leftItemsCount * -1; pos--) {
        (itemIndex > 0) ? itemIndex -= 1: itemIndex = data.totalItems - 1;

        data.items[itemIndex].css('opacity', 1);
        moveItem(data.items[itemIndex], pos);
      }
    }

    /**
     * Given the item and position, this function will calculate the new data
     * for the item. One the calculations are done, it will store that data in
     * the items data object
     */
    function performCalculations($item, newPosition) {
      var newDistanceFromCenter = Math.abs(newPosition);

      // Distance to the center
      if (newDistanceFromCenter < options.flankingItems + 1) {
        var calculations = data.calculations[newDistanceFromCenter];
      } else {
        var calculations = data.calculations[options.flankingItems + 1];
      }

      var distanceFactor = Math.pow(options.sizeMultiplier, newDistanceFromCenter);
      var newWidth = distanceFactor * $item.data('original_width');
      var newHeight = distanceFactor * $item.data('original_height');
      var widthDifference = Math.abs($item.width() - newWidth);
      var heightDifference = Math.abs($item.height() - newHeight);

      var newOffset = calculations.offset;
      var newDistance = calculations.distance;
      if (newPosition < 0) {
        newDistance *= -1;
      }

      if (options.orientation == 'horizontal') {
        var center = data.containerWidth / 2;
        var newLeft = center + newDistance - (newWidth / 2);
        var newTop = options.horizon - newOffset - (newHeight / 2);
      } else {
        var center = data.containerHeight / 2;
        var newLeft = options.horizon - newOffset - (newWidth / 2);
        var newTop = center + newDistance - (newHeight / 2);
      }

      newTop -= heightDifference / 2;
      newLeft -= widthDifference / 2;

      var newOpacity;
      if (newPosition === 0) {
        newOpacity = 1;
      } else {
        newOpacity = calculations.opacity;
      }

      // Depth will be reverse distance from center
      var newDepth = options.flankingItems + 2 - newDistanceFromCenter;

      $item.data('width', newWidth);
      $item.data('height', newHeight);
      $item.data('top', newTop);
      $item.data('left', newLeft);
      $item.data('oldPosition', $item.data('currentPosition'));
      $item.data('depth', newDepth);
      $item.data('opacity', newOpacity);
      $item.data('distanceFactor', distanceFactor);
    }

    function moveItem($item, newPosition) {
      // Only want to physically move the item if it is within the boundaries
      // or in the first position just outside either boundary
      if (Math.abs(newPosition) <= options.flankingItems + 1) {
        performCalculations($item, newPosition);

        data.itemsAnimating++;

        $item
          .css('z-index', $item.data().depth)
          // Animate the items to their new position values
          .animate({
            'left': $item.data().left,
            'top': $item.data().top,
            'opacity': $item.data().opacity
          }, data.currentSpeed, options.animationEasing, function () {
            // Animation for the item has completed, call method
            itemAnimationComplete($item, newPosition);
          });

        TweenMax.to($item, data.currentSpeed / 1000, {
          scaleX: $item.data('distanceFactor'),
          scaleY: $item.data('distanceFactor'),
          ease: options.animationEasing
        });

      } else {
        $item.data('currentPosition', newPosition);
        // Move the item to the 'hidden' position if hasn't been moved yet
        // This is for the intitial setup
        if ($item.data('oldPosition') === 0) {
          $item
            .css({
              'left': $item.data().left,
              'top': $item.data().top,
              'opacity': $item.data().opacity,
              'z-index': $item.data().depth
            });

          TweenMax.to($item, 0, {
            scaleX: $item.data('distanceFactor'),
            scaleY: $item.data('distanceFactor')
          });
        }
      }

    }

    /**
     * This function is called once an item has finished animating to its
     * given position. Several different statements are executed here, such as
     * dealing with the animation queue
     */
    function itemAnimationComplete($item, newPosition) {
      data.itemsAnimating--;

      $item.data('currentPosition', newPosition);

      // Keep track of what items came and left the center position,
      // so we can fire callbacks when all the rotations are completed
      if (newPosition === 0) {
        data.currentCenterItem = $item;
      }

      // all items have finished their rotation, lets clean up
      if (data.itemsAnimating === 0) {
        data.carouselRotationsLeft -= 1;
        data.currentlyMoving = false;

        // If there are still rotations left in the queue, rotate the carousel again
        // we pass in zero because we don't want to add any additional rotations
        if (data.carouselRotationsLeft > 0) {
          rotateCarousel(0);
          // Otherwise there are no more rotations and...
        } else {
          // Reset the speed of the carousel to original
          data.currentSpeed = options.speed;

          data.currentCenterItem.addClass(options.activeClassName);

          if (data.performingSetup === false) {
            options.movedToCenter(data.currentCenterItem);
            options.movedFromCenter(data.previousCenterItem);
          }

          data.performingSetup = false;
          // reset & initate the autoPlay
          autoPlay();
        }
      }
    }

    /**
     * Function called to rotate the carousel the given number of rotations
     * in the given direciton. Will check to make sure the carousel should
     * be able to move, and then adjust speed and move items
     */
    function rotateCarousel(rotations) {
      // Check to see that a rotation is allowed
      if (data.currentlyMoving === false) {

        // Close card share modal when carousel publication rotates
        _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].closeShareModal();

        // Remove active class from the center item while we rotate
        data.currentCenterItem.removeClass(options.activeClassName);

        data.currentlyMoving = true;
        data.itemsAnimating = 0;
        data.carouselRotationsLeft += rotations;

        if (options.quickerForFurther === true) {
          // Figure out how fast the carousel should rotate
          if (rotations > 1) {
            data.currentSpeed = options.speed / rotations;
          }
          // Assure the speed is above the minimum to avoid weird results
          data.currentSpeed = (data.currentSpeed < 100) ? 100 : data.currentSpeed;
        }

        // Iterate thru each item and move it
        for (var i = 0; i < data.totalItems; i++) {
          var $item = $(data.items[i]);
          var currentPosition = $item.data('currentPosition');

          var newPosition;
          if (data.currentDirection == 'forward') {
            newPosition = currentPosition - 1;
          } else {
            newPosition = currentPosition + 1;
          }
          // We keep both sides as even as possible to allow circular rotation to work.
          // We will "wrap" the item arround to the other side by negating its current position
          var flankingAllowance = (newPosition > 0) ? data.rightItemsCount : data.leftItemsCount;
          if (Math.abs(newPosition) > flankingAllowance) {
            newPosition = currentPosition * -1;
            // If there's an uneven number of "flanking" items, we need to compenstate for that
            // when we have an item switch sides. The right side will always have 1 more in that case
            if (data.totalItems % 2 == 0) {
              newPosition += 1;
            }
          }

          moveItem($item, newPosition);
        }
      }
    }

    /**
     * The event handler when an image within the carousel is clicked
     * This function will rotate the carousel the correct number of rotations
     * to get the clicked item to the center, or will fire the custom event
     * the user passed in if the center item is clicked
     */
    $(this).children().bind("click", function () {
      var itemPosition = $(this).data().currentPosition;

      if (options.imageNav == false) {
        return;
      }
      // Don't allow hidden items to be clicked
      if (Math.abs(itemPosition) >= options.flankingItems + 1) {
        return;
      }
      // Do nothing if the carousel is already moving
      if (data.currentlyMoving) {
        return;
      }

      data.previousCenterItem = data.currentCenterItem;

      // Remove autoplay
      autoPlay(true);
      options.autoPlay = 0;

      var rotations = Math.abs(itemPosition);
      if (itemPosition == 0) {
        options.clickedCenter($(this));
      } else {
        // Fire the 'moving' callbacks
        options.movingFromCenter(data.currentCenterItem);
        options.movingToCenter($(this));
        if (itemPosition < 0) {
          data.currentDirection = 'backward';
          rotateCarousel(rotations);
        } else if (itemPosition > 0) {
          data.currentDirection = 'forward';
          rotateCarousel(rotations);
        }
      }
    });

    function nextItemFromCenter() {
      // Prevent error when mouse scroll is fired during reload after resize
      if (data && data.currentCenterItem) {
        var $next = data.currentCenterItem.next();
        if ($next.length <= 0) {
          $next = data.currentCenterItem.parent().children().first();
        }
        return $next;
      }
    }

    function prevItemFromCenter() {
      // Prevent error when mouse scroll is fired during reload after resize
      if (data && data.currentCenterItem) {
        var $prev = data.currentCenterItem.prev();
        if ($prev.length <= 0) {
          $prev = data.currentCenterItem.parent().children().last();
        }
        return $prev;
      }
    }

    /**
     * Intiate a move of the carousel in either direction. Takes care of firing
     * the 'moving' callbacks
     */
    function moveOnce(direction) {
      if (data.currentlyMoving === false) {
        data.previousCenterItem = data.currentCenterItem;

        options.movingFromCenter(data.currentCenterItem);
        if (direction == 'backward') {
          options.movingToCenter(prevItemFromCenter());
          data.currentDirection = 'backward';
        } else if (direction == 'forward') {
          options.movingToCenter(nextItemFromCenter());
          data.currentDirection = 'forward';
        }
      }

      rotateCarousel(1);
    }

    /**
     * Navigation with arrow keys
     */
    $(document).keydown(function (e) {
      if (options.keyboardNav) {
        // arrow left or up
        if ((e.which === 37 && options.orientation == 'horizontal') || (e.which === 38 && options.orientation ==
            'vertical')) {
          autoPlay(true);
          options.autoPlay = 0;
          moveOnce('backward');
          // arrow right or down
        } else if ((e.which === 39 && options.orientation == 'horizontal') || (e.which === 40 && options
            .orientation == 'vertical')) {
          autoPlay(true);
          options.autoPlay = 0;
          moveOnce('forward');
        }
        // should we override the normal functionality for the arrow keys?
        if (options.keyboardNavOverride && (
            (options.orientation == 'horizontal' && (e.which === 37 || e.which === 39)) ||
            (options.orientation == 'vertical' && (e.which === 38 || e.which === 40))
          )) {
          e.preventDefault();
          return false;
        }
      }
    });

    /**
     * Public API methods
     */
    this.reload = function (newOptions) {
      if (typeof newOptions === "object") {
        var combineDefaultWith = newOptions;
      } else {
        var combineDefaultWith = {};
      }
      options = $.extend({}, $.fn.waterwheelCarousel.defaults, newOptions);

      initializeCarouselData();
      data.itemsContainer.children().hide();
      forceImageDimensionsIfEnabled();

      preload(function () {
        setOriginalItemDimensions();
        preCalculatePositionProperties();
        setupCarousel();
        setupStarterRotation();
      });
    };



    this.next = function () {
      autoPlay(true);
      options.autoPlay = 0;

      moveOnce('forward');
    };
    this.prev = function () {
      autoPlay(true);
      options.autoPlay = 0;

      moveOnce('backward');
    };

    this.reload(startingOptions);

    return this;
  };

  var recalculateInitialOptionsResponsive = function () {
    var newOptions = {};
    var currentWidth = 0;
    currentWidth = $(window).outerWidth();
    if (currentWidth < 768) {
      newOptions.separation = 260;
      newOptions.forcedImageWidth = 290;
    } else if (currentWidth > 768 && currentWidth < 1024) {
      newOptions.separation = 310;
      newOptions.forcedImageWidth = 330;
    } else {
      newOptions.separation = 262;
      newOptions.forcedImageWidth = 262;
    }
    return newOptions;
  };

  var whaterWheelCarouselDefaults = {
    // number tweeks to change apperance
    startingItem: 1, // item to place in the center of the carousel. Set to 0 for auto
    separation: 280, // distance between items in carousel
    separationMultiplier: 0.9, // multipled by separation distance to increase/decrease distance for each additional item (default: 0.6)
    horizonOffset: 0, // offset each item from the "horizon" by this amount (causes arching)
    horizonOffsetMultiplier: 1, // multipled by horizon offset to increase/decrease offset for each additional item
    sizeMultiplier: 0.7, // determines how drastically the size of each item changes
    opacityMultiplier: 0.6, // determines how drastically the opacity of each item changes
    horizon: 0, // how "far in" the horizontal/vertical horizon should be set from the container wall. 0 for auto
    flankingItems: 1, // the number of items visible on either side of the center

    // animation
    speed: 300, // speed in milliseconds it will take to rotate from one to the next
    animationEasing: 'linear', // the easing effect to use when animating
    quickerForFurther: true, // set to true to make animations faster when clicking an item that is far away from the center
    edgeFadeEnabled: false, // when true, items fade off into nothingness when reaching the edge. false to have them move behind the center image

    // misc
    linkHandling: 2, // 1 to disable all (used for facebox), 2 to disable all but center (to link images out)
    autoPlay: 0, // indicate the speed in milliseconds to wait before autorotating. 0 to turn off. Can be negative
    orientation: 'horizontal', // indicate if the carousel should be 'horizontal' or 'vertical'
    activeClassName: 'carousel-center', // the name of the class given to the current item in the center
    keyboardNav: false, // set to true to move the carousel with the arrow keys
    keyboardNavOverride: true, // set to true to override the normal functionality of the arrow keys (prevents scrolling)
    imageNav: true, // clicking a non-center image will rotate that image to the center

    // preloader
    preloadImages: true, // disable/enable the image preloader.
    forcedImageWidth: 0, // specify width of all images; otherwise the carousel tries to calculate it
    forcedImageHeight: 0, // specify height of all images; otherwise the carousel tries to calculate it

    // callback functions
    movingToCenter: $.noop, // fired when an item is about to move to the center position
    movedToCenter: $.noop, // fired when an item has finished moving to the center
    clickedCenter: $.noop, // fired when the center item has been clicked
    movingFromCenter: $.noop, // fired when an item is about to leave the center position
    movedFromCenter: $.noop // fired when an item has finished moving from the center
  };

  // Set initial responsive options only for carousel-publication widget
  // For other carousel variant such as gallery inspect  recalculateInitialOptionsResponsivePhotoGallery() functions
  var whaterWheelCarouselDefaultsResponsive = recalculateInitialOptionsResponsive();

  // Object spread get error in edge e ie11

   $.fn.waterwheelCarousel.defaults = {
     ...whaterWheelCarouselDefaults,
     separation: whaterWheelCarouselDefaultsResponsive.separation,
forcedImageWidth: whaterWheelCarouselDefaultsResponsive.forcedImageWidth

   };
})(jQuery);

// $.fn.waterwheelCarousel.defaults =
//     Object.assign({}, whaterWheelCarouselDefaults,
//     {separation: whaterWheelCarouselDefaultsResponsive.separation,
//     forcedImageWidth: whaterWheelCarouselDefaultsResponsive.forcedImageWidth});
// })(jQuery);

window.addEventListener('load', () => {

  // Recalculate initial options responsive for Carousel Publications
  var recalculateInitialOptionsResponsive = function () {
    var newOptions = {};
    var currentWidth = 0;
    currentWidth = $(window).outerWidth();
    if (currentWidth < 768) {
      newOptions.separation = 260;
      newOptions.forcedImageWidth = 290;
    } else if (currentWidth >= 768 && currentWidth < 1024) {
      newOptions.separation = 310;
      newOptions.forcedImageWidth = 330;
    } else {
      newOptions.separation = 263;
      newOptions.forcedImageWidth = 263;
    }
    return newOptions;
  };

  // Recalculate initial options responsive for Photo Gallery
  var recalculateInitialOptionsResponsivePhotoGallery = function () {
    var newOptions = {};
    var currentWidth = 0;
    currentWidth = $(window).outerWidth();
    if (currentWidth < 500) {
      newOptions.separation = 100;
      newOptions.forcedImageWidth = 289;
    } else if (currentWidth >= 500 && currentWidth < 768) {
      newOptions.separation = 160;
      newOptions.forcedImageWidth = 289;
    } else if (currentWidth >= 768 && currentWidth < 1024) {
      newOptions.separation = 310;
      newOptions.forcedImageWidth = 600;
    } else if (currentWidth >= 1024 && currentWidth < 1440) {
      newOptions.separation = 180;
      newOptions.forcedImageWidth = 550;
    } else {
      newOptions.separation = 250;
      newOptions.forcedImageWidth = 712;
    }
    return newOptions;
  };

  if ($(".carousel-publications-container").length > 0) {
    var $carouselsPublications = [];
    var carouselsPublicationsIndex = 0;

    // Initialize waterwheel carousel for each carousel present in the page
    $(".carousel-publications-container").each(function () {
      $carouselsPublications[carouselsPublicationsIndex] = $(this);
      $carouselsPublications[carouselsPublicationsIndex].prop('carousel-publication-id',
        carouselsPublicationsIndex);
      // Photo gallery widget default value support
      if ($($carouselsPublications[carouselsPublicationsIndex]).hasClass('photo-gallery-container')) {
        var defaultPhotoGalleryOptions = recalculateInitialOptionsResponsivePhotoGallery();
        $carouselsPublications[carouselsPublicationsIndex].waterwheelCarousel({
          separation: defaultPhotoGalleryOptions.separation,
          forcedImageWidth: defaultPhotoGalleryOptions.forcedImageWidth
        });
      } else {
        $carouselsPublications[carouselsPublicationsIndex].waterwheelCarousel();
      };

      // Prev button handling
      $carouselsPublications[carouselsPublicationsIndex].parent().children('.carousel-publications-prev').on(
        'click',
        function (event) {
          try {
            const currentCarousel = $(event.target).parents('.carousel-publications-wrap').children(
              '.carousel-publications-container');
            var id = currentCarousel.prop('carousel-publication-id');
            id = Number(id);
            $carouselsPublications[id].prev();
          } catch (er) {
            console.error(er);
          }
          return false;
        });

      // Next button handling
      $carouselsPublications[carouselsPublicationsIndex].parent().children('.carousel-publications-next').on(
        'click',
        function (event) {
          try {
            const currentCarousel = $(event.target).parents('.carousel-publications-wrap').children(
              '.carousel-publications-container');
            var id = currentCarousel.prop('carousel-publication-id');
            id = Number(id);
            $carouselsPublications[id].next();
          } catch (er) {
            console.error(er);
          }
          return false;
        });

      carouselsPublicationsIndex += 1;
    });

    // Swipe handling
    $(".carousel-publications-container").swipe({
      swipeStatus: function (event, phase, direction, distance) {
        const currentCarousel = $(event.target).parents('.carousel-publications-wrap').children(
          '.carousel-publications-container');
        var id = currentCarousel.prop('carousel-publication-id');
        id = Number(id);

        if (phase == "end") {
          if (direction == "right") {
            $carouselsPublications[id].prev();
          } else if (direction == "left") {
            $carouselsPublications[id].next();
          } else {
            return false;
          }
        }
      },
      triggerOnTouchEnd: false,
      threshold: 100
    });

    // Mouse Wheel Handling (disabled)

    /* $(".carousel-publications-wrap").on('mousewheel', '.carousel-publications-container', function (e) {
      const currentCarousel = $(e.target).parents('.carousel-publications-wrap').children(
        '.carousel-publications-container');
      var id = currentCarousel.prop('carousel-publication-id');
      id = Number(id);

      if (e.deltaY > 0) {
        $carouselsPublications[id].next();
      } else {
        $carouselsPublications[id].prev();
      }

      e.preventDefault();
    }); */


    // Reload on resize handling

    var resizeTimer;
    var windowInitialWidth = $(window).outerWidth();

    $(window).on('resize', function (e) {
      // Prevent multiple reload when change screen orientation or window is resized multiple times
      if ($(window).outerWidth() != windowInitialWidth) {
        windowInitialWidth = $(window).outerWidth();
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var newOptions = recalculateInitialOptionsResponsive();
          var newPhotoGalleryOptions = recalculateInitialOptionsResponsivePhotoGallery();
          for (var i = 0; i < $carouselsPublications.length; i++) {
            if ($carouselsPublications[i].hasClass('photo-gallery-container')) {
              // Photo gallery widget default value support
              $carouselsPublications[i].reload(newPhotoGalleryOptions);
            } else {
              $carouselsPublications[i].reload(newOptions);
            }
          }
        }, 500);
      }
    });
  }
});


/***/ }),

/***/ "./src/scripts/widgets/contacts-carousel.js":
/*!**************************************************!*\
  !*** ./src/scripts/widgets/contacts-carousel.js ***!
  \**************************************************/
/*! exports provided: ContactsCarousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactsCarousel", function() { return ContactsCarousel; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class ContactsCarousel {

  constructor(bindClass) {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 20,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 2.5,
          slideBy: 2
        },
        1440: {
          items: 3.5,
          slideBy: 3
        }
      }
    }, true);
  }
}

window.addEventListener('load', () => {
  const component = new ContactsCarousel('.contacts-carousel.carousel-container .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/widgets/corporate-carousel.js":
/*!***************************************************!*\
  !*** ./src/scripts/widgets/corporate-carousel.js ***!
  \***************************************************/
/*! exports provided: CorporateCarousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CorporateCarousel", function() { return CorporateCarousel; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class CorporateCarousel {
  constructor(bindClass) {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 3.5,
          slideBy: 3
        },
        1440: {
          items: 4.5,
          slideBy: 4
        },
        1920: {
          items: 5.2,
          slideBy: 5
        }
      }
    }, true);
    $('.corporate-carousel .card-corporate').click(this.handleClick);
  }

  handleClick(event) {
   
    if ($(event.target).is('span') || $(event.target).is('a')) {
      event.preventDefault();
    } 
    const el = event.currentTarget;
    const url = $(el).attr('data-url');
    const target = $(el).attr('data-target');
    if (url && url.length > 0) {
      window.open(url, target);
    }
    
  }
}

$(() => {
  const component = new CorporateCarousel('.carousel-container.corporate-carousel .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/widgets/data-table-old.js":
/*!***********************************************!*\
  !*** ./src/scripts/widgets/data-table-old.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// export const MOBILE_OPTIONS = {
//   aspectRatio: 1,
//   legend: {
//     position: 'bottom',
//     labels: {
//       padding: 20,
//       fontSize: 18,
//       fontFamily: 'EniTabReg',
//       fontColor: '#333',
//       usePointStyle: true,
//       boxWidth: 10
//     },
//   },
//   layout: {
//     padding: {
//       left: 0,
//       right: 0,
//       top: 0,
//       bottom: 0
//     }
//   },
//   showAllTooltips: true,
//   tooltips: {

//     backgroundColor: 'rgba(0,0,0,0)',
//     titleFontColor: 'rgba(0,0,0,0)',
//     animationDuration: 0,
//     bodyFontColor: '#333',
//     xAlign: 'center',
//   }  
// };
// export const DESKTOP_OPTIONS = {
//   aspectRatio: 2.3,
//   legend: {
//     position: 'right',
//     labels: {
//       padding: 52,
//       fontSize: 18,
//       fontFamily: 'EniTabReg',
//       fontColor: '#333',
//       usePointStyle: true,
//       boxWidth: 30,
      
//     }
 
//   },
//   layout: {
//     padding: {
//       left: 0,
//       right: 0,
//       top: 50,
//       bottom: 50
//     }
//   },
  
//   tooltips: {
//   //   callbacks: {
//   //     labelColor: function(tooltipItem, chart) {
//   //       return {
           
//   //       };
//   //     },
//   //     label: function(tooltipItem, data) {
        
//   //       var label = data.datasets[tooltipItem.datasetIndex].label || '';
//   //       console.log('data: ', chart.config.data.datasets);
//   //       if (label) {
//   //           label += ': ';
//   //       }
//   //       label += Math.round(tooltipItem.yLabel * 100) / 100;
//   //       return label;
//   //   }
//   // },
//    backgroundColor: 'rgba(0,0,0,0)',
//     animationDuration: 0,
//     bodyFontColor: '#333',
//     xAlign: 'center',
//   },
//   showAllTooltips: true,
// };

// // Add a polyfill for Math.trunc() because of error on IE (the object doesn't accept property or method trunc)
// Math.trunc = Math.trunc || function (x) {
//   if (isNaN(x)) {
//     return NaN;
//   }
//   if (x > 0) {
//     return Math.floor(x);
//   }
//   return Math.ceil(x);
// };

// export class DateTable {
//   constructor() {

//     Chart.pluginService.register({
//       beforeRender: function (chart) {
//           if (chart.config.options.showAllTooltips) {
//               // create an array of tooltips
//               // we can't use the chart tooltip because there is only one tooltip per chart
//               chart.pluginTooltips = [];
//               chart.config.data.datasets.forEach(function (dataset, i) {
//                   chart.getDatasetMeta(i).data.forEach(function (sector, j) {
//                       chart.pluginTooltips.push(new Chart.Tooltip({
//                           _chart: chart.chart,
//                           _chartInstance: chart,
//                           _data: chart.data,
//                           _options: chart.options.tooltips,
//                           _active: [sector]
//                       }, chart));
//                   });
//               });
  
//               // turn off normal tooltips
//               chart.options.tooltips.enabled = false;
//           }
//       },
//       afterDraw: function (chart, easing) {
//           if (chart.config.options.showAllTooltips) {
//               // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
//               if (!chart.allTooltipsOnce) {
//                   if (easing !== 1)
//                       return;
//                   chart.allTooltipsOnce = true;
//               }
  
//               // turn on tooltips
//               chart.options.tooltips.enabled = true;
//               Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
//                   tooltip.initialize();
//                   tooltip.update();
//                   // we don't actually need this since we are not animating tooltips
//                   tooltip.pivot();
//                   tooltip.transition(easing).draw();
//               });
//               chart.options.tooltips.enabled = false;
//           }
//       },
      
//   });


//     const sections = $('section.data-table');
//     if (sections.length > 0) {
//       sections.each((i, el) => {
//         this.handleTableScroll(el);
//         const graphCanvas = $(el).find('canvas.data-table-graph');
//         const isDark = $(el).hasClass('dark-gray-theme');
//         if (graphCanvas.length > 0) {
//           this.drawGraphs(graphCanvas, isDark);
//         }

//       });
//     }

    

//     // const graphSections = $('section.data-table canvas.data-table-graph');
//     // if (graphSections.length > 0) {
//     //   graphSections.each((i, graphCanvas) => {        
//     //     this.drawGraphs(graphCanvas);
//     //   });
//     // }


//   }

//   checkScroll(target, settings) {
//     console.log('checkScroll', target, settings);
//   }

//   drawGraphs(graphCanvas, isDark) {
//     console.log(graphCanvas);
//     const data = JSON.parse($(graphCanvas).attr('data-graph'));
//     const color = isDark ? '#fff' : '#333';
//     MOBILE_OPTIONS.legend.labels.fontColor = DESKTOP_OPTIONS.legend.labels.fontColor = color;

//     const pie = new Chart(graphCanvas, {
//       type: 'pie',
//       data: data,
//       options: 
//         window.innerWidth < 1025 ? MOBILE_OPTIONS : DESKTOP_OPTIONS
    
    
//     });

//     // pie.options.legend.onHover = (event, legendItem) => {
//     //   const index = data.labels.findIndex(l => l === legendItem.text);
//     //   const color = pie.data.datasets[0].backgroundColor[0];
//     // };

//     window.onresize = () => {
//       this.updateGraph(pie);
//     };
//   }

//   updateGraph(pie) {
//     if (pie) {
//       pie.options = window.innerWidth < 1025 ? MOBILE_OPTIONS : DESKTOP_OPTIONS;
//       pie.update();
//     }
//   }

//   handleTableScroll(el) {
//     const leftBtn = $(el).find('button.left-scroll');
//     leftBtn.addClass("hidden");

//     const rightBtn = $(el).find('button.right-scroll');

//     const dt = $(el).find('table.eni-table');
//     if (dt.width() <= dt.parent('.scroll-x').width()) {
//       // disable right btn
//       rightBtn.addClass("hidden");
//     }
//     let scrollLeftIntervalId = 0;
//     let scrollRightIntervalId = 0;

//     rightBtn.on('mousedown touchstart', (event) => {
//       scrollRightIntervalId = setInterval(() => {
//         // Handle right scroll
//         console.log('handleRightScroll', event);
//         const section = $(event.currentTarget).parents('section.data-table');
//         const eniFocusArea = section.find('.eni-focus-area');
//         const scrollXDiv = section.find('.scroll-x');
//         const dt = section.find('.eni-table');
//         const thActive = dt.find('th.active');
//         $(thActive).toggleClass('active');
//         const nextTh = $(thActive).next('th');
//         if (nextTh) {
//           scrollXDiv.scrollTo($(nextTh), 'slow', {
//             onAfter: (t) => {
//               console.log('onAfter', t);
//               $(t).toggleClass('active');
//               const diff = Math.trunc(dt.width() - scrollXDiv.scrollLeft());
//               section.find('button.left-scroll').removeClass("hidden");
//               if (diff <= eniFocusArea.width()) {
//                 section.find('button.right-scroll').addClass("hidden");
//               }
//             }
//           });
//         }
//       }, 50);

//     }).bind('mouseup mouseleave touchend', () => {
//       clearInterval(scrollRightIntervalId);
//     });

//     leftBtn.on('mousedown touchstart', (event) => {
//       scrollLeftIntervalId = setInterval(() => {

//         // Handle left scroll
//         console.log('handleLeftScroll', event);
//         const section = $(event.currentTarget).parents('section.data-table');
//         const scrollXDiv = section.find('.scroll-x');
//         const dt = section.find('.eni-table');
//         const thActive = dt.find('th.active');
//         $(thActive).toggleClass('active');
//         const previousTh = $(thActive).prev('th');
//         if (previousTh) {
//           scrollXDiv.scrollTo($(previousTh), 'slow', {
//             onAfter: (t) => {
//               console.log('onAfter', t);
//               $(t).toggleClass('active');
//               section.find('button.right-scroll').removeClass("hidden");
//               if (scrollXDiv.scrollLeft() == 0) {
//                 section.find('button.left-scroll').addClass("hidden");
//               }
//             }
//           });
//         }

//       }, 50);

//     }).bind('mouseup mouseleave touchend', () => {
//       clearInterval(scrollLeftIntervalId);
//     });
//   }
// }

// $(() => {
//   const component = new DateTable();
// });


/***/ }),

/***/ "./src/scripts/widgets/data-table.js":
/*!*******************************************!*\
  !*** ./src/scripts/widgets/data-table.js ***!
  \*******************************************/
/*! exports provided: DateTable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateTable", function() { return DateTable; });
// Add a polyfill for Math.trunc() because of error on IE (the object doesn't accept property or method trunc)
Math.trunc = Math.trunc || function (x) {
  if (isNaN(x)) {
    return NaN;
  }
  if (x > 0) {
    return Math.floor(x);
  }
  return Math.ceil(x);
};

class DateTable {
  constructor() {
    var data = genData();

    if (data) {
      var MobileOptionsDark = {
        animation: false,
        legend: {
          left: 'center',
          bottom: 0,
          orient: 'horizontal',
          data: data.legendData,
          icon: 'circle',
          itemWidth: 20,
          itemHeight: 20,
          itemGap: 30,
          selectedMode: false,
          textStyle: {
            color: '#fff',
            fontFamily: 'EniTabReg',
            fontSize: 16
          }
        },
        series: [{
          type: 'pie',
          radius: '70%',
          bottom: 20,
          center: ['50%', '50%'],
          data: data.seriesData,

          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.8)'
            }
          },
          label: {
            color: '#fff',
            formatter: '{@name}'
          },
          labelLine: {
            lineStyle: {
              color: '#fff'
            },

          }
        }]
      };

      var MobileOptionsLight = {
        animation: false,
        legend: {
          left: 'center',
          bottom: 0,
          orient: 'horizontal',
          data: data.legendData,
          icon: 'circle',
          itemWidth: 20,
          itemHeight: 20,
          itemGap: 30,
          selectedMode: false,
          textStyle: {
            color: '#333',
            fontFamily: 'EniTabReg',
            fontSize: 16
          }
        },
        series: [{
          type: 'pie',
          radius: '70%',
          bottom: 20,
          center: ['50%', '50%'],
          data: data.seriesData,

          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.8)'
            }
          },
          label: {
            color: '#333',
            formatter: '{@name}'
          },
          labelLine: {
            lineStyle: {
              color: '#333'
            },

          }
        }]
      };

      var DesktopOptionsDark = {
        animation: false,
        legend: {
          orient: 'vertical',
          right: 20,
          top: '40%',
          bottom: 'auto',
          icon: 'circle',
          itemWidth: 30,
          itemHeight: 30,
          itemGap: 30,
          data: data.legendData,
          selectedMode: false,
          textStyle: {
            color: '#fff',
            fontFamily: 'EniTabReg',
            fontSize: 18
          }
        },
        series: [{
          type: 'pie',
          radius: '85%',
          top: 20,
          center: ['40%', '50%'],
          data: data.seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.8)'
            }
          },
          label: {
            color: '#fff',
            formatter: '{@name}'
          },
          labelLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        }]
      };

      var DesktopOptionsLight = {
        animation: false,
        legend: {
          orient: 'vertical',
          right: 20,
          top: '40%',
          bottom: 'auto',
          data: data.legendData,
          selectedMode: false,
          icon: 'circle',
          itemWidth: 30,
          itemHeight: 30,
          itemGap: 30,
          textStyle: {
            color: '#333',
            fontFamily: 'EniTabReg',
            fontSize: 18
          }
        },
        series: [{
          type: 'pie',
          radius: '85%',
          top: 20,
          center: ['40%', '50%'],
          data: data.seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.8)'
            }
          },
          label: {
            color: '#333',
            formatter: '{@name}'
          },
          labelLine: {
            lineStyle: {
              color: '#333'
            },

          }
        }]
      };

      const charts = $('.maindata-table-graph');

      for (let i = 0; i < charts.length; i++) {
        if (charts && $(charts)) {
          var myChart = echarts.init(charts[i]);
          const section = $(charts[i]).parent().parent();

          let isDark = $(section).hasClass('dark-gray-theme');
          var color;
          (isDark) ? color = '#fff': color = '#333';
          console.log('color', color);
          if (window.innerWidth < 1025 && isDark) {
            myChart.setOption(MobileOptionsDark);
          } else if (window.innerWidth < 1025 && !isDark) {
            myChart.setOption(MobileOptionsLight);
          } else if (window.innerWidth > 1024 && isDark) {
            myChart.setOption(DesktopOptionsDark);
          } else {
            myChart.setOption(DesktopOptionsLight);
          }
          // (window.innerWidth < 1025) ? myChart.setOption(MobileOption) : myChart.setOption(DesktopOptions);
          // (isDark) ? myChart.setOption(DesktopOptionsDark) : myChart.setOption(DesktopOptionsLight);
        }
      }
    }

    function genData() {
      var graph = $('#main');

      if (graph && graph.length > 0) {
        var nameList = JSON.parse($(graph).attr('data-graph'));
        const count = nameList.labels.length;

        var legendData = [];
        var data = [];
        for (var i = 0; i < count; i++) {
          var bgColor = nameList.datasets[0].backgroundColor[i];
          var lab = nameList.datasets[0].data[i];

          var label = nameList.labels[i].toUpperCase();
          legendData.push(label);

          data.push({
            value: lab,
            name: label,
            itemStyle: {
              color: bgColor
            },
          });
        }
        return {
          legendData: legendData,
          seriesData: data
        };
      } else return false;
    }

    const sections = $('section.data-table');
    if (sections && sections.length > 0) {
      sections.each((i, el) => {
        this.handleTableScroll(el);
        //    const graphCanvas = $(el).find('div.maindata-table-graph');
        //    const isDark = $(el).hasClass('dark-gray-theme');
      });
    }
  }

  checkScroll(target, settings) {
    console.log('checkScroll', target, settings);
  }

  // drawGraphs(graphCanvas, isDark) {
  //   console.log(graphCanvas);
  //   const data = JSON.parse($(graphCanvas).attr('data-graph'));
  //   const color = isDark ? '#fff' : '#333';
  //   // pie.options.legend.onHover = (event, legendItem) => {
  //   //   const index = data.labels.findIndex(l => l === legendItem.text);
  //   //   const color = pie.data.datasets[0].backgroundColor[0];
  //   // };

  //   window.onresize = () => {
  //     this.updateGraph(pie);
  //   };
  // }

  updateGraph(pie) {
    if (pie) {
      pie.options = window.innerWidth < 1025 ? MOBILE_OPTIONS : DESKTOP_OPTIONS;
      pie.update();
    }
  }

  handleTableScroll(el) {
    const leftBtn = $(el).find('button.left-scroll');
    leftBtn.addClass("hidden");

    const rightBtn = $(el).find('button.right-scroll');

    const dt = $(el).find('table.eni-table');
    if (dt.width() <= dt.parent('.scroll-x').width()) {
      // disable right btn
      rightBtn.addClass("hidden");
    }
    let scrollLeftIntervalId = 0;
    let scrollRightIntervalId = 0;

    rightBtn.on('mousedown touchstart', (event) => {
      scrollRightIntervalId = setInterval(() => {
        // Handle right scroll
        console.log('handleRightScroll', event);
        const section = $(event.currentTarget).parents('section.data-table');
        const eniFocusArea = section.find('.eni-focus-area');
        const scrollXDiv = section.find('.scroll-x');
        const dt = section.find('.eni-table');
        const thActive = dt.find('th.active');
        $(thActive).toggleClass('active');
        const nextTh = $(thActive).next('th');
        if (nextTh) {
          scrollXDiv.scrollTo($(nextTh), 'slow', {
            onAfter: (t) => {
              console.log('onAfter', t);
              $(t).toggleClass('active');
              const diff = Math.trunc(dt.width() - scrollXDiv.scrollLeft());
              section.find('button.left-scroll').removeClass("hidden");
              if (diff <= eniFocusArea.width()) {
                section.find('button.right-scroll').addClass("hidden");
              }
            }
          });
        }
      }, 50);

    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollRightIntervalId);
    });

    leftBtn.on('mousedown touchstart', (event) => {
      scrollLeftIntervalId = setInterval(() => {

        // Handle left scroll
        console.log('handleLeftScroll', event);
        const section = $(event.currentTarget).parents('section.data-table');
        const scrollXDiv = section.find('.scroll-x');
        const dt = section.find('.eni-table');
        const thActive = dt.find('th.active');
        $(thActive).toggleClass('active');
        const previousTh = $(thActive).prev('th');
        if (previousTh) {
          scrollXDiv.scrollTo($(previousTh), 'slow', {
            onAfter: (t) => {
              console.log('onAfter', t);
              $(t).toggleClass('active');
              section.find('button.right-scroll').removeClass("hidden");
              if (scrollXDiv.scrollLeft() == 0) {
                section.find('button.left-scroll').addClass("hidden");
              }
            }
          });
        }
      }, 50);

    }).bind('mouseup mouseleave touchend', () => {
      clearInterval(scrollLeftIntervalId);
    });
  }
}

$(() => {
  const component = new DateTable();
});


/***/ }),

/***/ "./src/scripts/widgets/display-launch-card.js":
/*!****************************************************!*\
  !*** ./src/scripts/widgets/display-launch-card.js ***!
  \****************************************************/
/*! exports provided: DisplayLaunchCard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisplayLaunchCard", function() { return DisplayLaunchCard; });
class DisplayLaunchCard {
  constructor() {
    this.displayLaunchCard();
  }

  displayLaunchCard() {
    var ExpandCollapse = function (event) {
      var accordion = $(event.target).parent().parent().children('.display-launch-card-description-container');
      var icon = $(event.target).next().children('.icon-more');
      var windowSize = $(window).width();

      if (windowSize < 1028) {
        accordion.toggleClass('expanded');
        icon.toggleClass('expanded');
      }
    };
    $('.display-launch-card-title').on('click', ExpandCollapse);
  }
}

$(() => {
  const component = new DisplayLaunchCard();
});


/***/ }),

/***/ "./src/scripts/widgets/document-disclaimer-egl.js":
/*!********************************************************!*\
  !*** ./src/scripts/widgets/document-disclaimer-egl.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(() => {

  const buttons = $('.document-disclaimer-btn');

  for (let i = 0; i < buttons.length; i++) {
    if (buttons && $(buttons)) {
      $(buttons[i]).on('click', () => {
        console.log('BOTTONE CLICCATO');
        var X = $(buttons[i]).attr('document-link');
        console.log('BOTTONE CLICCATO X', X);
        $('#link-disclaimer-egl').attr('href', X);
      });
    }
  }

  let show = false;
  var target = $('#link-disclaimer-egl');
  $('#disclaimer-terms-egl').click(() => {

    if (!show) {
      $('#disclaimer-terms-egl').click(() => {
        $(target).addClass("visible");
        show = true;
      });
    } else {
      $('#disclaimer-terms-egl').click(() => {
        $(target).removeClass("visible");
        show = false;
      });
    }
  });

  $(target).click( () => {
    $('#ModalDocumentDisclaimerEGL').modal('toggle');
  });

  $('.eni-modal').on("hide.bs.modal", function() {
    $(target).removeClass("visible");
    setTimeout(() => {
      $("input").prop('checked', false);
    }, 20);
    show = false;
  });
   
});



/***/ }),

/***/ "./src/scripts/widgets/document-disclaimer.js":
/*!****************************************************!*\
  !*** ./src/scripts/widgets/document-disclaimer.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(() => {

  const buttons = $('.document-disclaimer-btn');

  for (let i = 0; i < buttons.length; i++) {
    if (buttons && $(buttons)) {
      $(buttons[i]).on('click', () => {
        console.log('BOTTONE CLICCATO');
        var X = $(buttons[i]).attr('document-link');
        console.log('BOTTONE CLICCATO X', X);
        $('#link-disclaimer').attr('href', X);
      });
    }
  }

  let show = false;
  var target = $('#link-disclaimer');
  $('#disclaimer-terms').click(() => {

    if (!show) {
      $('#disclaimer-terms').click(() => {
        $(target).addClass("visible");
        show = true;
      });
    } else {
      $('#disclaimer-terms').click(() => {
        $(target).removeClass("visible");
        show = false;
      });
    }
  });

  $(target).click( () => {
    $('#ModalDocumentDisclaimer').modal('toggle');
  });

  $('.eni-modal').on("hide.bs.modal", function() {
    $(target).removeClass("visible");
    setTimeout(() => {
      $("input").prop('checked', false);
    }, 20);
    show = false;
  });
   
});



/***/ }),

/***/ "./src/scripts/widgets/editorial-collection-card.js":
/*!**********************************************************!*\
  !*** ./src/scripts/widgets/editorial-collection-card.js ***!
  \**********************************************************/
/*! exports provided: EditorialCollectionCard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditorialCollectionCard", function() { return EditorialCollectionCard; });
class EditorialCollectionCard {
  constructor() {
    var isMobile = $(window).outerWidth() < 1024;
    if(!isMobile){
    $('.editorial-collection-highlight .content-type .title a, .editorial-collection-highlight .content-box a.title').hover(
      (event) => this.handleHover(event.currentTarget, true),
      (event) => this.handleHover(event.currentTarget, false)
    );
    }
    if ($('.editorial-collection-highlight .view-more-container')) {
      $(window).resize(event => this.handleViewMoreContainerResize(event));
      if ($('.editorial-collection-highlight .view-more-container').is(':visible')) {
        this.handleCards($('.editorial-collection-highlight .cards-container'));
      }
      $('.editorial-collection-highlight .view-more-container .btn-view-more').click(this.handleViewMoreClick);
      $('.editorial-collection-highlight .view-more-container .btn-view-less').click(event => this.handleViewLessClick(event));
    }
  }

  handleHover(el, inOut) {
    const catEl = $(el).parent().parent().find('.category');

    if (inOut) {
      catEl.addClass('active');
    } else {
      catEl.removeClass('active');
    }
  }

  handleViewMoreContainerResize(event) {
    const viewMoreContainer = $('.editorial-collection-highlight .view-more-container');
    if (viewMoreContainer && viewMoreContainer.is(':visible')) {
      this.handleCards($('.editorial-collection-highlight .cards-container'));
    }
  }

  handleCards(cards) {
    cards.each((i, card) => {
      const details = $(card).find('.detail');
      if (details && details.length > 3) {
        details.each((j, detail) => {
          if (j > 3) {
            $(detail).hide();
          }
        });
      }
    });
  }

  handleViewMoreClick(event) {
    console.log('handleViewMoreClick', event);
    try {
      const btn = event.currentTarget;
      $(btn).hide();
      const parent = $(btn).parents('.collection-col-right');
      const cards = parent.find('.detail');
      cards.show();
      $(btn).next('.btn-view-less').show();

    } catch (ex) {
      console.error(ex);
    }
  }

  handleViewLessClick(event) {
    console.log('handleViewLessClick', event);
    try {
      const btn = event.currentTarget;
      $(btn).hide();
      const parent = $(btn).parents('.collection-col-right');
      const cards = parent.find('.detail');
      cards.each((i, card) => {
        if (i > 3) {
          $(card).hide();
        }
      });
      $(btn).prev('.btn-view-more').show();

    } catch (ex) {
      console.error(ex);
    }
  }
}

$(() => {
  const component = new EditorialCollectionCard();
});


/***/ }),

/***/ "./src/scripts/widgets/editorial-content-list.js":
/*!*******************************************************!*\
  !*** ./src/scripts/widgets/editorial-content-list.js ***!
  \*******************************************************/
/*! exports provided: EDITORIAL_CONTENT_LIST_PROPS, EditorialContentList */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITORIAL_CONTENT_LIST_PROPS", function() { return EDITORIAL_CONTENT_LIST_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditorialContentList", function() { return EditorialContentList; });
const EDITORIAL_CONTENT_LIST_PROPS = {
  TITLE_CLASS: '.editorial-content-list .content-title'
};
class EditorialContentList {
  constructor() {
    var isMobile = $(window).outerWidth() < 1024;
    if(!isMobile){
    $(EDITORIAL_CONTENT_LIST_PROPS.TITLE_CLASS).hover(
      (event) => {
        this.handleTitleHover(event.target);
      }
      ,
      (event) => {
        this.handleTitleHover(event.target);
      }
    );
    }
  }

  handleTitleHover(el) {
    const contentBox = $(el).parents('.content-box');
    const yellowLine = $(contentBox).find('i.dash');

    yellowLine.toggleClass('yellow-line');
    yellowLine.toggleClass('yellow-pipe');

  }

}

$(() => {
  const component = new EditorialContentList();
});


/***/ }),

/***/ "./src/scripts/widgets/event-cover.js":
/*!********************************************!*\
  !*** ./src/scripts/widgets/event-cover.js ***!
  \********************************************/
/*! exports provided: EventCover */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventCover", function() { return EventCover; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! mobile-detect */ "./node_modules/mobile-detect/mobile-detect.js");
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mobile_detect__WEBPACK_IMPORTED_MODULE_1__);



class EventCover {

  constructor(currentEventHighlight) {
    const eventHighlights = $(currentEventHighlight);
    for (let i = 0; i < eventHighlights.length; i++) {
      this.init(eventHighlights[i]);
    }
  }

  init(currentEventHighlight) {
    // Get Data Attributes
    var mainSelector = '#' + $(currentEventHighlight).attr('id');

    var eventStart = new Date($(mainSelector).data("event-start")).getTime();
    var eventEnd = new Date($(mainSelector).data("event-end")).getTime();
    var eventPublish = new Date($(mainSelector).data("event-pub")).getTime();
    var isCountdown = $(mainSelector).data("countdown");

    // Get Current Date
    var currentDate = new Date().getTime();

    var countdownContainer = mainSelector + ' .countdown-container';
    var liveContainer = mainSelector + ' .live-container';
    var onDemandContainer = mainSelector + ' .ondemand-container';

    if (isCountdown === true) {
      $(countdownContainer).show();
      $(liveContainer).hide();
      $(onDemandContainer).hide();

      // Check if Event is Current, Past or Future
      if (eventStart > currentDate) {
        // Future Event
        this.startCountdown(mainSelector, eventStart, eventPublish);
      } else if (eventStart <= currentDate) {
        if (eventEnd < currentDate) {
          // Past
          this.handlePastEvent(countdownContainer, liveContainer, onDemandContainer);
        } else {
          // Current
          this.handleLiveEvent(countdownContainer, liveContainer, onDemandContainer);
        }
      }
    } else {
      $(countdownContainer).hide();
      $(liveContainer).hide();
      $(onDemandContainer).hide();
    }

  }

  startCountdown(mainSelector, date, publishDate) {
    var countdownContainer = mainSelector + ' .countdown-container';
    var liveContainer = mainSelector + ' .live-container';
    var progressBar = mainSelector + ' .countdown-container .progress-bar-container .progress-bar';
    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = date - now;

      var progressBarWidth = ((now - publishDate) / (date - publishDate)) * 100;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if(seconds < 10) {
        seconds = "0" + seconds;
      }
      if(minutes < 10) {
        minutes = "0" + minutes;
      }
      if(hours < 10) {
        hours = "0" + hours;
      }
      if (days < 10) {
        days = "0" + days;
      }

      // Inject values into DOM

      $(countdownContainer + ' .numbers .days .value').text(days);
      $(countdownContainer + ' .numbers .hours .value').text(hours);
      $(countdownContainer + ' .numbers .minutes .value').text(minutes);
      $(countdownContainer + ' .numbers .seconds .value').text(seconds);
      $(progressBar).css("width", progressBarWidth + "%");

      if (distance < 0) {
        clearInterval(x);
        $(countdownContainer).hide();
        $(liveContainer).show();
      }
    }, 1000);

  }

  handleLiveEvent(countdownContainer, liveContainer, onDemandContainer) {
    $(countdownContainer).hide();
    $(liveContainer).show();
    $(onDemandContainer).hide();
  };

  handlePastEvent(countdownContainer, liveContainer, onDemandContainer) {
    $(countdownContainer).hide();
    $(liveContainer).hide();
    $(onDemandContainer).show();
  }
}



$(document).ready(function () {
  const init = new EventCover(".event-cover");
});


/***/ }),

/***/ "./src/scripts/widgets/event-highlight-countdown.js":
/*!**********************************************************!*\
  !*** ./src/scripts/widgets/event-highlight-countdown.js ***!
  \**********************************************************/
/*! exports provided: EVENT_HIGHLIGHT_PROPS, EventHighlightHome */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_HIGHLIGHT_PROPS", function() { return EVENT_HIGHLIGHT_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventHighlightHome", function() { return EventHighlightHome; });

const EVENT_HIGHLIGHT_PROPS = {
  SECTION_CLASS: 'section.event-highlight-countdown',
};

class EventHighlightHome {

  constructor() {

    console.log('EventHighlightHome');
    // Manage children selector when dynamic section instantiate class

    $(EVENT_HIGHLIGHT_PROPS.SECTION_CLASS).click(this.handleClick);
    $(EVENT_HIGHLIGHT_PROPS.SECTION_CLASS).hover((event) => this.handleHover(event, true), (event) => this.handleHover(
      event, false));

    const heroBanner = $(EVENT_HIGHLIGHT_PROPS.SECTION_CLASS);
    for (let i = 0; i < heroBanner.length; i++) {
      this.initCountDown(heroBanner[i]);
    }
    
  }

  initCountDown(heroBanner){
    // Get Data Attributes
    var mainSelector = '#' + $(heroBanner).attr('id');

    var countdownStart = new Date($(mainSelector).data("countdown-start")).getTime();
    var countdownEnd = new Date($(mainSelector).data("countdown-end")).getTime();
    var isCountdown = $(mainSelector).data("countdown");
    var cta = $(mainSelector).data("cta");
    var disclaimer = $(mainSelector).data("disclaimer");

    // Get Current Date
    var currentDate = new Date().getTime();

    var countdownContainer = mainSelector + ' .content-box .statement-container .countdown-container';
    var liveContainer = mainSelector + ' .content-box .statement-container .live-container';
    var onDemandContainer = mainSelector + ' .content-box .statement-container .on-demand-container';

    //$(countdownContainer).hide();
    $(countdownContainer).css("display", "none");
    $(liveContainer).hide();
    $(onDemandContainer).hide();

    if (isCountdown === true) {

      if (countdownEnd > currentDate && countdownStart <= currentDate && countdownEnd > countdownStart) {
        //$(countdownContainer).show();
        $(countdownContainer).css("display", "inline-block");
        $(liveContainer).hide();
        $(onDemandContainer).hide();
        this.startCountdown(mainSelector, countdownStart, countdownEnd, disclaimer);
      }
      else if(countdownEnd <= currentDate) {
        //setto link section, title, share
        let linkCta = $(liveContainer + ' a.eni-btn').attr('href');
        let linkCtaTarget = $(liveContainer + ' a.eni-btn').attr('target');
        $(mainSelector).attr('data-url',linkCta);
        $(mainSelector).attr('data-target',linkCtaTarget);
        $(mainSelector + ' h2 a').attr('href',linkCta);
        $(mainSelector + ' h2 a').attr('target',linkCtaTarget);
        $(mainSelector + ' .share-container .btn-share').attr('data-url',linkCta);
        if(disclaimer){
          $(mainSelector).attr('data-disclaimer-status','on');
          $(mainSelector + ' h2 a').attr('href','#');
          $(liveContainer + ' a.eni-btn').attr('href','#');
          $(mainSelector + ' h2 a').on('click', (event) => {
            $('#link-disclaimer-egl').attr('href', linkCta);
            $('#ModalDocumentDisclaimerEGL').modal('toggle');
            event.preventDefault();
          });
          $(liveContainer + ' a.eni-btn').on('click', (event) => {
            $('#link-disclaimer-egl').attr('href', linkCta);
            $('#ModalDocumentDisclaimerEGL').modal('toggle');
            event.preventDefault();
          });
        }
        //$(countdownContainer).hide();
        $(countdownContainer).css("display", "none");
        $(liveContainer).show();
        $(onDemandContainer).hide();
      }

    } else if (cta == "live"){
      if(disclaimer){
        $(mainSelector).attr('data-disclaimer-status','on');
        let linkCta = $(liveContainer + ' a.eni-btn').attr('href');
        $(mainSelector + ' h2 a').attr('href','#');
        $(liveContainer + ' a.eni-btn').attr('href','#');
        $(mainSelector + ' h2 a').on('click', (event) => {
          $('#link-disclaimer-egl').attr('href', linkCta);
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
        $(liveContainer + ' a.eni-btn').on('click', (event) => {
          $('#link-disclaimer-egl').attr('href', linkCta);
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
      }
      $(countdownContainer).css("display", "none");
      $(liveContainer).show();
      $(onDemandContainer).hide();

    } else if(cta == "ondemand") {
      if(disclaimer){
        $(mainSelector).attr('data-disclaimer-status','on');
        let linkCta = $(onDemandContainer + ' a.eni-btn').attr('href');
        $('#link-disclaimer-egl').attr('href', linkCta);
        $(mainSelector + ' h2 a').attr('href','#');
        $(onDemandContainer + ' a.eni-btn').attr('href','#');
        $(mainSelector + ' h2 a').on('click', (event) => {
          $('#link-disclaimer-egl').attr('href', linkCta);
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
        $(onDemandContainer + ' a.eni-btn').on('click', (event) => {
          $('#link-disclaimer-egl').attr('href', linkCta);
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
      }
      $(countdownContainer).css("display", "none");
      $(liveContainer).hide();
      $(onDemandContainer).show();
    }

  }

  startCountdown(mainSelector, start, end, disclaimer) {
    console.log('start countdown');
    const countdownContainer = mainSelector + ' div.content-box div.countdown-container';
    const progressBar = mainSelector +
      ' div.content-box div.countdown-container div.progress-bar-container > div';
    const liveContainer = mainSelector + ' div.content-box div.live-container';

    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = end - now;

      var progressBarWidth = ((now - start) / (end - start)) * 100;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if(seconds < 10) {
        seconds = "0" + seconds;
      }
      if(minutes < 10) {
        minutes = "0" + minutes;
      }
      if(hours < 10) {
        hours = "0" + hours;
      }
      if (days < 10) {
        days = "0" + days;
      }

      // Inject values into DOM
      $(countdownContainer + ' .numbers .days .value').text(days);
      $(countdownContainer + ' .numbers .hours .value').text(hours);
      $(countdownContainer + ' .numbers .minutes .value').text(minutes);
      $(countdownContainer + ' .numbers .seconds .value').text(seconds);

      $(progressBar).css("width", progressBarWidth + "%");

      if (distance <= 500) {
        $(countdownContainer).fadeOut(500);

        if (distance <= 0) {
          clearInterval(x);
          $(liveContainer).fadeIn(500);
          //setto link section, title, share
          let linkCta = $(liveContainer + ' a.eni-btn').attr('href');
          let linkCtaTarget = $(liveContainer + ' a.eni-btn').attr('target');
          $(mainSelector).attr('data-url',linkCta);
          $(mainSelector).attr('data-target',linkCtaTarget);
          $(mainSelector + ' h2 a').attr('href',linkCta);
          $(mainSelector + ' h2 a').attr('target',linkCtaTarget);
          $(mainSelector + ' .share-container .btn-share').attr('data-url',linkCta);
          if(disclaimer){
            $(mainSelector).attr('data-disclaimer-status','on');
            $(mainSelector + ' h2 a').attr('href','#');
            $(liveContainer + ' a.eni-btn').attr('href','#');
            $(mainSelector + ' h2 a').on('click', (event) => {
              $('#link-disclaimer-egl').attr('href', linkCta);
              $('#ModalDocumentDisclaimerEGL').modal('toggle');
              event.preventDefault();
            });
            $(liveContainer + ' a.eni-btn').on('click', (event) => {
              $('#link-disclaimer-egl').attr('href', linkCta);
              $('#ModalDocumentDisclaimerEGL').modal('toggle');
              event.preventDefault();
            });
          }
        }
      }
    }, 250);

  }

  handleClick(event) {

    if ($(event.target).hasClass('icon-share-small') || $(event.target).hasClass('btn-share')) {
      event.preventDefault();
      return;
    } 
    if($(event.target).hasClass('icon-arrow-right-small') || $(event.target).hasClass('arrow-link')){
      return;
    }
    if($(event.target).hasClass('eni-btn')){
      return;
    }
    const section = event.currentTarget;
    const url = $(section).attr('data-url');
    const target = $(section).attr('data-target');
    const disclaimerStatus = $(section).attr('data-disclaimer-status');
    if (url && url.length > 0) {
      if(disclaimerStatus == 'on'){
        $('#link-disclaimer-egl').attr('href', url);
        $("#ModalDocumentDisclaimerEGL").modal("toggle");
      }
      else
        window.open(url, target);
      
    }
    event.preventDefault();
  }
  
  handleHover(event, inOut) {
    const section = event.currentTarget;
    const yellowLine = $(section).find('i.dash');
    if (inOut) {
      yellowLine.addClass('active');
    } else {
      yellowLine.removeClass('active');
    }
  }

 
}

$(() => {
  const component = new EventHighlightHome();
});


/***/ }),

/***/ "./src/scripts/widgets/event-highlight.js":
/*!************************************************!*\
  !*** ./src/scripts/widgets/event-highlight.js ***!
  \************************************************/
/*! exports provided: EventHighlight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventHighlight", function() { return EventHighlight; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! mobile-detect */ "./node_modules/mobile-detect/mobile-detect.js");
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mobile_detect__WEBPACK_IMPORTED_MODULE_1__);



class EventHighlight {

  constructor(currentEventHighlight) {
    const eventHighlights = $(currentEventHighlight);
    for (let i = 0; i < eventHighlights.length; i++) {
      this.init(eventHighlights[i]);
    }
  }

  init(currentEventHighlight) {
    // Get Data Attributes
    const isDouble = $(currentEventHighlight).data("double-event");
    var mainSelector = '#' + $(currentEventHighlight).attr('id');

    var eventStart = new Date($(mainSelector).data("event-start")).getTime();
    var eventEnd = new Date($(mainSelector).data("event-end")).getTime();
    var eventPublish = new Date($(mainSelector).data("event-pub")).getTime();
    var isCountdown = $(mainSelector).data("countdown");

    // Get Current Date
    var currentDate = new Date().getTime();

    var countdownContainer = mainSelector + ' .content-box .eni-focus-area .countdown-container';
    var liveContainer = mainSelector + ' .content-box .eni-focus-area .live-container';
    var startDateContainer = mainSelector + '> div.content-box > div > p > span.ts__year';
    var startDateContainer2 = mainSelector + '> div.content-box > div > p > span.ts__days';
    var onDemandContainer = mainSelector + '> .content-box > .eni-focus-area .on-demand-container';


    if (isDouble && isDouble === true) {
      mainSelector += " .section-content";

      const events = $(mainSelector);

      for (let i = 0; i < 2; i++) {
        let currentEvent = events[i];

        // Handle click
        $(currentEvent).click(function () {
          const url = $(currentEvent).data('url');
          const target = $(currentEvent).data('target');
          const eventTarget = event.target;

          if (!($(eventTarget).hasClass("btn-share") || $(eventTarget).hasClass("icon-share-small")) &&
            url && url.length > 0) {
            window.open(url, target);
          }
        });

        countdownContainer = $(currentEvent).find('.content-box .eni-focus-area .countdown-container');
        liveContainer = $(currentEvent).find('.content-box .eni-focus-area .live-container');
        // startDateContainer = $(currentEvent).find('div.content-box > div > p');
        startDateContainer = $(currentEvent).find('div.content-box > div > p > span.ts__year');
        startDateContainer2 = $(currentEvent).find('div.content-box > div > p > span.ts__days');
        onDemandContainer = $(currentEvent).find('.content-box > .eni-focus-area .on-demand-container');

        eventStart = new Date($(currentEvent).data("event-start")).getTime();
        eventEnd = new Date($(currentEvent).data("event-end")).getTime();
        eventPublish = new Date($(currentEvent).data("event-pub")).getTime();
        isCountdown = $(currentEvent).data("countdown");

        // Set date in DOM
        $(startDateContainer).text(moment(eventStart).format("dddd[,] D MMMM YYYY"));
        $(startDateContainer2).text(moment(eventStart).format("h:mm a [CEST]"));
console.log('startDateContainer: ', startDateContainer);


        if (isCountdown === true) {
          $(countdownContainer).show();
          $(liveContainer).hide();
          $(onDemandContainer).hide();

          // Check if Event is Current, Past or Future
          if (eventStart > currentDate) {
            // Future Event
            this.startCountdown(mainSelector, eventStart, eventPublish);
          } else if (eventStart <= currentDate) {
            if (eventEnd < currentDate) {
              // Past
              this.handlePastEvent(countdownContainer, liveContainer, onDemandContainer);
            } else {
              // Current
              this.handleLiveEvent(countdownContainer, liveContainer, onDemandContainer);
            }
          }
        } else {
          $(countdownContainer).hide();
          $(liveContainer).hide();
          $(onDemandContainer).hide();
        }

      }

    } else {
      // Set date in DOM
      $(startDateContainer).text(moment(eventStart).format("dddd[,] D MMMM YYYY"));
      $(startDateContainer2).text(moment(eventStart).format("h:mm a [CEST]"));

      $(mainSelector).click(function (event) {
        const url = $(mainSelector).data('url');
        const target = $(mainSelector).data('target');
        const eventTarget = event.target;

        if (!($(eventTarget).hasClass("btn-share") || $(eventTarget).hasClass("icon-share-small")) &&
          url && url.length > 0) {
          window.open(url, target);
        }
      });

      if (isCountdown === true) {
        $(countdownContainer).show();
        $(liveContainer).hide();
        $(onDemandContainer).hide();

        // Check if Event is Current, Past or Future
        if (eventStart > currentDate) {
          // Future Event
          this.startCountdown(mainSelector, eventStart, eventPublish);
        } else if (eventStart <= currentDate) {
          if (eventEnd < currentDate) {
            // Past
            this.handlePastEvent(countdownContainer, liveContainer, onDemandContainer);
          } else {
            // Current
            this.handleLiveEvent(countdownContainer, liveContainer, onDemandContainer);
          }
        }
      } else {
        $(countdownContainer).hide();
        $(liveContainer).hide();
        $(onDemandContainer).hide();
      }
    }
  }

  startCountdown(mainSelector, date, publishDate) {
    const countdownContainer = mainSelector + ' > div.content-box > div > div.countdown-container';
    const progressBar = mainSelector +
      ' > div.content-box > div > div.countdown-container > div.progress-bar-container > div';
    const liveContainer = mainSelector + ' > div.content-box > div > div.live-container';

    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = date - now;

      var progressBarWidth = ((now - publishDate) / (date - publishDate)) * 100;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if(seconds < 10) {
        seconds = "0" + seconds;
      }
      if(minutes < 10) {
        minutes = "0" + minutes;
      }
      if(hours < 10) {
        hours = "0" + hours;
      }
      if (days < 10) {
        days = "0" + days;
      }

      // Inject values into DOM
      $(countdownContainer + ' .numbers .days .value').text(days);
      $(countdownContainer + ' .numbers .hours .value').text(hours);
      $(countdownContainer + ' .numbers .minutes .value').text(minutes);
      $(countdownContainer + ' .numbers .seconds .value').text(seconds);

      $(progressBar).css("width", progressBarWidth + "%");

      if (distance < 0) {
        clearInterval(x);
        $(countdownContainer).hide();
        $(liveContainer).show();
      }
    }, 1000);

  }

  handleLiveEvent(countdownContainer, liveContainer, onDemandContainer) {
    $(countdownContainer).hide();
    $(liveContainer).show();
    $(onDemandContainer).hide();
  };

  handlePastEvent(countdownContainer, liveContainer, onDemandContainer) {
    $(countdownContainer).hide();
    $(liveContainer).hide();
    $(onDemandContainer).show();
  }
}



$(document).ready(function () {
  const init = new EventHighlight(".event-highlight");
});


/***/ }),

/***/ "./src/scripts/widgets/format-video-player.js":
/*!****************************************************!*\
  !*** ./src/scripts/widgets/format-video-player.js ***!
  \****************************************************/
/*! exports provided: FormatVideoPlayer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatVideoPlayer", function() { return FormatVideoPlayer; });
/* harmony import */ var _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/yt-utils */ "./src/scripts/common/yt-utils.js");
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");
/* harmony import */ var _common_digital_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/digital-data */ "./src/scripts/common/digital-data.js");




// import Utils from '../common/utils';

class FormatVideoPlayer {

    constructor() {

        console.log('FormatVideoPlayer timestamp');
        $(".format-video-player .card--main").hover(function() {
            $(".full-video-image-widget").addClass("hover");
        });

        $(".full-video-image-widget .icon-video-outline").on("mouseout", function() {
            $(".full-video-image-widget").removeClass("hover");
        });
        
        this.seasonParams = (this.getParameterByName('stagione')) ? this.getParameterByName('stagione') : 1;
        this.episodeParams = (this.getParameterByName('episodio')) ? this.getParameterByName('episodio') : 1;

        const seasonCarousel = $(".format-video-player");
        for (let i = 0; i < seasonCarousel.length; i++) {
            if (seasonCarousel && $(seasonCarousel)) {
                
                this.episode( $(seasonCarousel[i]), $(seasonCarousel[i]).find('.card--main') );
                this.season( $(seasonCarousel[i]) );
                
                //this.init( $(videoSections[i]).find('.card--main') );
                
                //this.handleVideo();
            }
        }

        if ( $( window ).width() < 1024 ){
            $('.card--list').eq( this.seasonParams - 1 ).find('.item').eq( this.episodeParams - 1 ).addClass('active');
        } else {
            $('.card--list').eq( this.seasonParams - 1 ).find('.item').eq( this.episodeParams - 1 ).click();
        }

       
    }

    getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    season( elem ) {

        //const urlParams = new URLSearchParams(window.location.search);
        //const mySeason = urlParams.get('season');

        Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_1__["owlCarouselUtls"])( $(elem).find('.card-carousel') , {
            loop: false,
            dots: false,
            nav: true,
            mouseDrag: false,
            center: false,
            autoWidth: false,
            margin: 0,
            navText: [ $(elem).find('.icon-arrow-left') , $(elem).find('.icon-arrow-right') ],
            rewind: false,
            items: 1,
            startPosition: (this.seasonParams - 1),
        }, true);

    }

    episode( elem, container ) {
        
        $(elem).find('.item').on('click', (e) => {

            const item = $(e.target).hasClass('item') ? $(e.target) : $(e.target).closest('.item');

            if ( item ){
                if ( $(elem).find('.item.active') ){
                    let category_old = $(elem).find('.item.active').attr('data-category');
                    $(container).closest('.format-video-player').removeClass(category_old);
                }
                let category = $(item).attr('data-category');
                // let category = 'deep-science';
                console.log('format-video-player episode', $(container), $(container).closest('.format-video-player'));
                $(container).closest('.format-video-player').addClass( category + ' open');
                $(elem).find('.item').removeClass('active');
                $(item).addClass('active');
                $(container).html( $(item).html() ).show();
                $(container).attr( 'class', 'card--main ' + $(item).attr('data-yt-category') );
                $(container).find('.media source').detach();

                console.log('format-video-player episode', $(container), $(container).closest('.format-video-player'));

                if ( $( window ).width() < 1024 ){
                    $(container).find('.yt-embedded').wrap( "<div class='yt-embedded-wrapper'></div>" );
                    this.initMobile( container, item )
                } else {
                    this.initDesktop( container, item )
                }
            }
            
        });

    }

    initDesktop(elem, item) {
        console.log( 'format-video-player initDesktop');

        $(elem).find('picture').on( 'click', (e) => {

            this.handleVideo(elem, false, item);

            //let top_of_element = $(elem).offset().top;
            //let bottom_of_element = $(elem).offset().top + $(elem).outerHeight();
            //document.onscroll = () => this.handleVideoScroll(top_of_element, bottom_of_element);
            //e.preventDefault();

        });

        let _this = this;
        $('<div class="icon-close-small"></div>').appendTo( elem ).on('click', (e) => {
            $( elem ).closest('.format-video-player').removeClass('open');
            $( 'body' ).removeClass( 'modal-open' );
            console.log( 'format-video-player initDesktop', elem );
            console.log( 'format-video-player initDesktop', $( elem ).closest('.format-video-player') );
            console.log( 'format-video-player initDesktop', _this.ytUtils );
            _this.ytUtils.pauseVideoFull();
            $(elem).hide();
            $(elem).html('');
        });

    }

    initMobile(elem, item) {
        console.log( 'format-video-player initDesktop');

        this.handleVideo(elem, true, item);
        $( 'body' ).addClass( 'modal-open' );
        
        let _this = this;
        $('<div class="icon-close-small"></div>').appendTo( elem ).on('click', (e) => {
            console.log( 'format-video-player', _this.ytUtils );
            $( elem ).closest('.format-video-player').removeClass('open');
            $( 'body' ).removeClass( 'modal-open' );
            _this.ytUtils.pauseVideoFull();
            $(elem).hide();
        });

    }

    handleVideo(videoSection, picture, item) {
        _common_digital_data__WEBPACK_IMPORTED_MODULE_2__["DigitalDataUtils"].handleClickItemFormatVideo(item);

        const ytEmbedded = $(videoSection).find(".yt-embedded");

        console.log( 'format-video-player handleVideo', ytEmbedded );

        if (ytEmbedded) {
            const timestamp = new Date().getTime();
            const playerId = String('yt-' + timestamp);
            $(ytEmbedded).attr("id", playerId);
            const ytId = $(ytEmbedded).attr("data-yt-id");
            this.ytUtils = _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__["YtUtils"].createInstance(
                playerId,
                [ytId], {
                    autoplay: 1,
                    autohide: 1,
                    modestbranding: 0,
                    rel: 0,
                    showinfo: 0,
                    controls: 1,
                    disablekb: 1,
                    enablejsapi: 0,
                    iv_load_policy: 3,
                    loop: 0
                },
                true,
                true
            );
            this.startVideo( this.ytUtils, videoSection, picture );
        }
    }

    startVideo(yt, container, picture) {
        if ( !picture ){
            $(container).find("picture").hide();
        }
        $(container).find("iframe").show();
        //yt.startVideo(container);
    }

    /*handleVideoScroll(top_of_element, bottom_of_element) {
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
            // this.ytUtils.startVideo();
        } else {
            this.ytUtils.pauseVideoFull();
            $('.full-video-image-bg').css({
                'display': 'block'
            });

        }
    }*/
}

$(() => {
    const component = new FormatVideoPlayer();
});

/***/ }),

/***/ "./src/scripts/widgets/full-video-image.js":
/*!*************************************************!*\
  !*** ./src/scripts/widgets/full-video-image.js ***!
  \*************************************************/
/*! exports provided: FullVideoImage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FullVideoImage", function() { return FullVideoImage; });
/* harmony import */ var _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/yt-utils */ "./src/scripts/common/yt-utils.js");

// import Utils from '../common/utils';

class FullVideoImage {

  constructor() {

    console.log('FullVideoImage');

    $(".full-video-image-widget .icon-video-outline").hover(function() {
      $(".full-video-image-widget").addClass("hover");
    });

    $(".full-video-image-widget .icon-video-outline").on("mouseout", function() {
      $(".full-video-image-widget").removeClass("hover");
    });

    // const videoSection = $("section.full-video-image-widget.yt-video");
    // $("section.full-video-image-widget.yt-video").click(ev => {
    //   if (!($(ev.target).hasClass("btn-share") || $(ev.target).hasClass("icon-share-small"))) {
    //     $("section.full-video-image-widget .icon-share-small").hide();
    //     if (videoSection && videoSection.length > 0) {
    //       this.handleVideo(ev.currentTarget);
    //       $(window).scroll(() => this.handleVideoScroll(videoSection));
    //     }
    //     this.handleVideo();
    //   }
    // });

    
    const videoSections = $("section.full-video-image-widget.yt-video");
    for (let i = 0; i < videoSections.length; i++) {
      if (videoSections && $(videoSections)) {
        $(videoSections[i]).click( (e) => {
          
          if ($(e.target).hasClass('icon-share-small') || $(e.target).hasClass('btn-share')) {
            e.preventDefault();
            return;
          }

          $("section.full-video-image-widget .icon-share-small").hide();
          
          this.handleVideo(videoSections[i]);
         
          let top_of_element = $(videoSections[i]).offset().top;
          let bottom_of_element = $(videoSections[i]).offset().top + $(videoSections[i]).outerHeight();
          document.onscroll = () => this.handleVideoScroll(top_of_element, bottom_of_element);
          e.preventDefault();
          // $(window).scroll(() => this.handleVideoScroll($(videoSections[i])));
        });
      }
      this.handleVideo();
    }
 
  }

  handleVideo(videoSection) {
    const ytEmbedded = $(videoSection).find(".yt-embedded");
    if (ytEmbedded) {
      const playerId = $(ytEmbedded).attr("id");
      const ytId = $(ytEmbedded).attr("data-yt-id");
      this.ytUtils = _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__["YtUtils"].createInstance(
        playerId,
        [ytId],
        {
          autoplay: 1,
          autohide: 1,
          modestbranding: 0,
          rel: 0,
          showinfo: 0,
          controls: 1,
          disablekb: 1,
          enablejsapi: 0,
          iv_load_policy: 3,
          loop: 1
        },
        true,
        true
      );
      this.startVideo(this.ytUtils, videoSection);
    }
  }

  startVideo(yt, container) {
    if ($("html[class*='aem-AuthorLayer-']").length > 0) {
    } else {
      $(container)
        .find("img")
        .hide();
      $(container)
        .find(".eni-focus-area")
        .hide();
      yt.startVideo(container);
    }
  }

  handleVideoScroll( top_of_element, bottom_of_element) {
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
      // this.ytUtils.startVideo();
    } else {
      this.ytUtils.pauseVideoFull();
      $('.full-video-image-bg').css({
        'display': 'block'
      });
     
    }
    
    // if (Utils.isInViewport(videoSection)) {
    //   // this.ytUtils.startVideo();
    //   console.log('start video', videoSection);
    //   console.log('dentro');
    // } else {
    //     this.ytUtils.pauseVideo();
    //     console.log('pause video', videoSection);
    //     console.log('this.ytUtils.player', this.ytUtils.player);
    // }
  }
}

$(() => {
  const component = new FullVideoImage();
});


/***/ }),

/***/ "./src/scripts/widgets/global-presence-card-country4.js":
/*!**************************************************************!*\
  !*** ./src/scripts/widgets/global-presence-card-country4.js ***!
  \**************************************************************/
/*! exports provided: SHOW_MORE_STATUS, GlobalPresenceCardCountry4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOW_MORE_STATUS", function() { return SHOW_MORE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalPresenceCardCountry4", function() { return GlobalPresenceCardCountry4; });
const SHOW_MORE_STATUS = {
  DEFAULT: 'default',
  SHOW_MORE: 'more',
  SHOW_LESS: 'less'
};
class GlobalPresenceCardCountry4 {
  constructor() {
    if ($('.global-presence-card-country-grid-da-4').length > 0) {

      $('.global-presence-card-country-grid-da-4 .btn.view-more').click((event) => this.handleViewMore(event));
      $('.global-presence-card-country-grid-da-4 .btn.view-less').click((event) => this.handleViewLess(event));

      $('.global-presence-card-country-grid-da-4').each((i, el) => {
        this.handleCountryCard(el);
      });
    }
  }

  handleCountryCard(container, showMoreStatus = SHOW_MORE_STATUS.DEFAULT) {
    console.log(container);
    if (window.innerWidth > 1023) {
      this.handleDesktopPagination(container, showMoreStatus);
    } else {
      this.handleMobilePagination(container, showMoreStatus);
    }
  }

  handleDesktopPagination(container, showMoreStatus) {
    const cards = $(container).find('.card-country');
    if (cards && cards.length > 16) {
      switch (showMoreStatus) {
        case SHOW_MORE_STATUS.DEFAULT:
        case SHOW_MORE_STATUS.SHOW_LESS:
          $(cards).filter(':gt(15)').hide();
          $(container).find('.btn.view-more').show();
          $(container).find('.btn.view-less').hide();
          break;

        case SHOW_MORE_STATUS.SHOW_MORE:
          $(cards).show();
          $(container).find('.btn.view-more').hide();
          $(container).find('.btn.view-less').show();
          break;
      }

    } else {
      // remove view-more button
      $(container).find('.btn.view-more').hide();
      $(container).find('.btn.view-less').hide();
    }
  }

  handleMobilePagination(container, showMoreStatus) {
    const cards = $(container).find('.card-country');
    if (cards && cards.length > 3) {
      switch (showMoreStatus) {
        case SHOW_MORE_STATUS.DEFAULT:
        case SHOW_MORE_STATUS.SHOW_LESS:
          $(cards).filter(':gt(2)').hide();
          $(container).find('.btn.view-more').show();
          $(container).find('.btn.view-less').hide();
          break;
        case SHOW_MORE_STATUS.SHOW_MORE:
          $(cards).filter(':hidden:lt(3)').show();
          if ($(cards).length === $(cards).filter(':visible').length) {
            $(container).find('.btn.view-more').hide();
            $(container).find('.btn.view-less').show();
          }
          break;
      }
    } else {
      // remove view-more button
      $(container).find('.btn.view-more').hide();
      $(container).find('.btn.view-less').hide();
    }
  }

  handleViewMore(event) {
    console.log(event);
    const container = $(event.target).parents('.global-presence-card-country-grid-da-4');
    this.handleCountryCard(container, SHOW_MORE_STATUS.SHOW_MORE);
  }

  handleViewLess(event) {
    console.log(event);
    const container = $(event.target).parents('.global-presence-card-country-grid-da-4');
    this.handleCountryCard(container, SHOW_MORE_STATUS.SHOW_LESS);
  }

}

$(() => {
  const component = new GlobalPresenceCardCountry4();
});

/***/ }),

/***/ "./src/scripts/widgets/global-presence-project-highlight.js":
/*!******************************************************************!*\
  !*** ./src/scripts/widgets/global-presence-project-highlight.js ***!
  \******************************************************************/
/*! exports provided: ProjectHighlight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProjectHighlight", function() { return ProjectHighlight; });
class ProjectHighlight {
  constructor() {
    if ($('.global-presence-project-highlight').length > 0) {
      $('.global-presence-project-highlight').each((i, el) => {
        this.handlePaginations(el);
      });

      $('.global-presence-project-highlight div.eni-focus-area > div.slider-paginator > div > button.btn.icon-arrow-left')
        .click((event) => this.handlePrevPage(event));
      $('.global-presence-project-highlight div.eni-focus-area > div.slider-paginator > div > button.btn.icon-arrow-right')
        .click((event) => this.handleNextPage(event));
    }
  }

  handlePaginations(container, goTo = '') {
    const slides = $(container).find('.slide-container');

    if (slides && slides.length > 1) {
      $(slides).hide();
      const actualPage = $(container).find('.page-active');
      const page = +$(actualPage).text();
      const totalPage = $(container).find('.page-total');
      const totPage = +$(totalPage).text();
      const prevBtn = $(container).find('.btn.icon-arrow-left');
      const nextBtn = $(container).find('.btn.icon-arrow-right');
      var pageHideBtn = 0;

      console.log("Current Page: ", page);
      console.log("Total Page Count: ", totPage);

      switch (goTo) {
        case 'next':
          pageHideBtn = page + 1;
          break;

        case 'prev':
          pageHideBtn = page - 1;
          break;
      }

      if (pageHideBtn === totPage) {
        $(nextBtn).css("visibility", "hidden");
      } else {
        $(nextBtn).css("visibility", "visible");
      }

      if (pageHideBtn === 1) {
        $(prevBtn).css("visibility", "hidden");
      } else {
        $(prevBtn).css("visibility", "visible");
      }
      switch (goTo) {
        case 'next':
          $($(slides).get(page - 1)).hide();
          $($(slides).get(page)).show();
          $(actualPage).text(page + 1);
          $(prevBtn).show();
          if ($(window).width() < 1023) {
            $($(slides).get(page)).find(".slider-image")[0].scrollIntoView();
          }
          break;
        case 'prev':
          $($(slides).get(page - 1)).hide();
          $($(slides).get(page - 2)).show();
          $(actualPage).text(page - 1);
          $(nextBtn).show();
          if ($(window).width() < 1023) {
            $($(slides).get(page - 2)).find(".slider-image")[0].scrollIntoView();
          }
          break;
        default:
          $(slides).filter(':lt(1)').show();
          $(actualPage).text('1');
          $(totalPage).text(slides.length);

          $(prevBtn).hide();
      }
    } else {
      $(container).find('.slider-paginator').hide();
    }
  }

  handlePrevPage(event) {
    const container = $(event.target).parents('.global-presence-project-highlight');
    this.handlePaginations(container, 'prev');
  }

  handleNextPage(event) {
    const container = $(event.target).parents('.global-presence-project-highlight');
    this.handlePaginations(container, 'next');
  }
}

$(() => {
  const component = new ProjectHighlight();
});


/***/ }),

/***/ "./src/scripts/widgets/global-presence-sustainability-goal.js":
/*!********************************************************************!*\
  !*** ./src/scripts/widgets/global-presence-sustainability-goal.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(function () {
  if ($(window).width() < 1023) {
    $(".flip-card").click(function () {
      var description = $(this).find(".description");
      var imgContainer = $(this).find(".img-container");

      if (!$(imgContainer).hasClass("remove")) {
        $(imgContainer).addClass("remove");
        $(description).addClass("show");
      } else {
        $(imgContainer).removeClass("remove");
        $(description).removeClass("show");
      }
    });
  }
});


/***/ }),

/***/ "./src/scripts/widgets/grid-card3.js":
/*!*******************************************!*\
  !*** ./src/scripts/widgets/grid-card3.js ***!
  \*******************************************/
/*! exports provided: GridCard3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GridCard3", function() { return GridCard3; });
class GridCard3 {
  constructor() {
    $('.grid-card-3 .grid-card.link-card').click((event)=>this.handleClick(event));
    $('.grid-card-3 .grid-card.link-badge-store').click((event)=>this.handleClick2(event));
  }

  handleClick(event) {
    if ($(event.target).is('a')) {
      return;
    }
    const currentTarget = $(event.currentTarget);
    console.log(currentTarget);
    const href = $(currentTarget).attr('data-url');
    const target = $(currentTarget).attr('data-target');
    window.open(href, target);
  }

  handleClick2(event) {

    const isSafari = navigator.userAgent.indexOf("Safari") !== -1;
    const isIphone = navigator.userAgent.indexOf("iPhone") !== -1;
    const isMobileIosSafari = isSafari && isIphone;

    if (isMobileIosSafari){
      if ($(event.target).is('a')) {
        return;
      }

      document.ontouchmove = (e) => e.preventDefault();

      if ($("body").hasClass("modal-open")) {
        document.ontouchmove = (e) => true;
      }
      else {
        document.ontouchmove = (e) => e.preventDefault();
      }
    }
  }
}

$(() => {
  const component = new GridCard3();
});

/***/ }),

/***/ "./src/scripts/widgets/herobanner-homepage.js":
/*!****************************************************!*\
  !*** ./src/scripts/widgets/herobanner-homepage.js ***!
  \****************************************************/
/*! exports provided: HERO_BANNER_PROPS, HeroBannerHomepage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HERO_BANNER_PROPS", function() { return HERO_BANNER_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeroBannerHomepage", function() { return HeroBannerHomepage; });
/* harmony import */ var _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/yt-utils */ "./src/scripts/common/yt-utils.js");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");



const HERO_BANNER_PROPS = {
  SECTION_CLASS: 'section.herobanner-homepage',
  VIDEO_SECTION_CLASS: 'section.herobanner-homepage.yt-video'
};

class HeroBannerHomepage {

  constructor(initializeForDynamicContent) {

    console.log('HeroBannerHomepage');
    // Manage children selector when dynamic section instantiate class
    if (initializeForDynamicContent) {
      HERO_BANNER_PROPS.SECTION_CLASS = HERO_BANNER_PROPS.SECTION_CLASS + '.eni-target-widget';
      HERO_BANNER_PROPS.VIDEO_SECTION_CLASS = HERO_BANNER_PROPS.VIDEO_SECTION_CLASS + '.eni-target-widget';
    }

    $(HERO_BANNER_PROPS.SECTION_CLASS).click(this.handleClick);
    $(HERO_BANNER_PROPS.SECTION_CLASS).hover((event) => this.handleHover(event, true), (event) => this.handleHover(
      event, false));
    const videoSection = $(HERO_BANNER_PROPS.VIDEO_SECTION_CLASS);
    if (videoSection && videoSection.length > 0) {
      this.handleVideo(videoSection);
      $(window).scroll(() => this.handleVideoScroll(videoSection));
    }

    const heroBanner = $(HERO_BANNER_PROPS.SECTION_CLASS);
    for (let i = 0; i < heroBanner.length; i++) {
      this.initCountDown(heroBanner[i]);
    }
    
  }

  initCountDown(heroBanner){
    // Get Data Attributes
    var mainSelector = '#' + $(heroBanner).attr('id');

    var countdownStart = new Date($(mainSelector).data("countdown-start")).getTime();
    var countdownEnd = new Date($(mainSelector).data("countdown-end")).getTime();
    var isCountdown = $(mainSelector).data("countdown");
    var cta = $(mainSelector).data("cta");
    var disclaimer = $(mainSelector).data("disclaimer");

    // Get Current Date
    var currentDate = new Date().getTime();

    var countdownContainer = mainSelector + ' .content-box .statement-container .countdown-container';
    var liveContainer = mainSelector + ' .content-box .statement-container .live-container';
    var onDemandContainer = mainSelector + ' .content-box .statement-container .on-demand-container';

    //$(countdownContainer).hide();
    $(countdownContainer).css("display", "none");
    $(liveContainer).hide();
    $(onDemandContainer).hide();

    if (isCountdown === true) {

      if (countdownEnd > currentDate && countdownStart <= currentDate && countdownEnd > countdownStart) {

        //$(countdownContainer).show();
        $(countdownContainer).css("display", "inline-block");
        $(liveContainer).hide();
        $(onDemandContainer).hide();
        this.startCountdown(mainSelector, countdownStart, countdownEnd, disclaimer);
      }
      else if(countdownEnd <= currentDate) {
        //setto link section e link title quando il conteggio è finito ma il redattore non ha modificato la fase
        let linkCta = $(liveContainer + ' a.eni-btn').attr('href');
        let linkCtaTarget = $(liveContainer + ' a.eni-btn').attr('target');
        $(mainSelector).attr('data-url',linkCta);
        $(mainSelector).attr('data-target',linkCtaTarget);
        $(mainSelector + ' h2 a').attr('href',linkCta);
        $(mainSelector + ' h2 a').attr('target',linkCtaTarget);
        if(disclaimer){
          $(mainSelector).attr('data-disclaimer-status','on');
          $('#link-disclaimer-egl').attr('href', linkCta);
          $(mainSelector + ' h2 a').attr('href','#');
          $(liveContainer + ' a.eni-btn').attr('href','#');
          $(mainSelector + ' h2 a').on('click', (event) => {
            $('#ModalDocumentDisclaimerEGL').modal('toggle');
            event.preventDefault();
          });
          $(liveContainer + ' a.eni-btn').on('click', (event) => {
            $('#ModalDocumentDisclaimerEGL').modal('toggle');
            event.preventDefault();
          });
        }
        //$(countdownContainer).hide();
        $(countdownContainer).css("display", "none");
        $(liveContainer).show();
        $(onDemandContainer).hide();
      }

    } else if (cta == "live"){
      if(disclaimer){
        $(mainSelector).attr('data-disclaimer-status','on');
        let linkCta = $(liveContainer + ' a.eni-btn').attr('href');
        $('#link-disclaimer-egl').attr('href', linkCta);
        $(mainSelector + ' h2 a').attr('href','#');
        $(liveContainer + ' a.eni-btn').attr('href','#');
        $(mainSelector + ' h2 a').on('click', (event) => {
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
        $(liveContainer + ' a.eni-btn').on('click', (event) => {
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
      }
      $(countdownContainer).css("display", "none");
      $(liveContainer).show();
      $(onDemandContainer).hide();

    } else if(cta == "ondemand") {
      if(disclaimer){
        $(mainSelector).attr('data-disclaimer-status','on');
        let linkCta = $(onDemandContainer + ' a.eni-btn').attr('href');
        $('#link-disclaimer-egl').attr('href', linkCta);
        $(mainSelector + ' h2 a').attr('href','#');
        $(onDemandContainer + ' a.eni-btn').attr('href','#');
        $(mainSelector + ' h2 a').on('click', (event) => {
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
        $(onDemandContainer + ' a.eni-btn').on('click', (event) => {
          $('#ModalDocumentDisclaimerEGL').modal('toggle');
          event.preventDefault();
        });
      }
      $(countdownContainer).css("display", "none");
      $(liveContainer).hide();
      $(onDemandContainer).show();
    }

  }

  startCountdown(mainSelector, start, end, disclaimer) {
    console.log('start countdown');
    const countdownContainer = mainSelector + ' div.content-box div.countdown-container';
    const progressBar = mainSelector +
      ' div.content-box div.countdown-container div.progress-bar-container > div';
    const liveContainer = mainSelector + ' div.content-box div.live-container';

    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = end - now;

      var progressBarWidth = ((now - start) / (end - start)) * 100;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if(seconds < 10) {
        seconds = "0" + seconds;
      }
      if(minutes < 10) {
        minutes = "0" + minutes;
      }
      if(hours < 10) {
        hours = "0" + hours;
      }
      if (days < 10) {
        days = "0" + days;
      }

      // Inject values into DOM
      $(countdownContainer + ' .numbers .days .value').text(days);
      $(countdownContainer + ' .numbers .hours .value').text(hours);
      $(countdownContainer + ' .numbers .minutes .value').text(minutes);
      $(countdownContainer + ' .numbers .seconds .value').text(seconds);

      $(progressBar).css("width", progressBarWidth + "%");

      if (distance <= 500) {
        $(countdownContainer).fadeOut(500);

        if (distance <= 0) {
          clearInterval(x);
          $(liveContainer).fadeIn(500);
          //setto link section e link title quando finisce il conteggio
          let linkCta = $(liveContainer + ' a.eni-btn').attr('href');
          let linkCtaTarget = $(liveContainer + ' a.eni-btn').attr('target');
          $(mainSelector).attr('data-url',linkCta);
          $(mainSelector).attr('data-target',linkCtaTarget);
          $(mainSelector + ' h2 a').attr('href',linkCta);
          $(mainSelector + ' h2 a').attr('target',linkCtaTarget);
          if(disclaimer){
            $(mainSelector).attr('data-disclaimer-status','on');
            $('#link-disclaimer-egl').attr('href', linkCta);
            $(mainSelector + ' h2 a').attr('href','#');
            $(liveContainer + ' a.eni-btn').attr('href','#');
            $(mainSelector + ' h2 a').on('click', (event) => {
              $('#ModalDocumentDisclaimerEGL').modal('toggle');
              event.preventDefault();
            });
            $(liveContainer + ' a.eni-btn').on('click', (event) => {
              $('#ModalDocumentDisclaimerEGL').modal('toggle');
              event.preventDefault();
            });
          }
        }
      }
    }, 250);

  }

  handleClick(event) {
    if($(event.target).hasClass('icon-arrow-right-small') || $(event.target).hasClass('arrow-link')){
      return;
    }
    if($(event.target).hasClass('eni-btn')){
      return;
    }
   
    const section = event.currentTarget;
    const url = $(section).attr('data-url');
    const target = $(section).attr('data-target');
    const disclaimerStatus = $(section).attr('data-disclaimer-status');
    if (url && url.length > 0) {
      if(disclaimerStatus == 'on'){
        $('#link-disclaimer-egl').attr('href', url);
        $("#ModalDocumentDisclaimerEGL").modal("toggle");
      }
      else
        window.open(url, target);
      
    }
    event.preventDefault();
  }

  handleHover(event, inOut) {
    const section = event.currentTarget;
    const yellowLine = $(section).find('i.dash');
    if (inOut) {
      yellowLine.addClass('active');
    } else {
      yellowLine.removeClass('active');
    }
  }

  handleVideo(videoSection) {
    const ytEmbedded = $(videoSection).find('.yt-embedded');
    if (ytEmbedded) {
      const playerId = $(ytEmbedded).attr('id');
      const ytId = $(ytEmbedded).attr('data-yt-id');
      this.ytUtils = _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__["YtUtils"].createInstance(playerId, [ytId], {
        autoplay: 0,
        autohide: 1,
        modestbranding: 0,
        rel: 0,
        showinfo: 0,
        controls: 0,
        disablekb: 1,
        enablejsapi: 0,
        iv_load_policy: 3,
        loop: 1
      });
      setTimeout(() => this.startVideo(this.ytUtils, videoSection), 4000);
    }
  }

  startVideo(yt, container) {
    if ($("html[class*='aem-AuthorLayer-']").length > 0) {
      console.log('no start video');
    } else {
      $(container).find('img').hide();
      $(container).find('.eni-focus-area').hide();
      yt.startVideo(container);
    }
  }

  handleVideoScroll(videoSection) {
    if (_common_utils__WEBPACK_IMPORTED_MODULE_1__["default"].isInViewport(videoSection)) {
      this.ytUtils.startVideo();
    } else {
      console.log('is not in viewport', this.ytUtils);
      this.ytUtils.pauseVideo();
    }
  }
}

$(() => {
  const component = new HeroBannerHomepage(false);
});


/***/ }),

/***/ "./src/scripts/widgets/herobanner-video.js":
/*!*************************************************!*\
  !*** ./src/scripts/widgets/herobanner-video.js ***!
  \*************************************************/
/*! exports provided: HerobannerVideoSwitch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HerobannerVideoSwitch", function() { return HerobannerVideoSwitch; });
/* harmony import */ var _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/yt-utils */ "./src/scripts/common/yt-utils.js");
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");
/* harmony import */ var _common_digital_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/digital-data */ "./src/scripts/common/digital-data.js");




// import Utils from '../common/utils';

class HerobannerVideoSwitch {

    constructor() {
        this.timing = 12000;
        this.desktop = null;
        this.stack = [];

        this.items = $(".herobanner-video-widget .card--list > div");
        
        let _this = this;
        $(this.items).on("click", function(e) {
            let i = $(this).index();
            _this.start( i );
        });

        $(".herobanner-video-widget a.content-title").on("click", function(e) {
            return false;
        });

        $( window ).resize(function() {
            
            _this.checkSize();

        });
        _this.checkSize();
    }

    checkSize( ){
        let _this = this;
        const carousels = $(".herobanner-video-widget .content-box .video-focus-area .card--list");

        
        console.log( 'HerobannerVideoSwitch window', $( window ).width());
        if($('.wcm-enicom__base').length<1){
            if ( carousels && $( window ).width() < 1024 ){
                console.log( 'HerobannerVideoSwitch window', _this.desktop);
                if ( _this.desktop !== false ){
                    console.log( 'HerobannerVideoSwitch window DO DCAROUSEL');

                    _this.desktop = false;
                    clearTimeout( this.timer );

                    for (let i = 0; i < carousels.length; i++) {
                        if (carousels && $(carousels)) {
                            
                            console.log( 'HerobannerVideoSwitch window DO DCAROUSEL on', $(carousels));

                            _this.initCarousel( $(carousels[i]) );

                        }
                    }
                } 
            } else {
                if ( _this.desktop != true ){
                    console.log( 'HerobannerVideoSwitch window REMOVE DCAROUSEL', this.stack);
                    _this.desktop = true;
                    
                    for (let i = 0; i < this.stack.length; i++) {
                        $(this.stack[i]).owlCarousel('destroy');
                    }
                    this.start(0);
                }
            }
        }
    }

    initCarousel( elem ){
        let c = Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_1__["owlCarouselUtls"])( $(elem) , {
            loop: false,
            nav: false,
            mouseDrag: false,
            center: false,
            autoWidth: false,
            margin: 0,
            rewind: false,
            items: 1,
            autoplay: true,
            autoplayTimeout: 12000,
        }, true);

        this.stack.push( c );
    }

    start(i){
        clearInterval( this.timer );

        if ( i >= $(this.items).length ){
            i = 0;
        }

        this.draw( this.items.eq(i) );

        this.timer = setTimeout(() => {
            this.start(i+1);
        }, this.timing);
    }

    draw( _this ){
        $(this.items).removeClass('active');
        $(_this).addClass('active');
        
        $(_this).parent().prev().html( $(_this).html() ).append($('<span class="loadingProgress">'));

        let category = $(_this).find('> div').attr('class');
        let img = $(_this).find('picture img').attr('src');
        let picture = $(_this).closest('.content-box').prev();
        $(picture).find('source').attr('srcset', img);
        $(picture).find('img').attr('src', img);
        $(_this).closest('.content-box').addClass(category);

        $(_this).closest('.content-box').find(".card--main a.content-title").on("click", function(e) {
            return false;
        });

        $(_this).closest('.content-box').find(".card--main a.eni-btn,.card--main a.arrow-link").on("click", function(e) {
            const ddutils = new _common_digital_data__WEBPACK_IMPORTED_MODULE_2__["DigitalDataUtils"]()
            ddutils.handleClickItem(e);
        });
        
    }

}

$(() => {
    const component = new HerobannerVideoSwitch();
});

/***/ }),

/***/ "./src/scripts/widgets/highlight_editorial_content.js":
/*!************************************************************!*\
  !*** ./src/scripts/widgets/highlight_editorial_content.js ***!
  \************************************************************/
/*! exports provided: HIGHLIGHT_EDITORIAL_CONTENT_PROPS, HighlightEditorialContent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIGHLIGHT_EDITORIAL_CONTENT_PROPS", function() { return HIGHLIGHT_EDITORIAL_CONTENT_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HighlightEditorialContent", function() { return HighlightEditorialContent; });
const HIGHLIGHT_EDITORIAL_CONTENT_PROPS = {
  SECTION_CLASS: '.highlight-editorial-content',
  TWO_CONTENT_COL: '.highlight-editorial-content.two-content .highlight-2col'
};

class HighlightEditorialContent {
  constructor(initializeForDynamicContent) {

    // Manage children selector when dynamic section instantiate class
    if (initializeForDynamicContent) {
      HIGHLIGHT_EDITORIAL_CONTENT_PROPS.SECTION_CLASS = HIGHLIGHT_EDITORIAL_CONTENT_PROPS.SECTION_CLASS +
        '.eni-target-widget';
      HIGHLIGHT_EDITORIAL_CONTENT_PROPS.TWO_CONTENT_COL =
        '.highlight-editorial-content.two-content.eni-target-widget .highlight-2col';
    }

    var isMobile = $(window).outerWidth() < 1024;
    if (!isMobile) {
      $(HIGHLIGHT_EDITORIAL_CONTENT_PROPS.SECTION_CLASS).hover(
        (event) => {
          if (!$(event.target).hasClass('two-content')) {
            this.handleTitleHover(event.target, true);
          }
        },
        (event) => {
          if (!$(event.target).hasClass('two-content')) {
            this.handleTitleHover(event.target, false);
          }
        }
      );
    }

    $(HIGHLIGHT_EDITORIAL_CONTENT_PROPS.SECTION_CLASS).click(
      (event) => {
        if ($(event.target).hasClass('two-content') || $(event.currentTarget).hasClass('two-content')) {
          return;
        } else {
          this.handleClick(event);
        }
      });

    $(HIGHLIGHT_EDITORIAL_CONTENT_PROPS.TWO_CONTENT_COL).hover(

      (event) => {
        this.handleTitleHover(event.target, true);
      },
      (event) => {
        this.handleTitleHover(event.target, false);
      }
    );

    $(HIGHLIGHT_EDITORIAL_CONTENT_PROPS.TWO_CONTENT_COL).click(
      (event) => {
        this.handleClick(event);
      });
  }

  handleTitleHover(el, inOut) {
    const yellowLine = $(el).find('i.dash');

    if (inOut) {
      yellowLine.addClass('yellow-pipe');
      yellowLine.removeClass('yellow-line');
    } else {
      yellowLine.addClass('yellow-line');
      yellowLine.removeClass('yellow-pipe');
    }
  }

  handleClick(event) {
    if ($(event.target).hasClass('icon-share-small') || $(event.target).hasClass('btn-share')) {
      return;
    }

    event.preventDefault();
    let href, target;
    if ($(event.target).hasClass('external-link') || $(event.target.parentElement).hasClass('external-link')) {
      const a = $(event.target).parent('a');
      href = a.attr('href');
      target = a.attr('target');
    } else {
      href = $(event.currentTarget).attr('data-href');
      target = $(event.currentTarget).attr('data-target');
    }
    window.open(href, target);
  }
}

$(() => {
  const component = new HighlightEditorialContent(false);
});


/***/ }),

/***/ "./src/scripts/widgets/identity-card.js":
/*!**********************************************!*\
  !*** ./src/scripts/widgets/identity-card.js ***!
  \**********************************************/
/*! exports provided: SHOW_MORE_STATUS, IdentityCard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOW_MORE_STATUS", function() { return SHOW_MORE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IdentityCard", function() { return IdentityCard; });
const SHOW_MORE_STATUS = {
    DEFAULT: 'default',
    SHOW_MORE: 'more',
    SHOW_LESS: 'less'
  };
  class IdentityCard {
    constructor() {
      if ($('.identity-card').length > 0) {
  
        $('.identity-card .btn.view-more').click((event) => this.handleViewMore(event));
        $('.identity-card .btn.view-less').click((event) => this.handleViewLess(event));
  
        $('.identity-card').each((i, el) => {
          this.handleCountryCard(el);
        });
      }
    }
  
    handleCountryCard(container, showMoreStatus = SHOW_MORE_STATUS.DEFAULT) {
      console.log(container);
      if (window.innerWidth > 1023) {
        this.handleDesktopPagination(container, showMoreStatus);
      } else {
        this.handleMobilePagination(container, showMoreStatus);
      }
    }
  
    handleDesktopPagination(container, showMoreStatus) {
      const cards = $(container).find('.grid-card');
      if (cards && cards.length > 3) {
        switch (showMoreStatus) {
          case SHOW_MORE_STATUS.DEFAULT:
          case SHOW_MORE_STATUS.SHOW_LESS:
            $(cards).filter(':gt(2)').hide();
            $(container).find('.btn.view-more').show();
            $(container).find('.btn.view-less').hide();
            break;
  
          case SHOW_MORE_STATUS.SHOW_MORE:
            $(cards).show();
            $(container).find('.btn.view-more').hide();
            $(container).find('.btn.view-less').show();
            break;
        }
  
      } else {
        // remove view-more button
        $(container).find('.btn.view-more').hide();
        $(container).find('.btn.view-less').hide();
      }
    }
  
    handleMobilePagination(container, showMoreStatus) {
      const cards = $(container).find('.grid-card');
      if (cards && cards.length > 3) {
        switch (showMoreStatus) {
          case SHOW_MORE_STATUS.DEFAULT:
          case SHOW_MORE_STATUS.SHOW_LESS:
            $(cards).filter(':gt(2)').hide();
            $(container).find('.btn.view-more').show();
            $(container).find('.btn.view-less').hide();
            break;
          case SHOW_MORE_STATUS.SHOW_MORE:
            $(cards).filter(':hidden:lt(3)').show();
            if ($(cards).length === $(cards).filter(':visible').length) {
              $(container).find('.btn.view-more').hide();
              $(container).find('.btn.view-less').show();
            }
            break;
        }
      } else {
        // remove view-more button
        $(container).find('.btn.view-more').hide();
        $(container).find('.btn.view-less').hide();
      }
    }
  
    handleViewMore(event) {
      console.log(event);
      const container = $(event.target).parents('.identity-card');
      this.handleCountryCard(container, SHOW_MORE_STATUS.SHOW_MORE);
    }
  
    handleViewLess(event) {
      console.log(event);
      const container = $(event.target).parents('.identity-card');
      this.handleCountryCard(container, SHOW_MORE_STATUS.SHOW_LESS);
    }
  
  }
  
  $(() => {
    const component = new IdentityCard();
  });

/***/ }),

/***/ "./src/scripts/widgets/iframe-resizer.js":
/*!***********************************************!*\
  !*** ./src/scripts/widgets/iframe-resizer.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IframeResizer; });
class IframeResizer {
  constructor() {
    $(document).ready(() => {
      this.handleIframeResize();
    });

  }
  handleIframeResize() {
    // Euroland Iframe
    const iframeEurolandToBeResized = $("iframe[class*='iframe-resize']");

    // Internal Iframe
    const iframeToBeResized = $("iframe[class*='iframe-origin-resize']");

    if (iframeEurolandToBeResized && iframeEurolandToBeResized.length > 0) {
      for (let i = 0; i < iframeEurolandToBeResized.length; i++) {
        const idEurolandIframeToResize = $(iframeEurolandToBeResized[i]).attr('id');
        if (typeof EurolandToolIntegrationObject !== 'undefined') {
          EurolandToolIntegrationObject.set(idEurolandIframeToResize);
        }
      }
      if (iframeToBeResized && iframeToBeResized.length > 0) {
        for (let i = 0; i < iframeToBeResized.length; i++) {
          const idIframeToResize = $(iframeToBeResized[i]).attr('id');
          iFrameResize({
            log: false,
          }, '#' + idIframeToResize);
        }
      }
    }
  }

}

$(() => {
  const component = new IframeResizer();
});


/***/ }),

/***/ "./src/scripts/widgets/infographics.js":
/*!*********************************************!*\
  !*** ./src/scripts/widgets/infographics.js ***!
  \*********************************************/
/*! exports provided: Infographics */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Infographics", function() { return Infographics; });
class Infographics {
  constructor() {
    if ($('.infographics').length > 0) {
      $('.infographics').each((i, el) => {
        this.handlePaginations(el);
      });

      $('.infographics .btn.icon-arrow-left').click((event) => this.handlePrevPage(event));
      $('.infographics .btn.icon-arrow-right').click((event) => this.handleNextPage(event));
    }
  }

  handlePaginations(container, goTo = '') {
    const slides = $(container).find('.slide-container');
    const prevBtn = $(container).find('.btn.icon-arrow-left');
    const nextBtn = $(container).find('.btn.icon-arrow-right');
    if (slides && slides.length > 1) {
      const actualPage = $(container).find('.page-active');
      const page = +$(actualPage).text();
      const totalPage = $(container).find('.page-total');
      const totPage = +$(totalPage).text();
      var pageHideBtn = 0;

      console.log("Current Page: ", page);
      console.log("Total Page Count: ", totPage);

      switch (goTo) {
        case 'next':
          pageHideBtn = page + 1;
          break;

        case 'prev':
          pageHideBtn = page - 1;
          break;
      }

      if (pageHideBtn === totPage) {
        $(nextBtn).css("visibility", "hidden");
      } else {
        $(nextBtn).css("visibility", "visible");
      }

      if (pageHideBtn === 1) {
        $(prevBtn).css("visibility", "hidden");
      } else {
        $(prevBtn).css("visibility", "visible");
      }
      switch (goTo) {
        case 'next':
          $($(slides).get(page - 1)).hide('fast', 'linear');
          $($(slides).get(page)).show('fast', 'linear');
          $(actualPage).text(page + 1);
          $(prevBtn).show();
          break;
        case 'prev':
          $($(slides).get(page - 1)).hide('fast', 'linear');
          $($(slides).get(page - 2)).show('fast', 'linear');
          $(actualPage).text(page - 1);
          $(nextBtn).show();
          break;
        default:
          $(slides).filter(':lt(1)').css('display', 'flex');
          $(actualPage).text('1');
          $(totalPage).text(slides.length);

          $(prevBtn).hide();
      }
    } else if (slides.length == 1) {
      // const totalPage = $(container).find('.page-total');
      const paginator = $(container).find('.infographic-paginator');
      $(slides).filter(':lt(1)').show();
      // $(totalPage).hide();
      $(paginator).hide();
      // $(prevBtn).hide();
      // $(nextBtn).hide();
    } else {
      $(container).find('.infographic-paginator').hide();
    }
  }

  handlePrevPage(event) {
    console.log(event);
    const container = $(event.target).parents('.infographics');
    this.handlePaginations(container, 'prev');
  }

  handleNextPage(event) {
    console.log(event);
    const container = $(event.target).parents('.infographics');
    this.handlePaginations(container, 'next');
  }
}

$(() => {
  const component = new Infographics();
});


/***/ }),

/***/ "./src/scripts/widgets/interactive-map-detail.js":
/*!*******************************************************!*\
  !*** ./src/scripts/widgets/interactive-map-detail.js ***!
  \*******************************************************/
/*! exports provided: InteractiveMapDetail */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractiveMapDetail", function() { return InteractiveMapDetail; });
/* harmony import */ var _common_tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/tooltip */ "./src/scripts/common/tooltip.js");

  
  const MAX_ZOOM_DETAIL = 17;
  const DEFAULT_ZOOM_DETAIL = 13;
  const MIN_ZOOM_DETAIL = 7;
  var ispointer = false;
  //var currentCursor = null;
  //var clusterActive = null;
  
  /* A - Metodo restore zoom iniziale + zoom in e out su click pin */
  var INIT_ZOOM_DETAIL = 0;
  
  /* B - Metodo default zoom in e out su click pin */
  //var countIn = 0;
  //var countOut = 0;
  
  class InteractiveMapDetail {
  
    constructor() {
        const sections = $('section.interactive-map-detail');
        //this.zoomDefault = MAX_ZOOM_DETAIL;
  
        sections.each((index) => {
            const section = sections[index];
            const mapDiv = $(section).find('.eni-map');
            const tooltip = new _common_tooltip__WEBPACK_IMPORTED_MODULE_0__["Tooltip"]();
            if (mapDiv.length > 0) {
                this.initMapDetail(section, mapDiv, index, tooltip);
  
                /* B */
                //$(section).find('.map-buttons-container .zoom-in-btn').click((event => countIn = countIn + 1));
                //$(section).find('.map-buttons-container .zoom-out-btn').click((event => countOut = countOut + 1));
  
                this.closeBtn(section, index);
                $(section).find('.map-buttons-container .location-btn').click((event => this.handleLocation(
                    event, index)));
                $(section).find('.map-buttons-container .zoom-in-btn').click((event => this.handleZoom(event,
                    true, index)));
                $(section).find('.map-buttons-container .zoom-out-btn').click((event => this.handleZoom(event,
                    false, index)));
                
            }
        });
    }
    
    closeBtn(section, index){
        $(section).find('button.drawer-btn').on( 'click', event => this.handleCloseBtn(section, event, index));
    }
  
    initMapDetail(section, mapDiv, index, tooltip) {
        //console.log('InteractiveMapDetail initMapDetail', section, mapDiv, index, tooltip);
  
        try {
            let titlemap = [];
            let titleColor = null;
            let countTitle = null;

            const id = $(mapDiv).attr('id');
  
            this.markerNormal = {
                url: $(section).attr('data-map-icon-marker-normal'),
                scaledSize: new google.maps.Size(15, 15),
                labelOrigin: new google.maps.Point(7.5, -20),
                anchor: new google.maps.Point(7.5, 7.5)
            };
            this.markerSelected = {
                url: $(section).attr('data-map-icon-marker-selected'),
                scaledSize: new google.maps.Size(30, 30),
                labelOrigin: new google.maps.Point(16, -20),
                anchor: new google.maps.Point(15, 15)
            };
            this.maps = this.maps || [];
            this.selectedMarkers = this.selectedMarkers || [];
            this.lastZooms = this.lastZooms || [];
            this.gMarkers = this.gMarkers || [];
  
            let options = {}
  
            // zoom della mappa al click sul pin
            this.zoomDefault = DEFAULT_ZOOM_DETAIL;
            
            options = {
                mapTypeId: 'satellite',
                maxZoom: MAX_ZOOM_DETAIL,
                minZoom: MIN_ZOOM_DETAIL,
                disableDefaultUI: true
            }
  
            this.maps[index] = new google.maps.Map(
                document.getElementById(id), options
            );
  
            this.selectedMarkers[index] = null;

            let markers = $(section).attr('data-map-markers') ? JSON.parse($(section).attr('data-map-markers')) : null;
            //console.log('InteractiveMapDetail initMapDetail markers', markers);
            markers = this.handleGeoJson(section, this.maps[index], index, tooltip, titlemap , titleColor, countTitle);
            return titlemap , titleColor, countTitle;
  
        }
         catch (ex) {
            console.error(ex);
        }
  
    }
  
    handleMarkers(markers, section, map, index, detailsMap) {
  
        detailsMap = (detailsMap === undefined) ? false : detailsMap;
  
        this.gMarkers[index] = [];
        const nation = $(section).attr('data-map-nation-selected') ? $(section).attr('data-map-nation-selected').replace(/"/gi, '') : null;
  
        let categoryMap = '';

        markers.forEach(m => {
  
            //- default color and pin keep them for compatibility ---
                let color = '#ffd300';
                let pin = Object.assign({}, this.markerNormal);
                let pin_selected = Object.assign({}, this.markerSelected);
  
                pin.url = $(section).attr('data-map-icon-marker-'+m.category);
                pin_selected.url = pin.url.replace('.svg', "-hover.svg");
                
                //- get color and pin from category map ---
                  switch (m.category) {
                      case 'suolo':
                          color = '#F8A800';
                          categoryMap = m.category;
                          break;
                      case 'falda':
                          color = '#17CADD';
                          categoryMap = m.category;
                      break;
                      case 'aree':
                          color = '#9FDA58';
                          categoryMap = m.category;
                      break;
                  }
                
                //$('[data-map-nation="'+m.title+'"] h3').css({"color": color});
  
            //console.log('InteractiveMapDetail handleMarkers info', color, pin, pin_selected);
  
              let label = '';
              label = {
                    text: m.title,
                    color: color,
                    fontSize: '16px',
                    fontFamily: 'Open Sans',
                    className: 'label'
              }
  
            const gMarker = new google.maps.Marker({
                position: new google.maps.LatLng( m.lat, m.lng ),
                label: label,
                icon: pin,
                pin: pin,
                pin_selected: pin_selected,
                zIndex: 100,
                optimized: false
            });
            gMarker.setMap(map);
            this.gMarkers[index].push(gMarker);
  
            google.maps.event.addListener(gMarker, 'mouseover', () => {
                gMarker.setIcon( pin_selected );
                gMarker.label.className = 'label active';
            });
            
            google.maps.event.addListener(gMarker, 'mouseout', () => {
                if (this.selectedMarkers[index] !== gMarker) {
                    gMarker.label.className = 'label';
                    gMarker.setIcon( pin );
                }
            });
            
            google.maps.event.addListener(gMarker, 'click', () => {
                this.selectNation(section, map, m, gMarker, index);
            });
  
            //- activate current nation ---
            if (nation && nation == m.title) {
                this.selectNation(section, map, m, gMarker, index);
            }
        });
  
        
        //let categoryMap = $(section).attr('data-map-marker-category');
        let categoryMarker = '';
        //console.log("CATEGORIA: " + categoryMarker);

        switch (categoryMap) {
        

        case 'default' :
        case '"default"':
          categoryMarker = $(section).attr('data-map-icon-marker-normal');
            break;

        case 'aree':
        case '"aree"':
          categoryMarker = $(section).attr('data-map-marker-aree');
            break;

        case 'falda':
        case '"falda"':
          categoryMarker = $(section).attr('data-map-marker-falda');
            break;

        case 'suolo':
        case '"suolo"':
          categoryMarker = $(section).attr('data-map-marker-suolo');
            break;
        }

        //console.log($(section).attr('data-map-icon-marker-normal'));
        //console.log("BACK: " + categoryMarker);

      //- group nearest marker ---
        this.markerCluster = new MarkerClusterer(map, this.gMarkers[index], {
        styles: [{
                url: categoryMarker,
                height: 40,
                width: 40,
                textColor: '#000',
                textSize: 16,
                fontFamily: 'EniTabReg'
                }]
        });
        
        $(section).on('mouseover', 'div', function(e) {
        if ( $(this).attr('class') == 'cluster-hover') {
        switch ( categoryMap ) {
            
            case 'default' :
            case '"default"':
                $(this).attr('class', 'cluster-hover');
                break;

            case 'aree':
            case '"aree"':
                $(this).attr('class', 'cluster-hover-aree');
                break;

            case 'falda':
            case '"falda"':
                $(this).attr('class', 'cluster-hover-falda');
                break;
            
            case 'suolo':
            case '"suolo"':
              $(this).attr('class', 'cluster-hover-suolo');
                break;
                }
            }
        });

    }
  
    //- Deselect current pointer and active the clicked one ---
    selectNation(section, map, nation, gMarker, index) {
  
        //console.log('InteractiveMapDetail selectNation', this.selectedMarkers, this.selectedMarkers[index]);
  
        /* A */
        if (INIT_ZOOM_DETAIL===0) {
          INIT_ZOOM_DETAIL = map.getZoom();
        }
  
        if (this.selectedMarkers && this.selectedMarkers[index]) {
            //- deselect old active pointer ---
  
            const actualMarker = this.selectedMarkers[index];
            actualMarker.setIcon( actualMarker.pin );
            actualMarker.label.className = 'label';
            //const detailActualDiv = $(section).find(`div.marker-container[data-map-nation="${actualMarker.label.text}"]`);
            const detailActualDiv = $(section).find(`div.marker-container`);
            if (detailActualDiv) {
                $(detailActualDiv).addClass('hide');
            }
            this.selectedMarkers[index] = null;
        }
  
        if (!this.selectedMarkers || !this.selectedMarkers[index]) {
            //- activate current pointer ---
  
            gMarker.setIcon( gMarker.pin_selected );
            gMarker.label.className = 'label active';
            this.selectedMarkers[index] = gMarker;
            this.lastZooms[index] = map.getZoom();
            //map.setZoom(this.zoomDefault);
            //map.setZoom(this.lastZooms[index]);
  
            /* B */
            //map.setZoom( this.maps[index].getZoom() - countIn + countOut + 1);
  
            /* A */
            //map.setZoom(INIT_ZOOM_DETAIL+1);

            map.setZoom( DEFAULT_ZOOM_DETAIL + 2 );
            
            map.setCenter( gMarker.getPosition() );
            const detailDiv = $(section).find(`div.marker-container[data-map-nation="${nation.title}"]`);
            if (detailDiv) {
                $(detailDiv).toggleClass('hide');
            }
            const buttonCont = $(section).find(`div.map-buttons-container`);
            if (buttonCont) {
                $(buttonCont).addClass('open');
            }
        }
  
    }
  
    handleGeoJson(section, map, index, tooltip, titlemap , titleColor, countTitle) {
        //console.log('InteractiveMapDetail handleGeoJson', index, section);
        //console.log('TITLE: ' + titlemap);
  
        const geoJsonUrl = $(section).attr('data-map-geojson-url');
        if (geoJsonUrl) {
            $.getJSON(geoJsonUrl.replace(/"/gi, ''), (geoJson) => {
  
                //console.log('InteractiveMapDetail handleGeoJson', geoJson);
  
                map.data.addGeoJson(geoJson, {
                    idPropertyName: 'id'
                });
                // Add some style.
                map.data.setStyle((f) => {
                    return /** @type {google.maps.Data.StyleOptions} */ ({
                        fillColor: f.getProperty('fill'),
                        fillOpacity: f.getProperty('fill-opacity'),
                        strokeColor: f.getProperty('stroke'),
                        strokeOpacity: f.getProperty('stroke-opacity'),
                        strokeWeight: f.getProperty('stroke-width'),
                        icon: f.getProperty('icon')
                    });
                });
                
                // calcolo del limite dell'area del poligono
                const bounds = new google.maps.LatLngBounds();
                map.data.forEach(function(feature) {
                    feature.getGeometry().forEachLatLng(function(latlng) {
                        bounds.extend(latlng);
                    });
                });
  
                map.fitBounds(bounds);

                map.data.addListener('click', (event) => {

                    //console.log("ISPOINTER FUORI: " + window.ispointer);

                    if(!window.ispointer){
                    this.selectArea(markers, section, event, index, titlemap , titleColor, countTitle);
                    //console.log("ISPOINTER true: " + window.ispointer);
                    }
                    else{
                        window.ispointer = false;
                        //console.log("ISPOINTER false: " + window.ispointer);
                    }
                });

                let markers = [];
                for (let i = 0; i < geoJson.features.length; i++) {
                    const item = geoJson.features[i];
  
                    //- calculate category ---
                    //- is the last work inthe file path name, after last underscore and before extension dot ---
                        let myRegexp = /.+(\_(.+)\.)/g;
                        let regexResult = myRegexp.exec( geoJsonUrl );
                        let category = regexResult ? regexResult.pop() : null;
  
                    //- calculate progress ---
                    //- progress is like [100] appended at the end of the description field ---
                        let description = item.properties.description;
                        let stroke = item.properties.stroke;

                        if ( stroke == '#E63A36'){
                        titleColor = '#E63A36';
                        titlemap[i] = item.properties.name;
                        countTitle = i;
                        //console.log("Test: " + stroke + " " + titlemap[i] + i);
                        }

                        if ( stroke == '#999999' ){
                        titleColor = '#999999';
                        titlemap[i] = item.properties.name;
                        countTitle = i;
                        //console.log("Test: " + stroke + " " + titlemap[i] + i);
                        }

                        let percent = null; 
                        myRegexp = /.+(\[(.+)\])/g; 
                        regexResult = myRegexp.exec( description );
                        if ( regexResult ){
                            percent = regexResult ? +regexResult.pop() : null;
                            description = description.replace( regexResult.pop(), "" );
                        }
  
                    if ( item.geometry.type == 'Point' ){
                        markers.push( {
                            "lat": item.geometry.coordinates[1],
                            "lng": item.geometry.coordinates[0],
                            "title": item.properties.name,
                            "stroke": item.properties.stroke,
                            "description": description,
                            "category": category,
                            "percent": percent
                        } );
                    }
                }
  
                if ( markers.length ){
                    this.createSidePanel( markers, section );
                    this.closeBtn(section, index);
                    this.handleMarkers(markers, section, map, index, true);
                }

                /*
                if(window.matchMedia("(pointer: coarse)").matches) {
                    // touchscreen
                    currentCursor = true;
                }

                $(section).on('mouseover', 'div', function(e) {
                    if ( $(this).attr('class') == 'cluster-hover' ) {
                        var elements = document.getElementsByClassName('mapTooltip');
                        for (var i in elements) {
                        if (elements.hasOwnProperty(i)) {
                        elements[i].style.zIndex = 0;
                            }
                        }

                        clusterActive = true;
                       console.log(clusterActive);
                      }
                      else
                      clusterActive = false;
                      
                });
        
                $(section).on('mouseout', 'div', function(e) {
                    clusterActive = false;
                       var elements = document.getElementsByClassName('mapTooltip');
                        for (var i in elements) {
                        if (elements.hasOwnProperty(i)) {
                        elements[i].style.zIndex = 100;
                            }
                        }
                });

                map.data.addListener('mouseover', (event) => {
                    if (currentCursor != true){
                    this.showTooltip(markers, tooltip, event);
                    console.log("VALORE: " + clusterActive);}
                  });
          
                map.data.addListener('mouseout', (event) => {
                    if (currentCursor != true)
                    this.hideTooltip(tooltip);
                    console.log("VALORE FALSE: " + clusterActive);
                  });*/

            });
        }
    }
  
    //- Dinamically create detail panel ---
    createSidePanel( markers, section ) {
        //console.log('InteractiveMapDetail createSidePanel markers', markers);
        //console.log('InteractiveMapDetail createSidePanel section', $(section).find('.eni-map'));
  
        markers.forEach(m => {
            let color = '#FFDD00';
            switch (m.category) {
                case 'suolo':
                    color = '#F8A800';
                    break;
                case 'falda':
                    color = '#17CADD';
                    break;
                case 'aree':
                    color = '#9FDA58';
                    break;
            }

            let btnclose = section.getElementsByClassName('drawer-btn')[0].innerHTML;
            
            let container = $('<div class="marker-container hide" data-map-nation="'+m.title+'"><button class="btn drawer-btn">'+btnclose+'</button></div>');
            let content = $('<div class="marker-content"></div>');
            let h3 = $('<h3 style="color: '+color+'" class="marker-title">'+m.title+'</h3>');
            let p = $('<p>'+m.description+'</p>');
            
            $(content).append( $(h3), $(p) );
            if ( m.percent ){
                let bar = $('<div class="map-progress-bar"><span style="width:'+m.percent+'%; background:'+color+';"></span></div>');
                $(content).append( $(bar) );
            }
            $(container).append( $(content) );
  
            //console.log('InteractiveMapDetail createSidePanel container', $(container));
            $(section).append(container);
            //}
        });
    }
  
    selectArea(markers, section, event, index, titlemap , titleColor, countTitle) {

        $(section).find('div.marker-container').addClass('hide');

        if (this.gMarkers[index]) {
            /*this.gMarkers[index].forEach(marker => {
                marker.setIcon(  this.selectedMarkers[index].pin );
               });*/
            if (this.selectedMarkers[index]) {
                this.selectedMarkers[index].label.className = 'label';
                this.selectedMarkers[index].setIcon( this.selectedMarkers[index].pin );
            }
            this.selectedMarkers[index] = null;
          }

        let color = '#FFDD00';
            switch (markers[0].category) {
                case 'suolo':
                    color = '#F8A800';
                    break;
                case 'falda':
                    color = '#17CADD';
                    break;
                case 'aree':
                    color = '#9FDA58';
                    break;
            }
        
        this.lastZooms[index] = this.maps[index].getZoom();
        const boundsFeature = new google.maps.LatLngBounds();
        event.feature.getGeometry().forEachLatLng((latlng) => {
            boundsFeature.extend(latlng);
        });
  
        this.maps[index].fitBounds(boundsFeature);
  
        //let title = event.feature.i.name; j
        //let description = event.feature.i.description; j
        let title = event.feature.getProperty('name');
        //console.log('TEST TITLE: ' + title);

        let description = event.feature.getProperty('description');
        //console.log('TEST DESCRIPTION: ' + description);

        //alert(description);

        //const geoJsonUrl = $(section).attr('data-map-geojson-url');
        let myRegexp = /.+(\_(.+)\.)/g;
        let regexResult = null;
        let percent = null;
        let progressbar = null; 

        myRegexp = /.+(\[(.+)\])/g; 
        regexResult = myRegexp.exec( description );
        if ( regexResult ){
            percent = regexResult ? +regexResult.pop() : null;
            description = description.replace( regexResult.pop(), "" );
            progressbar = $('<div class="map-progress-bar"><span style="width:'+percent+'%; background:'+color+';"></span></div>');
        }
        //alert(percent);

        const detailDiv = $(section).find(`div.marker-container#geojson-container`);
        if (detailDiv) {
            $(detailDiv).removeClass('hide');
        }
        const buttonCont = $(section).find(`div.map-buttons-container`);
        if (buttonCont) {
            $(buttonCont).addClass('open');
        }
            /*if ( m.title == m.titlemap ){
                console.log("Test: " + m.title + " " + titlemap[0]+ " " + color);
                color = '#E63A36';*/

        const titleContainer = $(detailDiv).find(`.marker-title`);
        const abstractContainer = $(detailDiv).find(`.marker-abstract`);
        const areaContainer = $(detailDiv).find(`.marker-content`);

        $(titleContainer).html(title && title.length > 0 ? title : 'N.A.');

        for ( var i=0; i<=countTitle; i++){
        if ( title == titlemap[i] && titleColor == '#E63A36'){
        color = '#E63A36';
            }
        else if ( title == titlemap[i] && titleColor == '#999999'){
        color = '#999999';
            }
        }

        $(titleContainer).attr('style', 'color:' + color);
        $(abstractContainer).html(description && description.length > 0 ? description : 'N.A.');
        $(areaContainer).children("div").remove();
        $(areaContainer).append(percent && percent > 0 ? progressbar : '');

        this.maps[index].setZoom( DEFAULT_ZOOM_DETAIL + 2 );
    }

    /*showTooltip(markers, tooltip, event) {
        const title = event.feature.j.name;
        let wa = null;
        for (var propt in event) {
          if (event[propt] != undefined && (event[propt].constructor.name == 'MouseEvent') ||
            (event[propt].constructor.toString() == '[object MouseEvent]') ||
            (event[propt].constructor.toString() == '[object MouseEventConstructor]')) {
            wa = event[propt];
            break;
          }
        }
        tooltip.show(wa.pageX, wa.pageY, title && title.length > 0 ?
          title : 'N.A.');

          let color = '#FFDD00';

                switch (markers[0].category) {
                    case 'suolo':
                        color = '#F8A800';
                        break;
                    case 'falda':
                        color = '#17CADD';
                        break;
                    case 'aree':
                        color = '#9FDA58';
                        break;
                    }

        document.getElementsByClassName('mapTooltip')[0].style.backgroundColor = color;
        document.getElementsByClassName('mapTooltip')[0].style.transition = '.0s';
      }
    
      hideTooltip(tooltip) {
        tooltip.hide();
      }*/
  
    handleCloseBtn(section, event, index) {
        const btn = event.target;
        const detailDiv = $(btn).parent();
        if (detailDiv) {
            $(section).find('div.marker-container').addClass('hide');
        }
        const buttonCont = $(detailDiv).parent().find('div.map-buttons-container');
        if (buttonCont) {
            $(buttonCont).removeClass('open');
        }
        if (this.gMarkers[index]) {
          /*this.gMarkers[index].forEach(marker => {
              marker.setIcon(  this.selectedMarkers[index].pin );
             });*/
          if (this.selectedMarkers[index]) {
              this.selectedMarkers[index].label.className = 'label';
              this.selectedMarkers[index].setIcon( this.selectedMarkers[index].pin );
          }
          this.selectedMarkers[index] = null;
        }
  
        /* A */
        //this.maps[index].setZoom( INIT_ZOOM_DETAIL );
        /* B */
        //this.maps[index].setZoom( MAX_ZOOM_DETAIL );

        this.maps[index].setZoom( this.lastZooms[index] );
        
    }
  
    handleLocation(event, index) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                this.maps[index].setCenter(pos);
                this.maps[index].setZoom(MAX_ZOOM_DETAIL);
            });
  
            /* A */
            if (INIT_ZOOM_DETAIL===0) {
              INIT_ZOOM_DETAIL = this.maps[index].getZoom();
            }
        }
    }
  
    handleZoom(event, inOrOut, index) {
      /* A */
      if (INIT_ZOOM_DETAIL===0) {
          INIT_ZOOM_DETAIL = this.maps[index].getZoom();
        }
        
      const newZoom = inOrOut ? this.maps[index].getZoom() + 1 : this.maps[index].getZoom() - 1;
      this.maps[index].setZoom(newZoom);
    }
  
  }
  
  window.initMapDetail = () => {
    console.log('initMapDetail');
    const component = new InteractiveMapDetail();
  };

/***/ }),

/***/ "./src/scripts/widgets/interactive-map-light.js":
/*!******************************************************!*\
  !*** ./src/scripts/widgets/interactive-map-light.js ***!
  \******************************************************/
/*! exports provided: InteractiveMapLight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractiveMapLight", function() { return InteractiveMapLight; });
/* harmony import */ var _common_tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/tooltip */ "./src/scripts/common/tooltip.js");


const MAX_ZOOM_LIGHT = 13;
const MIN_ZOOM_LIGHT = 3;
class InteractiveMapLight {

  constructor() {
    const sections = $('section.interactive-map-light');
    this.zoomDefault = MAX_ZOOM_LIGHT;

    sections.each((index) => {
      const section = sections[index];
      const mapDiv = $(section).find('.eni-map');
      const tooltip = new _common_tooltip__WEBPACK_IMPORTED_MODULE_0__["Tooltip"]();
      if (mapDiv.length > 0) {
        this.initMapLight(section, mapDiv, index, tooltip);

        this.closeBtn(section, index);
        $(section).find('.map-buttons-container .location-btn').click((event => this.handleLocation(
          event, index)));
        $(section).find('.map-buttons-container .zoom-in-btn').click((event => this.handleZoom(event,
          true, index)));
        $(section).find('.map-buttons-container .zoom-out-btn').click((event => this.handleZoom(event,
          false, index)));
      }
    });
  }

  closeBtn(section, index) {
    $(section).find('button.drawer-btn').on('click', event => this.handleCloseBtn(event, index));
  }

  initMapLight(section, mapDiv, index, tooltip) {
    //console.log('InteractiveMapLight initMapLight', section, mapDiv, index, tooltip);

    try {
      const id = $(mapDiv).attr('id');
      const alt = $(section).hasClass('alt-color');
      const zoom = +$(section).attr('data-map-zoom');
      const lat = +$(section).attr('data-map-lat');
      const lng = +$(section).attr('data-map-lng');

      this.markerNormal = {
        url: $(section).attr('data-map-icon-marker-normal'),
        scaledSize: new google.maps.Size(15, 15),
        labelOrigin: new google.maps.Point(7.5, -20),
        anchor: new google.maps.Point(7.5, 7.5)
      };
      this.markerSelected = {
        url: $(section).attr('data-map-icon-marker-selected'),
        scaledSize: new google.maps.Size(30, 30),
        labelOrigin: new google.maps.Point(16, -20),
        anchor: new google.maps.Point(15, 15)
      };
      this.maps = this.maps || [];
      this.selectedMarkers = this.selectedMarkers || [];
      this.lastZooms = this.lastZooms || [];
      this.gMarkers = this.gMarkers || [];

      // CR: Mostra label stati
      let styles = [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#bfb8a3"
            },
            {
              "weight": 1.5
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.neighborhood",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.province",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.province",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "labels.text",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e9e6dd"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#9abdd3"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#456b82"
            }
          ]
        }
      ];
      // END CR

      // let styles = [
      //   {
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#f5f5f5"
      //       }
      //     ]
      //   },
      //   {
      //     "elementType": "labels.icon",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#616161"
      //       }
      //     ]
      //   },
      //   {
      //     "elementType": "labels.text.stroke",
      //     "stylers": [
      //       {
      //         "color": "#f5f5f5"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#bfb8a3"
      //       },
      //       {
      //         "weight": 1.5
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative.country",
      //     "elementType": "labels.text",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative.land_parcel",
      //     "elementType": "labels.text",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative.land_parcel",
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#bdbdbd"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative.locality",
      //     "elementType": "labels.text",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative.neighborhood",
      //     "elementType": "labels.text",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative.province",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "administrative.province",
      //     "elementType": "labels.text",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "landscape",
      //     "elementType": "labels.text",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "landscape.natural.terrain",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#ffffff"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "poi",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#eeeeee"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "poi",
      //     "elementType": "geometry.fill",
      //     "stylers": [
      //       {
      //         "color": "#eeeeee"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "poi",
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#757575"
      //       },
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "poi",
      //     "elementType": "labels.text.stroke",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "poi.park",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#ffffff"
      //       },
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "poi.park",
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#9e9e9e"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#ffffff"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road",
      //     "elementType": "geometry.stroke",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road",
      //     "elementType": "labels",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road.arterial",
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#757575"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road.highway",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#dadada"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road.highway",
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#616161"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road.highway.controlled_access",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#e9e6dd"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "road.local",
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#9e9e9e"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "transit",
      //     "stylers": [
      //       {
      //         "visibility": "off"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "transit.line",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#e5e5e5"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "transit.station",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#eeeeee"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "water",
      //     "elementType": "geometry",
      //     "stylers": [
      //       {
      //         "color": "#9abdd3"
      //       }
      //     ]
      //   },
      //   {
      //     "featureType": "water",
      //     "elementType": "labels.text.fill",
      //     "stylers": [
      //       {
      //         "color": "#456b82"
      //       }
      //     ]
      //   }
      // ];

      //console.log('InteractiveMapLight initMapLight type', zoom);
      let options = {};

      options = {
        center: {
          lat: lat,
          lng: lng
        },
        zoom: zoom,
        styles: (alt) ? styles : styles,
        //maxZoom: MAX_ZOOM_LIGHT,
        minZoom: MIN_ZOOM_LIGHT,
        disableDefaultUI: true
      };

      this.maps[index] = new google.maps.Map(
        document.getElementById(id), options
      );

      this.selectedMarkers[index] = null;

      let markers = $(section).attr('data-map-markers') ? JSON.parse($(section).attr('data-map-markers')) : null;
      //console.log('InteractiveMapLight initMapLight markers', markers);
      this.handleMarkers(markers, section, this.maps[index], index);
    } catch (ex) {
      console.error(ex);
    }
  }

  handleMarkers(markers, section, map, index, detailsMap) {

    detailsMap = (detailsMap === undefined) ? false : detailsMap;

    this.gMarkers[index] = [];
    const nation = $(section).attr('data-map-nation-selected') ? $(section).attr('data-map-nation-selected').replace(/"/gi, '') : null;

    markers.forEach(m => {

      //- default color and pin keep them for compatibility ---
      let color = '#ffd300';
      let pin = Object.assign({}, this.markerNormal);
      let pin_selected = Object.assign({}, this.markerSelected);

      pin.url = $(section).attr('data-map-icon-marker-' + m.category);
      pin_selected.url = pin.url.replace('.svg', "-hover.svg");

      //- get color and pin from category map ---
      switch (m.category) {
        //- test category used only in develop environment ---
        case 'pinStandard':
          color = '#ffd300';
          break;
        case 'sedeEnirewind':
          color = '#efefef';
          break;
        case 'falda':
          color = '#a529b6';
          break;
        case 'aree':
          color = '#9fda58';
          break;
        case 'suolo':
          color = '#f8a800';
          break;
        case 'areeSuolo':
          color = '#ffd300';
          break;
        case 'areeSin':
          color = '#9fda58';
          break;
        case 'suoloSin':
          color = '#f8a800';
          break;
        case 'areeSuoloSin':
          color = '#ffd300';
          break;
      }

      $('[data-map-nation="' + m.title + '"] h3').css({ "color": m.titleColor });


      //console.log('InteractiveMapLight handleMarkers info', color, pin, pin_selected);

      let label = '';
      //if ( !detailsMap ){
      label = {
        text: m.title,
        color: color,
        fontSize: '16px',
        fontFamily: 'Open Sans',
        className: 'label'
      };
      //}

      const gMarker = new google.maps.Marker({
        position: new google.maps.LatLng(m.lat, m.lng),
        label: label,
        icon: pin,
        pin: pin,
        pin_selected: pin_selected,
        zIndex: 100,
        optimized: false
      });
      gMarker.setMap(map);
      this.gMarkers[index].push(gMarker);

      google.maps.event.addListener(gMarker, 'mouseover', () => {
        gMarker.setIcon(pin_selected);
        gMarker.label.className = 'label active';
      });

      google.maps.event.addListener(gMarker, 'mouseout', () => {
        if (this.selectedMarkers[index] !== gMarker) {
          gMarker.label.className = 'label';
          gMarker.setIcon(pin);
        }
      });

      google.maps.event.addListener(gMarker, 'click', () => {
        this.selectNation(section, map, m, gMarker, index);
      });

      //- activate current nation ---
      if (nation && nation == m.title) {
        this.selectNation(section, map, m, gMarker, index);
      }
    });

    let categoryMarker = null;
    let categoryMap = $(section).attr('data-map-marker-category');

    switch (categoryMap) {
      //- test category used only in develop environment ---
      case 'default':
      case '"default"':
        categoryMarker = $(section).attr('data-map-icon-marker-normal');
        break;

      case 'falda':
      case '"falda"':
        categoryMarker = $(section).attr('data-map-marker-falda');
        break;
    }

    //- group nearest marker ---
    this.markerCluster = new MarkerClusterer(map, this.gMarkers[index], {
      styles: [{
        url: categoryMarker,
        height: 40,
        width: 40,
        textColor: '#000',
        textSize: 16,
        fontFamily: 'EniTabReg'
      }]
    });

    $(section).on('mouseover', 'div', function (e) {
      if ($(this).attr('class') == 'cluster-hover') {
        switch (categoryMap) {
          //- test category used only in develop environment ---
          case 'default':
          case '"default"':
            $(this).attr('class', 'cluster-hover');
            break;

          case 'falda':
          case '"falda"':
            $(this).attr('class', 'cluster-hover-falda');
            break;
        }
      }
    });

  }

  //- Deselect current pointer and active the clicked one ---
  selectNation(section, map, nation, gMarker, index) {

    //console.log('InteractiveMapLight selectNation', this.selectedMarkers, this.selectedMarkers[index]);

    if (this.selectedMarkers && this.selectedMarkers[index]) {
      //- deselect old active pointer ---

      const actualMarker = this.selectedMarkers[index];
      actualMarker.setIcon(actualMarker.pin);
      actualMarker.label.className = 'label';
      //const detailActualDiv = $(section).find(`div.marker-container[data-map-nation="${actualMarker.label.text}"]`);
      const detailActualDiv = $(section).find(`div.marker-container`);
      if (detailActualDiv) {
        $(detailActualDiv).addClass('hide');
      }
      this.selectedMarkers[index] = null;
    }

    if (!this.selectedMarkers || !this.selectedMarkers[index]) {
      //- activate current pointer ---

      gMarker.setIcon(gMarker.pin_selected);
      gMarker.label.className = 'label active';
      this.selectedMarkers[index] = gMarker;
      this.lastZooms[index] = map.getZoom();
      map.setZoom(this.zoomDefault);
      map.setCenter(gMarker.getPosition());
      const detailDiv = $(section).find(`div.marker-container[data-map-nation="${nation.title}"]`);
      if (detailDiv) {
        $(detailDiv).toggleClass('hide');
      }
      const buttonCont = $(section).find(`div.map-buttons-container`);
      if (buttonCont) {
        $(buttonCont).addClass('open');
      }
    }
  }

  handleCloseBtn(event, index) {
    const btn = event.target;
    const detailDiv = $(btn).parent();
    if (detailDiv) {
      $(detailDiv).addClass('hide');
    }
    const buttonCont = $(detailDiv).parent().find('div.map-buttons-container');
    if (buttonCont) {
      $(buttonCont).removeClass('open');
    }
    if (this.gMarkers[index]) {
      /*this.gMarkers[index].forEach(marker => {
          marker.setIcon(  this.selectedMarkers[index].pin );
         });*/
      if (this.selectedMarkers[index]) {
        this.selectedMarkers[index].label.className = 'label';
        this.selectedMarkers[index].setIcon(this.selectedMarkers[index].pin);
      }
      this.selectedMarkers[index] = null;
    }
    this.maps[index].setZoom(this.lastZooms[index]);
  }

  handleLocation(event, index) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.maps[index].setCenter(pos);
        // this.maps[index].setZoom(MAX_ZOOM_LIGHT);
      });
    }
  }

  handleZoom(event, inOrOut, index) {
    const newZoom = inOrOut ? this.maps[index].getZoom() + 1 : this.maps[index].getZoom() - 1;
    this.maps[index].setZoom(newZoom);
  }

}

window.initMapLight = () => {
  console.log('initMapLight');
  const component = new InteractiveMapLight();
};

/***/ }),

/***/ "./src/scripts/widgets/interactive-map.js":
/*!************************************************!*\
  !*** ./src/scripts/widgets/interactive-map.js ***!
  \************************************************/
/*! exports provided: InteractiveMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractiveMap", function() { return InteractiveMap; });
/* harmony import */ var _common_tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/tooltip */ "./src/scripts/common/tooltip.js");


const MAX_ZOOM = 7;
const MIN_ZOOM = 3;
class InteractiveMap {

  constructor() {
    const sections = $('section.interactive-map');
    sections.each((index) => {
      const section = sections[index];
      const mapDiv = $(section).find('.eni-map');
      const tooltip = new _common_tooltip__WEBPACK_IMPORTED_MODULE_0__["Tooltip"]();
      if (mapDiv.length > 0) {
        this.initMap(section, mapDiv, index, tooltip);
        $(section).find('button.drawer-btn').click(event => this.handleCloseBtn(event, index));
        $(section).find('.map-buttons-container .location-btn').click((event => this.handleLocation(
          event, index)));
        $(section).find('.map-buttons-container .zoom-in-btn').click((event => this.handleZoom(event,
          true, index)));
        $(section).find('.map-buttons-container .zoom-out-btn').click((event => this.handleZoom(event,
          false, index)));
      }
    });
  }

  initMap(section, mapDiv, index, tooltip) {
    try {
      const id = $(mapDiv).attr('id');
      const zoom = +$(section).attr('data-map-zoom');
      const lat = +$(section).attr('data-map-lat');
      const lng = +$(section).attr('data-map-lng');


      this.markerNormal = {
        url: $(section).attr('data-map-icon-marker-normal'),
        scaledSize: new google.maps.Size(15, 15),
        labelOrigin: new google.maps.Point(7.5, -20)
      };
      this.markerSelected = {
        url: $(section).attr('data-map-icon-marker-selected'),
        scaledSize: new google.maps.Size(30, 30),
        labelOrigin: new google.maps.Point(16, -20)
      };
      this.maps = this.maps || [];
      this.selectedMarkers = this.selectedMarkers || [];
      this.lastZooms = this.lastZooms || [];
      this.gMarkers = this.gMarkers || [];
      this.maps[index] = new google.maps.Map(document.getElementById(id), {
        center: {
          lat: lat,
          lng: lng
        },
        zoom: zoom,
        styles: [{
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [{
            "saturation": 36
          }, {
            "lightness": 40
          }, {
            "color": "#ffd100"
          }]
        }, {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [{
            "visibility": "on"
          }, {
            "color": "#000000"
          }, {
            "lightness": 16
          }]
        }, {
          "featureType": "all",
          "elementType": "labels.icon",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#000000"
          }, {
            "lightness": 20
          }]
        }, {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": "#000000"
          }, {
            "lightness": 17
          }, {
            "weight": 1.2
          }]
        }, {
          "featureType": "administrative",
          "elementType": "labels.text",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [{
            "color": "#000000"
          }, {
            "lightness": 20
          }]
        }, {
          "featureType": "landscape",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [{
            "color": "#111111"
          }, {
            "lightness": 21
          }]
        }, {
          "featureType": "poi",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [{
            "visibility": "on"
          }, {
            "color": "#5f5f5f"
          }]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": "#000000"
          }, {
            "lightness": 29
          }, {
            "weight": 0.2
          }]
        }, {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [{
            "color": "#000000"
          }, {
            "lightness": 18
          }, {
            "visibility": "simplified"
          }]
        }, {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#606060"
          }, {
            "lightness": "39"
          }, {
            "gamma": "0.43"
          }, {
            "saturation": "-47"
          }]
        }, {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [{
            "color": "#000000"
          }, {
            "lightness": 16
          }]
        }, {
          "featureType": "road.local",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#524300"
          }]
        }, {
          "featureType": "road.local",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": "#555555"
          }]
        }, {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [{
            "lightness": 19
          }, {
            "color": "#5d5d5d"
          }]
        }, {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "color": "#000000"
          }, {
            "lightness": 17
          }]
        }, {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }],
        maxZoom: MAX_ZOOM,
        minZoom: MIN_ZOOM,
        disableDefaultUI: true
      });

      this.selectedMarkers[index] = null;

      const markers = $(section).attr('data-map-markers') ? JSON.parse($(section).attr('data-map-markers')) : null;
      if (markers) {
        this.handleMarkers(markers, section, this.maps[index], index);
      } else {
        this.handleGeoJson(section, this.maps[index], index, tooltip);
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  handleMarkers(markers, section, map, index) {
    this.gMarkers[index] = [];
    const nation = $(section).attr('data-map-nation-selected') ? $(section).attr('data-map-nation-selected').replace(
      /"/gi, '') : null;
    markers.forEach(m => {
      const gMarker = new google.maps.Marker({
        position: new google.maps.LatLng(m.lat, m.lng),
        label: {
          text: m.title,
          color: '#ffd300',
          fontSize: '16px',
          fontFamily: 'Open Sans'
        },
        icon: this.markerNormal,
        optimized: false
      });
      gMarker.setMap(map);
      this.gMarkers[index].push(gMarker);
      google.maps.event.addListener(gMarker, 'mouseover', () => {
        gMarker.setIcon(this.markerSelected);
      });
      google.maps.event.addListener(gMarker, 'mouseout', () => {
        if (this.selectedMarkers[index] !== gMarker) {
          gMarker.setIcon(this.markerNormal);
        }
      });
      google.maps.event.addListener(gMarker, 'click', () => {
        this.selectNation(section, map, m, gMarker, index);
      });
      if (nation && nation == m.title) {
        this.selectNation(section, map, m, gMarker, index);
      }
    });


    this.markerCluster = new MarkerClusterer(map, this.gMarkers[index], {
      styles: [{
        url: $(section).attr('data-map-icon-marker-normal'),
        height: 40,
        width: 40,
        textColor: '#000',
        textSize: 16,
        fontFamily: 'EniTabReg'
      }]
    });
  }

  selectNation(section, map, nation, gMarker, index) {
    if (this.selectedMarkers && this.selectedMarkers[index]) {
      const actualMarker = this.selectedMarkers[index];
      actualMarker.setIcon(this.markerNormal);
      const detailActualDiv = $(section).find(`div.marker-container[data-map-nation="${actualMarker.label.text}"]`);
      if (detailActualDiv) {
        $(detailActualDiv).toggleClass('hide');
      }
      this.selectedMarkers[index] = null;
    }
    if (!this.selectedMarkers || !this.selectedMarkers[index]) {
      gMarker.setIcon(this.markerSelected);
      this.selectedMarkers[index] = gMarker;
      this.lastZooms[index] = map.getZoom();
      map.setZoom(MAX_ZOOM);
      map.setCenter(gMarker.getPosition());
      const detailDiv = $(section).find(`div.marker-container[data-map-nation="${nation.title}"]`);
      if (detailDiv) {
        $(detailDiv).toggleClass('hide');
      }
      const buttonCont = $(section).find(`div.map-buttons-container`);
      if (buttonCont) {
        $(buttonCont).addClass('open');
      }
    }
  }

  handleGeoJson(section, map, index, tooltip) {
    const geoJsonUrl = $(section).attr('data-map-geojson-url');
    if (geoJsonUrl) {
      $.getJSON(geoJsonUrl.replace(/"/gi, ''), (geoJson) => {

        map.data.addGeoJson(geoJson, {
          idPropertyName: 'id'
        });
        // Add some style.
        map.data.setStyle((f) => {
          return /** @type {google.maps.Data.StyleOptions} */ ({
            fillColor: f.getProperty('fill'),
            fillOpacity: f.getProperty('fill-opacity'),
            strokeColor: f.getProperty('stroke'),
            strokeOpacity: f.getProperty('stroke-opacity'),
            strokeWeight: f.getProperty('stroke-width'),
            icon: f.getProperty('icon')
          });
        });

        const bounds = new google.maps.LatLngBounds();
        map.data.forEach(function (feature) {
          feature.getGeometry().forEachLatLng(function (latlng) {
            bounds.extend(latlng);
          });
        });

        map.fitBounds(bounds);

        map.data.addListener('click', (event) => {
          this.selectArea(section, event, index);
        });

        map.data.addListener('mouseover', (event) => {
          this.showTooltip(tooltip, event);
        });

        map.data.addListener('mouseout', (event) => {
          this.hideTooltip(tooltip);
        });

      });
    }
  }

  selectArea(section, event, index) {
    this.lastZooms[index] = this.maps[index].getZoom();
    const boundsFeature = new google.maps.LatLngBounds();
    event.feature.getGeometry().forEachLatLng((latlng) => {
      boundsFeature.extend(latlng);
    });

    this.maps[index].fitBounds(boundsFeature);

    const title = event.feature.l.name;
    const description = event.feature.l.description;
    const detailDiv = $(section).find(`div.marker-container#geojson-container`);
    if (detailDiv) {
      $(detailDiv).removeClass('hide');
    }
    const buttonCont = $(section).find(`div.map-buttons-container`);
    if (buttonCont) {
      $(buttonCont).addClass('open');
    }
    const titleContainer = $(detailDiv).find(`.marker-title`);
    const abstractContainer = $(detailDiv).find(`.marker-abstract`);
    $(titleContainer).html(title && title.length > 0 ? title :
      'N.A.');
    $(abstractContainer).html(description && description.length > 0 ? description : 'N.A.');
  }

  showTooltip(tooltip, event) {
    const title = event.feature.l.name;
    let wa = null;
    for (var propt in event) {
      if (event[propt] != undefined && (event[propt].constructor.name == 'MouseEvent') ||
        (event[propt].constructor.toString() == '[object MouseEvent]') ||
        (event[propt].constructor.toString() == '[object MouseEventConstructor]')) {
        wa = event[propt];
        break;
      }
    }
    tooltip.show(wa.pageX, wa.pageY, title && title.length > 0 ?
      title : 'N.A.');
  }

  hideTooltip(tooltip) {
    tooltip.hide();
  }

  handleCloseBtn(event, index) {
    const btn = event.target;
    const detailDiv = $(btn).parent();
    if (detailDiv) {
      $(detailDiv).addClass('hide');
    }
    const buttonCont = $(detailDiv).parent().find('div.map-buttons-container');
    if (buttonCont) {
      $(buttonCont).removeClass('open');
    }
    if (this.gMarkers[index]) {
      this.gMarkers[index].forEach(marker => {
        marker.setIcon(this.markerNormal);
      });
      if (this.selectedMarkers[index]) {
        this.selectedMarkers[index].setIcon(this.markerNormal);
      }
      this.selectedMarkers[index] = null;
    }
    this.maps[index].setZoom(this.lastZooms[index]);
  }

  handleLocation(event, index) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.maps[index].setCenter(pos);
        // this.maps[index].setZoom(MAX_ZOOM);
      });
    }
  }

  handleZoom(event, inOrOut, index) {
    const newZoom = inOrOut ? this.maps[index].getZoom() + 1 : this.maps[index].getZoom() - 1;
    this.maps[index].setZoom(newZoom);
  }



}

window.initMap = () => {
  console.log('initMap');
  initMapLight();
  initMapDetail();
  const component = new InteractiveMap();
};


/***/ }),

/***/ "./src/scripts/widgets/manager-detail.js":
/*!***********************************************!*\
  !*** ./src/scripts/widgets/manager-detail.js ***!
  \***********************************************/
/*! exports provided: ManagerDetail */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ManagerDetail", function() { return ManagerDetail; });
// import { animateCSS, ANIMATE_EFFECT } from '../common/animate';

class ManagerDetail {
  constructor() {
    $('.manager-detail .btn-view-more').click(this.handleViewMore);
    $('.manager-detail .btn-view-less').click(this.handleViewLess);
    // animateCSS($('.manager-detail .manager-image')[0], ANIMATE_EFFECT.FADE_IN_UP);
  }

  handleViewMore(event) {
    try {
      const parent = $(event.currentTarget).parent();
      $(parent).removeClass('d-flex');
      $(parent).addClass('d-none');
      const card = $(event.currentTarget).parents('.manager-card')[0];
      const moreContent = $(card).find('.more-content');
      if (moreContent) {
        moreContent.show();
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  handleViewLess(event) {
    console.log(event);
    try {
      const parent = $(event.currentTarget).parents('.more-content');
      parent.hide();
      const card = $(event.currentTarget).parents('.manager-card')[0];
      const showViewMoreDiv = $(card).find('.btn-view-more').parent();
      if (showViewMoreDiv) {
        $(showViewMoreDiv).removeClass('d-none');
        $(showViewMoreDiv).addClass('d-flex');
      }
    } catch (ex) {
      console.error(ex);
    }
  }
}

$(() => {
  const component = new ManagerDetail();
});

/***/ }),

/***/ "./src/scripts/widgets/managers-card.js":
/*!**********************************************!*\
  !*** ./src/scripts/widgets/managers-card.js ***!
  \**********************************************/
/*! exports provided: ManagersCard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ManagersCard", function() { return ManagersCard; });
/* harmony import */ var _common_animate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/animate */ "./src/scripts/common/animate.js");


class ManagersCard {
  constructor() {
    $('.managers-card button.view-more').on('click', (e) => {
      console.log(e);
      this.showMore(e.currentTarget);
      return false;
    });

    $('.managers-card button.view-less').on('click', (e) => {
      this.showLess(e.currentTarget);
      return false;
    });

    $('.managers-card .manager-item').click(this.handleCardLink);
  }

  showMore(el) {
    console.log('showMore');
    $(el).hide();
    try {
      const row = $(el).parents('.managers-container').children('.manager-row');
      // animateCSS(row[0], ANIMATE_EFFECT.BOUNCE_IN_UP);
      $(row).show();
      const btnLess = $(el).parents('.view-more-box').children('.view-less');
      $(btnLess).show();

    } catch (er) {
      console.error(er);
    }
  }

  showLess(el) {
    $(el).hide();
    try {
      const row = $(el).parents('.managers-container').children('.manager-row');
      $(row).hide();
      const btnMore = $(el).parents('.view-more-box').children('.view-more');
      $(btnMore).show();
    } catch (er) {
      console.error(er);
    }
  }

  handleCardLink(event) {
    const el = event.currentTarget;
    if ($(event.target).is('h3') || $(event.target).is('a')) {
      event.preventDefault();
    }
    const url = $(el).attr('data-url');
    const target = $(el).attr('data-target');
    if (url && url.length > 0) {
      window.open(url, target);
    }
  }
}

$(() => {
  const component = new ManagersCard();
});


/***/ }),

/***/ "./src/scripts/widgets/media-collection-detail-cover.js":
/*!**************************************************************!*\
  !*** ./src/scripts/widgets/media-collection-detail-cover.js ***!
  \**************************************************************/
/*! exports provided: MediaCollectionDetailCover */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaCollectionDetailCover", function() { return MediaCollectionDetailCover; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");
/* harmony import */ var _common_yt_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/yt-utils */ "./src/scripts/common/yt-utils.js");
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");




class MediaCollectionDetailCover {
    constructor() {
        console.log('MediaCollectionDetailCover');

        $('.media-detail-cover .drawer-btn').click(this.handlePlaylistClick);
        $('.media-detail-cover .playlist-image').click((event) => this.handleContentClick(event));
        $('.media-detail-cover .playlist-detail-title').click((event) => this.handleContentClick(event));
        $('.scroll-y').scroll((event) => this.handleGalleryPlaylistContainerScroll(event));

        this.owl = Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])('.carousel-container.gallery-slider .owl-carousel', {
            loop: true,
            nav: true,
            mouseDrag: false,
            center: true,
            autoWidth: false,
            margin: 0,
            navText: [],
            /* onTranslate: this.onTranslated, */
            rewind: false,
            items: 1
        }, true);

        // yt-video
        const videoSections = $('section.media-detail-cover.yt-video');
        if (videoSections) {
            this.ytUtils = new Map();
            videoSections.each((i, section) => {
                const iconContainer ="<div class='icon-container'><button class='btn btn-share d-none d-lg-block' data-url='https://www.google.com'><i class='icon-share-small'></i></button><button type='button' class='btn btn-share d-lg-none' data-toggle='modal' data-target='#shareModal' data-url='https://www.google.com'><span class='icon-share-small'></span></button><button class='btn btn-share d-none d-lg-block' data-url='https://www.google.com'><i class='icon-share-small'></i></button><button type='button' class='btn btn-share d-lg-none' data-toggle='modal' data-target='#shareModal' data-url='https://www.google.com'><span class='icon-share-small'></span></button></div>"
                const ytEmbedded = $(section).find('.yt-embedded');
                const playerId = ytEmbedded.attr('id');
                const ytId = ytEmbedded.attr('data-yt-ids').split(',');
                console.log('MediaCollectionDetailCover loop', playerId, ytId, section);
                if ($(section).hasClass('video-new')) {
                    $(ytEmbedded).parent().addClass('ytEmbedded' );
                    const picture = $(ytEmbedded).prev();
                    $(picture).addClass('ppporva' );
                    $(picture).find('img').attr('src', 'https://img.youtube.com/vi/'+ytId+'/hqdefault.jpg' );
                    $(picture).find('source').attr('srcset', 'https://img.youtube.com/vi/'+ytId+'/hqdefault.jpg');
                    ytEmbedded.wrap("<div class='iframe-wrapper'><div></div></div>");
                }
                this.ytUtils = this.ytUtils.set(playerId, _common_yt_utils__WEBPACK_IMPORTED_MODULE_1__["YtUtils"].createInstance(playerId, ytId, {
                    autoplay: 1,
                    autohide: 1,
                    modestbranding: 0,
                    rel: 0,
                    showinfo: 0,
                    controls: 1,
                    disablekb: 1,
                    enablejsapi: 0,
                    iv_load_policy: 3
                }, true));
            });
        }


    }

    handlePlaylistClick(event) {
        const btn = event.target;
        const parent = $(btn).parent('.playlist-container');
        parent.toggleClass('closed');
    }

    handleContentClick(event) {
        console.log(event);
        const el = event.currentTarget;
        const parentContainer = $(el).parents('.media-detail-cover');
        // this.reorderContent(el, $(el).parents('.scroll-y'));
        this.handleActive(el, parentContainer);
        this.closePlaylistContainer(el);
        const soundcloudUrl = $(el).attr('data-soundcloud-url');
        if (soundcloudUrl) {
            this.switchSoundCloudIframe(soundcloudUrl, parentContainer);
        }

        const photoPos = $(el).attr('data-gallery-pos');
        if (photoPos) {
            this.goToPhoto(photoPos, parentContainer);
        }

        const ytVideoIndex = $(el).attr('data-yt-index');
        if (ytVideoIndex) {
            const playerId = $(el).attr('data-player-id');
            this.loadYTVideo(ytVideoIndex, playerId);
        }
    }

    // reorderContent(currentEl, scrollContainer) {
    //   console.log('reorderContent', scrollContainer);
    //   const contentRow = $(currentEl).parents('.playlist-content');
    //   $(contentRow).prependTo(scrollContainer);
    // }

    handleActive(el, parentContainer) {
        try {
            $(parentContainer).find('.playlist-content').removeClass('active');
            $(el).parents('.playlist-content').addClass('active');
        } catch (err) {

        }
    }

    closePlaylistContainer(el) {
        $(el).parents('.playlist-container').toggleClass('closed');
    }

    switchSoundCloudIframe(url, parentContainer) {
        console.log('switchSoundcloud', url);
        console.log('parentContainer', parentContainer);
        const SC_URL =
            `https://w.soundcloud.com/player/?url=${url}&color=%23ff5500&auto_play=true&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`;
        const iframe = $(parentContainer).find('iframe');

        iframe.attr('src', SC_URL);

    }

    goToPhoto(photoPos, parentContainer) {
        console.log('goToPhoto', photoPos, parentContainer);
        console.log('owl', this.owl);
        this.owl.trigger('to.owl.carousel', [photoPos, 200]);
    }

    loadYTVideo(ytVideoIndex, playerId) {
        const ytu = this.ytUtils.get(playerId);
        ytu.player.playVideoAt(ytVideoIndex);
    }

    handleGalleryPlaylistContainerScroll(event) {
        // Close share modal at scroll of .scroll-y elements
        _common_utils__WEBPACK_IMPORTED_MODULE_2__["default"].closeShareModal();
    }


}

$(() => {
    const component = new MediaCollectionDetailCover();
});

/***/ }),

/***/ "./src/scripts/widgets/media-highlight.js":
/*!************************************************!*\
  !*** ./src/scripts/widgets/media-highlight.js ***!
  \************************************************/
/*! exports provided: MEDIA_HIGHLIGHT_PROPS, MediaHighlight, MediaHighlightPlay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDIA_HIGHLIGHT_PROPS", function() { return MEDIA_HIGHLIGHT_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaHighlight", function() { return MediaHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaHighlightPlay", function() { return MediaHighlightPlay; });
/* harmony import */ var _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/yt-utils */ "./src/scripts/common/yt-utils.js");


const MEDIA_HIGHLIGHT_PROPS = {
    VIDEO_SECTION_CLASS: 'section.media-highlight-widget.yt1-video',
    MEDIA_HIGHLIGHT_1COL: '.media-highlight-widget.media-highlight-1col',
    MEDIA_HIGHLIGHT_2COL: '.media-highlight-widget .media-highlight-2col',
};

class MediaHighlight {

    constructor(initializeForDynamicContent) {
        console.log('MediaHighlight');

        // Manage children selector when dynamic section instantiate class
        if (initializeForDynamicContent) {
            MEDIA_HIGHLIGHT_PROPS.VIDEO_SECTION_CLASS = MEDIA_HIGHLIGHT_PROPS.VIDEO_SECTION_CLASS + '.eni-target-widget';
            MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_1COL = '.eni-target-widget ' + MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_1COL;
            MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_2COL = '.eni-target-widget ' + MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_2COL;
        }

        const videoSections = $(MEDIA_HIGHLIGHT_PROPS.VIDEO_SECTION_CLASS);
        if (videoSections) {
            this.ytUtils = new Map();
            console.log('videoSections', videoSections);
            videoSections.each((i, section) => {
                const ytEmbedded = $(section).find('.yt-embedded');
                if (ytEmbedded) {
                    ytEmbedded.each((i, el) => {
                        const playerId = $(el).attr('id');
                        const ytId = $(el).attr('data-yt-id');
                        this.ytUtils = this.ytUtils.set(playerId, _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__["YtUtils"].createInstance(playerId, ytId, {
                            autoplay: 1,
                            autohide: 1,
                            modestbranding: 0,
                            rel: 0,
                            showinfo: 0,
                            controls: 0,
                            disablekb: 1,
                            enablejsapi: 0,
                            iv_load_policy: 3
                        }));
                    });
                }
            });
        }
        var isMobile = $(window).outerWidth() < 1024;
        if (!isMobile) {
            $(MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_1COL).hover((event) => this.handleOver(event, true), (event) => this
                .handleOver(event, false));
            $(MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_2COL).hover((event) => this.handleOver(event, true), (event) =>
                this
                .handleOver(event, false));
        }

        $(MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_1COL).click(this.handleClick);
        $(MEDIA_HIGHLIGHT_PROPS.MEDIA_HIGHLIGHT_2COL).click(this.handleClick);


    }

    handleOver(event, inOut) {
        this.handleTitleHover(event.currentTarget, inOut);
        this.handleVideoHover(event.currentTarget, inOut);
    }

    handleTitleHover(section, inOut) {
        const i = $(section).find('i.dash');
        if (inOut) {
            i.removeClass('yellow-line');
            i.addClass('yellow-pipe');
        } else {
            i.removeClass('yellow-pipe');
            i.addClass('yellow-line');
        }
    }

    handleVideoHover(section, inOut) {
        try {
            if ($(section).hasClass('yt1-video')) {
                const ytId = $(section).find('iframe').attr('id');
                const ytu = this.ytUtils.get(ytId);
                if (inOut) {
                    $(section).find('picture').hide();
                    ytu.startVideo($(section));
                } else {
                    ytu.stopVideo();
                    $(section).find('picture').show();
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    handleClick(event) {
        console.log(event);
        if ($(event.target).hasClass('icon-share-small') || $(event.target).hasClass('btn-share')) {
            return;
        }

        const url = $(event.currentTarget).attr('data-url');
        const target = $(event.currentTarget).attr('data-target');
        if (url && url.length > 0) {
            window.open(url, target);
        }
    }
}

$(document).ready(() => {
    const component = new MediaHighlight(false);
});


class MediaHighlightPlay {

    constructor() {
        console.info('MediaHighlightPlay constructor');
        
        const video = $(".media-video-highlight .video-box");
        for (let i = 0; i < video.length; i++) {   

                this.init( $(video[i]) );
                
        }

    }

    init(elem) {
        console.log('MediaHighlightPlay init');

        const picture = $(elem).find('picture');
        const iframe = $('<div data-yt-id="' + $(picture).attr('data-yt-id') + '"></div>');

        $(picture).click((e) => {

            $(elem).append(iframe);
            $(picture).hide();
            this.handleVideo(iframe, false);

        });

    }

    handleVideo(ytEmbedded, picture) {
        if (ytEmbedded) {
            const timestamp = new Date().getTime();
            const playerId = String('yt-' + timestamp);
            $(ytEmbedded).attr("id", playerId);
            const ytId = $(ytEmbedded).attr("data-yt-id");
            this.ytUtils = _common_yt_utils__WEBPACK_IMPORTED_MODULE_0__["YtUtils"].createInstance(
                playerId,
                [ytId], {
                    autoplay: 1,
                    autohide: 1,
                    modestbranding: 0,
                    rel: 0,
                    showinfo: 0,
                    controls: 1,
                    disablekb: 1,
                    enablejsapi: 0,
                    iv_load_policy: 3,
                    loop: 1
                },
                true,
                true
            );
            this.startVideo(this.ytUtils, videoSection, picture);
        }
    }

    startVideo(yt, container, picture) {
        if ( !picture ){
            $(container).find("picture").hide();
        }
        $(container).find("iframe").show();
        //yt.startVideo(container);
    }
}

$(() => {
    const component = new MediaHighlightPlay();
});

/***/ }),

/***/ "./src/scripts/widgets/no-browser-support.js":
/*!***************************************************!*\
  !*** ./src/scripts/widgets/no-browser-support.js ***!
  \***************************************************/
/*! exports provided: NoBrowserSupport */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoBrowserSupport", function() { return NoBrowserSupport; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class NoBrowserSupport {
    constructor() {
        const isIE = _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].isIE();
        const el = $('.no-browser-support');
        if (el.length > 0) {
            if (isIE) {
                $(el).addClass('show');
            }
        }
    }
}

$(() => {
    const component = new NoBrowserSupport();
});

/***/ }),

/***/ "./src/scripts/widgets/number-highlight.js":
/*!*************************************************!*\
  !*** ./src/scripts/widgets/number-highlight.js ***!
  \*************************************************/
/*! exports provided: NumbersHighlight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumbersHighlight", function() { return NumbersHighlight; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class NumbersHighlight {
  constructor(bindClass) {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 20,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 2.5,
          slideBy: 2
        },
        1440: {
          items: 3.5,
          slideBy: 3
        }
      }
    }, true);

    // $('.carousel-numbers .card-number').click(this.handleClick);
  }

  // handleClick(event) {
  //   let url, target;
  //   if ($(event.target).hasClass('icon-arrow-right-small')) {
  //     const a = $(event.target).parent('a');
  //     url = $(a).attr('href');
  //     target = $(a).attr('target');
  //     event.preventDefault();
  //   } else if ($(event.target).is('a')) {
  //     return;
  //   }
  //   else {
  //     const el = event.currentTarget;
  //     url = $(el).attr('data-link');
  //     target = $(el).attr('data-target');
  //   }
  //   window.open(url, target);
  // }
}

$(() => {
  const component = new NumbersHighlight('.carousel-container.numbers-highlight-carousel .owl-carousel');
});

/***/ }),

/***/ "./src/scripts/widgets/numbers-carousel.js":
/*!*************************************************!*\
  !*** ./src/scripts/widgets/numbers-carousel.js ***!
  \*************************************************/
/*! exports provided: NumbersCarousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumbersCarousel", function() { return NumbersCarousel; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class NumbersCarousel {
  constructor(bindClass) {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 2.5,
          slideBy: 2
        },
        1440: {
          items: 3.5,
          slideBy: 3
        }
      }
    }, true);

    $('.carousel-numbers .card-number').click(this.handleClick);
  }

  handleClick(event) {
    let url, target;
    if ($(event.target).hasClass('icon-arrow-right-small')) {
      const a = $(event.target).parent('a');
      url = $(a).attr('href');
      target = $(a).attr('target');
      event.preventDefault();
    } else if ($(event.target).is('a')) {
      return;
    } else {
      const el = event.currentTarget;
      url = $(el).attr('data-link');
      target = $(el).attr('data-target');
    }
    if (url && url.length > 0) {
      window.open(url, target);
    }
  }
}

$(() => {
  const component = new NumbersCarousel('.carousel-container.numbers-carousel .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/widgets/our-channel-panel.js":
/*!**************************************************!*\
  !*** ./src/scripts/widgets/our-channel-panel.js ***!
  \**************************************************/
/*! exports provided: OUR_CHANNEL_PANEL_PROPS, OurChannelPanel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OUR_CHANNEL_PANEL_PROPS", function() { return OUR_CHANNEL_PANEL_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OurChannelPanel", function() { return OurChannelPanel; });
const OUR_CHANNEL_PANEL_PROPS = {
  TITLE_CLASS: '.our-channel-panel .channel-label h3'
};
class OurChannelPanel {
  constructor() {
    $(OUR_CHANNEL_PANEL_PROPS.TITLE_CLASS).hover(
      (event) => {
        this.handleTitleHover(event.target);
      },
      (event) => {
        this.handleTitleHover(event.target);
      }
    );
  }

  handleTitleHover(el) {
    const contentBox = $(el).parents('.channel-label');
    const yellowLine = $(contentBox).find('span.dash');

    yellowLine.toggleClass('yellow-line');
    yellowLine.toggleClass('yellow-pipe');

  }

}

$(() => {
  const component = new OurChannelPanel();
});


/***/ }),

/***/ "./src/scripts/widgets/people-tab.js":
/*!*******************************************!*\
  !*** ./src/scripts/widgets/people-tab.js ***!
  \*******************************************/
/*! exports provided: PeopleTab */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PeopleTab", function() { return PeopleTab; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class PeopleTab {
  constructor() {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])('.people-carousel .people-tab-container', {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 20,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 2.5,
          slideBy: 2
        },
        1440: {
          items: 3.5,
          slideBy: 3
        }
      }
    }, true);
  }
}



/***/ }),

/***/ "./src/scripts/widgets/photo-gallery.js":
/*!**********************************************!*\
  !*** ./src/scripts/widgets/photo-gallery.js ***!
  \**********************************************/
/*! exports provided: PhotoGallery */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhotoGallery", function() { return PhotoGallery; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class PhotoGallery {

  constructor(photoGalleryContainerClass) {

    // Swipe handling in gallery overlay
    var handleSwipe = function (magnificPopup) {
      $(".mfp-gallery").swipe({
        swipeStatus: function (event, phase, direction, distance) {
          if (phase == "end") {
            if (direction == "right") {
              magnificPopup.prev.call();
            } else if (direction == "left") {
              magnificPopup.next.call();
            } else {
              return false;
            }
          }
          return true;
        },
        triggerOnTouchEnd: false,
        threshold: 100
      });
    };

    $('.photo-gallery-container').each(function () {

      $(this).magnificPopup({
        delegate: 'a', // child items selector, by clicking on it popup will open
        type: 'image',
        mainClass: 'photogallery-popup',
        // Image Type
        image: {
          markup: '<div class="mfp-figure">' +
            '<div class="mfp-top-bar">' +
            '<div class="mfp-counter"></div>' +
            '</div>' +
            '<div class="mfp-img"></div>' +
            '<div class="mfp-bottom-bar">' +
            '<div class="mfp-title"></div>' +
            /* '<div class="mfp-counter"></div>' + */
            '</div>' +
            '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

          cursor: null, // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

          /* titleSrc: 'img-background', */ // Attribute of the target element that contains caption for the slide.
          // Or the function that should return the title. For example:
          titleSrc: function (item) {
            if ($(item.el) && $(item.el).children('.mfp-description').length > 0 &&
              $(item.el).children('.mfp-description').text()) {
              return $(item.el).children('.mfp-description').text();
            } else {
              return '';
            }
            /* return item.el.attr('title') + '<small>by Marsel Van Oosten</small>'; */
          },

          verticalFit: true, // Fits image in area vertically

          tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
        },
        // Iframe Type
        iframe: {
          markup: '<div class="mfp-top-bar">' +
            '<div class="mfp-counter"></div>' +
            '</div>' +
            '<div class="mfp-iframe-scaler">' +
            '<iframe class="mfp-iframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' +
            '</div>' +
            '<div class="mfp-bottom-bar">' +
            '<div class="mfp-title"></div>' +
            '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

          patterns: {
            youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: 'https://www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            }
            // ,vimeo: {
            //   index: 'vimeo.com/',
            //   id: '/',
            //   src: '//player.vimeo.com/video/%id%?autoplay=1'
            // },
            // gmaps: {
            //   index: '//maps.google.',
            //   src: '%id%&output=embed'
            // }

            // you may add here more sources

          },

          srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        },
        gallery: {
          enabled: true,
          /* preload: [0, 3], */ // read about this option in next Lazy-loading section
          navigateByImgClick: false,
          arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
          tPrev: 'Precedente', // title for left button
          tNext: 'Successivo', // title for right button
          tCounter: '<span class="mfp-counter"><span class="mfp-current-page">%curr%</span>/%total%</span>' // markup of counter
        },
        closeBtnInside: false,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
        tClose: 'Chiudi',
        callbacks: {
          open: function () {
            // Make body uscrollable (fix mobile scroll when magnificPopup open)
            $('body').addClass('unscrollable');
            handleSwipe(this);
            _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].stopBodyScrollingiOS(true);
          },
          close: function () {
            $('body').removeClass('unscrollable');
            _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].stopBodyScrollingiOS(false);
          },
          elementParse: function (item) {
            // Function will fire for each target element
            // "item.el" is a target DOM element (if present)
            // "item.src" is a source that you may modify
            /* console.log(item.el); */
            /* console.log(item); */ // Do whatever you want with "item" object
          },
          markupParse: function (template, values, item) {
            // Triggers each time when content of popup changes

            if (item.type && item.type === 'iframe') {
              if (item.el.children('p.mfp-description') && item.el.children('p.mfp-description').text())
                // Get iframe type description
                var iframeDescription = item.el.children('p.mfp-description').text();

              // Set iFrame description
              values.title = iframeDescription;
            }
          },
        }
        // other options
      });

    });

    $('.photo-gallery-item').click(this.handleClick);
  }

  handleClick(event) {
    console.log('handleClick', event);
    // Photo gallery - Prevent click when card is not center/active
    if ($(event.target).parents('.photo-gallery-item')) {
      let photoGalleryItem = $(event.target).parents('.photo-gallery-item');
      if (photoGalleryItem.hasClass('photo-gallery-item') && !photoGalleryItem.hasClass(
          'carousel-center')) {
        return false;
      }
    }
  }
}

window.addEventListener('load', () => {
  const component = new PhotoGallery('.carousel-publications-container.photo-gallery-container');
});


/***/ }),

/***/ "./src/scripts/widgets/project-highlight-complex-page.js":
/*!***************************************************************!*\
  !*** ./src/scripts/widgets/project-highlight-complex-page.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(function () {
  if ($(window).width() < 1023) {
    $(".flip-card-complex-page").click(function () {
      var description = $(this).find(".description");
      var imgContainer = $(this).find(".flip-img");

      if (!$(imgContainer).hasClass("remove")) {
        $(imgContainer).addClass("remove");
        $(description).addClass("show");
      } else {
        $(imgContainer).removeClass("remove");
        $(description).removeClass("show");
      }
    });
  }
});


/***/ }),

/***/ "./src/scripts/widgets/publication-list.js":
/*!*************************************************!*\
  !*** ./src/scripts/widgets/publication-list.js ***!
  \*************************************************/
/*! exports provided: PublicationList */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PublicationList", function() { return PublicationList; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class PublicationList {
  constructor() {
    const publicationsItemContainers = $('.publications-item-container');
    if (publicationsItemContainers && publicationsItemContainers.length > 0) {
      for (let i = 0; i < publicationsItemContainers.length; i++) {
        const publicationsItemContainer = publicationsItemContainers[i];
        const publicationsItemContainerSection = $(publicationsItemContainer).parents('section');
        _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].checkLastVisiblePublicationItem(publicationsItemContainerSection);
        _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].checkLastVisibleAccordionsElement(publicationsItemContainerSection);
      }
    }
  }

}
$(document).ready(() => {
  const component = new PublicationList();
});


/***/ }),

/***/ "./src/scripts/widgets/search-images.js":
/*!**********************************************!*\
  !*** ./src/scripts/widgets/search-images.js ***!
  \**********************************************/
/*! exports provided: SearchImages */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchImages", function() { return SearchImages; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");
/* harmony import */ var _common_share__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/share */ "./src/scripts/common/share.js");



class SearchImages  {
  constructor() {

    $('.search-gallery .image-container').each(function () {

      $(this).magnificPopup({
        type: 'image',
        delegate: 'div.overlay',
        mainClass: 'search-gallery-popup',
        // Image Type
        image: {
          markup: '<div class="row">'+
                    '<div class="col-lg-8 col-md-12 col-sm-12">' +
                      '<div class="mfp-figure">' +
                        '<div class="mfp-img"></div>' +
                      '</div>' +
                    '</div>' +
                    '<div class="col-lg-4 col-md-12 col-sm-12">' +
                      '<div class="mfp-imagetitle">'+ $(this).attr("imagetitle") +'</div>' +
                      '<div class="mfp-imagedescription">'+ $(this).attr("imagedescription") +'</div>' +
                      '<div class="mfp-imageicon">' +
                        '<a href="'+ $(this).attr("imagepath") +'" title="download" download><span class="icon-download-small"></span></a>' +
                        //'<button class="btn btn-share d-none d-lg-block" data-url="'+ $(this).attr("imagepath") +'"><i class="icon-share-small"></i></button>' +
	                      //'<button type="button" class="btn btn-share d-lg-none" data-toggle="modal" data-target="#shareModal" data-url="'+ $(this).attr("imagepath") +'"><span class="icon-share-small"></span></button>' +
                      '</div>' +
                      '<div class="mfp-imageauthor">' +
                        '<span class="icon-small-photography"></span>'+ $(this).attr("imageauthor") +''+
                      '</div>' +
                      '<div class="mfp-imagefeatures"><span class="icon-small-azioni-e-feedback-espandi"></span>'+ $(this).attr("imageweight") +' - '+ $(this).attr("imagesize") +'</div>' +
                      '<div class="mfp-imagefeatures"><span class="icon-small-formati-gallery"></span><span class="filetype">'+ $(this).attr("imageformat") +'</span></div>' +
                      //'<div class="mfp-imagedetails"><a href="#" title="" target=""><span class="icon-arrow-right-small"></span></a> '+ $(this).attr("imagegallerylabel") +'</div>' +
                      '<div class="mfp-imageuseterms">'+
                        '<span class="icon-creative-commons-cc"></span>'+
                        '<span class="icon-creative-commons-by"></span>'+
                        '<span class="icon-creative-commons-nc-us"></span>'+
                        '<span class="icon-creative-commons-nd"></span>'+
                        '<a href="'+ $(this).attr("imageusetermslink") +'" title="'+ $(this).attr("imageusetermslabel") +'" target="_blank">'+ $(this).attr("imageusetermslabel") +'</a>'+
                      '</div>'+
                      '<div class="mfp-imagerights">'+
                      '<span class="copy-symbol">&copy;</span>'+ $(this).attr("imagerightslabel") +'</div>' +
                    '</div>'+
                  '</div>', 
            // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

          cursor: null, // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

          /* titleSrc: 'img-background', */ // Attribute of the target element that contains caption for the slide.
          // Or the function that should return the title. For example:
          
          titleSrc: function (item) {
            if ($(item.el) && $(item.el).parents('figure').length > 0 &&
              $(item.el).parents('figure').children('.image-title') &&
              $(item.el).parents('figure').children('.image-title').length > 0 &&
              $(item.el).parents('figure').children('.image-title').text()) {
              return $(item.el).parents('figure').children('.image-title').text();
            } else {
              return '';
            }
          },

          verticalFit: true, // Fits image in area vertically

          tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
        },
        closeBtnInside: false,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
        tClose: 'Chiudi',
        callbacks: {
          open: function () {
            // Make body unscrollable (fix mobile scroll when magnificPopup open)
            $('body').addClass('unscrollable');
            //Utils.stopBodyScrollingiOS(true);
            //share button
            //this.shareUtils = Share.createInstance(false);
            if($('.mfp-imageauthor').text().length < 4) 
              $('.mfp-imageauthor').remove();
          },
          close: function () {
            $('body').removeClass('unscrollable');
            //Utils.stopBodyScrollingiOS(false);
          }
        }
      });

    });

  }
}

$(() => {
  const component = new SearchImages();
});

/***/ }),

/***/ "./src/scripts/widgets/single-image-video.js":
/*!***************************************************!*\
  !*** ./src/scripts/widgets/single-image-video.js ***!
  \***************************************************/
/*! exports provided: SingleImageVideo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SingleImageVideo", function() { return SingleImageVideo; });
/* harmony import */ var _common_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/utils */ "./src/scripts/common/utils.js");


class SingleImageVideo {
  constructor() {
    $('.single-image-video .image-container').magnificPopup({
      type: 'image',
      delegate: 'div.overlay',
      mainClass: 'single-image-video-popup',
      // Image Type
      image: {
        markup: '<div class="mfp-figure">' +
          '<div class="mfp-top-bar">' +
          '</div>' +
          '<div class="mfp-img"></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '</div>' +
          '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

        cursor: null, // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

        /* titleSrc: 'img-background', */ // Attribute of the target element that contains caption for the slide.
        // Or the function that should return the title. For example:
        titleSrc: function (item) {
          if ($(item.el) && $(item.el).parents('.single-image-video-item').length > 0 &&
            $(item.el).parents('.single-image-video-item').children('.description') &&
            $(item.el).parents('.single-image-video-item').children('.description').length > 0 &&
            $(item.el).parents('.single-image-video-item').children('.description').text()) {
            return $(item.el).parents('.single-image-video-item').children('.description').text();
          } else {
            return '';
          }
          /* return item.el.attr('title') + '<small>by Marsel Van Oosten</small>'; */
        },

        verticalFit: true, // Fits image in area vertically

        tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
      },
      closeBtnInside: false,
      closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
      tClose: 'Chiudi',
      callbacks: {
        open: function () {
          // Make body uscrollable (fix mobile scroll when magnificPopup open)
          $('body').addClass('unscrollable');
          _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].stopBodyScrollingiOS(true);
        },
        close: function () {
          $('body').removeClass('unscrollable');
          _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].stopBodyScrollingiOS(false);
        }
      }
    });

    $('.single-image-video .video-container').magnificPopup({
      type: 'iframe',
      delegate: '.overlay-video',
      mainClass: 'single-image-video-popup',
      // Iframe Type
      iframe: {
        markup: '<div class="mfp-top-bar">' +
          '<div class="mfp-counter"></div>' +
          '</div>' +
          '<div class="mfp-iframe-scaler">' +
          '<iframe class="mfp-iframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' +
          '</div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

        patterns: {
          youtube: {
            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

            id: 'v=', // String that splits URL in a two parts, second part should be %id%
            // Or null - full URL will be returned
            // Or a function that should return %id%, for example:
            // id: function(url) { return 'parsed id'; }

            src: 'https://www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1?enablejsapi=1'
          },
          gmaps: {
            index: '//maps.google.',
            src: '%id%&output=embed'
          }

          // you may add here more sources

        },

        srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
      },
      closeBtnInside: false,
      closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
      tClose: 'Chiudi',
      callbacks: {
        markupParse: function (template, values, item) {
          // Triggers each time when content of popup changes

          if (item.type && item.type === 'iframe') {
            if (item.el.parents('.single-image-video-item') && item.el.parents('.single-image-video-item')
              .length > 0 &&
              item.el.parents('.single-image-video-item').children('.description') &&
              item.el.parents('.single-image-video-item').children('.description').length > 0 &&
              item.el.parents('.single-image-video-item').children('.description').text())
              // Get iframe type description
              var iframeDescription = item.el.parents('.single-image-video-item').children('.description')
                .text();

            // Set iFrame description
            values.title = iframeDescription;
          }
        },
        open: function () {
          // Make body uscrollable (fix mobile scroll when magnificPopup open)
          $('body').addClass('unscrollable');
          _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].stopBodyScrollingiOS(true);
        },
        close: function () {
          $('body').removeClass('unscrollable');
          _common_utils__WEBPACK_IMPORTED_MODULE_0__["default"].stopBodyScrollingiOS(false);
        }
      }
    });
  }
}

$(() => {
  const component = new SingleImageVideo();
});


/***/ }),

/***/ "./src/scripts/widgets/tab-new.js":
/*!****************************************!*\
  !*** ./src/scripts/widgets/tab-new.js ***!
  \****************************************/
/*! exports provided: TabNewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabNewComponent", function() { return TabNewComponent; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class TabNewComponent {
  constructor() {

    this.setMaxChildWidth();

    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])('.eni-tab-new-section .eni-tab-new-container .owl-carousel', {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 0,
      navText: [],
      // onTranslate: this.onTranslated, 
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 1.5,
          slideBy: 1
        },
        1440: {
          items: 1.5,
          slideBy: 1
        },
        1920: {
          items: 1.5,
          slideBy: 1
        }
      }
    }, true);


    this.handleTabClick();
  }

  setMaxChildWidth() {
    const max_width = Math.max.apply(Math, $(".eni-tab-new-section .fixed-width .owl-item").map(function(){ return parseFloat($(this).width()+1); }).get());
    $(".eni-tab-new-section .fixed-width .eni-tab").each(function(){
        $(this).css({width : max_width})
    });
  }

  handleTabClick() {
    $(".eni-tab-new-section .eni-tab").click(event => {

      const clickedBtn = $(event.target);
      const allBtnsCurrentSection = clickedBtn.closest(".eni-tab-new-section").find(".eni-tab");
      const currentSectionContent = clickedBtn.closest(".eni-tab-new-section").find(".eni-tab-content");

      // Remove active class from all buttons in current section
      allBtnsCurrentSection.removeClass("active");

      // Add active class to currently clicked button
      clickedBtn.closest(".eni-tab").addClass("active");

      // Calcolo Viewport e posizione di inizio e fine del bottone cliccato
      var startPositionBtn = jQuery(clickedBtn.closest(".eni-tab")).offset().left;
      var finalPositionBtn = startPositionBtn + jQuery(clickedBtn.closest(".eni-tab")).width()+42;
      var screenWidth = clickedBtn.closest(".eni-tab-new-section").find(".owl-stage-outer").width();

      // Se supera la viewport spostiamo il Bottone a sinistra.
      var owl = $('.owl-carousel');
      owl.owlCarousel(); 
      console.log("startPositionBtn " + startPositionBtn + " - finalPositionBtn " + finalPositionBtn + " - screenWidth " + screenWidth);
      if (finalPositionBtn > screenWidth ) {
        owl.trigger('next.owl.carousel');
      }
      if (startPositionBtn < 0 ) {
        owl.trigger('prev.owl.carousel');
      }

      // Get Current
      var contentId = clickedBtn.closest(".eni-tab").data("target");

      // Hide all content in current section
      currentSectionContent.removeClass("active");

      // Show currently active content
      this.showContentById(contentId);
    });
  }

  showContentById(id) {
    $(".eni-tab-new-section #" + id).addClass("active");
  }
}

$(() => {
  const component = new TabNewComponent();
});


/***/ }),

/***/ "./src/scripts/widgets/tab.js":
/*!************************************!*\
  !*** ./src/scripts/widgets/tab.js ***!
  \************************************/
/*! exports provided: TabComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabComponent", function() { return TabComponent; });
class TabComponent {
  constructor() {
    this.handleTabClick();
  }

  handleTabClick() {
    $(".eni-tab-section .eni-tab").on('click', event => {
      const clickedBtn = $(event.target);
      const allBtnsCurrentSection = clickedBtn.closest(".eni-tab-section").find(".eni-tab");
      const currentSectionContent = clickedBtn.closest(".eni-tab-section").find(".eni-tab-content");

      // Remove active class from all buttons in current section
      allBtnsCurrentSection.removeClass("active");

      // Add active class to currently clicked button
      clickedBtn.addClass("active");

      // Get Current
      const contentId = clickedBtn.data("target");

      // Hide all content in current section
      currentSectionContent.removeClass("active");

      // Show currently active content
      this.showContentById(contentId);

      // cr anchor
      const tab = clickedBtn.data('tab');
      console.log('tab', tab);
      if (tab) {
        event.preventDefault();
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('tab', tab);
        window.history.replaceState({}, '', `${location.pathname}?${searchParams.toString()}`);
      }
    });
  }

  showContentById(id) {
    $(".eni-tab-section #" + id).addClass("active");
  }
}

$(() => {
  const component = new TabComponent();
});


/***/ }),

/***/ "./src/scripts/widgets/timeline.js":
/*!*****************************************!*\
  !*** ./src/scripts/widgets/timeline.js ***!
  \*****************************************/
/*! exports provided: Timeline */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Timeline", function() { return Timeline; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class Timeline {
  constructor() {
    this.yearsOwl = Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])('.timeline .year-container .owl-carousel', {
      items: 5,
      loop: false,
      nav: true,
      dots: false,
      mouseDrag: false,
      center: true,
      autoWidth: false,
      margin: 20,
      navText: [],
      rewind: false,
      onTranslate: (event) => this.removeAlmostActiveYears(event),
      onTranslated: (event) => this.handleAlmostActiveYears(event),
      onInitialized: (event) => this.handleAlmostActiveYears(event),
      responsive: {
        0: {
          items: 2.5
        },
        650: {
          items: 5
        }
      }
    }, false);

    this.cardsOwl = Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])('.timeline .cards-container .owl-carousel', {
      items: 3,
      loop: false,
      nav: false,
      dots: false,
      mouseDrag: false,
      center: true,
      autoWidth: true,
      navText: [],
      rewind: false,
      margin: 0,
      onDragged: (event) => this.handleDragItem(event),
    }, false);

    $('.timeline .year-item').click((event) => this.handleClickYearItem(event));

    $('.timeline .card-timeline').click((event) => this.handleClickYearItem(event));

  }

  removeAlmostActiveYears(event) {
    $(event.target).find('.owl-item').removeClass('almost-active');
  }

  handleAlmostActiveYears(event) {
    try {
      console.log('handleAlmostActiveYears', event);
      if (event) {
        const itemActive = $(event.target).find('.owl-item.active.center');
        console.log('itemActive', itemActive);
        const prevItem = $(itemActive).prev('.active');
        console.log('prevItem', prevItem);
        if (prevItem) {
          prevItem.addClass('almost-active');
        }
        const nextItem = $(itemActive).next('.active');
        console.log('nextItem', nextItem);
        if (nextItem) {
          nextItem.addClass('almost-active');
        }

        this.cardsOwl.trigger('to.owl.carousel', [event.item.index]);
      }
    } catch (ex) {}
  }

  handleClickYearItem(event) {
    const el = event.currentTarget;
    console.log('handleClickYearItem', el);
    const index = $(el).attr('data-index');
    this.yearsOwl.trigger('to.owl.carousel', [index]);
    // this.cardsOwl.trigger('to.owl.carousel', [index]);
  }

  handleDragItem(event) {
    const index = event.item.index;
    this.yearsOwl.trigger('to.owl.carousel', [index]);
  }
}

$(() => {
  const component = new Timeline();
});


/***/ }),

/***/ "./src/scripts/widgets/tool-investor.js":
/*!**********************************************!*\
  !*** ./src/scripts/widgets/tool-investor.js ***!
  \**********************************************/
/*! exports provided: ToolInvestor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToolInvestor", function() { return ToolInvestor; });
/* harmony import */ var _common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/owl-carousel */ "./src/scripts/common/owl-carousel.js");


class ToolInvestor {
  constructor(bindClass) {
    Object(_common_owl_carousel__WEBPACK_IMPORTED_MODULE_0__["owlCarouselUtls"])(bindClass, {
      loop: false,
      nav: true,
      mouseDrag: false,
      center: false,
      autoWidth: true,
      margin: 20,
      navText: [],
      /* onTranslate: this.onTranslated, */
      rewind: false,
      responsive: {
        0: {
          items: 1.5,
          slideBy: 1
        },
        // 768: {
        //   items: 2.5,
        //   slideBy: 2
        // },
        1024: {
          items: 2.5,
          slideBy: 2
        },
        1440: {
          items: 3.5,
          slideBy: 3
        }
      }
    }, true);

    // $('.carousel-numbers .card-number').click(this.handleClick);
  }

  // handleClick(event) {
  //   let url, target;
  //   if ($(event.target).hasClass('icon-arrow-right-small')) {
  //     const a = $(event.target).parent('a');
  //     url = $(a).attr('href');
  //     target = $(a).attr('target');
  //     event.preventDefault();
  //   } else if ($(event.target).is('a')) {
  //     return;
  //   }
  //   else {
  //     const el = event.currentTarget;
  //     url = $(el).attr('data-link');
  //     target = $(el).attr('data-target');
  //   }
  //   window.open(url, target);
  // }
}

$(() => {
  const component = new ToolInvestor('.carousel-container.tool-investor-carousel .owl-carousel');
});


/***/ }),

/***/ "./src/scripts/widgets/versalis-global.presence.js":
/*!*********************************************************!*\
  !*** ./src/scripts/widgets/versalis-global.presence.js ***!
  \*********************************************************/
/*! exports provided: VersalisGlobalPresence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VersalisGlobalPresence", function() { return VersalisGlobalPresence; });
class VersalisGlobalPresence {

    constructor(cmp) {
        console.log('VersalisGlobalPresence', cmp);
        if (cmp) {
            const regionContainer = $(cmp).find('.versalis-global-presence__regions-container');
            const optionLinks = $(cmp).find('.region-btn');
            this.bindRegionLink(regionContainer, optionLinks);

        }
    }

    bindRegionLink(regionContainer, links) {
        links.on('click', (ev) => {
            $('.versalis-global-presence__desktop-message').hide();
            console.log('region link', ev);
            const btn = ev.target;
            $('.versalis-global-presence__option-link').removeClass('active');
            $('.versalis-global-presence__countries-container').removeClass('active');
            $('.versalis-global-presence__country_container').removeClass('active');
            $(btn).toggleClass('active');
            const id = $(btn).data('target');
            console.log('region link id', id);
            this.showCountries(regionContainer, id);

        });
    }


    showCountries(regionCmp, regionId) {
        const regionNode = $(`#${regionId}`);
        $(regionCmp).addClass('hide');
        $('.versalis-global-presence__countries-container').removeClass('active');
        regionNode.addClass('active');
        this.bindCountryButtons(regionCmp, regionNode);
    }

    bindCountryButtons(regionContainer, regionNode) {
        regionNode.find('.versalis-global-presence__back-link').on('click', () => {
            console.log('back link');
            this.showRegions(regionContainer);
        });
        regionNode.find('.country-btn').on('click', (ev) => {
            console.log('country link', ev.target);
            this.showCountryDetail(regionNode, $(ev.target).data('target'));
        });
    }

    showRegions(regionCmp) {
        $('.versalis-global-presence__option-link').removeClass('active');
        $('.versalis-global-presence__countries-container').removeClass('active');
        $(regionCmp).removeClass('hide');
    }

    showCountryDetail(regionNode, countryId) {
        console.log('showCountryDetail', regionNode, countryId);
        regionNode.removeClass('active');
        const countryDetailsNode = $(`#${countryId}`);
        countryDetailsNode.addClass('active');
        countryDetailsNode.find('.versalis-global-presence__back-link').on('click', () => {
            regionNode.addClass('active');
            countryDetailsNode.removeClass('active');
        });

        countryDetailsNode.find('.site-btn').on('click', (ev) => {
            const content = $(ev.target).siblings('.site-details__content').clone();
            $('#site-details-modal').empty().append(content);
            $(content).show();
            $('#site-details-modal').addClass('show');
            $('#site-details-modal').find('.site-details__close-btn').on('click', () => {
                $('#site-details-modal').removeClass('show');
            });
        });

        countryDetailsNode.find('.filter-tag').on('click', (ev) => {
            this.handleFilter(ev.target, countryDetailsNode.find('.site-btn'));
        });
    }

    handleFilter(filter, sites) {
        const type = $(filter).data('type');
        const value = $(filter).text();
        $(filter).toggleClass('active');
        console.log('type', type, value);
        console.log('sites', sites);
        const sitesFiltered = sites.filter((i, site) => {
            const data = site.dataset[type];
            console.log('data', data.split(','));
            return !data.split(',').includes(value);
        });
        if ($(filter).hasClass('active')) {
            $(sitesFiltered).hide();
        } else {
            $(sitesFiltered).show();
        }
    }

}
$(() => {
    const components = $('.versalis-global-presence');
    components.each((i, cmp) => new VersalisGlobalPresence(cmp));
});

/***/ }),

/***/ 0:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** multi ./src/scripts/mobile-menu.js ./src/scripts/header/header-rich-text-carousel.js ./src/scripts/header/header-search-carousel.js ./src/scripts/header/header.component.js ./src/scripts/common/animate.js ./src/scripts/common/card.js ./src/scripts/common/carousel-utils.js ./src/scripts/common/cookie-banner.js ./src/scripts/common/datepicker_translations.js ./src/scripts/common/digital-data.js ./src/scripts/common/eni-tales.js ./src/scripts/common/filters-util.js ./src/scripts/common/form-utils.js ./src/scripts/common/initDynamicContent.js ./src/scripts/common/modals.js ./src/scripts/common/owl-carousel.js ./src/scripts/common/pagination-util.js ./src/scripts/common/scroll.js ./src/scripts/common/search-tab-utils.js ./src/scripts/common/share.js ./src/scripts/common/tab-utils.js ./src/scripts/common/tooltip.js ./src/scripts/common/tt-paginator.plugin.js ./src/scripts/common/tt-show-more.plugin.js ./src/scripts/common/utils.js ./src/scripts/common/yt-utils.js ./src/scripts/widgets/breadcrumbs.js ./src/scripts/widgets/calendar.js ./src/scripts/widgets/card-external-link.js ./src/scripts/widgets/card-sub-category.js ./src/scripts/widgets/carousel-editorial.js ./src/scripts/widgets/carousel-event.js ./src/scripts/widgets/carousel-generic.js ./src/scripts/widgets/carousel-global-presence.js ./src/scripts/widgets/carousel-places.js ./src/scripts/widgets/carousel-publications.js ./src/scripts/widgets/contacts-carousel.js ./src/scripts/widgets/corporate-carousel.js ./src/scripts/widgets/data-table-old.js ./src/scripts/widgets/data-table.js ./src/scripts/widgets/display-launch-card.js ./src/scripts/widgets/document-disclaimer-egl.js ./src/scripts/widgets/document-disclaimer.js ./src/scripts/widgets/editorial-collection-card.js ./src/scripts/widgets/editorial-content-list.js ./src/scripts/widgets/event-cover.js ./src/scripts/widgets/event-highlight-countdown.js ./src/scripts/widgets/event-highlight.js ./src/scripts/widgets/format-video-player.js ./src/scripts/widgets/full-video-image.js ./src/scripts/widgets/global-presence-card-country4.js ./src/scripts/widgets/global-presence-project-highlight.js ./src/scripts/widgets/global-presence-sustainability-goal.js ./src/scripts/widgets/grid-card3.js ./src/scripts/widgets/herobanner-homepage.js ./src/scripts/widgets/herobanner-video.js ./src/scripts/widgets/highlight_editorial_content.js ./src/scripts/widgets/identity-card.js ./src/scripts/widgets/iframe-resizer.js ./src/scripts/widgets/infographics.js ./src/scripts/widgets/interactive-map-detail.js ./src/scripts/widgets/interactive-map-light.js ./src/scripts/widgets/interactive-map.js ./src/scripts/widgets/manager-detail.js ./src/scripts/widgets/managers-card.js ./src/scripts/widgets/media-collection-detail-cover.js ./src/scripts/widgets/media-highlight.js ./src/scripts/widgets/no-browser-support.js ./src/scripts/widgets/number-highlight.js ./src/scripts/widgets/numbers-carousel.js ./src/scripts/widgets/our-channel-panel.js ./src/scripts/widgets/people-tab.js ./src/scripts/widgets/photo-gallery.js ./src/scripts/widgets/project-highlight-complex-page.js ./src/scripts/widgets/publication-list.js ./src/scripts/widgets/search-images.js ./src/scripts/widgets/single-image-video.js ./src/scripts/widgets/tab-new.js ./src/scripts/widgets/tab.js ./src/scripts/widgets/timeline.js ./src/scripts/widgets/tool-investor.js ./src/scripts/widgets/versalis-global.presence.js ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/mobile-menu.js */"./src/scripts/mobile-menu.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/header/header-rich-text-carousel.js */"./src/scripts/header/header-rich-text-carousel.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/header/header-search-carousel.js */"./src/scripts/header/header-search-carousel.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/header/header.component.js */"./src/scripts/header/header.component.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/animate.js */"./src/scripts/common/animate.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/card.js */"./src/scripts/common/card.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/carousel-utils.js */"./src/scripts/common/carousel-utils.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/cookie-banner.js */"./src/scripts/common/cookie-banner.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/datepicker_translations.js */"./src/scripts/common/datepicker_translations.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/digital-data.js */"./src/scripts/common/digital-data.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/eni-tales.js */"./src/scripts/common/eni-tales.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/filters-util.js */"./src/scripts/common/filters-util.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/form-utils.js */"./src/scripts/common/form-utils.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/initDynamicContent.js */"./src/scripts/common/initDynamicContent.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/modals.js */"./src/scripts/common/modals.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/owl-carousel.js */"./src/scripts/common/owl-carousel.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/pagination-util.js */"./src/scripts/common/pagination-util.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/scroll.js */"./src/scripts/common/scroll.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/search-tab-utils.js */"./src/scripts/common/search-tab-utils.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/share.js */"./src/scripts/common/share.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/tab-utils.js */"./src/scripts/common/tab-utils.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/tooltip.js */"./src/scripts/common/tooltip.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/tt-paginator.plugin.js */"./src/scripts/common/tt-paginator.plugin.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/tt-show-more.plugin.js */"./src/scripts/common/tt-show-more.plugin.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/utils.js */"./src/scripts/common/utils.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/common/yt-utils.js */"./src/scripts/common/yt-utils.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/breadcrumbs.js */"./src/scripts/widgets/breadcrumbs.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/calendar.js */"./src/scripts/widgets/calendar.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/card-external-link.js */"./src/scripts/widgets/card-external-link.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/card-sub-category.js */"./src/scripts/widgets/card-sub-category.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/carousel-editorial.js */"./src/scripts/widgets/carousel-editorial.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/carousel-event.js */"./src/scripts/widgets/carousel-event.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/carousel-generic.js */"./src/scripts/widgets/carousel-generic.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/carousel-global-presence.js */"./src/scripts/widgets/carousel-global-presence.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/carousel-places.js */"./src/scripts/widgets/carousel-places.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/carousel-publications.js */"./src/scripts/widgets/carousel-publications.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/contacts-carousel.js */"./src/scripts/widgets/contacts-carousel.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/corporate-carousel.js */"./src/scripts/widgets/corporate-carousel.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/data-table-old.js */"./src/scripts/widgets/data-table-old.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/data-table.js */"./src/scripts/widgets/data-table.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/display-launch-card.js */"./src/scripts/widgets/display-launch-card.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/document-disclaimer-egl.js */"./src/scripts/widgets/document-disclaimer-egl.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/document-disclaimer.js */"./src/scripts/widgets/document-disclaimer.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/editorial-collection-card.js */"./src/scripts/widgets/editorial-collection-card.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/editorial-content-list.js */"./src/scripts/widgets/editorial-content-list.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/event-cover.js */"./src/scripts/widgets/event-cover.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/event-highlight-countdown.js */"./src/scripts/widgets/event-highlight-countdown.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/event-highlight.js */"./src/scripts/widgets/event-highlight.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/format-video-player.js */"./src/scripts/widgets/format-video-player.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/full-video-image.js */"./src/scripts/widgets/full-video-image.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/global-presence-card-country4.js */"./src/scripts/widgets/global-presence-card-country4.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/global-presence-project-highlight.js */"./src/scripts/widgets/global-presence-project-highlight.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/global-presence-sustainability-goal.js */"./src/scripts/widgets/global-presence-sustainability-goal.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/grid-card3.js */"./src/scripts/widgets/grid-card3.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/herobanner-homepage.js */"./src/scripts/widgets/herobanner-homepage.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/herobanner-video.js */"./src/scripts/widgets/herobanner-video.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/highlight_editorial_content.js */"./src/scripts/widgets/highlight_editorial_content.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/identity-card.js */"./src/scripts/widgets/identity-card.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/iframe-resizer.js */"./src/scripts/widgets/iframe-resizer.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/infographics.js */"./src/scripts/widgets/infographics.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/interactive-map-detail.js */"./src/scripts/widgets/interactive-map-detail.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/interactive-map-light.js */"./src/scripts/widgets/interactive-map-light.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/interactive-map.js */"./src/scripts/widgets/interactive-map.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/manager-detail.js */"./src/scripts/widgets/manager-detail.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/managers-card.js */"./src/scripts/widgets/managers-card.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/media-collection-detail-cover.js */"./src/scripts/widgets/media-collection-detail-cover.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/media-highlight.js */"./src/scripts/widgets/media-highlight.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/no-browser-support.js */"./src/scripts/widgets/no-browser-support.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/number-highlight.js */"./src/scripts/widgets/number-highlight.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/numbers-carousel.js */"./src/scripts/widgets/numbers-carousel.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/our-channel-panel.js */"./src/scripts/widgets/our-channel-panel.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/people-tab.js */"./src/scripts/widgets/people-tab.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/photo-gallery.js */"./src/scripts/widgets/photo-gallery.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/project-highlight-complex-page.js */"./src/scripts/widgets/project-highlight-complex-page.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/publication-list.js */"./src/scripts/widgets/publication-list.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/search-images.js */"./src/scripts/widgets/search-images.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/single-image-video.js */"./src/scripts/widgets/single-image-video.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/tab-new.js */"./src/scripts/widgets/tab-new.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/tab.js */"./src/scripts/widgets/tab.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/timeline.js */"./src/scripts/widgets/timeline.js");
__webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/tool-investor.js */"./src/scripts/widgets/tool-investor.js");
module.exports = __webpack_require__(/*! /Users/cscoma/work/git/versalis/versalis-html-site/src/scripts/widgets/versalis-global.presence.js */"./src/scripts/widgets/versalis-global.presence.js");


/***/ })

/******/ });